import { hardcodedResources } from './hardcoded.js';
import { legacyResources } from './legacy.js';

export const resources = {
  zh: {
    feedback: {
      "title": "问题反馈",
      "submit": "提交",
      "cancel": "取消",
      "page": "当前页面",
      "subject": "问题标题",
      "subjectRequired": "请填写问题标题",
      "subjectMax": "不超过 120 个字",
      "subjectPlaceholder": "一句话说明遇到的问题",
      "description": "问题描述",
      "descriptionPlaceholder": "发生了什么，期望怎样；可直接粘贴截图",
      "descriptionRequired": "请填写问题描述或添加图片（文字不超过 4000 个字）",
      "addImages": "添加图片",
      "imageHint": "在输入框内按 Ctrl+V / ⌘V 直接粘贴截图。支持 PNG、JPEG、WebP；最多 3 张，合计不超过 1MB。",
      "tooMany": "最多添加 3 张图片",
      "tooLarge": "图片总大小不能超过 1MB",
      "imageType": "仅支持 PNG、JPEG、WebP 图片",
      "readFailed": "图片读取失败，请重试",
      "removeImage": "删除第 {{index}} 张图片",
      "remove": "删除",
      "submitted": "反馈已提交",
      "submitFailed": "提交失败，请稍后再试",
      "detailFailed": "反馈详情加载失败，请重试"
    },
    portalNavigation: {
      toolApplications: 'AI 工具箱',
      openAssistant: '打开 AI 聊天窗口',
      assistantUnavailable: '聊天窗口加载失败，请重试。',
      assistantUpgradeRequired: '请先更新 Agent 版本以启用聊天窗口。',
    },
    account: {
      settings: { title: '个人设置' },
      dingtalk: {
        title: '钉钉连接',
        loadFailed: '钉钉连接状态加载失败',
        connectFailed: '连接钉钉失败，请稍后重试',
        connectionError: '连接异常',
        authorizationFailedTitle: '钉钉完整授权未完成',
        authorizationFailed: '钉钉完整授权未完成，请点击“重新授权”再次尝试。',
        connected: '钉钉已连接',
        revoked: '已解除 CREST 与钉钉的连接',
        reauthorize: '需要重新授权',
        notConnected: '未连接',
        disabled: '管理员尚未启用托管钉钉连接',
        purposeTitle: 'CREST 如何使用钉钉权限',
        purpose:
          '用于助手读取和处理你的日历、待办、消息、文档等个人钉钉数据。Token 和 CLI 由 CREST 托管；每次写操作仍需单独确认。',
        organization: '授权组织',
        permissions: '已授权能力',
        items: '项',
        authorizedAt: '最近授权',
        manifest: '权限清单版本',
        confirmFullAuthorization: '确认完整授权',
        reauthorizeAction: '重新授权',
        connectAction: '连接并授权全部钉钉能力',
        revokeConfirm: '确认解除 CREST 与钉钉的连接？',
        revokeAction: '解除连接',
        cardTitle: '连接钉钉以继续',
        cardPurpose: 'CREST 需要获得你的钉钉授权才能完成当前请求。',
        managedHint: 'Token 和 CLI 由 CREST 安全托管；每次写操作仍需你单独确认。',
        connect: '连接钉钉',
        later: '稍后处理',
        read: '读取',
        write: '写入',
        provider: '钉钉',
      },
    },
    knowledgeBaseManagement: {
      title: '知识库管理',
      subtitle: '管理个人与企业知识，智能体通过目录、摘要和正文三级渐进式加载。',
      personal: '个人知识库',
      enterprise: '企业知识库',
      public: '公共知识库',
      department: '部门知识库',
      newKnowledgeBase: '新建知识库',
      name: '名称',
      description: '描述',
      departments: '可访问部门',
      selectDepartments: '请选择至少一个部门',
      create: '创建知识库',
      cancel: '取消',
      createSuccess: '知识库已创建',
      createFailed: '创建知识库失败，请检查配置后重试',
      loadFailed: '知识库加载失败，请稍后重试',
      deleteTitle: '删除知识库“{{name}}”？',
      deleteDescription: '库内文档和章节目录将一并删除，且无法恢复。',
      delete: '删除知识库',
      deleteSuccess: '知识库已删除',
      empty: '暂无知识库，可新建一个开始整理资料',
      selectHint: '请选择一个知识库查看和管理文档',
      documents: '文档',
      sections: '章节',
      source: '来源',
      conversationSource: '对话沉淀',
      directUploadSource: '直接上传',
      progressiveTag: 'OpenViking · 渐进式加载',
      progressiveHint:
        'CREST 负责权限与渐进式加载，OpenViking 提供语义和向量检索；智能体先发现目录和摘要，再按需读取有界正文。',
      personalDescription: '仅创建者本人可见和使用。',
      publicDescription: '企业全员可见和使用。',
      departmentDescription: '仅所选 CREST 企业组织成员可见和使用。',
      myKnowledgeBases: '我的知识库',
      candidates: '待整理',
      documentHistory: '文档记录',
      publishRequests: '发布申请',
      publishReview: '发布审核',
      requestPublish: '申请发布',
      requestEnterprisePublish: '申请发布到企业知识库',
      publishRequestHint: '提交后由知识库管理员审核，审核通过才会写入企业 OpenViking 文档库。',
      publishAfterApproval: '申请阶段不会修改企业知识库，可在审核完成前撤回。',
      enterpriseTarget: '目标企业知识库',
      selectEnterpriseTarget: '请选择可访问的企业知识库',
      publishReason: '发布说明',
      publishReasonPlaceholder: '说明文档用途、适用范围和建议受众',
      submitForReview: '提交审核',
      publishTargetsLoadFailed: '企业知识库列表加载失败，请稍后重试。',
      publishRequestCreated: '发布申请已提交',
      publishRequestFailed: '发布申请提交失败，请稍后重试。',
      publishRequestsLoadFailed: '发布申请加载失败，请稍后重试。',
      noPublishRequests: '暂无知识发布申请。',
      publishStatus: '审核状态',
      submittedAt: '提交时间',
      requester: '申请人',
      withdraw: '撤回',
      cancelPublishTitle: '撤回这条发布申请？',
      confirmCancelPublish: '确认撤回',
      publishRequestCancelled: '发布申请已撤回',
      approve: '批准',
      retryPublish: '重试发布',
      reject: '驳回',
      qualityCheck: '质量检查',
      exactDuplicate: '目标库已有相同内容',
      highRisk: '{{count}} 项高风险',
      qualityWarnings: '{{count}} 项提醒',
      qualityPassed: '检查通过',
      approvePublishTitle: '批准企业知识发布',
      rejectPublishTitle: '驳回企业知识发布',
      approveAndPublish: '批准并发布',
      confirmReject: '确认驳回',
      reviewNotePlaceholder: '填写审核意见；驳回时建议说明修改要求',
      publishApproved: '文档已发布到企业知识库',
      publishRejected: '发布申请已驳回',
      reviewFailed: '审核操作失败，请稍后重试。',
      publishStatuses: {
        pending: '待审核',
        publishing: '发布中',
        approved: '已发布',
        rejected: '已驳回',
        cancelled: '已撤回',
        failed: '发布失败',
      },
      file: '文件',
      uploadedAt: '上传时间',
      knowledgeStatus: '知识状态',
      actions: '操作',
      organize: '保存到知识库',
      notOrganized: '仅会话使用',
      unsupportedForKnowledge: '暂不支持沉淀',
      noCandidates: '暂无待整理文档，对话附件可继续仅在当前会话使用。',
      noConversationFiles: '暂无可用的对话文档记录。',
      conversationFilesLoadFailed: '对话文档记录加载失败，请稍后重试。',
      knowledgeBase: '知识库',
      scope: { owner: '个人', system: '企业公共', shared: '部门共享' },
      status: {
        pending: '待处理',
        parsing: '解析中',
        chunking: '章节整理中',
        embedding: '索引中',
        done: '已发布',
        failed: '失败',
      },
    },
    openVikingStudio: {
      title: '文档库管理',
      subtitle: '通过 OpenViking Studio 管理文档资源、连接与知识库后端配置。',
      checking: '检查连接…',
      connected: 'OpenViking 已连接',
      disconnected: 'OpenViking 未就绪',
      reload: '重新加载',
      openStandalone: '独立打开 Studio',
      unavailableTitle: 'OpenViking 连接异常',
      unavailableDescription:
        '请检查 OpenViking 服务、Crest 后端开关和 Studio 地址，然后重新加载。',
      loading: '正在加载 OpenViking Studio…',
      frame: 'OpenViking Studio 连接与配置',
      directoryTitle: 'Crest 用户目录同步',
      directoryAccount: 'OpenViking Account',
      crestActiveUsers: 'Crest 启用用户',
      synchronizedUsers: '已同步',
      pendingUsers: '待同步',
      directoryStatus: '目录状态',
      directorySynchronized: '已同步',
      directoryPending: '需要同步',
      directoryUnavailable: '无法读取 OpenViking 用户目录，请检查管理员权限和后端配置。',
      syncUsers: '同步 Crest 用户',
      syncSuccess: '已同步 {{count}} 个 Crest 用户',
      syncFailed: '用户目录同步失败，请检查 OpenViking Root Key 和服务日志。',
    },
    openVikingConsole: {
      common: {
        refresh: '刷新',
        loadFailed: 'OpenViking 数据加载失败',
        requestFailed: '请求失败',
        query: '查询',
        reset: '重置',
        date: '日期',
        delete: '删除',
      },
      home: {
        title: '首页',
        description: '查看 OpenViking 上下文规模、Token、检索和提交趋势。',
        contextData: '上下文数据量',
        items: '项',
        todayTokens: '今日 Tokens',
        todayRetrievals: '今日检索',
        tokenTrend: '最近 14 天 Token 趋势',
        contextCommits: '上下文提交统计',
        total: '总计',
        resources: '资源写入',
        messages: '会话消息',
        commits: '会话提交',
        contextBreakdown: '文件 {{files}} · 技能 {{skills}} · 记忆 {{memories}}',
        tokenBreakdown:
          'VLM 输入 {{vlm_input}} · 输出 {{vlm_output}} · Embedding {{embedding_input}}',
        retrievalBreakdown: 'find {{find}} · search {{search}}',
      },
      retrieval: {
        title: '检索',
        description: '运行 OpenViking find 或 search，查看查询计划与分层结果。',
        mode: '检索模式',
        scope: '目标 URI',
        limit: '结果数',
        query: '查询内容',
        queryRequired: '请输入查询内容',
        queryPlaceholder: '输入自然语言查询',
        run: '运行检索',
        queryPlan: '查询计划',
        resultCount: '共 {{count}} 条结果',
      },
      playground: {
        title: '实验场',
        description: '浏览上下文文件系统、预览资源并与 OpenViking Agent 对话。',
        explorer: '上下文浏览器',
        preview: '内容预览',
        agent: 'Agent',
        addResource: '添加资源',
        dir: '目录',
        file: '文件',
        directorySelected: '已选择目录',
        previewFailed: '内容读取失败',
        selectResource: '选择文件或目录查看内容',
        chatEmpty: '开始一次 Agent 对话',
        send: '发送',
        chatPlaceholder: '向 OpenViking Agent 提问',
        source: '资源来源',
        upload: '上传文件',
        remote: '远程地址',
        uploadHint: '点击或拖拽文件到此处',
        fileRequired: '请选择要上传的文件',
        remoteUrl: '远程资源地址',
        targetUri: '目标 URI',
        resourceAdded: '资源已提交处理',
        resourceFailed: '资源提交失败',
      },
      logs: {
        title: '请求日志',
        description: '查看 OpenViking 审计到的 API 请求、状态和耗时。',
        total: '总调用次数',
        successRate: '成功率',
        apiType: 'API 类型',
        status: '状态',
        time: '时间',
        method: '方法',
        path: '路径',
        duration: '耗时',
      },
      sessions: {
        title: '会话板',
        description: '管理 OpenViking Session、消息、上下文提交和记忆提取。',
        new: '新建会话',
        empty: '暂无会话',
        deleteConfirm: '确认删除这个会话？',
        select: '请选择会话',
        commit: '提交上下文',
        extract: '提取记忆',
        committed: '上下文提交已启动',
        extracted: '记忆提取已启动',
        noMessages: '暂无消息',
        send: '发送',
        placeholder: '输入会话消息',
        replyReceived: '已收到 Agent 回复',
        messageAdded: '消息已添加',
      },
      identity: {
        title: '连接与身份',
        description: '查看服务连接、当前 Crest trusted identity 和用户目录同步状态。',
        connection: '服务连接',
        connected: 'OpenViking 已连接',
        disconnected: 'OpenViking 未就绪',
        secretHint: 'Root Key 由 Crest 后端 Secret 注入，不保存到浏览器。',
        current: '当前身份',
        directory: '用户目录',
        crestActive: 'Crest 启用用户',
        synchronized: '已同步',
        pending: '待同步',
        sync: '同步 Crest 用户',
        syncSuccess: '已同步 {{count}} 个 Crest 用户',
        syncFailed: '用户目录同步失败',
        systemStatus: 'OpenViking 系统状态',
        users: '目录用户',
      },
      oauth: {
        title: 'OAuth 验证',
        description: '审批其他设备或客户端发起的 OpenViking OAuth 授权请求。',
        hint: '输入请求方显示的一次性验证码。审批动作使用当前 Crest 用户对应的 trusted identity。',
        code: '验证码',
        codeRequired: '请输入验证码',
        approve: '批准授权',
        success: '已批准 {{client}} 的授权请求',
        successUnknown: '授权请求已批准',
      },
    },
    opportunityDetail: {
      closedReadOnly: '该商机已关闭，无法再进行编辑。',
      displayPreferences: '个性化配置',
      displayPreferencesHint: '选择打开商机详情时默认展开的流程区域。',
      showApprovalProcess: '默认显示审批流程',
      showOpportunityProcess: '默认显示商机进程',
      processTitle: '商机进程',
      processState: {
        active: '进行中',
        completed: '已完成',
        aborted: '已中止',
      },
      preferencesSaved: '个性化配置已保存',
    },
    notificationMessages: {
      oaClosePending: '站内消息已读，OA 通知暂未关闭',
      batchOaClosePending: '已将 {{read}} 条站内消息设为已读；{{pending}} 条 OA 通知暂未关闭',
    },
    serviceLogs: {
      title: '服务日志',
      subtitle: '查看外部系统调用审批流或智能体的发起信息、处理状态和审批意见。',
      sourceSystem: '外部系统',
      eventName: '发起事件',
      taskType: '任务类型',
      oaId: '流程 OA ID',
      oaProcessStatus: 'OA 流程状态',
      processName: '流程名称',
      initiator: '发起人',
      agent: 'Agent',
      approvalOpinion: 'Agent 审批意见',
      status: '处理状态',
      startedAt: '发起时间',
      duration: '处理耗时',
      searchPlaceholder: '搜索事件、OA ID、流程、发起人或 Agent',
      sourcePlaceholder: '筛选外部系统',
      statusPlaceholder: '筛选处理状态',
      refresh: '刷新日志',
      retry: '重新加载',
      loadFailed: '服务日志加载失败',
      loadFailedDescription: '无法读取服务日志，请检查服务状态后重试。',
      empty: '暂无外部系统调用记录',
      total: '共 {{total}} 条',
      runId: '运行 ID',
      workflowRunId: '工作流运行 ID',
      error: '失败原因',
      overview: {
        title: '运行概览',
        systems: '已接入系统',
        taskTypes: '任务类型',
        totalInvocations: '累计调用',
        last24Hours: '近 24 小时',
        questionAnswering: '智能问答',
        workflowProcessing: '流程处理',
        riskAlerts: '风险预警',
        agentTasks: '智能体任务',
        completed: '已完成',
        inProgress: '处理中',
        failed: '失败/取消',
        completionRate: '完成率',
        averageDuration: '平均耗时',
        systemDistribution: '系统构成',
        taskTypeDistribution: '任务类型构成',
      },
      statuses: {
        submitted: '已提交',
        working: '处理中',
        input_required: '等待确认',
        completed: '处理完成',
        failed: '处理失败',
        canceled: '已取消',
      },
      oaProcessStatuses: {
        '1': '审批通过',
        '2': '审批驳回',
        '3': '审批中',
        '4': '已撤回',
        unknown: '未知状态（{{status}}）',
      },
    },
    contractExport: {
      title: '合同导出',
      subtitle: '从 OA 合同审批数据生成销售凭证批导 Excel',
      refresh: '刷新',
      searchPlaceholder: '搜索合同或模版名称',
      contract: '合同',
      templateId: '模版 ID',
      templateName: '模版名称',
      updatedAt: '流程更新时间',
      action: '操作',
      download: '下载',
      selectCurrentPage: '选择当前页',
      selectSearchResults: '选择全部搜索结果（{{total}}）',
      clearSelection: '清空选择',
      batchDownload: '批量下载（{{total}}）',
      batchFilename: '合同批量导出',
      total: '共 {{total}} 条',
      loadFailed: '合同审批数据加载失败',
      downloadFailed: '合同 Excel 生成失败',
      batchDownloadFailed: '所选合同全部下载失败，请稍后重试',
      batchDownloadPartial: '批量下载完成，其中 {{failed}} 份生成失败',
    },
    enterpriseBrainSettings: {
      title: '平台设置',
      subtitle: '统一管理 Agent 平台的运行环境、助手、编排和扩展能力。',
      groups: {
        runtime: {
          title: '运行环境',
          description: '配置 Agent 平台使用的模型服务和智能体运行时。',
        },
        assistants: {
          title: '助手与编排',
          description: '管理企业助手及其工作流、工具和执行边界。',
        },
        extensions: {
          title: '扩展能力',
          description: '管理工具、MCP 服务、技能和插件等可复用能力。',
        },
      },
      links: {
        models: '模型管理',
        cli: '智能体管理',
        agents: '助手管理',
        orchestration: '智能体编排',
        tools: '工具管理',
        mcp: 'MCP 管理',
        skills: '技能管理',
        knowledge: '知识库管理',
        plugins: '插件管理',
        presentations: 'PPT 模板中心',
      },
    },
    presentationTemplates: {
      title: 'PPT 模板中心',
      subtitle: '管理品牌模板、固定结构模板、业务数据绑定和助手默认模板。',
      upload: '上传模板',
      empty: '暂无 PPT 模板，请先上传企业模板',
      loadFailed: 'PPT 模板加载失败',
      operationFailed: '操作失败',
      name: '模板',
      mode: '模式',
      brandMode: '品牌模板',
      fixedMode: '固定结构',
      version: '版本',
      structure: '结构',
      structureSummary: '{{slides}} 示例页 / {{layouts}} 布局',
      pendingAnalysis: '待分析',
      businessData: '业务数据',
      unbound: '未绑定',
      status: '状态',
      published: '已发布',
      archived: '已归档',
      draft: '草稿',
      actions: '操作',
      publish: '发布',
      dataBinding: '数据绑定',
      bindAssistant: '绑定助手',
      more: '更多',
      archive: '归档',
      setOrgDefault: '设为企业默认',
      orgDefaultSaved: '企业默认模板已更新',
      orgDefault: '企业默认',
      created: '模板已创建，请检查分析结果后发布',
      profileSaved: '业务数据绑定已保存',
      assistantBound: '助手默认模板已绑定',
      versionUploaded: '新版本已上传，请重新发布',
      publishTitle: '发布“{{name}}”v{{version}}',
      publishWarning: '结构警告：{{warnings}}',
      publishHint: '发布后可在工作台选择并用于正式生成。',
      publishWithWarnings: '接受警告并发布',
      publishTemplate: '发布模板',
      publishedSuccess: '模板已发布',
      archiveTitle: '归档“{{name}}”',
      archiveHint: '归档后不能用于新生成，历史 PPT 仍保留模板版本引用。',
      archiveTemplate: '归档模板',
      archivedSuccess: '模板已归档',
      cancel: '取消',
      currentVersion: '当前版本',
      canvas: '画布',
      templateStructure: '模板结构',
      templateStructureSummary: '{{masters}} 母版 / {{layouts}} 布局 / {{slides}} 示例页',
      placeholders: '占位符',
      unresolved: '未识别',
      warnings: '结构警告',
      none: '无',
      uploadVersion: '上传新版本',
      downloadSource: '下载源模板',
      downloadSourceFailed: '源模板下载失败',
      createTitle: '上传 PPT 模板',
      createAction: '分析并创建模板',
      templateGuidance:
        '固定模板应使用 PowerPoint 母版、布局和命名占位符；系统会分析全部结构并在发布前检查。',
      templateName: '模板名称',
      templateNameRequired: '请输入模板名称',
      description: '使用说明',
      templateMode: '模板模式',
      brandModeHint: '品牌模板：保持视觉风格，AI 选择合适页型',
      fixedModeHint: '固定结构：严格保持页序和占位符职责',
      scope: '适用范围',
      shared: '企业共享',
      owner: '仅自己',
      businessProfile: '业务数据场景（可选）',
      pptxFile: 'PPTX 文件',
      choosePptx: '选择 PPTX 文件',
      choosePptxRequired: '请选择 PPTX 模板文件',
      profileTitle: '配置业务数据',
      saveBindings: '保存数据绑定',
      profilePlaceholder: '选择标准业务数据场景',
      callsBeforeGeneration: '生成前将调用：{{bindings}}',
      bindingTitle: '绑定助手默认模板',
      saveBinding: '保存绑定',
      bindingHint: '助手生成 PPT 时默认使用“{{name}}”；用户在对话中显式选择模板时会覆盖此绑定。',
      selectAssistant: '选择助手',
      generationHistory: '生成记录与质量追溯',
      historyLoadFailed: 'PPT 生成记录加载失败',
      historyEmpty: '暂无 PPT 生成记录',
      generatedOn: '生成时间',
      usedTemplate: '模板版本',
      nativeMode: '智能排版（未使用固定模板）',
      qualityTier: '质量通道',
      qualityTiers: { native: '原生高质量', template: '模板生成', fallback: '基础降级' },
      generationStatuses: {
        planning: '规划中',
        generating: '生成中',
        completed: '已完成',
        failed: '失败',
      },
      refresh: '刷新',
      download: '下载',
      downloadFailed: 'PPT 下载失败',
    },
    assistantDefinitionForm: {
      reasoning: {
        label: '推理强度（可选）',
        tooltip: '只展示当前官方模型支持的强度；不选择时使用模型默认值。',
        default: '模型默认',
        panoramaActive: '报告链路已生效',
        maxHelp: '适合跨表研究、业务归因和管理报告；运行时间与 Token 消耗更高。',
        levels: {
          minimal: 'minimal（最快）',
          low: 'low（低）',
          medium: 'medium（标准）',
          high: 'high（高）',
          xhigh: 'xhigh（很高）',
          max: 'max（最强分析）',
        },
      },
      mcp: {
        label: 'MCP',
        tooltip: '选择当前助手可使用的 MCP；全局审批与启停仍在 MCP 管理中完成。',
        placeholder: '选择要关联到当前助手的 MCP（可多选）',
        status: { enabled: '已启用', disabled: '已停用', pending: '待审', blocked: '已拉黑' },
      },
      plugins: {
        label: '插件',
        tooltip: '选择服务器上已安装并启用的 Codex 插件；仅对当前助手生效。',
        placeholder: '选择要为此助手启用的插件（可多选）',
        codexOnly: '仅 Codex 运行时支持助手级插件',
      },
    },
    brainParameterSettings: {
      title: '参数配置',
      subtitle: '维护 Agent 平台运行所需的全局非敏感参数。',
      tabs: {
        flowParameters: '流程参数',
        interfaceRoutes: '接口路由',
      },
      flow: {
        cardTitle: 'OA 流程模版',
        sourceNote:
          'OA 模版 ID 和名称同步自 EKP.KM_REVIEW_TEMPLATE；流程负责人、审批节点和节点审批人在 CREST 中维护，同步时会保留；关联工作流和 API 从智能体编排实时同步。',
        count: '{{count}} 个流程',
        filteredCount: '当前显示 {{count}} 条',
        sequence: '序号',
        flowId: '模版ID',
        crestTemplateName: 'CREST模版名称',
        oaTemplateName: 'OA模版名称',
        owner: '流程负责人',
        ownerEditLabel: '设置流程 {{name}} 的负责人',
        selectOwner: '选择流程负责人',
        unassigned: '未配置负责人',
        approvalNodes: '审批节点',
        nodeCount: '{{count}} 个节点',
        nodeSequence: '顺序',
        nodeName: '节点名称',
        nodeNameEditLabel: '编辑审批节点 {{name}}',
        nodeApprovers: '节点审批人',
        nodeApproverEditLabel: '设置节点 {{name}} 的审批人',
        selectApprovers: '选择节点审批人（可多选）',
        noApprovers: '未配置审批人',
        noNodes: '暂未配置审批节点',
        addNode: '添加审批节点',
        newNodeName: '新审批节点',
        deleteNode: '删除审批节点 {{name}}',
        detailTitle: '流程详情',
        associatedWorkflow: '关联工作流',
        associatedApi: '关联 API',
        webhookApi: 'Webhook API',
        notAssociated: '未关联工作流',
        active: '生效中',
        inactive: '未生效',
        noActiveWorkflow: '暂无生效工作流',
        noWebhookApi: '生效工作流未发布 Webhook',
        associationLoadFailed: '工作流关联信息暂不可用，OA 模版参数仍可正常维护。',
        crestNameEditLabel: '编辑流程 {{id}} 的 CREST 模版名称',
        actions: '操作',
        searchPlaceholder: '搜索模版 ID、OA 名称或 CREST 名称',
        addPlaceholder: '输入 32 位模版 ID',
        addNamePlaceholder: '输入 OA 模版名称',
        add: '添加',
        deleteLabel: '删除流程 ID {{id}}',
        save: '保存配置',
        saveSuccess: '流程参数已保存',
        saveFailed: '流程参数保存失败',
        invalidId: '模版 ID 必须是 32 位十六进制字符串',
        invalidName: 'OA 模版名称和 CREST 模版名称均不能为空',
        duplicateId: '该模版 ID 已在配置中',
        loadFailed: '流程参数加载失败',
        loadFailedDescription: '无法读取流程参数，请检查服务和数据库迁移状态。',
        retry: '重新加载',
      },
      flowWorkspace: {
        title: '流程',
        subtitle: '查看当前登录用户负责或参与的 OA 流程模板，并展开审批节点与审批人明细。',
        owned: '我负责的（{{count}}）',
        participated: '我参与的（{{count}}）',
        search: '搜索流程名称、负责人或模版 ID',
        empty: '当前没有符合条件的流程',
        loadFailed: '流程列表加载失败',
      },
      interfaceRoute: {
        pageTitle: '接口路由',
        pageSubtitle: '管理 Agent 平台对外接口、请求校验规则和生效工作流路由。',
        cardTitle: '对外接口路由',
        descriptionText:
          '外部系统无需登录或 API Key，直接向已发布的 POST 地址提交 JSON；平台将按路由字段自动转发。',
        create: '新建接口路由',
        createTitle: '新建接口路由',
        editTitle: '编辑接口路由',
        formSubtitle: '配置路由字段及请求、返回参数；支持粘贴 JSON 自动生成参数定义。',
        key: '路由 Key',
        keyPlaceholder: '如 oa-approval-route',
        keyRequired: '请输入路由 Key',
        keyPattern: '小写字母开头，2-40 位小写字母、数字或连字符',
        postAddress: 'POST 地址',
        postAddressHint: '编辑地址中间的路由 Key；发布后外部系统将通过此地址调用。',
        postAddressPublishedHint: '编辑路由 Key 后，当前 POST 地址将立即失效，请同步更新调用方。',
        name: '接口名称',
        nameRequired: '请输入接口名称',
        description: '接口说明',
        requestSchema: '请求 JSON Schema',
        requestSchemaHint: '用于约束外部系统提交的 JSON 请求体。',
        responseSchema: '返回 JSON Schema',
        requestParameters: '请求参数配置',
        responseParameters: '返回参数配置',
        schemaRequired: '请输入请求 JSON Schema',
        invalidSchema: '请求 JSON Schema 必须是合法的 JSON 对象',
        invalidResponseSchema: '返回参数必须是合法的 JSON 对象，请检查后重试',
        routingField: '路由字段',
        routingFieldHint: '每次请求读取该字段值，并到参数配置表查询对应的工作流和 Webhook URL。',
        routingFieldRequired: '请输入用于路由的请求字段路径',
        routingRules: '参数路由规则',
        fieldPathPlaceholder: '请求参数路径，如 data.type',
        operator: '匹配方式',
        matchValue: '匹配值',
        target: '目标工作流 Webhook',
        targetRequired: '请选择目标工作流 Webhook',
        removeRule: '删除第 {{index}} 条规则',
        addRule: '添加路由规则',
        save: '保存',
        cancel: '取消',
        status: '发布状态',
        published: '已发布',
        unpublished: '未发布',
        publicUrl: 'POST 地址',
        publishToCreateUrl: '发布后生成 POST 地址',
        requestRules: '参数关联',
        viewRules: '查看（{{count}} 条）',
        calls: '调用次数',
        actions: '操作',
        edit: '编辑',
        test: '测试',
        testTitle: '测试接口路由：{{name}}',
        testSubtitle: '输入 JSON 请求体，查看目标 Agent 工作流返回的输出内容。',
        testSideEffectWarning: '测试会真实触发目标工作流及其输出 API，请使用测试数据。',
        testRequestBody: '请求 JSON',
        runTest: '发起测试',
        testResponse: 'Agent 输出 API 响应（{{duration}} ms）',
        testInvalidJson: '请输入合法的 JSON 对象后再测试',
        testSuccess: '路由测试成功',
        testFailed: '路由测试失败',
        publish: '发布',
        unpublish: '取消发布',
        unpublishConfirm: '取消发布后外部 URL 将不可调用，是否继续？',
        rulesTitle: '参数配置关联详情',
        templateId: '模板 ID',
        workflowTaskId: '工作流任务 ID',
        workflowName: '工作流名称',
        webhookUrl: 'Webhook URL',
        defaultRule: '默认规则',
        loadFailed: '接口路由加载失败',
        retry: '重新加载',
        saveSuccess: '接口路由已保存',
        saveFailed: '接口路由保存失败',
        publishSuccess: '接口路由已发布',
        unpublishSuccess: '接口路由已取消发布',
        actionFailed: '接口路由操作失败',
        operators: {
          equals: '等于',
          in: '属于列表',
          contains: '包含',
          exists: '存在',
          default: '默认',
        },
      },
    },
    workflowBusinessForm: {
      title: '业务表单注册',
      refresh: '刷新',
      register: '注册业务表单',
      edit: '编辑',
      save: '保存注册',
      loadFailedTitle: '业务表单注册暂不可用',
      loadFailedDescription: '无法读取业务表单契约，请稍后重试。',
      retry: '重试',
      empty: '暂无业务表单注册',
      saveSuccess: '业务表单注册已保存',
      saveFailed: '业务表单注册保存失败',
      invalidJson: '{{field}}必须是合法的 JSON 对象',
      businessType: '业务类型',
      businessTypeHint: '使用“业务域.实体”格式，例如 crm.account',
      name: '名称',
      domain: '业务域',
      createRoute: '业务入口',
      viewRoute: '详情路由',
      businessKeyRule: '业务键规则',
      conditionFields: '流程字段白名单',
      conditionFieldsHint: '使用英文逗号分隔允许进入流程条件和快照的字段',
      status: '状态',
      enabled: '启用',
      disabled: '停用',
      startMode: '发起方式',
      workflowCenter: '允许从流程中心发起',
      businessSystemOnly: '仅允许从业务系统发起',
      businessSystemOnlyShort: '业务系统发起',
      formContractVersion: '契约版本',
      allowedActions: '允许的业务动作',
      inputSchema: '输入 JSON Schema',
      snapshotSchema: '业务快照 JSON Schema',
      advancedContract: '高级表单契约',
      operation: '操作',
      systemOnlyTitle: '请从业务系统提交审批',
      systemOnlyDescription:
        '该流程使用 CRM 业务表单。客户或商机必须先在 CRM 中完成业务校验，再通过记录上的“提交审批”动作发起。',
      goToBusinessSystem: '前往 {{name}}',
      startApproval: '发起审批',
    },
    crmApproval: {
      title: '流程中心审批',
      processing: '审批处理',
      workflowCenter: '流程中心',
      currentNode: '当前节点',
      pendingAssignees: '当前审批人',
      updatedAt: '最近更新',
      timeline: '审批动态',
      openWorkflow: '查看流程实例',
      refresh: '刷新审批动态',
      loadFailed: '流程中心审批状态暂时无法加载，CRM 业务数据不受影响。',
      noActivities: '流程已提交，正在等待流程引擎返回动态。',
      assigneeUnavailable: '用户已停用或当前不可见',
      status: {
        START_REQUESTED: '等待启动',
        RUNNING: '审批中',
        CANCELLATION_REQUESTED: '正在撤回',
        APPROVED: '已通过',
        REJECTED: '已拒绝',
        CANCELLED: '已取消',
        START_FAILED: '启动失败',
      },
      events: {
        'workflow.instance.started': '流程已启动',
        'workflow.task.created': '审批任务已创建',
        'workflow.task.completed': '审批任务已处理',
        'workflow.instance.completed': '流程已结束',
        'workflow.instance.cancelled': '流程已取消',
      },
      actions: {
        pending: '待审批',
        approve: '通过',
        approved: '通过',
        reject: '拒绝',
        rejected: '拒绝',
        cancelled: '取消',
      },
    },
    crmApprovalPeople: {
      title: '审批人员列表',
      subtitle: '按人员汇总审批流程、可审批组织和通知方式，共 {{total}} 人',
      approverName: '审批人员名称',
      status: '状态',
      active: '已生效',
      inactive: '未生效',
      approvalFlows: '参与的审批流程',
      approvableOrganizations: '可审批的组织',
      globalScope: '全部组织',
      notificationTypes: '通知类型',
      notification: {
        oa: 'OA通知',
        email: '邮件通知',
        system: 'CRM系统通知',
        station: 'CRM系统通知',
        dingtalk: '钉钉机器人通知',
      },
      createdAt: '创建时间',
      updatedAt: '修改时间',
      searchPlaceholder: '搜索审批人员、流程或组织',
      approvalFlowFilter: '审批流程筛选',
      allApprovalFlows: '全部审批流程',
      organizationFilter: '组织范围筛选',
      allOrganizationScopes: '全部组织范围',
      specificOrganizations: '指定组织',
      statusFilter: '状态筛选',
      allStatuses: '全部状态',
      refresh: '刷新',
      total: '共 {{count}} 人',
      loadFailed: '审批人员列表加载失败，请刷新后重试。',
      loadFailedWithReason: '审批人员列表加载失败：{{reason}}',
    },
    crmLiteApproval: {
      designerTitle: 'CRM 轻量审批流程',
      designerSubtitle: '在 CRM 内配置审批链路；与独立 Flowable 流程中心互不影响。',
      inboxTitle: 'CRM 轻量审批待办',
      inboxSubtitle: '处理由 CRM 内部轻量流程产生的审批任务。',
      name: '流程名称',
      code: '流程编码',
      description: '说明',
      businessType: '业务类型',
      associatedBusiness: '关联业务',
      associatedBusinessRequired: '请选择关联业务。',
      associatedBusinessPlaceholder: '选择提交动作',
      associatedBusinessHint: '业务提交时会按该动作匹配当前已发布的审批流程。',
      associatedBusinessUnset: '未配置',
      businessActions: {
        ACCOUNT_OVERSEAS_SUBMIT: '海外客户提交',
        OPPORTUNITY_OVERSEAS_SUBMIT: '海外商机提交',
        POC_OVERSEAS_SUBMIT: '海外 POC 提交',
        ACCOUNT_DOMESTIC_SUBMIT: '国内客户提交',
        OPPORTUNITY_DOMESTIC_SUBMIT: '国内商机提交',
        POC_DOMESTIC_SUBMIT: '国内 POC 提交',
      },
      engineType: '审批引擎',
      engineRequired: '请选择审批引擎。',
      internalEngine: 'CRM 内部审批引擎',
      internalEngineShort: 'CRM 内部',
      internalEngineHint: '在 CRM 中可视化编排并由轻量运行时执行',
      externalEngine: '外部 Flowable 审批引擎',
      externalEngineShort: '外部 Flowable',
      externalEngineHint: '引用流程中心已部署的 Flowable 流程',
      externalEngineNotice:
        'CRM 仅保存外部流程定义引用；发布和执行通过 workflow-api 完成，不会修改独立 Flowable 项目。',
      externalProcess: 'Flowable 流程定义',
      externalProcessRequired: '请选择 Flowable 流程定义。',
      externalProcessHint: '保存流程 key，实际启动时使用 Flowable 中最新部署的对应定义。',
      externalProcessPlaceholder: '搜索流程名称或 key',
      externalCatalogFailed: '无法读取 Flowable 流程目录；可输入已知的流程 key，发布时会再次校验。',
      notificationConfig: '通知配置',
      notificationRequired: '请至少选择一种通知方式。',
      notificationHint: '通知会在审批任务到达审批人时发送；钉钉机器人需先完成平台侧机器人配置。',
      notificationChannel: {
        oa: 'OA通知',
        email: '邮件通知',
        system: 'CRM系统通知',
        dingtalk: '钉钉机器人通知',
      },
      version: '版本',
      statusLabel: '状态',
      updatedAt: '更新时间',
      actions: '操作',
      edit: '编辑',
      publish: '发布',
      disable: '停用',
      refresh: '刷新',
      create: '新建流程',
      createTitle: '新建轻量审批流程',
      editTitle: '编辑轻量审批流程',
      saveDraft: '保存草稿',
      approvalNode: '审批节点',
      nodeName: '节点名称',
      approvalMode: '多人审批方式',
      anyMode: '任意一人通过',
      allMode: '所有人通过',
      assigneeIds: '审批人用户 ID',
      assigneeIdsHint: '首期使用 CRM systemuserid；输入后按回车添加。',
      assigneeIdsPlaceholder: '输入用户 UUID',
      selectApprover: '选择审批人',
      selectedApprovers: '选择审批人',
      selectApproverPlaceholder: '按姓名或邮箱搜索',
      addApprover: '增加审批人',
      removeApprover: '删除审批人',
      approverRequired: '请选择审批人。',
      approverMinimum: '至少需要一名审批人。',
      duplicateApprover: '不能重复选择同一审批人。',
      approverEmail: '邮箱：{{email}}',
      emailMissing: '未配置邮箱',
      approverCatalogFailed: '审批人目录加载失败，请刷新后重试。',
      addApprovalNode: '添加审批节点',
      addConditionNode: '添加条件分支',
      addConditionAfterStart: '在开始节点后添加条件分支',
      addParallelAfterStart: '在开始节点后添加并行审批',
      addBranchAfterStart: '从开始节点添加审批分支',
      startNode: '开始节点',
      startNodeHint: '审批发起后从此处进入流程，可先按发起人或业务数据进行条件判断。',
      startMultipleTargetsHint: '开始节点可以直接连接多个后续审批或条件节点。',
      canvasConnectionHint: '首次添加条件会放在开始节点后；继续添加时会自动横向生成同级分支。',
      parallelApprovalHint: '已选择审批节点；再次添加审批节点将创建并行分支。',
      starterDepartment: '发起人所在部门',
      departmentLevel: '组织部门层级',
      departmentLevelPlaceholder: '选择发起人部门的组织层级',
      departmentValuePlaceholder: '选择该层级的组织部门',
      departmentLevels: {
        ROOT: '根组织',
        LEVEL_1: '1级组织',
        LEVEL_2: '2级组织',
        LEVEL_3: '3级组织',
        LEVEL_4: '4级组织',
      },
      starterUser: '发起人身份',
      starterRegion: '发起人大区归属',
      businessField: '业务字段',
      opportunityForecastAmount: '商机预测金额',
      forecastAmountPlaceholder: '输入预测金额',
      conditionSource: '条件对象',
      conditionBranches: '条件分支',
      conditionCompare: '比较方式',
      conditionValue: '条件值',
      conditionValuePlaceholder: '100 或 a,b',
      conditionCatalogFailed: '条件选项加载失败，请刷新后重试。',
      addCondition: '添加条件',
      removeCondition: '删除条件',
      matchedTarget: '匹配后进入',
      unmatchedTarget: '未匹配时进入',
      conditionOperator: {
        EQ: '等于',
        NE: '不等于',
        GT: '大于',
        GTE: '大于等于',
        LT: '小于',
        LTE: '小于等于',
        IN: '属于列表',
        CONTAINS: '包含',
        NOT_CONTAINS: '不包含',
      },
      removeNode: '删除节点',
      moveUp: '上移节点',
      moveDown: '下移节点',
      endNodeHint: '所有审批节点完成后，流程自动进入结束节点。',
      loadFailed: '流程定义加载失败，请刷新后重试。',
      saved: '流程草稿已保存。',
      saveFailed: '流程保存失败，请检查字段后重试。',
      publishConfirm: '发布后新发起的审批将使用这个版本，确定发布吗？',
      published: '流程版本已发布。',
      disableConfirm: '停用后不能再发起新审批，确定停用吗？',
      subject: '审批主题',
      currentNode: '当前节点',
      receivedAt: '收到时间',
      approve: '通过',
      reject: '拒绝',
      approveTitle: '通过审批任务',
      rejectTitle: '拒绝审批任务',
      commentPlaceholder: '填写审批意见（可选）',
      approved: '审批任务已通过。',
      rejected: '审批任务已拒绝。',
      inboxLoadFailed: '轻量审批待办加载失败，请刷新后重试。',
      status: { DRAFT: '草稿', PUBLISHED: '已发布', DISABLED: '已停用' },
    },
    workbench: {
      assistantStudio: '设置',
      assistantStudioHint: '集中管理数字助手、监督执行任务，并配置个人技能与知识库。',
      assistantSkills: '技能',
      assistantKnowledge: '知识库',
      myAssistants: '助手',
      taskCenter: '任务',
      taskCenterHint: '查看进行中、待介入和最近完成的助手任务。',
      crmWriteAccountTitle: '创建客户前请核对必填信息',
      crmWriteOpportunityTitle: '创建商机前请核对必填信息',
      crmWriteAiPrefill: 'AI 已预填',
      crmWriteHint:
        '选项和关联记录来自当前 CRM 元数据及你的权限范围；确认后仍由 CRM API 做最终校验。',
      pptxPagination: '幻灯片翻页',
      previousSlide: '上一页',
      nextSlide: '下一页',
      slidePage: '第 {{current}} / {{total}} 页',
      pptxPreview: 'PowerPoint 预览',
      addContent: '添加文件、文件夹或任务类型',
      addFiles: '添加文件',
      addFolder: '添加文件夹',
      secureDocumentsClosed: '开启企业文档加解密',
      secureDocumentsOpen: '企业文档加解密已开启',
      secureDocumentsChecking: '正在验证企业内网…',
      secureDocumentsEnabled: '已连接企业内网；上传附件将先解密，生成文件下载时将自动加密',
      secureDocumentsUnavailable: '非企业内网无法使用该功能',
      secureDownload: '加密下载',
      taskType: '任务类型',
      taskTypeQuestion: '智能问答',
      taskTypeWorkflow: '流程处理',
      taskTypeRisk: '风险预警',
      taskTypeAgent: '智能体任务',
      copyMessage: '复制消息',
      editMessage: '编辑消息',
      editingMessage: '正在编辑已发送消息；修改后将作为新消息发送',
      cancelEditMessage: '取消编辑消息',
      presentationTemplate: 'PPT 模板',
      presentationTemplateAria: '选择 PPT 生成模板',
      saveAttachmentToKnowledgeBase: '保存到知识库',
      saveAttachmentHint: '复用当前对话原文件建立长期知识，保存前会检查质量、重复和敏感信息。',
      saveToKnowledgeBase: '保存到知识库',
      linkExistingKnowledge: '关联已有文档',
      savedToKnowledgeBase: '已保存到知识库',
      targetKnowledgeBase: '目标知识库',
      noPromotionTarget: '暂无可管理的知识库，请先新建个人知识库。',
      createPersonalKnowledgeBase: '新建个人知识库',
      knowledgeBasesLoadFailed: '知识库加载失败，请稍后重试。',
      attachmentSavedToKnowledgeBase: '文档已保存并建立检索索引。',
      attachmentAlreadyInKnowledgeBase: '相同内容已存在，已关联已有文档。',
      attachmentSaveFailed: '保存到知识库失败，请检查文档状态后重试。',
      preflightRunning: '正在检查文档…',
      preflightFailed: '文档检查失败，请确认格式和权限后重试。',
      preflightPassed: '质量检查通过，可以保存到知识库。',
      retryRun: '重新运行',
      modelConnectionInterrupted:
        '模型连接暂时中断，本次请求尚未确认执行任何操作。请点击“重新运行”再试一次。',
      duplicateKnowledge: '目标知识库已有相同内容：{{name}}',
      possibleKnowledgeVersion: '发现同名文档，可能是已有知识的新版本',
      acknowledgeSensitiveKnowledge: '我已确认文档的访问范围，并同意保存可能包含的敏感信息。',
      knowledgeWarning: {
        short_content: '正文较短，可能缺少足够的可检索内容。',
        credential: '检测到 {{count}} 处疑似密钥、口令或令牌，请谨慎扩大访问范围。',
        personal_id: '检测到 {{count}} 处疑似身份证号码，请确认合规性。',
        email: '检测到 {{count}} 个邮箱地址。',
        phone: '检测到 {{count}} 个手机号码。',
      },
    },
    orchestrationNode: {
      tool: '工具',
      selectTool: '请选择工具',
      highRisk: '高风险',
      destructiveTool: '高风险工具：执行前必须人工确认',
      toolArguments: '工具参数',
      toolArgumentsHint:
        '支持 {{message}}、{{output}} 和触发变量；数字、布尔或复杂占位符可在高级 JSON 中配置。',
      schemaMode: '表单',
      jsonMode: '高级 JSON',
      toolArgumentsJson: '参数 JSON',
      noToolArguments: '该工具没有需要配置的参数。',
      invalidJsonObject: '工具参数必须是有效的 JSON 对象',
      invalidJsonValue: '请输入有效的 JSON 值',
      requiredArgument: '请填写必填参数',
      boundAgent: '绑定智能体',
      boundAgentHint: '该节点执行时使用此智能体（含其模型组、技能和工具）',
      selectAgent: '选择智能体',
      agentDisabled: '已停用',
      agentUnavailable: '不可用',
      acceptFileInput: '接收文件输入',
      multimodalInput: '多模态文件输入',
      multimodalInputHint:
        '图片会直接交给支持视觉的模型；文档及其他文件按原文件交给支持附件的运行时。实际能力取决于智能体绑定的模型和运行时。',
      fileInputVariable: '文件变量名',
      fileInputVariableHint: '绑定 Webhook 或上游节点输出的文件列表，默认使用 files。',
      fileInputVariableRequired: '请输入文件变量名',
      llmModel: '模型',
      llmModelRequired: '请选择模型',
      llmModelPlaceholder: '选择模型组',
      llmDefaultModel: '默认模型组',
      llmContext: '上下文',
      llmContextHint: '从工作流变量读取上下文，支持点号路径；留空时使用上游输出。',
      llmContextPlaceholder: '设置变量值，例如 content 或 payload.form',
      llmMessagePlaceholder:
        '输入提示词；支持 {{message}}、{{output}} 和 {{变量路径}} 插入工作流数据。',
      llmMessageRequired: '请输入消息内容',
      llmAddMessage: '添加消息',
      llmDeleteMessage: '删除第 {{index}} 条消息',
      llmVision: '视觉',
      llmVisionHint: '开启后会把工作流附件信息加入模型上下文；实际视觉能力取决于模型。',
      llmSeparateReasoning: '启用推理标签分离',
      llmSeparateReasoningHint: '模型返回推理内容时，单独写入 llm_reasoning 变量。',
      llmOutputVariables: '输出变量',
      llmStructuredOutput: '结构化输出',
      llmResponseSchema: '响应 JSON Schema',
      llmResponseSchemaInvalid: '响应格式必须是有效的 JSON Schema 对象',
      llmTextOutputHint: '默认输出文本，并记录实际模型和 Token 用量。',
      llmFailureRetry: '失败时重试',
      llmMaxAttempts: '最大尝试次数',
      llmRetryDisabledHint: '模型调用失败后立即进入异常处理。',
      llmExceptionStrategy: '异常处理',
      llmExceptionNone: '无（终止流程）',
      llmExceptionContinue: '继续并保留上游输出',
      llmExceptionFallback: '使用兜底文本继续',
      llmFallbackText: '兜底文本',
      llmFallbackTextRequired: '请输入模型失败时使用的兜底文本',
      llmModelParameters: '模型参数',
      llmTemperature: '温度',
      llmTemperatureHint: '数值越高输出越发散，越低越稳定。',
      llmNextStepHint: '下一步请在画布中从该节点右侧连接桩连接目标节点。',
      webhookAcceptFiles: '接收上传文件',
      webhookMultipartTitle: 'multipart/form-data 文件输入',
      webhookMultipartHint:
        '文件放入配置的字段；复杂 JSON 可放入 payload 字段。文件会安全落存，工作流内只传文件引用。',
      webhookOaFormHint:
        'OA 表单正文可放入 text 或 content 字段；多个远程文件地址可放入 file_urls 数组。',
      webhookResponseBody: '响应 JSON 模板',
      webhookRequestBodySchema: '请求体 JSON Schema',
      webhookRequestBodySchemaHint:
        '定义并校验调用方请求格式；标准输出为 content 和 file，file 始终是 URL 数组。',
      webhookRequestBodySchemaInvalid: '请求体格式必须是有效的 JSON Schema 对象',
      webhookResponseBodyHint:
        '支持 {{request_id}}、{{workflow_id}}、{{oa_id}}、{{file_count}} 和 {{payload}}。',
      webhookResponseBodyInvalid: '响应模板必须是有效的 JSON 对象',
      webhookEndpointSection: 'Webhook 入口',
      webhookUrl: 'Webhook URL',
      webhookPublishedUrlHint: '保存并发布工作流后，外部系统可直接向此地址发起 POST 请求。',
      webhookUrlSecretHint: '调用密钥已包含在 URL 中，无需配置额外请求头。',
      webhookContentType: '内容类型',
      webhookHeaderParameters: 'Header 参数',
      webhookRequired: '必填',
      webhookRequestParameters: '请求体参数',
      webhookResponseParameters: '响应参数',
      webhookPasteJson: '粘贴 JSON 生成',
      webhookPasteJsonHint:
        '粘贴一个完整 JSON 对象，系统会格式化内容并自动推断字段路径、类型、必填项和嵌套结构。',
      webhookJsonSample: 'JSON 样例',
      webhookJsonSamplePlaceholder: '粘贴 JSON 对象，支持代码块或经过字符串转义的 JSON',
      webhookGenerateParameters: '解析并生成参数',
      webhookCancelGenerate: '取消',
      webhookJsonGenerated: '已根据 JSON 生成参数定义',
      webhookJsonInvalid: '无法解析 JSON，请确认粘贴内容是有效的 JSON 对象',
      webhookNoParameters: '粘贴 JSON 后自动生成参数',
      webhookParameterName: '变量名',
      webhookParameterType: '类型',
      webhookParameterRequired: '必填',
      webhookParameterExample: '示例',
      webhookResponseExample: '响应体样例',
      webhookToggleRequired: '切换参数 {{name}} 的必填状态',
      webhookAdvancedDefinition: '高级 JSON 定义',
      webhookRequestExample: '请求体样例',
      webhookJsonSchema: 'JSON Schema',
      webhookJsonSchemaInvalid: '参数定义必须是有效的 JSON Schema 对象',
      webhookInputMapping: '输入映射',
      webhookInputPath: '输入字段路径',
      webhookInputPathHint: '从 JSON 请求体读取文本，支持点号路径；留空则使用完整请求体。',
      webhookTextTemplate: '输入映射模板',
      webhookTextTemplateHint: '支持 {{input}} 和 {{payload}}。',
      webhookTextTemplateRequired: '请输入输入映射模板',
      webhookResponseSection: '响应',
      webhookResponseStatus: '状态码',
      webhookOutputVariables: '输出变量',
      webhookSecuritySection: '调用安全',
      webhookSecretWarning: '密钥由系统自动生成并包含在调用地址中，请只提供给可信调用方。',
      webhookSecret: 'Webhook 密钥',
      webhookSecretHint: '密钥默认隐藏；点击小眼睛可查看明文。',
      webhookSecretRequired: '系统尚未生成 Webhook 密钥，请重新添加节点',
      webhookSecretPlaceholder: '系统自动生成调用密钥',
      outputApiRequestTab: '业务请求',
      outputApiTokenTab: 'Token 获取',
      outputApiTokenHint:
        '先调用认证接口获取 Token，再自动写入业务请求头。Client Secret 只通过环境变量引用，不进入工作流配置。',
      outputApiTokenEnabled: '启用 Token 获取',
      outputApiEndpoint: '目标接口地址',
      outputApiEndpointRequired: '请输入目标接口地址',
      outputApiBaseUrlEnv: '基础地址环境变量',
      outputApiBaseUrlEnvHint: '目标为相对路径时必填，例如 OA_API_BASE_URL。',
      outputApiMethod: '请求方法',
      outputApiTimeoutSeconds: '请求超时（秒）',
      outputApiBodyTemplate: 'JSON 请求体模板',
      outputApiBodyTemplateHint:
        '支持 {{outputJson}}、{{messageJson}}、{{runIdJson}} 和工作流变量的 Json 占位符。',
      outputApiBodyTemplateRequired: '请输入 JSON 请求体模板',
      outputApiHeaders: '普通请求头（JSON）',
      outputApiHeadersInvalid: '请求头必须是有效的 JSON 对象',
      outputApiRequestContract: '请求参数定义',
      outputApiResponseContract: '返回参数定义',
      outputApiLegacyAuthEnv: '固定认证值环境变量',
      outputApiLegacyAuthEnvHint:
        '兼容无需换取 Token 的接口；只保存环境变量名，密钥值不进入工作流。',
      outputApiTargetHeader: '目标认证请求头',
      outputApiTokenEndpoint: 'Token 接口地址',
      outputApiTokenEndpointRequired: '请输入 Token 接口地址',
      outputApiTokenBodyTemplate: 'Token JSON 请求体模板',
      outputApiTokenBodyTemplateHint:
        '使用 {{clientSecretJson}} 安全插入环境变量中的密钥，禁止直接填写明文 Client Secret。',
      outputApiClientSecretRef: 'Client Secret 引用',
      outputApiClientSecretRefHint:
        '仅支持 env:VARIABLE_NAME；变量名必须加入 ORCHESTRATION_SECRET_ENV_ALLOWLIST。',
      outputApiClientSecretRefRequired: '请输入 Client Secret 环境变量引用',
      outputApiClientSecretRefInvalid: '格式必须为 env:VARIABLE_NAME',
      outputApiTokenValuePath: 'Token 字段路径',
      outputApiTokenTypePath: 'Token 类型字段路径',
      outputApiTokenRequestContract: 'Token 请求参数定义',
      outputApiTokenResponseContract: 'Token 返回参数定义',
      webhookFileField: '上传文件字段名',
      webhookFileFieldRequired: '请输入上传文件字段名',
      webhookFileVariable: '输出文件变量名',
      webhookFileVariableHint: '下游智能体节点通过该变量接收文件列表。',
      webhookFileVariableRequired: '请输入输出文件变量名',
      maximumFiles: '最多文件数',
      allowedFileTypes: '允许的文件类型',
      allowedFileTypesRequired: '请选择至少一种文件类型',
      fileTypeImage: '图片',
      fileTypeDocument: '文档',
      fileTypeAudio: '音频',
      fileTypeVideo: '视频',
      fileTypeOther: '其他',
      resourceDownloadTitle: '受治理的远程资源下载',
      resourceDownloadHint:
        '从 Webhook 数据字段读取一个地址或地址数组。仅允许访问服务端出口白名单中的域名，下载后只向下游传递文件引用。',
      resourceUrlPath: '资源地址字段路径',
      resourceUrlPathHint: '支持点号路径，例如 file_url、data.files 或 payload.data.file_url。',
      resourceUrlPathRequired: '请输入资源地址字段路径',
      resourceOutputVariable: '输出文件变量名',
      resourceMaximumFileMb: '单文件上限（MB）',
      resourceMaximumTotalMb: '文件总上限（MB）',
      resourceTimeoutSeconds: '下载超时（秒）',
      resourceRedirectLimit: '最大重定向次数',
      resourceFailureMode: '下载失败时',
      resourceFailureFail: '终止工作流',
      resourceFailureSkip: '跳过失败文件',
      resourceAuthorizationSecretRef: '认证 Secret 引用',
      resourceAuthorizationSecretRefHint:
        '可选，仅填写 env:VARIABLE；该环境变量还需加入编排 Secret 白名单。',
    },
    orchestrationCanvas: {
      nodeMenuMore: '更多节点操作：{{name}}',
      nodeMenuRun: '运行此步骤',
      nodeMenuReplace: '更换节点',
      nodeMenuCopy: '拷贝',
      nodeMenuDuplicate: '复制',
      nodeMenuDelete: '删除',
      nodeMenuHelp: '查看帮助文档',
      nodeMenuAbout: '关于',
      nodeMenuNoDescription: '该节点暂无补充说明。',
      nodeMenuCopySuccess: '节点配置已拷贝到剪贴板',
      nodeMenuCopyFailed: '无法访问剪贴板，请检查浏览器权限',
      nodeMenuDuplicateSuccess: '节点副本已创建',
      nodeMenuDeleteConfirmTitle: '删除节点“{{name}}”？',
      nodeMenuDeleteConfirmDescription: '节点及其关联连线将被删除，此操作将在保存草稿后生效。',
      nodeMenuHelpTitle: '“{{name}}”节点帮助',
      nodeCopySuffix: '（副本）',
      nodeReplaceTitle: '更换“{{name}}”节点',
      nodeReplaceSubtitle: '保留当前位置和关联连线，新节点将使用默认配置。',
      nodeReplaceTriggers: '触发器',
      nodeReplaceProcessors: '处理节点',
      nodeReplaceCurrent: '当前',
      nodeReplaceConfirm: '更换节点',
      nodeReplaceNoDescription: '暂无节点说明',
      nodeReplaceSuccess: '节点已更换，请配置新节点后保存草稿',
      nodeReplaceOptions: '可更换节点',
      canvasToolbar: '画布工具栏',
      openNodeLibrary: '添加节点',
      closeNodeLibrary: '关闭节点库',
      nodeLibraryTitle: '可用节点',
      nodeLibrarySearch: '搜索节点',
      nodeLibrarySearchPlaceholder: '搜索节点、智能体、工具…',
      nodeLibraryEmpty: '没有匹配的节点',
      nodeLibraryNoDescription: '暂无节点说明',
      nodeLibraryGroups: {
        start: '开始节点',
        logic: '逻辑转换',
        tools: '工具',
      },
      nodeKindLabels: {
        router: '路由',
        llm: 'LLM',
        agent: '智能体',
        tool: '工具',
        resource_download: '资源下载',
        reviewer: '结果审核',
        approval: '人工确认',
        subflow: '子工作流',
        user_input: '用户输入',
        schedule_trigger: '定时器触发器',
        webhook_trigger: 'Webhook 触发器',
        input_api: 'Webhook 触发器（旧）',
        database_query: '数据库查询',
        output_api: '输出 API',
        terminal: '终点',
      },
      classicValidationPassed: '校验通过',
      classicValidationFailed: '校验失败，请稍后重试',
      classicEditorHint:
        '画布默认处于编辑状态：点击节点配置，拖动连线增边、拖桩连节点，选中后按 Delete 删除；保存草稿后发布生效，虚线表示条件分支。',
      classicEditableDraft: '可编辑草稿',
      classicUnsaved: '未保存',
      classicAutoLayout: '自动布局',
      classicValidationResults: '校验结果',
      classicValidate: '校验',
      classicIssueCount: '（{{errors}} 错 / {{warnings}} 警）',
      classicSaveDraft: '保存草稿',
      classicPublishDraftConfirm: '发布当前草稿并重编译运行时编排图？',
      classicPublish: '发布',
      classicRevertDraftConfirm: '放弃草稿改动，回退到已发布图？',
      classicRevertDraft: '放弃草稿',
      classicValidationPassedNoIssues: '校验通过，无问题',
      classicError: '错误',
      classicWarning: '告警',
      draftSaved: '草稿已保存',
      saveFailed: '草稿保存失败，请检查节点配置',
      publishBlocked: '发布前校验未通过：{{details}}',
      published: '已发布，运行时编排图已更新',
      publishFailed: '发布失败，请稍后重试',
      reverted: '已回退到已发布图',
      revertFailed: '草稿回退失败，请稍后重试',
      v2Title: '强类型画布 V2',
      debug: '调试',
      graphDebugger: '图调试器',
      liveDebug: '实时调试',
      runHistory: '运行历史',
      selectHistoricalRun: '选择历史运行进行回放',
      historyLoadFailed: '历史运行加载失败',
      playTimeline: '播放时间轴',
      pausePlayback: '暂停回放',
      forkFromNode: '选择分叉节点',
      forkRun: '分叉重跑',
      forkStarted: '已创建安全分叉运行',
      reusedOutput: '复用来源输出',
      compareRuns: '运行对比',
      selectTwoRuns: '选择两个运行进行对比',
      leftRun: '运行 A',
      rightRun: '运行 B',
      outputChanged: '输出变化',
      yes: '是',
      no: '否',
      modelCostEstimation: '模型成本估算',
      inputCostPerMillion: '输入单价 / 百万 Token',
      outputCostPerMillion: '输出单价 / 百万 Token',
      costCurrency: '币种',
      modelCostHint: '留空表示不估算费用；已配置单价会按节点实际 Token 用量写入 Trace。',
      closeDebugger: '关闭图调试器',
      debugPanelResize: '调整调试侧栏宽度',
      debugDryRun: '草稿快照安全调试',
      debugDryRunHint:
        '本次运行绑定当前画布快照；工具、HTTP、输出 API 和人工确认仅生成预览，不执行真实副作用。',
      debugInputs: '工作流输入 JSON',
      debugBreakpoints: '断点节点',
      debugBreakpointsHint: '可选择一个或多个节点，运行前暂停',
      startDebug: '开始调试',
      pauseDebug: '暂停',
      continueDebug: '继续',
      stepDebug: '单步执行',
      pausedBeforeNode: '暂停在节点 {{nodeId}} 之前',
      refreshTrace: '刷新轨迹',
      debugFailed: '调试运行失败',
      debugNode: '调试此节点',
      nodeDebugTitle: 'V2 单节点调试',
      runNodeDebug: '运行此节点',
      nodeDebugIsolated: '隔离 dry-run',
      nodeDebugIsolatedHint:
        '仅执行当前节点，并使用下方 JSON 作为显式输入。工具、HTTP、输出 API、外部平台与代码节点只返回预览，不产生真实副作用；敏感值请继续使用 Secret Binding。',
      nodeDebugUnsupportedControl: '控制、分支或容器节点需要在完整工作流中调试',
      nodeDebugInputs: '节点输入 JSON',
      nodeDebugInputsInvalid: '节点输入必须是有效的 JSON 对象',
      noTrace: '启动调试后在此查看节点轨迹',
      traceDetails: '节点运行详情',
      traceInput: '输入',
      traceOutput: '输出',
      traceType: {
        'node.started': '运行中',
        'node.output': '已完成',
        'node.failed': '失败',
        'node.waiting_input': '等待输入',
      },
      runStatus: {
        running: '运行中',
        paused: '已暂停',
        completed: '已完成',
        failed: '失败',
        canceled: '已取消',
        terminated: '已终止',
        timed_out: '已超时',
        unknown: '未知',
      },
      v2LoadFailed: 'V2 画布加载失败',
      retry: '重新加载',
      searchNode: '搜索并定位节点',
      globalSearch: '搜索节点、变量、问题或评论',
      globalSearchGroups: {
        nodes: '节点',
        variables: '变量',
        issues: '校验问题',
        comments: '协作评论',
      },
      globalSearchCommentsFailed: '协作评论加载失败，其他搜索结果仍可使用',
      globalSearchNoCanvasTarget: '该结果没有可定位的画布节点',
      globalSearchVariableLocated: '已定位变量：{{name}}（{{type}}）',
      nodeDebugScope: '调试范围',
      nodeDebugScopeSingle: '仅当前节点',
      nodeDebugScopeDownstream: '当前节点及下游',
      nodeDebugDownstream: '下游范围 dry-run',
      nodeDebugDownstreamHint:
        '从当前节点开始执行所有可达下游；副作用节点强制 dry-run，范围外节点输出依赖会被拒绝。',
      nodeDebugWorkflowInputs: '工作流输入（JSON）',
      variableInspector: '变量检查',
      variableInspectorTitle: '变量检查器与数据血缘',
      variableInspectorSearch: '搜索变量、生产者、消费端或字段路径',
      variableInspectorSummary:
        '{{variables}} 个变量，{{mismatches}} 个类型冲突，{{unknown}} 个路径待确认',
      variableInspectorHint: '展开变量可查看生产者、所有消费端、深层路径和显式转换建议。',
      variableInspectorEmpty: '没有匹配的变量',
      variableInspectorProducer: '生产者',
      variableInspectorExternal: '工作流或环境',
      variableInspectorUnused: '当前变量没有消费端',
      variableInspectorPath: '字段路径',
      variableInspectorMismatchCount: '{{count}} 个冲突',
      variableInspectorUnknownCount: '{{count}} 个待确认',
      focusProducer: '定位生产节点',
      variableGroups: {
        workflow_input: '工作流输入',
        workflow: '流程变量',
        conversation: '会话变量',
        system: '系统变量',
        node: '节点输出',
        loop: '循环局部变量',
      },
      variableInspectorStatus: {
        compatible: '类型兼容',
        unknown: '路径类型待确认',
        mismatch: '类型冲突',
      },
      variableConversionSuggestion: {
        template_transform: '建议插入模板转换节点，显式生成 string 后再绑定。',
        code_sandbox: '建议插入代码沙箱节点，校验并显式转换为目标类型后再绑定。',
      },
      permissionImpact: '权限与数据影响',
      permissionImpactNone: '未发现外部数据访问或写入',
      permissionAccess: {
        read: '读取',
        write: '写入',
        destructive: '破坏性',
      },
      refreshPreview: '刷新迁移预览',
      previewOnly: 'V2 迁移预览',
      previewOnlyHint:
        '此视图由当前 V1 草稿确定性转换，用于检查强类型端口、数据绑定和发布错误；不会写入 Revision 或启用 V2。',
      previewUnavailableHint: '当前以只读迁移预览打开。原因：{{reason}}',
      v2FeatureDisabled: 'V2 功能开关尚未向当前用户启用',
      v2StorageMissing: '数据库能力尚未初始化：{{names}}',
      v2CapabilityUnknown: '无法确认 V2 能力状态，请检查 API 服务',
      storageCapability: {
        revisions: '不可变版本',
        releases: '发布记录',
        environments: '环境参数',
        comments: '协作评论',
        modelPricing: '模型费用',
        stepAttempts: '步骤重试记录',
      },
      revisionMode: 'V2 Revision 草稿',
      revisionModeHint:
        '端口连线会写入显式变量绑定；草稿可随时保存并创建不可变 Revision，完整强类型校验在发布时执行。',
      validationSummary: '{{errors}} 个错误 / {{warnings}} 个警告',
      validationIssues: 'V2 校验问题',
      validationPassed: 'V2 草稿校验通过',
      validationFailed: 'V2 草稿仍有错误，请从问题列表定位并修正',
      validationRequestFailed: 'V2 校验请求失败：{{error}}',
      editDraft: '编辑 V2 草稿',
      unsaved: '未保存',
      autoSaving: '自动保存中',
      autoSaved: '已自动保存',
      autoSaveFailed: '自动保存失败，请处理冲突或校验错误',
      publishRevision: '发布 Revision',
      publishRevisionConfirm: '发布当前 V2 Revision 并更新运行时版本？',
      v2Published: 'Revision {{revision}} 已发布',
      v2PublishFailed: 'V2 发布失败：{{error}}',
      publishGraphChanged: '发布期间画布又发生变化，已保存快照但未发布，请确认后重试',
      revisionStatus: {
        draft: '草稿',
        published: '已发布',
        archived: '已归档',
      },
      revisionHistory: '版本历史',
      refreshRevisions: '刷新版本',
      revisionLoadFailed: '版本历史加载失败',
      noRevisions: '尚无 V2 Revision',
      importRevision: '导入 DSL',
      revisionImported: '已导入为 Revision {{revision}}',
      exportRevision: '导出',
      restoreRevision: '恢复',
      restoreRevisionConfirm: '从 Revision {{revision}} 创建新的草稿？',
      revisionRestored: '已从 Revision {{revision}} 创建新草稿',
      compareRevisions: '比较版本',
      selectTwoRevisions: '选择两个 Revision',
      diffScope: '范围',
      diffEntity: '对象',
      diffOperation: '变化',
      diffPath: '字段路径',
      undo: '撤销',
      redo: '重做',
      addNode: '添加节点',
      searchNodeType: '搜索节点类型',
      nodeCategory: '节点分类',
      allNodeTypes: '全部节点',
      favoriteNodeTypes: '收藏',
      recentNodeTypes: '最近使用',
      noNodeTypes: '没有匹配的节点类型',
      addFavorite: '收藏节点类型',
      removeFavorite: '取消收藏节点类型',
      nodeTypes: {
        classifier: {
          name: 'LLM 分类器',
          description: '根据候选类别选择一个明确分支',
        },
        file_input: {
          name: '文件输入',
          description: '校验并输出当前用户可访问的文件引用',
        },
        document_extractor: {
          name: '文档提取',
          description: '按当前用户权限读取文件并提取受限长度文本',
        },
        list_operator: {
          name: '列表处理',
          description: '对数组执行汇总、扁平化或去重',
        },
        code_sandbox: {
          name: '代码沙箱',
          description: '经人工确认后，在默认断网的隔离 Docker 容器中执行 Python 或 Bash',
        },
        crm_entity_query: {
          name: 'CRM 实体查询',
          description: '以发起用户身份查询 CRM，并继承 RBAC、字段安全和组织范围',
        },
        crm_action: {
          name: 'CRM 动作',
          description: '预览或执行受人工确认、幂等和审计保护的 CRM 业务动作',
        },
        erp_action: {
          name: 'ERP 动作',
          description: '预览或执行受人工确认、幂等和审计保护的 ERP 财务动作',
        },
        flowable_approval: {
          name: 'Flowable 审批',
          description: '持久等待 Flowable 审批，并按业务日历执行 SLA 委派、升级和超时路由',
        },
        saga_compensation: {
          name: 'Saga 补偿',
          description: '顺序执行跨 CRM/ERP 动作，并在失败时按逆序执行已审批的补偿动作',
        },
        dify: {
          name: 'Dify',
          description: '调用 Dify Workflow 或 Chatflow，并返回统一结构化输出',
        },
        coze: {
          name: 'Coze Studio',
          description: '调用已发布的 Coze Bot，并汇聚流式回答',
        },
        n8n: {
          name: 'n8n',
          description: '调用 n8n 生产 Webhook，并返回统一结构化输出',
        },
        multi_agent_supervisor: {
          name: '多智能体主管',
          description: '并行委派多个 CREST 智能体，并保留每个专家的独立证据',
        },
        voting: {
          name: '投票汇聚',
          description: '按票数与置信度确定性汇聚专家候选，并输出完整计票证据',
        },
      },
      copyNameSuffix: '（副本）',
      copyNodes: '复制所选节点',
      pasteNodes: '粘贴节点',
      autoLayout: '自动布局',
      alignSelection: '对齐',
      distributeSelection: '等距分布',
      alignment: {
        left: '左对齐',
        center: '水平居中',
        right: '右对齐',
        top: '顶对齐',
        middle: '垂直居中',
        bottom: '底对齐',
      },
      distribution: {
        horizontal: '水平等距',
        vertical: '垂直等距',
      },
      deleteElement: '删除',
      addAnnotation: '添加便签',
      newAnnotationText: '新便签',
      annotationAccessibleName: '画布便签',
      annotationDetails: '便签设置',
      annotationText: '便签内容',
      annotationTextRequired: '请输入便签内容',
      annotationColor: '便签颜色',
      annotationWidth: '便签宽度',
      applyAnnotation: '应用便签',
      editAnnotation: '编辑便签',
      moveAnnotation: '移动便签',
      deleteAnnotation: '删除便签',
      deleteAnnotationConfirm: '确认删除这张便签？',
      annotationColors: {
        yellow: '黄色',
        blue: '蓝色',
        green: '绿色',
        pink: '粉色',
        gray: '灰色',
      },
      collaborationComments: '协作评论',
      collaborationOnline: '多人协作在线',
      collaborationUnavailable: '协作服务暂不可用，保存时仍会执行版本冲突检查',
      collaborationParticipant: '{{name}} · {{nodeId}}',
      activeNodeLocks: '{{count}} 个节点正在编辑',
      nodeLockFailed: '节点编辑锁获取失败',
      canvas: '画布',
      releaseGovernance: '环境与发布治理',
      governanceLoadFailed: '治理配置加载失败：{{error}}',
      firstRevisionNotSaved: '首个 V2 Revision 尚未保存',
      firstRevisionDraft: 'V2 首版草稿',
      firstRevisionDraftHint:
        '当前内容来自经典画布迁移预览；修复校验问题并保存后，系统才会创建首个不可变 V2 Revision。',
      saveFirstRevisionBeforeGovernance:
        '环境参数仍可先配置；依赖检查、协作评论和环境晋级会在首个 V2 Revision 保存后启用。',
      environment: {
        development: '开发',
        test: '测试',
        production: '生产',
      },
      secretReferenceOnly: '这里只保存 Secret 引用',
      secretReferenceOnlyHint:
        '请使用 {"别名":"env:VARIABLE"}；凭据值由部署环境或密钥平台管理，不会写入数据库或 DSL。',
      environmentParameters: '非敏感环境参数 JSON',
      environmentParameter: '环境参数',
      secretBindings: 'Secret Binding JSON',
      environmentConfigVersion: '环境配置版本',
      configuredSecrets: '已配置 Secret',
      saveEnvironment: '保存环境配置',
      environmentSaved: '环境配置已保存为 v{{version}}',
      checkDependencies: '检查依赖',
      dependenciesHealthy: '所有必需依赖可用',
      dependenciesUnhealthy: '存在不可用的必需依赖，已阻止晋级',
      noDependencies: '当前 Revision 没有外部依赖',
      rolloutPct: '生产灰度比例',
      promoteRevision: '晋级 Revision {{revision}}',
      saveRevisionBeforePromotion: '请先保存 V2 Revision',
      promotionSucceeded: 'Revision 晋级成功',
      releaseHistory: '环境 Release 历史',
      noReleases: '当前环境尚无 Release',
      rollbackHere: '回滚到此版本',
      rollbackSucceeded: '已创建新的回滚 Release',
      aiWorkflowDesigner: 'AI 工作流设计',
      aiProposalDoesNotAutoApply: 'AI 只生成候选，不会自动修改当前画布',
      aiProposalReviewHint:
        '候选以 Revision {{revision}} 为基线，必须检查语义差异、风险和测试后手动应用。',
      aiDesignInstruction: 'AI 工作流设计要求',
      aiDesignInstructionPlaceholder:
        '例如：在 CRM 商机查询后增加结构化风险判断，高风险时进入 Flowable 审批。',
      generateAiProposal: '生成候选与测试',
      aiDesignFailed: 'AI 工作流候选生成失败：{{error}}',
      aiApplyFailed: 'AI 候选应用失败：{{error}}',
      aiProposalApplied: 'AI 候选已保存为 Revision {{revision}}',
      baseRevision: '基线 Revision',
      proposalExpiresAt: '提案有效期',
      candidateHash: '候选内容哈希',
      semanticChanges: '语义差异',
      noSemanticChanges: '候选没有语义变化',
      wholeEntity: '整个对象',
      proposalRisks: '权限、副作用与成本风险',
      generatedTests: 'AI 生成测试',
      proposalWarnings: '编译警告',
      applyAiProposalConfirm: '确认应用这份 AI 候选？',
      applyAiProposalConfirmHint:
        '系统会再次校验签名、内容哈希和基线 Revision，并创建新的不可变草稿。',
      applyAsNewRevision: '应用为新 Revision',
      commentOnNode: '评论此节点',
      refreshComments: '刷新评论',
      commentsLoadFailed: '协作评论加载失败',
      commentTargetNode: '评论目标节点：{{nodeId}}',
      replyingTo: '正在回复 {{author}}',
      cancelReply: '取消回复',
      commentBody: '评论内容',
      commentPlaceholder: '输入评论；评论创建后不可编辑',
      commentsReadOnly: '当前 Revision 只能查看评论',
      sendComment: '发表评论',
      sendReply: '发送回复',
      noComments: '当前 Revision 暂无协作评论',
      commentResolved: '已解决',
      commentOpen: '待处理',
      locateCommentNode: '定位节点',
      replyComment: '回复',
      resolveComment: '标记已解决',
      reopenComment: '重新打开',
      createGroup: '分组选中节点',
      newGroupTitle: '新分组',
      groupAccessibleName: '画布分组：{{title}}',
      groupDetails: '分组设置',
      groupTitle: '分组名称',
      groupTitleRequired: '请输入分组名称',
      groupColor: '分组颜色',
      groupWidth: '分组宽度',
      groupHeight: '分组高度',
      applyGroup: '应用分组',
      editGroup: '编辑分组',
      deleteGroup: '删除分组',
      deleteGroupConfirm: '确认删除这个视觉分组？节点不会被删除。',
      groupColors: {
        blue: '蓝色',
        green: '绿色',
        purple: '紫色',
        orange: '橙色',
        gray: '灰色',
      },
      conditionBuilder: '条件构建器',
      conditionLeft: '左侧变量',
      conditionOperator: '比较运算符',
      conditionValueType: '值类型',
      conditionRight: '右侧值',
      conditionConnector: '条件连接方式',
      conditionAnd: '并且（AND）',
      conditionOr: '或者（OR）',
      applyCondition: '应用条件',
      appendCondition: '追加条件',
      clearCondition: '清空条件',
      conditionExpression: '受限条件表达式',
      conditionInvalid: '条件表达式无效',
      conditionValid: '条件表达式语法有效',
      conditionRequired: '请配置至少一个条件',
      conditionValueTypes: {
        string: '文本',
        number: '数字',
        boolean: '布尔',
        null: '空值',
        reference: '变量',
      },
      controlEdgeDetails: '控制连线配置',
      bindingEdgeDetails: '数据绑定详情',
      applyEdgeConfig: '应用连线配置',
      edgeSource: '起点',
      edgeTarget: '终点',
      edgeType: '连线类型',
      controlEdge: '控制流',
      bindingEdge: '数据绑定',
      bindingEdgeManagedHint: '数据绑定由目标节点的输入变量配置管理。',
      insertNodeOnEdge: '在线路中插入节点',
      insertNodeHint: '原线路会拆成两段；条件分支标识保留在起点到新节点这一段。',
      edgeLabel: '显示名称',
      edgeBranch: '分支标识',
      edgeBranchRequired: '请选择分支标识',
      edgeBranchHint: '运行时使用该标识决定激活哪条控制连线。',
      branchTrue: '条件成立（true）',
      branchFalse: '条件不成立（false）',
      unconditionalEdge: '无条件执行',
      validateDraft: '校验草稿',
      saveRevision: '保存 Revision',
      saveRevisionConfirm: '校验并保存为新的不可变 V2 Revision？',
      exitEdit: '退出编辑',
      discardLocalChanges: '有未保存的 V2 本地改动，退出编辑将丢弃这些改动。是否继续？',
      fixErrorsBeforeSave: '草稿存在发布级错误，请在发布前修正',
      revisionSaved: 'V2 Revision r{{revision}} 已保存',
      saveRevisionFailed: 'V2 Revision 保存失败：{{error}}',
      empty: '当前 V2 规范没有可显示的节点',
      canvasAccessibleName: '智能体编排 V2 画布',
      experimental: '实验',
      destructive: '高风险',
      definitionMissing: '缺少节点定义，无法确认端口类型',
      nodeAccessibleName: '工作流节点：{{name}}',
      controlInput: '控制流输入',
      controlOutput: '控制流输出',
      inputPortAccessible: '输入端口 {{name}}，类型 {{type}}',
      outputPortAccessible: '输出端口 {{name}}，类型 {{type}}',
      requiredPort: '必填端口',
      editNode: '编辑节点',
      nodeDetails: '节点详情',
      applyNodeConfig: '应用配置',
      nodeName: '节点名称',
      nodeNameRequired: '请输入节点名称',
      schemaForm: '表单配置',
      advancedJson: '高级 JSON',
      noConfigFields: '该节点没有可配置字段。',
      configJson: '配置 JSON',
      configRequired: '请填写必填配置',
      configJsonInvalid: '请输入有效的 JSON 值',
      configObjectRequired: '节点配置必须是有效的 JSON 对象',
      inputBindings: '输入变量绑定',
      noInputPorts: '该节点没有输入端口。',
      required: '必填',
      secretAllowed: '允许 Secret',
      requiredInputMissing: '该必填输入尚未绑定',
      bindingKindFor: '{{name}} 的绑定方式',
      variableFor: '{{name}} 的变量来源',
      selectVariable: '选择兼容变量',
      noCompatibleVariables: '当前没有类型兼容的变量来源',
      expressionFor: '{{name}} 的表达式',
      expectedType: '表达式预期类型',
      secretReferenceFor: '{{name}} 的 Secret 引用',
      literalFor: '{{name}} 的固定值',
      workflowInput: '工作流输入',
      nodeOutput: '节点 {{node}} 输出',
      bindingKind: {
        unset: '未绑定',
        variable: '变量',
        literal: '固定值',
        expression: '表达式',
        secret: 'Secret 引用',
      },
      connectionError: {
        endpoint_missing: '连线缺少起点或终点',
        self_loop: '节点不能连接到自身',
        handle_invalid: '控制流端口与数据端口不能混连',
        port_missing: '节点定义中不存在该端口',
        type_mismatch: '输出类型与目标输入类型不兼容',
        input_occupied: '目标输入端口已有数据绑定，请先删除原绑定',
        control_duplicate: '这两个节点之间已存在控制连线',
        edge_insert_control_only: '只能在控制流线路中插入节点',
        edge_insert_endpoint_missing: '线路起点或终点已不存在，请刷新画布',
        edge_insert_scope_mismatch: '不能跨越循环或迭代容器边界插入节点',
        edge_insert_node_unsupported: '入口、终点和循环控制节点不能插在线路中间',
        group_selection_required: '请先选择至少一个节点再创建分组',
      },
    },
    orchestrationDebug: {
      title: '对话调试',
      open: '对话调试',
      createWorkflow: '新建工作流',
      close: '关闭对话调试',
      clear: '清空调试记录',
      selectWorkflow: '选择要调试的工作流',
      internal: '内部画布',
      publishedHint: '调试使用当前已发布版本，不会修改编排配置。',
      inputFormat: '输入格式',
      outputFormat: '输出格式',
      inputUser: '用户输入',
      inputSchedule: '定时触发器',
      inputWebhook: 'Webhook 触发器',
      outputText: '文本',
      outputApi: 'API（JSON）',
      empty: '输入一条消息，测试当前工作流',
      placeholder: '输入测试消息；Enter 发送，Shift + Enter 换行',
      structuredInputPlaceholder: '输入 JSON 对象；Enter 发送，Shift + Enter 换行',
      structuredInputInvalid: '请输入有效的 JSON 对象后再开始调试',
      send: '发送测试消息',
      running: '工作流运行中…',
      emptyResponse: '工作流已完成，但未返回文本内容。',
      missingRunId: '后台未返回运行标识',
      runEnded: '运行结束（{{status}}），未返回文本内容。',
      statusFailed: '运行状态读取失败：{{error}}',
      executeFailed: '工作流执行失败：{{error}}',
      node: '节点',
      traceTitle: '节点执行轨迹',
      currentNode: '当前节点',
      lastNode: '最终到达节点',
      totalElapsed: '总耗时',
      nodeInput: '输入',
      nodeOutput: '输出',
      nodeError: '错误',
      emptyValue: '无',
      downloadedFiles: '已下载文件（{{count}} 个）',
      noDownloadedFiles: '没有成功下载的文件',
      stepStatusRunning: '运行中',
      stepStatusCompleted: '已完成',
      stepStatusFailed: '失败',
      stepStatusWaiting: '等待中',
      approve: '批准并继续',
      reject: '拒绝并终止',
      approved: '已批准，工作流将继续运行',
      rejected: '已拒绝，工作流将终止',
      approvalFailed: '人工确认提交失败：{{error}}',
      pendingApproval: '等待人工确认',
      approvalTarget: '即将执行：{{tool}}',
    },
    detailNavigation: {
      orchestration: '编排',
      api: '访问 API',
      logs: '日志',
      monitor: '监测',
      assistantType: '智能体',
      workflowType: '工作流',
      refresh: '刷新',
      logsTitle: '运行日志',
      logsLoadFailed: '运行日志加载失败',
      noLogs: '暂无运行记录',
      runInput: '输入',
      runOutput: '输出',
      runError: '错误',
      runStatus: '状态',
      duration: '耗时',
      startedAt: '开始时间',
      runStatus_submitted: '已提交',
      runStatus_working: '运行中',
      runStatus_input_required: '等待确认',
      runStatus_completed: '已完成',
      runStatus_failed: '失败',
      runStatus_canceled: '已取消',
      apiLoadFailed: 'API 配置加载失败',
      apiOperationFailed: 'API 操作失败',
      apiTitle: 'API 访问',
      apiExampleMessage: '请处理这条消息',
      apiPublished: 'API 已发布',
      publishApi: '发布 API',
      apiRotated: 'API Key 已轮换',
      rotateKey: '轮换 Key',
      revokeApiConfirm: '确定撤销该 API 吗？现有调用将立即失效。',
      apiRevoked: 'API 已撤销',
      revokeApi: '撤销 API',
      enableBeforePublish: '请先启用该助手，再发布 API。',
      copyKeyNow: '请立即复制 API Key',
      keyShownOnce: '为保障安全，完整 Key 仅在本次操作后显示。',
      apiNotPublished: '尚未发布 API',
      apiNotPublishedHint: '发布后，外部系统可通过独立 API Key 调用该助手。',
      endpoint: '调用地址',
      apiKey: 'API Key',
      authentication: '鉴权方式',
      requestCount: '调用次数',
      lastUsedAt: '最近调用',
      neverUsed: '尚未调用',
      requestExample: '请求示例',
      workflowApiTitle: '工作流入口 API',
      platform: '外部平台',
      configured: '已配置',
      notConfigured: '未配置',
      noWebhook: '当前工作流没有 Webhook 入口',
      noWebhookHint: '在编排中添加并发布 Webhook 触发器后，这里会展示调用地址和数据格式。',
      outputApis: '下游 API',
      method: '请求方法',
      contentTypes: '请求格式',
      urlSecretAuthentication: 'URL 密钥（无需额外请求头）',
      noAuthentication: '未配置签名密钥',
      requestSchema: '请求体定义',
      responseSchema: '返回值定义',
      responseExample: '返回值样例',
      monitorLoadFailed: '运行看板加载失败',
      monitorLoading: '正在汇总最近 30 天运行数据',
      monitorSummary: '最近 {{days}} 天：{{total}} 次运行，成功率 {{rate}}',
      monitorDescription: '重点检查安全拦截、失败率、P95、人工确认和引用覆盖情况。',
      successRate: '运行成功率',
      p95Latency: 'P95 延迟',
      awaitingConfirmation: '等待确认',
      adoptionRate: '用户采纳率',
      eventsTitle: '事件与安全信号',
      event: '事件',
      times: '次数',
      event_tool_call: '工具调用',
      event_error: '错误',
      event_input_required: '等待确认',
      event_citation: '引用',
      event_artifact: '产物',
      monitorFooter: 'Token 用量：{{tokens}}；负反馈：{{negative}}；运行失败：{{failed}}。',
    },
    orchestrationDetail: {
      title: '工作流详情',
      notFound: '未找到该工作流',
      back: '返回工作流列表',
      refresh: '刷新',
      debug: '对话调试',
      active: '生效中',
      inactive: '未生效',
      loadFailed: '工作流加载失败',
      retry: '重新加载',
      externalTitle: '外部 Agent 编排',
      platform: '平台',
      system: '所属系统',
      endpoint: '调用地址',
      apiKey: 'API Key',
      configured: '已安全配置',
      notConfigured: '未配置',
      version: '版本',
      canvasVersion: '画布版本',
      classicCanvas: '经典画布',
      v2Preview: 'V2 强类型预览',
      v2Canvas: 'V2 强类型画布',
    },
    workflowEdit: {
      title: '编辑工作流配置',
      subtitle: '可重新配置工作流名称、归属和外部平台连接；编号与编排类型不可修改。',
      save: '保存配置',
      updated: '工作流配置已更新',
      updateFailed: '工作流配置更新失败：{{error}}',
      key: '工作流编号',
      name: '工作流名称',
      nameRequired: '请输入工作流名称',
      system: '所属系统',
      systemRequired: '请选择所属系统',
      activeAssignmentHint: '当前工作流已生效，所属系统和 OA 模版不可修改。',
      oaTemplate: '关联 OA 模版',
      oaTemplateRequired: '请选择 OA 关联模版',
      oaTemplatePlaceholder: '输入 OA 模版名称搜索',
      templatesLoading: '正在加载…',
      templatesEmpty: '参数配置中暂无 OA 模版',
      templatesLoadFailed: 'OA 模版列表加载失败：{{error}}',
      type: '编排类型',
      internal: 'CREST 内部画布',
      external: '外部 Agent 平台',
      externalPlatform: '外部平台',
      externalPlatformRequired: '请选择外部 Agent 平台',
      externalEndpoint: '平台地址',
      externalEndpointRequired: '请输入平台地址',
      externalEndpointInvalid: '请输入完整的 HTTP/HTTPS 地址',
      cozeEndpointHint: 'Coze Studio 地址必须包含 bot_id 参数。',
      externalApiKey: '新 API Key',
      externalApiKeyHint: '留空将继续使用当前已加密保存的 API Key。',
      description: '描述',
    },
    workflowCreate: {
      number: '编号',
      numberHint: '创建成功后由系统自动分配，不可修改。',
      numberPlaceholder: '系统自动生成8位数字编号',
    },
    workflowManager: {
      sequence: '序号',
      searchLabel: '搜索工作流',
      searchPlaceholder: '搜索名称、编号、描述或关联模版',
      systemFilterLabel: '按所属系统筛选',
      allSystems: '全部系统',
      total: '共 {{total}} 条',
      deactivate: '取消生效',
      deactivateConfirm:
        '确认取消工作流“{{name}}”的生效状态？取消后所属系统可以暂时没有生效工作流。',
      deactivated: '已取消工作流生效状态',
      deactivateFailed: '取消生效失败：{{error}}',
    },
    common: {
      refresh: '刷新',
      edit: '编辑',
      save: '保存',
      cancel: '取消',
      delete: '删除',
      create: '新建',
      search: '搜索',
      submit: '提交',
      submitForReview: '提交审核',
      cancelSubmission: '取消提交',
      approve: '审核通过',
      accept: '接受',
      reject: '拒绝',
      back: '返回',
      confirm: '确认',
      yes: '是',
      no: '否',
      enable: '启用',
      disable: '禁用',
      readOnly: '只读',
      required: '必填',
      loading: '加载中...',
      noData: '无数据',
      total: '共',
      items: '条',
      summary: '概要',
      details: '详情',
      system: '系统信息',
      address: '地址',
      lookupOpener: '请选择',
      add: '添加',
      remove: '移除',
      assign: '分配',
      activate: '激活',
      deactivate: '停用',
      qualify: '验证',
      disqualify: '不予验证',
      close: '关闭',
      reopen: '重新打开',
      export: '导出',
      import: '导入',
      print: '打印',
      send: '发送',
      reply: '回复',
      view: '查看',
      copy: '复制',
      download: '下载',
      upload: '上传',
      filter: '筛选',
      reset: '重置',
      apply: '应用',
      next: '下一步',
      previous: '上一步',
      finish: '完成',
      ok: '确定',
      active: '活动中',
      inactive: '已停用',
      draft: '草稿',
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
      cancelled: '已取消',
      completed: '已完成',
      name: '名称',
      description: '描述',
      status: '状态',
      owner: '所有者',
      createdOn: '创建时间',
      modifiedOn: '修改时间',
      createdBy: '创建者',
      modifiedBy: '修改者',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      deleteConfirm: '确认删除？',
      unsavedChanges: '有未保存的变更',
      pleaseSelect: '请选择',
      pleaseInput: '请输入',
    },
    nav: {
      worklist: '工作列表',
      dashboard: '销售看板',
      inbox: '审批待办',
      weeklyReport: '销售周报',
      account: '客户',
      contact: '联系人',
      lead: '线索',
      opportunity: '商机',
      quote: '报价单',
      sinosure: '中信保',
      delivery: '交付项目',
      salesHub: '销售中心',
      financeCenter: '财务中心',
      operationsConsole: '运营中心',
      adminSettings: '系统设置',
      settings: '参数配置',
      appCenter: '应用中心',
      users: '用户管理',
      roles: '角色权限',
      fsp: '字段安全配置',
      buTree: '组织架构',
      auditLog: '全局审计日志',
      integrationLog: '集成日志',
      notifyHistory: '邮箱配置',
      businessUnit: '企业组织',
      frequencyBand: '频段配置',
      countryPhoneCode: '国家区号',
      currency: '币种',
      mailConfig: '收件人配置',
      approverSetup: '审批设置',
      pricing: '价格管理',
      quoteBasePrice: '通用价格底表',
      domesticPricing: '国内报价底表',
      overseasPricing: '海外报价底表',
      basePriceMaintenance: '底表维护',
    },
    financeCollections: {
      title: '客户催收',
      domesticTitle: '国内客户催收',
      overseasTitle: '海外客户催收',
      tabOverview: '综合台账',
      tabDomestic: '国内客户催收',
      tabOverseas: '海外客户催收',
      tabAgent: '催收智能体',
      tabSettings: '发件配置',
      senderConfigPageTitle: '催收发件配置',
      senderConfigPageSubtitle: '分别维护通用、国内和海外催收发件人，并验证邮件发送连接',
      ledgerTitle: '催收台账',
      ledgerSubtitle: '统一查看国内、海外和混合催收批次，处理待确认、待发送、失败和回款状态',
      subtitle: '导入发函清单和催款函模板，按客户批量生成催款函 Word',
      domesticSubtitle: '导入国内客户发函清单和催款函模板，按客户批量生成催款函 Word',
      overseasSubtitle: '导入海外客户发函清单和催款函模板，按客户批量生成催款函 Word',
      agentSubtitle:
        'AI Agent 负责识别输入、生成催收指引、起草并发送催收邮件；本页只保留执行记录和追踪结果',
      agentRule:
        '催收工作从右上角 AI 助手发起。页面不再要求用户套模板或整理固定格式文件，只展示批次、案件、草稿、发送和回款状态。',
      agentPageTitle: '催收 AI 助手',
      agentPageSubtitle:
        '上传发函清单和催款函 Word 模板，Agent 会读取原文件、保留模板样式并生成可复核的催款函',
      agentPromptPlaceholder:
        '上传客户清单和催收函 Word 模板后，选择“生成催收函 / 创建催收批次 / 发送催收邮件”，或直接描述本次催收目标。',
      agentRun: '交给 Agent 处理',
      agentAnswer: 'Agent 结果',
      agentTrace: '执行过程',
      agentConversation: '对话记录',
      agentConversationEmpty: '还没有催收对话',
      agentComposerTitle: '继续协作',
      agentQuickInstructions: '常用指令',
      agentQuickInstructionDefault: '选择指令',
      agentWorking: 'Agent 正在处理',
      agentFinalPending: '最终结论生成中',
      agentContinueWith: '继续操作',
      agentThinkingSummary: '思考摘要',
      agentDuration: '用时 {{seconds}} 秒',
      agentStop: '停止',
      agentStopped: '已停止回答。',
      agentNewConversation: '新对话',
      agentNewConversationConfirm: '当前页面记录会被清空，并生成新的上下文 ID。',
      agentConnecting: '正在连接 Agent',
      agentCompleted: '已完成',
      agentRunFailedShort: '运行失败',
      agentNoOutput: '无输出',
      agentDefaultCompleted: '已完成处理。',
      agentEmptyResult:
        'Agent 未返回处理结果，未确认已执行任何动作。请重新发起请求，或换新对话重试。',
      agentSyncPending: '正在同步后台结果',
      agentStreamInterrupted: 'Agent 可能仍在后台处理；结果完成后会自动回填到本对话。',
      agentUiIntentToast: 'Agent 已完成页面联动',
      agentUiIntentReady: 'Agent 已准备好相关页面，可在结果卡片中打开',
      agentRelatedPages: '相关页面',
      agentOpenCollectionLedger: '新标签页查看本批次台账',
      agentOpenCollectionLedgerWithCount: '新标签页查看本批次台账（{{count}} 条）',
      agentOpenUpdatedRecord: '新标签页查看已更新记录',
      agentOpenRelatedRecords: '新标签页查看相关记录',
      agentOpenLinkedPage: '新标签页打开页面',
      agentConfirmActionLabel: '确认{{name}}',
      agentConfirmActionPrompt:
        '确认{{name}}。请沿用上一条预览范围执行；如果会新增、发送或修改状态，先复述影响范围。',
      cancel: '取消',
      agentFailed: '催收 Agent 运行失败',
      attachInputFile: '附加清单/模板文件',
      agentFileParsed: '文件内容已加入 Agent 指令',
      agentFileParseFailed: '文件解析失败，请改为粘贴内容',
      agentAttachedFile: '以下内容来自文件：{{name}}',
      agentFileUploaded: '原文件已上传，Agent 将直接读取附件',
      agentFileUploadFailed: '文件上传失败，请稍后重试',
      agentFileLimit: '单次最多附加 100 个文件',
      agentOriginalFiles: '原文件附件',
      agentOriginalFileMode: '保留格式交给 Agent',
      agentDefaultFilePrompt:
        '请基于已上传的发函清单和催款函 Word 模板生成本批催款函，保留模板格式，并输出可下载文件。',
      agentGeneratedFiles: '生成文件',
      agentFileBlocked: '不可下载',
      agentArtifactDownloadFailed: '生成文件下载失败，请稍后重试',
      agentShortcutGenerateLetters: '生成催收函',
      agentShortcutCreateBatch: '创建催收批次',
      agentShortcutSendEmails: '发送催收邮件',
      agentExample1:
        '生成催收函：请基于已上传的客户清单和催收函 Word 模板生成本批催收函，保留模板格式，输出可下载的 Word 和打包文件；不要创建批次，不要发送邮件。',
      agentExample2:
        '创建催收批次：如果本会话已有催收函则直接复用，没有才基于清单和模板生成；再创建或复用同清单催收批次和案件。创建前先展示客户数量、金额、缺失项和影响范围给我确认。',
      agentExample3:
        '发送催收邮件：请复用本会话已有催收函和催收批次；缺少时才补生成、补创建。最后按系统配置的催收发件人发送，每封邮件必须附对应客户的 Word 催款函；默认跳过已发送案件，发送前先确认收件人、主题、附件和邮件数量。',
      senderConfigTitle: '催收发件人',
      senderConfigAction: '配置',
      senderConfigAdminAction: '管理员设置',
      senderConfigModalTitle: '催收发件配置',
      senderConfigSave: '保存',
      senderConfigVerify: '保存并验证',
      senderConfigReady: '已就绪',
      senderConfigDisabled: '未启用',
      senderConfigNeedsVerify: '待验证',
      senderConfigNotSet: '尚未配置发件邮箱',
      senderConfigDefault: '通用',
      senderConfigDomestic: '国内',
      senderConfigOverseas: '海外',
      senderConfigContactAdmin:
        '发送邮件会按催收范围自动使用国内/海外发件人；未就绪时请联系管理员配置。',
      senderConfigAdminHint:
        'Microsoft 365 模式下只需维护发件人信息；国内/海外未单独配置时，发送会回退通用发件人。',
      senderConfigProvider: '发信方式',
      senderConfigProviderM365: 'Microsoft 365',
      senderConfigProviderM365Short: 'M365',
      senderConfigProviderSmtp: 'SMTP',
      senderConfigProviderSmtpShort: 'SMTP',
      senderConfigM365Hint:
        '使用企业 Microsoft 365 统一授权代发，邮件会以该发件邮箱发出并保存到已发送邮件。',
      senderConfigSmtpHint: '兼容旧 SMTP 配置，需要为该发件人填写 SMTP 账号和授权码。',
      senderConfigAdvanced: 'SMTP 兼容设置',
      senderConfigEnabled: '启用催收发件配置',
      senderConfigFromName: '发件人名称',
      senderConfigFromEmail: '发件邮箱',
      senderConfigReplyTo: 'Reply-To',
      senderConfigFromNamePlaceholder: 'Baicells Collections',
      senderConfigFromEmailPlaceholder: 'collections@baicells.com',
      senderConfigReplyToPlaceholder: 'ar@baicells.com',
      senderConfigSmtpHost: 'SMTP 主机',
      senderConfigSmtpHostPlaceholder: 'smtp.example.com',
      senderConfigSmtpPort: '端口',
      senderConfigSecure: 'SSL 加密',
      senderConfigSmtpUser: 'SMTP 账号',
      senderConfigSmtpPassword: 'SMTP 密码/授权码',
      senderConfigPasswordKeep: '留空则沿用已保存授权码',
      senderConfigPasswordPlaceholder: '请输入邮箱授权码或 SMTP 密码',
      senderConfigEmailInvalid: '邮箱格式不正确',
      senderConfigLoadFailed: '催收发件配置读取失败',
      senderConfigSaved: '催收发件配置已保存',
      senderConfigSaveFailed: '催收发件配置保存失败',
      senderConfigVerifySuccess: '催收发件配置验证通过',
      senderConfigVerifyFailed: '催收发件配置验证失败',
      traceThinking: '思考',
      traceToolCall: '工具调用',
      traceToolResult: '工具结果',
      traceError: '错误',
      traceAgentStudioStarted: '已连接 Agent Studio',
      traceRuntimeStarted: '已启动 Agent Runtime',
      traceToolCallWithName: '处理：{{name}}',
      traceToolResultWithName: '已完成：{{name}}',
      traceActionPreviewWithName: '待确认：{{name}}',
      traceUiIntentWithKind: '页面联动 {{kind}}',
      traceArtifact: '生成文件',
      stageStarted: 'Agent 已启动，正在读取上下文',
      stageThinking: '正在分析催收任务',
      stageToolCall: '正在处理：{{name}}',
      stageActionPreview: '正在生成待确认动作',
      stageToolResult: '已完成：{{name}}',
      stageUiIntent: '正在联动页面',
      stageArtifact: '已生成可下载文件',
      stageDelta: '正在整理最终结果',
      backToLedger: '返回台账',
      refresh: '刷新',
      openAgent: '打开 AI 助手',
      loadFailed: '催收记录加载失败，请稍后重试',
      attemptLoadFailed: '发送记录加载失败，请稍后重试',
      markedPaid: '已标记回款',
      caseCount: '催收案件',
      overdueTotal: '逾期金额（按币种）',
      draftCases: '待生成草稿',
      blockedCases: '待确认',
      readyCases: '待发送',
      testSentCases: '已试发送',
      failedCases: '发送失败',
      sentCases: '已发送',
      ledgerSearchPlaceholder: '搜索客户、邮箱、合同、发票或批次',
      scopeAll: '全部范围',
      allBatches: '全部批次',
      scopeTitle: '范围',
      batchName: '批次',
      language: '语言',
      fromEmail: '发件人',
      recentBatches: '最近批次',
      noBatch: '暂无批次',
      caseUnit: '笔',
      caseLedger: '催收台账',
      caseDetailView: '案件明细',
      customerSummaryView: '按客户汇总',
      customerSummary: '客户汇总',
      batchCount: '批次数',
      contractInvoiceCount: '合同/发票数',
      maxOverdueDays: '最长逾期',
      priority: '优先级',
      statusTitle: '状态',
      invoiceNo: '发票号',
      nextFollowup: '下次跟进',
      validationIssues: '需要确认的信息',
      draftPreview: '邮件草稿',
      noDraft: '尚未生成邮件草稿',
      draftPendingHint: '请在 AI 助手中继续执行“生成催收函”或“发送催收邮件”后再复核草稿。',
      sendAttempts: '发送记录',
      noAttempts: '暂无发送记录',
      toEmail: '收件人',
      deliveryMode: '发送类型',
      sentAt: '发送时间',
      errorMessage: '异常说明',
      markPaid: '标记回款',
      status: {
        ready: '待发送',
        needs_review: '待确认',
        test_sent: '已试发送',
        sent: '已发送',
        failed: '发送失败',
        paid: '已回款',
        closed: '已关闭',
        draft: '待生成草稿',
        queued: '排队中',
        partial_sent: '部分发送',
        validating: '校验中',
      },
      priorityMap: {
        low: '低',
        normal: '普通',
        high: '高',
        critical: '紧急',
      },
      attemptStatus: {
        sent: '已发送',
        test_sent: '已试发送',
        failed: '失败',
        queued: '排队中',
        skipped: '已跳过',
      },
      statusView: {
        all: '全部',
        draft: '待生成草稿',
        needs_review: '待确认',
        ready: '待发送',
        test_sent: '已试发送',
        failed: '发送失败',
        sent: '已发送',
      },
      deliveryModeMap: {
        customer: '正式发送',
        test: '试发送',
      },
      scope: {
        domestic: '国内',
        overseas: '海外',
        mixed: '混合',
      },
      languageMap: {
        zh: '中文',
        en: '英文',
        auto: '自动',
      },
      ruleTitle: '批量生成规则',
      ruleDescription:
        '读取 Excel 的“发函清单”sheet，并替换 Word 模板中的公司名称、客户名称、客户邮箱、合同号、逾期金额、到期日、逾期天数、大写金额、截止日字段；金额大写按繁体中文财务大写生成。',
      uploadExcel: '导入发函清单',
      uploadExcelHint: '仅支持 .xlsx / .xls，必须包含“发函清单”sheet',
      uploadTemplate: '导入催款函模板',
      uploadTemplateHint: '仅支持 .docx，模板中保留需替换字段文本',
      createCollection: '新建催收',
      createTitle: '新建催收',
      createSubtitle: '手动录入一条催收记录，保存后会加入当前发函清单',
      createConfirm: '保存',
      createCancel: '取消',
      created: '已新增催收记录',
      requiredField: '请填写此字段',
      invalidEmail: '请输入有效邮箱',
      downloadListTemplate: '下载列表模板',
      templateDownloadFailed: '列表模板下载失败，请稍后重试',
      generate: '批量生成',
      downloadFileName: '客户催款函-{{date}}.zip',
      domesticDownloadFileName: '国内客户催款函-{{date}}.zip',
      overseasDownloadFileName: '海外客户催款函-{{date}}.zip',
      generateGuard: '请先导入发函清单、催款函模板，并确认存在有效数据',
      generated: '已生成 {{count}} 份催款函',
      generateFailed: '催款函生成失败，请检查模板是否为有效 docx',
      imported: '已读取 {{count}} 条发函数据',
      importFailed: '发函清单读取失败，请检查文件格式',
      missingHeaders: '发函清单缺少必要列',
      missingHeaderTitle: '缺少必要列',
      sheetNames: '工作表',
      validRows: '有效客户数',
      cutoffDate: '截止日',
      companyName: '公司名称',
      customerName: '客户名称',
      customerEmail: '客户邮箱',
      contractNo: '合同号',
      overdueAmount: '逾期金额',
      dueDate: '到期日',
      overdueDays: '逾期天数',
    },
    entityList: {
      actions: '操作',
      total: '共 {{formattedCount}} 条',
      selected: '已选 {{count}} 项',
      loading: '加载中...',
      quickFind: '快速搜索',
      createdOn: '创建时间',
      modifiedOn: '修改时间',
      startDate: '开始日期',
      endDate: '结束日期',
      new: '新建',
      moreActions: '更多操作',
      bulkDelete: '批量删除',
      bulkDeleteConfirmTitle: '批量删除 {{count}} 条记录？',
      bulkDeleteConfirmContent: '此操作不可撤销，请确认',
      bulkDeleteSuccess: '批量删除完成：成功 {{success}}，失败 {{failed}}',
      clearSelection: '取消选中',
      noData: '暂无数据',
      noMatches: '未找到 "{{query}}" 的匹配',
      noMatchesDescription: '试试其他关键词，或清空搜索查看全部',
      emptyDescription: '当后端返回数据后会显示在这里',
      loadFailed: '数据加载失败',
      loadFailedDescription: '请检查查看权限或稍后重试',
      retry: '重新加载',
    },
    contractList: {
      title: '合同单',
      create: '新建合同单',
      details: '详情',
      columns: {
        code: '合同编号',
        type: '合同类型',
        customer: '最终客户',
        country: '国家/地区',
        status: '状态',
        modifiedOn: '修改时间',
      },
      filters: {
        allTypes: '全部合同类型',
        allStatuses: '全部状态',
      },
      types: {
        overseas: '海外标准合同',
        'domestic-channel': '国内渠道合同',
        'domestic-operator': '国内运营商合同',
        unclassified: '未分类',
      },
      statuses: {
        draftPending: '草稿/待提交',
        draftApproval: '草稿/审批中',
        approved: '已通过',
        syncFailed: '同步失败',
      },
    },
    contractDetail: {
      loadFailed: '合同加载失败',
      loadFailedDescription: '合同数据读取或解析失败，请刷新重试；如持续失败，请联系管理员。',
      backToList: '返回合同列表',
      messages: {
        historyLoadFailed: '修改历史加载失败，请稍后重试',
        documentSaved: '合同正文已保存',
        documentSaveFailed: '合同正文保存失败，请稍后重试',
        quoteMissing: '当前合同未关联报价',
        quotePdfReady: '报价单 PDF 已生成',
        quotePdfFailed: '报价单 PDF 生成失败，请稍后重试',
        quoteRefreshSucceeded: '已更新为原关联报价的最新数据',
        quoteRefreshFailed: '更新报价失败，请稍后重试',
        contractPdfReady: '合同 PDF 已生成',
        contractPdfFailed: '合同 PDF 生成失败，请稍后重试',
      },
      header: {
        back: '返回',
        overseasTitle: '销售合同 {{code}}',
        domesticTitle: '销售合同 {{code}}',
        editing: '编辑中',
        readOnly: '只读',
        riskCount: '{{count}} 项风险',
        template: '模板 {{name}}',
        snapshotReady: '规则快照已生成',
        customer: '客户',
        contractDate: '合同日期',
        contractAmount: '合同金额',
        owner: '负责人',
        history: '修改历史',
        relations: {
          title: '合同关联记录',
          customer: '客户',
          opportunity: '商机',
          quote: '报价',
          labelSeparator: '：',
          notLinked: '未关联',
          viewDetails: '查看详情',
        },
        actions: {
          refresh: '刷新',
          refreshQuote: '更新报价',
          createCommercialInvoice: '创建商业发票',
          edit: '编辑',
          cancel: '取消',
          save: '保存',
          'generate-pdf': '生成 PDF',
          share: '分享',
        },
        quotePdf: '报价单 PDF',
        quotePdfGenerating: '报价单 PDF（生成中…）',
        quotePdfUnavailable: '报价单 PDF（未关联报价）',
        contractPdf: '合同 PDF',
        contractPdfGenerating: '合同 PDF（生成中…）',
        status: {
          draft: '草稿',
          pending: '审批中',
          approved: '已通过',
          syncFailed: '同步失败',
          sapNotSynced: 'SAP未同步',
          sapSyncing: 'SAP同步中',
          sapSyncFailed: 'SAP同步失败',
          sapSynced: 'SAP已同步',
          sapUnknown: 'SAP状态未知',
        },
      },
      tabs: {
        workspace: '合同正文',
        rules: '规则清单',
        clauses: '条款与差异',
        audit: '审计留痕',
        attachments: '附件',
      },
      workspace: {
        guidance:
          '右侧点击具体条款，左侧自动打开对应编辑区；可填写字段、选择条款参数、编辑正文、后插条款或删除可删除条款。',
        editorTitle: '合同编辑器',
        editorSummary: '当前 {{count}} 个合同内容块，章节来自标准模板；条款新增或删除后自动重排。',
        structured: '结构化正文',
        previewTitle: '正式合同预览',
        previewDescription: '按 A4 合同页面展示，右侧点击可回到左侧编辑',
        a4Layout: 'A4 版式',
        defaultWarning:
          '当前合同存在非标交期、非标付款和客户改稿条款；合同配置仍可编辑，正式生成需审批通过。',
      },
      attachments: {
        title: '合同附件',
        description: '客户非标模板、规则快照、审批附件和正式合同按来源留档。',
        upload: '上传附件',
        columns: {
          fileName: '文件名',
          type: '类型',
          source: '来源',
          owner: '上传/生成方',
          time: '时间',
          actions: '操作',
        },
        sources: {
          customerTemplate: '客户上传',
          generatedContract: '系统生成',
          ruleSnapshot: '规则引擎',
          approvalEvidence: '审批流',
        },
        types: {
          customerTemplate: '客户模板',
          generatedContract: '正式合同',
          ruleSnapshot: '规则快照',
          approvalEvidence: '审批附件',
        },
        owners: {
          customerTemplate: '客户 / Emily Chen',
          generatedContract: '合同生成服务',
          ruleSnapshot: '系统规则引擎',
          approvalEvidence: '销售运营',
        },
        afterApproval: '审批通过后生成',
        viewDifference: '查看差异',
        preview: '预览',
        download: '下载',
      },
      history: {
        drawerTitle: '修改历史',
        title: '本合同修改留痕',
        description: '根据当前合同正文与标准模板实时对比，记录条款新增、删除和修改。',
        all: '全部',
        clauseChanges: '条款修改',
        loading: '加载中',
        records: '{{count}} 条记录',
        currentEdit: '当前编辑',
        liveRecord: '实时记录',
        empty: '暂无修改记录',
        original: '原内容',
        current: '当前内容',
      },
      clauses: {
        title: '合同条款差异',
        empty: '暂无条款差异',
        columns: {
          clause: '条款',
          standard: '标准模板',
          current: '当前合同',
        },
      },
      editor: {
        addAtChapterEnd: '本章末尾新增',
        locatePreview: '定位预览',
        approvalCalculation: '审批测算',
        insertClauseAfter: '后插条款',
        delete: '删除',
        required: '必填',
        tableSummary:
          '保留原合同表格结构，共 {{count}} 行；产品、金额、签署等字段由系统或条款字段带入。',
        selectLabel: '选项字段',
        selectDescription: '从标准模板允许值中选择，右侧合同即时替换。',
        variableLabel: '系统带入',
        variableDescription: '来自客户、商机、报价或系统计算，不建议手工改写。',
        tableLabel: 'Word 表格',
        tableDescription: '沿用标准合同表格版式，数据由报价、产品或签署信息带入。',
        textLabel: '条款正文',
        lockedTextDescription: '固定文本，作为模板基准展示。',
        editableTextDescription: '可直接编辑客户协商后的条款文字。',
        added: '新增',
        modified: '已修改',
        validation: {
          separator: '；',
          supplierContactRequired: 'Supplier Contact 必填',
          supplierEmailRequired: 'Supplier Email 必填',
          supplierEmailInvalid: 'Supplier Email 格式不正确',
          supplierValid: 'Supplier 联系信息校验通过。',
          paymentPercentage: '付款比例合计 {{value}}，需调整为 100%',
          paymentChannel: '{{channel}} 付款通道触发商务审批',
          paymentCreditDays: 'after 付款节点必须填写 Credit Period Days',
          paymentNotPrepaid: '非 100% 预付款触发商务审批',
          paymentValid: '付款计划校验通过，比例合计 100%。',
        },
        fields: {
          'supplier-signing-entity': {
            helper: '选择合同签约主体，系统自动带出 Supplier Name / Address。',
          },
          'supplier-name': { helper: '随签约主体自动带出。' },
          'supplier-address': { helper: '随签约主体自动带出。' },
          'supplier-contact': { helper: '必填，作为合同签约联系信息。' },
          'supplier-tel': { helper: '选填，填写时建议包含国际区号。' },
          'supplier-email': { helper: '必填，提交前需要邮箱格式校验。' },
          'supplier-validation-summary': {
            helper: '系统检查 Supplier 联系人、电话和邮箱，并同步写入合同双方信息表。',
          },
          'overseas-product-table': {
            helper: '产品清单、数量、单价、小计和总金额从报价单同步，不在合同编辑器中手工填写。',
          },
          'delivery-days': {
            helper: '原 Delivery Date 展示改为 Lead Time，低于最长 Lead Time 会触发交付审批。',
          },
          'shipment-incoterm': { helper: '贸易术语，决定交付责任和风险转移方式。' },
          'shipment-named-place': { helper: '卖方履行交付义务且风险转移的具体地点。' },
          'warranty-months': { helper: '从 12 个月起，每 6 个月一个选项，最高 60 个月。' },
          'warranty-start-from': { helper: '明确质保起算事件。' },
          'payment-through': {
            helper: '付款通道，非 T/T 或非 100% 预付款将进入商务审批。',
          },
          'payment-down-payment-existed': { helper: '选择 Yes 后填写首付款比例。' },
          'payment-down-payment-percent': {
            helper: '填写 1-100 的百分比，系统校验付款计划总比例。',
          },
          'payment-remaining-percent': {
            helper: '剩余付款比例，需和首付款合计 100%。',
          },
          'payment-timing': { helper: '选择 after 时，Credit Period Days 必填。' },
          'payment-milestone': { helper: '付款触发节点。' },
          'payment-credit-days': { helper: 'Timing 为 after 时必填；before 可填 0。' },
          'payment-validation-summary': {
            helper: '系统根据付款通道、比例、节点和账期实时生成审批触发说明。',
          },
          'quote-revenue': {
            label: '折后报价收入',
            helper: '包含报价中的产品、软件以及向客户收取的技术服务与培训费用。',
          },
          'quote-product-cost': {
            label: '产品及履约成本',
            helper: '由报价或 BOQ 成本快照带入；缺失时不生成虚假利润。',
          },
          'market-fee-mode': {
            label: '市场费用方式',
            helper: '市场费用仅用于内部审批，不进入合同正文、合同金额或 PDF。',
          },
          'market-fee-value': {
            label: '市场费用数值',
            helper: '固定金额时填写金额；按比例时填写 0-100 的百分比。',
          },
          'market-fee-note': {
            label: '费用说明',
            helper: '填写费用用途或计算依据，供商务、财务和销售负责人审批。',
          },
        },
      },
      rules: {
        title: '规则清单',
        riskRules: '风险规则',
        description:
          '这里展示当前合同适用的规则项目和风险等级；条款文本差异和客户改稿详情请在“条款与差异”页查看。',
        total: '规则项',
        highRisk: '高风险规则',
        mediumRisk: '中风险规则',
        blocking: '阻断规则',
        count: '{{count}} 项',
        high: '高',
        medium: '中',
        calculationSource: '动态计算来源',
        readOnlySnapshot: '只读快照',
        quoteRevenue: '折后报价收入',
        marketFeeMode: '市场费用方式',
        marketFeeAmount: '市场费用金额',
        feeRecipient: '费用对象',
        productCost: '报价产品成本',
        profitAfterFee: '扣费后利润',
        profitMargin: '扣费后利润率',
        awaitingCost: '待报价成本同步',
        percentage: '按比例 {{value}}%',
        fixed: '固定金额 {{value}}',
        none: '无',
        recipientSales: '销售',
        findings: {
          'lead-time': '交期短于最长 Lead Time',
          payment: '付款条件非 100% 预付',
          currency: '非 USD 币种',
          custom: '存在自定义补充条款',
          legal: '客户修改固定通用条款',
          'market-fee': '存在市场费用',
        },
      },
      audit: {
        title: '审计留痕',
        description: '记录合同创建、规则快照、字段修改、审批提交和文件生成。',
        records: '{{count}} 条记录',
        loadFailed: '审计记录加载失败，请稍后重试',
        columns: {
          time: '时间',
          type: '类型',
          actor: '操作人',
          action: '动作',
          impact: '影响',
        },
        categories: {
          create: '创建',
          rule: '规则',
          edit: '编辑',
          approval: '审批',
          file: '文件',
          integration: '集成',
        },
        ruleSnapshot: '规则快照',
        generatedAt: '最近生成于 {{time}}',
        noRuleSnapshot: '当前合同尚未生成规则快照。',
        generated: '已生成',
        notGenerated: '未生成',
        templateVersion: '模板版本',
        templateVersionDescription: '展示审计记录中锁定的合同基准模板版本。',
        notRecorded: '未记录',
        contractVersion: '合同版本 V{{version}}',
        lockedAt: '锁定于 {{time}}',
        approvalPassed: '审批通过',
        pdfGenerated: 'PDF 生成',
        system: '系统',
        actions: {
          createContract: '创建合同',
          generateFormalVersion: '生成并锁定正式版本',
          saveContractChanges: '保存合同正文修改',
          modifyParameters: '修改合同参数',
        },
        fields: {
          snapshotVersion: '合同快照版本',
          paymentPlan: '付款计划',
          iws_signingentity: '签约主体',
          success: '成功',
        },
      },
      approval: {
        processTitle: '合同流程',
        active: '进行中',
        completed: '已完成',
        processHint: '流程按顺序推进，当前阶段会显示需要完成的审批。',
        actions: {
          submitQuote: '提交报价审批',
          submitContract: '提交合同审批',
          withdrawQuote: '撤回报价审批',
          withdrawContract: '撤回合同审批',
          resubmittingQuote: '正在重新提交报价审批…',
          reload: '重新加载',
        },
        editLocked: '报价正在审批或已经通过，如需修改请先撤回当前审批。',
        contractEditLocked: '合同正在 OA 审批或已经通过，当前版本不可修改。',
        statusLoadFailed: '报价审批状态加载失败，请稍后重试。',
        contractStatusLoadFailed: '合同 OA 审批状态加载失败，已暂时锁定编辑。',
        contractStatus: {
          not_submitted: '合同待提交',
          preparing: '合同审批准备中',
          submitting: '合同审批提交中',
          in_progress: '合同审批中',
          create_failed: '合同审批创建失败',
          create_uncertain: '合同审批创建待确认',
          withdrawing: '合同审批撤回中',
          withdraw_uncertain: '合同撤回待确认',
          resubmitting: '合同审批重新提交中',
          resubmit_uncertain: '合同重新提交待确认',
          approved: '合同审批已通过',
          rejected: '合同审批已驳回',
          withdrawn: '合同审批已撤回',
          voided: '合同审批已作废',
        },
        contractOverview: {
          title: '合同 OA 审批进度',
          subtitle: 'OA 负责审批流转，CREST 同步整体状态和流程编号。',
          notSubmittedTitle: '尚未提交合同审批',
          notSubmittedDescription: '报价审批通过后，可在页面顶部提交合同审批。',
          meta: '合同 OA 审批信息',
          round: '第 {{round}} 轮',
          processId: 'OA 流程编号 {{id}}',
          submittedAt: '提交时间 {{time}}',
          completedAt: '完成时间 {{time}}',
          activeDescription: '审批在 OA 中继续流转，OA 返回结果后 CREST 会自动更新状态。',
          approvedDescription: '该轮合同审批已经通过，审批版本保持锁定。',
          rejectedDescription: '该轮合同审批已经驳回并结束，可修改后创建新一轮审批。',
          withdrawnDescription: '该轮合同审批已经撤回并结束，可修改后创建新一轮审批。',
          voidedDescription: '该轮合同审批已经作废，不再继续流转，可重新创建一轮审批。',
          createFailedDescription: '该轮合同审批创建失败，未进入 OA 流转，可检查后重新提交。',
          resultApproved: '审批结果：已通过',
          resultRejected: '审批结果：已驳回',
          resultWithdrawn: '审批结果：已撤回',
          resultVoided: '审批结果：已作废',
          resultCreateFailed: '审批结果：创建失败',
          resultInProgress: '当前节点：合同审批中',
          resultUncertain: '当前状态：等待确认',
          nextApproved: '下一步：进入签署与归档。',
          nextRejected: '下一步：修改合同后，重新提交合同审批。',
          nextResubmit: '下一步：检查合同内容后，重新提交合同审批。',
          nextRetry: '下一步：检查参数后，再次提交合同审批。',
          nextWait: '下一步：等待 OA 完成审批并返回结果。',
          nextVerify: '下一步：请先在 OA 核实流程状态。',
        },
        contractWarning: {
          inProgress:
            '合同正在 OA 审批中，当前合同版本已锁定；如需修改，请先在 OA 中结束当前流程，待状态回传后再修改并重新提交。',
          approved: '合同审批已通过，当前审批版本保持锁定。',
        },
        domesticSubmit: {
          title: '提交国内合同到 OA 审批？',
          description:
            '系统字段将从合同、报价、客户及商机读取。请先检查 OA 模板参数，检查通过后再次确认提交。',
          confirm: '提交 OA 审批',
          checkParameters: '检查参数',
          confirmAfterCheck: '确认提交至 OA',
          parametersMissing: '审批参数不完整',
          parametersReady: '审批参数完整',
          readyDescription: '下一步确认后将锁定合同版本、生成 PDF，并创建 OA 国内合同审批流程。',
          validationMissing: '国内合同审批参数不完整，请补充后重试',
          success: '国内合同已提交 OA 审批',
          failed: '国内合同 OA 审批提交失败，请稍后重试',
        },
        resubmitUncertain: 'OA 再次提交结果尚未确认，请先在 OA 中核对，勿重复提交。',
        modal: {
          title: '提交报价审批',
          description:
            '先检查 CREST 和 OA 报价模板所需参数。校验通过后，需要再次确认才会创建 OA 流程。',
          isStamped: '是否盖章',
          includesModifiedProduct: '是否包含改制产品',
          isTechnicalDevelopmentProject: '是否为技术开发项目',
          productManagerOaId: '产品经理 OA 人员 ID',
          productManagerRequired: '技术开发项目必须填写产品经理 OA 人员 ID',
          deliveryProjectManagerOaId: '交付项目经理',
          deliveryProjectManagerPlaceholder: '请选择交付项目经理',
          salesProjectWbs: '销售项目 WBS',
          projectWbsCode: '项目 WBS 编号',
          oaIdPlaceholder: '请输入 OA 人员 ID',
          unresolvedMaterials: '确认物料生效状态',
          unresolvedMaterialsDescription:
            '以下物料无法从 CREST 主数据自动判断，请在再次检查参数前逐条确认。',
          materialEffectiveRequired: '请选择该物料是否已生效',
          yes: '是',
          no: '否',
          cancel: '取消',
          checkParameters: '检查审批参数',
          confirmSubmit: '确认提交 OA',
          parametersMissing: '审批参数尚未齐全',
          parametersReady: '审批参数已齐全',
          readyDescription: '再次确认后将生成不可变 PDF 快照并在 OA 创建报价审批流程。',
          validateFailed: '审批参数检查失败，请稍后重试',
          submitFailed: '报价审批提交失败，请根据提示处理后重试',
          submitSuccess: '报价审批已提交至 OA',
        },
        contractModal: {
          title: '提交海外合同审批',
          description:
            '系统字段将自动从合同、报价、客户和商机读取。请补充 OA 模板需要的信息，检查通过后再次确认提交。',
          customerType: '客户类型',
          salesArea: '销售区域',
          salesType: '销售类型',
          contractType: '合同类型',
          salesPerson: '销售人员',
          salesPersonRequired: '请选择销售人员',
          productManagerOaId: '产品经理 OA 人员 ID',
          deliveryManagerOaId: '交付经理 OA 人员 ID',
          oaIdPlaceholder: '请输入 OA 人员 ID',
          optionalOaIdPlaceholder: '选填，请输入 OA 人员 ID',
          productManager: '产品经理',
          deliveryManager: '交付经理',
          referrerPerson: '推荐人',
          personPlaceholder: '搜索姓名或邮箱',
          optionalPersonPlaceholder: '选填，搜索姓名或邮箱',
          framework: '是否框架合同',
          referrer: '推荐人参与',
          includes5g: '是否包含 5G 产品',
          referrerOaId: '推荐人 OA 人员 ID',
          referrerRequired: '请选择推荐人',
          specialRequirements: '特殊要求',
          hld: 'HLD 附件（选填）',
          testCase: 'Test case 附件（选填）',
          uploadOptional: '上传附件',
          uploadFailed: '附件上传失败，请稍后重试',
          yes: '是',
          no: '否',
          cancel: '取消',
          checkParameters: '检查审批参数',
          confirmSubmit: '确认提交 OA',
          parametersMissing: '审批参数尚未齐全',
          parametersReady: '审批参数已齐全',
          readyDescription: '再次确认后将锁定当前合同版本、生成 PDF 并创建 OA 海外合同审批流程。',
          validateFailed: '合同审批参数检查失败，请稍后重试',
          submitFailed: '合同审批提交失败，请根据提示处理后重试',
          submitSuccess: '海外合同审批已提交至 OA',
        },
        contractWithdraw: {
          title: '撤回海外合同审批',
          description: '仅审批中的流程可以撤回。撤回成功后合同恢复编辑，修改后需要重新提交审批。',
          reason: '撤回原因',
          reasonPlaceholder: '请说明需要撤回修改的原因',
          reasonRequired: '请填写撤回原因',
          reasonTooLong: '撤回原因不能超过 500 个字符',
          cancel: '取消',
          confirm: '确认撤回',
          success: '海外合同审批已从 OA 撤回',
          failed: '海外合同审批撤回失败，请稍后重试',
          uncertain: 'OA 撤回结果尚未确认，请先在 OA 中核对，勿重复操作。',
        },
        withdraw: {
          title: '撤回报价审批',
          description: '撤回后可继续修改报价和合同内容。撤回原因会同步到 OA 并保留审计记录。',
          reason: '撤回原因',
          reasonPlaceholder: '请说明需要撤回修改的原因',
          reasonRequired: '请填写撤回原因',
          reasonTooLong: '撤回原因不能超过 500 个字符',
          cancel: '取消',
          confirm: '确认撤回',
          success: '报价审批已从 OA 撤回',
          failed: '报价审批撤回失败，请稍后重试',
          uncertain: 'OA 撤回结果尚未确认，请先在 OA 中核对，勿重复操作。',
        },
        stage: {
          drafting: '合同编制',
          quote: '报价审批',
          contract: '合同审批',
          archive: '签署归档',
          draftingComplete: '已完成',
          quoteCurrent: '当前阶段',
          quoteApproved: '报价已通过',
          contractBlocked: '报价通过后开放',
          contractCurrent: '当前阶段',
          contractApproved: '合同已通过',
          contractRejected: '已驳回，可修改后重提',
          contractWithdrawn: '已撤回，可修改后重提',
          contractVoided: '上一轮已作废，可重新提交',
          archiveBlocked: '合同通过后开放',
          archiveCurrent: '待签署归档',
        },
      },
      validation: {
        draftSavedIncomplete: '草稿已保存，仍有 {{count}} 个必填项未完成',
        draftSavedComplete: '合同草稿已保存，必填信息已完整',
        submitBlocked: '提交前请先补齐 {{count}} 个必填项',
        incomplete: '未填写',
        invalidEmail: '邮箱格式不正确',
        completeTag: '信息完整',
        incompleteTag: '待完善 {{count}} 项',
      },
    },
    quoteDetail: {
      customer: '客户',
      opportunity: '商机',
      notLinked: '未关联',
      viewRelation: '查看详情',
      labelSeparator: '：',
      actions: {
        downloadQuotePdf: '下载报价 PDF',
        exportBoqQuote: 'BOQ 报价导出',
        downloadExport: '下载/导出',
        refresh: '刷新',
      },
      tabs: {
        quoteInfo: '报价单信息',
      },
      lines: {
        columns: {
          type: '类型',
          partNumber: '物料编码',
          productName: '产品名称',
          productModel: '产品型号',
          description: '产品描述',
          quantity: '数量',
          unitPrice: '单价',
          total: '合计',
          notes: '备注',
        },
        count: '共 {{count}} 条',
        totalLabel: '合计：',
      },
      draft: {
        quickConfig: '快速配置',
        existing: '已有 BOQ 草稿',
        savedAt: '保存于',
        unknownTime: '未知时间',
        restoreHint: '，点击快速配置会自动恢复。',
        continue: '继续配置',
      },
      exportTerms: {
        title: '报价单展示信息',
        description: '只维护客户报价单导出需要展示的信息；正式合同条款请在合同模块维护。',
        updatedAt: '更新于 {{time}}',
        editSaveHint: '编辑后使用页面顶部保存',
        messages: {
          loadFailed: '条款加载失败，请刷新后重试',
          saved: '条款已保存',
          saveFailed: '条款保存失败，请稍后重试',
        },
        sections: {
          basic: '基础条款',
          address: '地址信息',
          delivery: '交付与质保',
          compliance: '合规与签署',
          notes: '备注说明',
        },
        fields: {
          paymentTerms: '付款条件',
          freightTerms: '贸易/货运条款',
          shippingMethod: '运输方式',
          expiresOn: '报价有效期',
          billToContact: '账单联系人',
          shipToContact: '收货联系人',
          billToAddress: '账单地址',
          shipToAddress: '收货地址',
          billToCity: '账单城市',
          shipToCity: '收货城市',
          billToCountry: '账单国家',
          shipToCountry: '收货国家',
          billToPostalCode: '账单邮编',
          deliveryLeadTime: '交货周期',
          warranty: '质保',
          bankInfo: '银行信息',
          exportCompliance: '出口合规',
          sellerSignature: '我方签署区',
          customerSignature: '客户签署区',
          additionalNotes: '内部/客户备注',
          guidance: '填写建议',
        },
        guidanceExtra: '用于客户报价单导出，可填写价格说明、税费范围、交付前提和其他客户可见条款。',
        guidanceExample:
          '示例：\n1. 本报价不含运费、关税与现场施工费。\n2. 交期以合同签订并收到预付款后计算。\n3. 最终金额以双方签字合同或 PO 为准。',
        empty: {
          address: '暂无地址信息',
          delivery: '暂无交付与质保信息',
          compliance: '暂无合规与签署信息',
          notes: '暂无备注说明',
        },
      },
      priceLookup: {
        title: '价格查询参数',
        fields: { class: 'Class', subclass: 'Subclass' },
        placeholders: { class: '选择 Class', subclass: '选择 Subclass' },
        validation: { classRequired: '请选择 Class', subclassRequired: '请选择 Subclass' },
        actions: { lookup: '查询价格' },
        help: {
          lookupFlow:
            '先按 Class 和 Subclass 从 BOQ 物料库筛选候选，再按候选物料编码合并 WPS 信息。',
        },
        candidates: { summary: '已筛出 {{count}} 个候选物料编码：' },
        results: { title: '候选物料 ({{count}})', empty: '请选择 Class 和 Subclass 后查询价格' },
        columns: {
          source: '来源',
          partNumber: '物料编码',
          productName: '产品名称',
          productRemark: '产品备注',
          salesStatus: '可售状态',
          lifecycle: '生命周期',
          description: '对外描述',
          model: '型号',
          band: '频段',
          listPrice: '目录价',
          salesPrice: '销售价',
          directorPrice: '总监价',
          priceStatus: '价格状态',
          matchScore: '命中分',
        },
        messages: {
          catalogLoadFailed: '基站分类加载失败，请刷新页面后重试',
          missingQuote: '缺少报价单上下文，无法查询基站价格',
          noMatches: '未找到匹配的基站价格，请尝试其他 Class 或 Subclass',
          matchesFound: '找到 {{count}} 条匹配的基站价格',
          lookupFailed: '价格查询失败：{{reason}}',
          unknownError: '未知错误',
        },
      },
    },
    boqConfigurator: {
      title: 'BOQ 配置器',
      tabs: { config: '配置', bom: 'BOM 汇总' },
      fields: {
        quote: '报价',
        customer: '客户',
        project: '项目',
        currentTotal: '当前报价合计',
      },
      status: {
        draft: '草稿',
        saving: '保存中',
        saved: '已保存',
        savedAt: '已保存 {{time}}',
        pending: '待保存',
        error: '保存失败',
      },
      statusHelp: {
        draft: '草稿保存状态',
        saving: '正在自动保存草稿',
        saved: '草稿已保存',
        pending: '有改动等待自动保存',
        error: '草稿自动保存失败，请重试或检查网络',
      },
      actions: {
        close: '关闭',
        closeAria: '关闭 BOQ 配置器',
        retrySave: '重试保存',
        continueEditing: '继续编辑',
        createAnother: '再建一份',
      },
      messages: {
        payloadTooLarge: '配置内容过大，请刷新后重试或联系管理员',
        catalogPartialFailure: '部分配置物料库加载失败，稍后重试或重新打开配置器',
        restoredDraft: '已恢复上次保存的 BOQ 草稿：{{time}}',
        startFailed: '启动配置器失败',
        draftSaved: '草稿已保存',
        draftSaveFailed: '草稿保存失败，请检查网络后重试',
        confirmClose: '确认关闭？',
        closeAfterSaveFailure:
          '草稿自动保存失败。关闭前会再尝试保存一次；如果仍失败，将保留当前页面。',
        closeWithChanges: '当前还有未保存改动。关闭前会先保存草稿。',
        closeSaved: '草稿已保存。',
        saveFailedKeptOpen: '草稿保存失败，已保留当前页面，请稍后重试',
        submittedLines: '已落 {{count}} 行物料到报价单',
        initializing: '正在初始化配置器...',
        submitSuccess: '提交成功',
        submittedToQuote: '物料已写入报价单。',
      },
      directory: {
        title: '配置目录',
        aria: 'BOQ 配置目录',
        summary: '{{templates}} 个站型 / {{sites}} 站',
        ranSummary: 'RAN · {{templates}}站型 · {{sites}}站',
        network: '网络设施',
        networkEmpty: '网络设施 · 未添加',
        networkEmptyTarget: '网络设施空态',
        gateway: '网关',
        additionalMaterials: '补充物料',
        additionalMaterialsCount: '补充物料 · {{count}}项',
        serviceExpenses: '服务费用',
        serviceExpensesCount: '服务费用 · {{count}}项',
        locate: '定位到 {{target}}',
        expand: '展开 {{target}}',
        collapse: '折叠 {{target}}',
        noBand: '未选频段',
        templateSummary: '{{name}} · {{sectors}}扇区 · {{bands}} · {{sites}}站',
        sectorConfig: '扇区配置',
        sectorSummary: '扇区配置 · {{bands}}',
        baseStation: '基站',
        antenna: '天线',
        siteSupport: '站点配套',
        issueSummary: '{{label}} 有 {{count}} 个待处理项',
        issueDetails: '{{label}} 有 {{count}} 个待处理项：{{messages}}',
      },
      additionalMaterials: {
        add: '添加补充物料',
        empty: '尚未添加补充物料',
        hint: '从完整物料库选择，按填写数量独立进入 BOM，不乘站点数',
        selectTitle: '选择补充物料',
        selectHint: '可按物料分类、物料编码、Class 和 Subclass 筛选',
        total: '共 {{total}} 项',
      },
      inquiry: {
        title: '外购选型询价',
        newTitle: '新建外购选型询价',
        detailTitle: '询价详情',
        entry: '外购选型询价',
        entryAria: '物料询价，{{count}} 条记录',
        empty: '暂无询价记录',
        itemCount: '{{count}} 项物料',
        resultAvailable: '已有询价结果',
        resultPending: '待返回结果',
        actions: {
          create: '新建询价',
          backToHistory: '返回询价历史',
          addItem: '添加物料行',
          removeItem: '删除物料 {{index}}',
          saveDraft: '保存询价草稿',
          submitApproval: '提交 OA 审批',
          view: '查看',
          withdraw: '撤回询价',
          retry: '重新加载',
        },
        stats: { total: '全部', pending: '审批中', approved: '已通过', draft: '草稿' },
        columns: {
          number: '询价单号',
          materials: '物料',
          applicant: '申请人',
          createdAt: '创建时间',
          status: '审批状态',
          result: '询价结果',
          actions: '操作',
        },
        status: {
          draft: '草稿',
          pending: '审批中',
          approved: '已通过',
          rejected: '已驳回',
          withdrawn: '已撤回',
        },
        form: {
          contextTitle: '业务信息（系统带出）',
          requestTitle: '询价要求',
          itemsTitle: '询价物料',
          itemTitle: '物料 {{index}}',
        },
        fields: {
          country: '国家/地区',
          urgency: '紧急程度',
          requiredDate: '期望回复日期',
          currency: '询价币种',
          reason: '询价原因',
          materialName: '物料名称',
          specification: '型号规格',
          class: 'Class（产品类）',
          subclass: 'Subclass（产品子类）',
          quantity: '数量',
          unit: '单位',
          targetPrice: '目标单价（{{currency}}）',
          technicalDescription: '技术描述',
          remarks: '询价备注',
        },
        urgency: { normal: '一般', urgent: '紧急' },
        placeholders: { reason: '说明为什么需要对 PLM 外物料发起询价' },
        validation: {
          materialName: '请填写物料名称',
          specification: '请填写型号规格',
          quantity: '请填写数量',
        },
        messages: {
          draftSaved: '询价草稿已保存',
          submitted: '询价已提交 OA 审批',
          loadFailed: '询价记录加载失败，请重试',
          saveFailed: '询价保存失败，请检查内容后重试',
          withdrawn: '询价审批已撤回',
          withdrawFailed: '询价撤回失败，请刷新后重试',
        },
      },
      picker: {
        choose: '选择',
        added: '已添加',
        zeroStockTitle: '库存提示',
        zeroStockMessage: '物料 {{partNumber}} 当前库存为 0，是否确定选择？',
        zeroStockConfirm: '确定',
        zeroStockCancel: '取消',
        change: '改选',
        changeSelection: '{{value}}，改选',
        removeSelected: '移除已选物料',
        unavailable: '暂无',
        columns: '列设置',
        keywordPlaceholder: '物料编码 / 型号 / 名称',
        all: '全部',
        inStock: '有库存',
        filter: '查询 ▼',
        collapse: '收起 ▲',
        clear: '清空',
        noData: '暂无数据',
        select: '选择 {{target}}',
        noAntenna: '不配天线',
        noServer: '不配服务器',
        clearCore: '清除 CORE',
        clearOmc: '清除 OMC',
        clearGateway: '清除网关',
        labels: {
          partNumber: '物料编码',
          name: '名称',
          model: '型号',
          description: '描述',
          externalDescription: '对外描述',
          inventory: '库存',
          unit: '单位',
          price: '价格',
          quantity: '数量',
          operation: '操作',
          status: '状态',
          category: '分类',
          productRemark: '产品备注',
          salesStatus: '可售状态',
          listPrice: '目录价',
          salesPrice: '销售价',
          directorPrice: '总监价',
          class: 'Class（产品类）',
          subclass: 'Subclass（产品子类）',
        },
      },
      material: {
        remarkColumn: '备注',
        fullBands: '完整适配频段：{{bands}}',
        listPrice: '目录价',
        salesPrice: '销售价',
        directorPrice: '总监价',
        remark: '物料备注',
        remarkAria: '物料备注',
        remarkPlaceholder: '填写仅供内部使用的物料备注',
        cancelRemark: '取消备注',
        saveRemark: '保存备注',
        internalRemark: '物料备注（仅内部使用）',
        editRemark: '编辑物料备注',
        fillRemark: '填写备注',
        cancel: '取消',
        save: '保存',
      },
      config: {
        ranSummary: '{{templates}} 站型 · {{sites}} 站 · {{bands}}',
        ranOptionalEmpty: 'RAN 为可选配置；如需配置基站、天线及配套，请新增站型。',
        expandBlock: '展开配置块',
        collapseBlock: '折叠配置块',
        expandNamedBlock: '展开{{title}}',
        collapseNamedBlock: '折叠{{title}}',
        expandTemplate: '展开站型 {{name}}',
        collapseTemplate: '折叠站型 {{name}}',
        deployment: '部署',
        sites: '站',
        siteTypeSiteCount: '站型 · {{templates}}/{{sites}}站',
        keepOneTemplate: '至少保留 1 个站型',
        selectLeftTemplate: '请选择左侧站型',
        notSelected: '未选',
        templateDeleted: '站型已删除',
        sectorNumber: '扇区 {{number}}',
        copySectorToAll: '复制此扇区配置到全部扇区',
        selectLeftTarget: '请选择左侧站型或网络设施',
        quantitySubtotalHint: '数量/小计见顶部「BOM 汇总」Tab',
        networkNoSiteMultiplier: '网络设施不乘站数。请在网络设施区域添加 CORE、OMC 或网关。',
        networkTableHint: '网络设施不乘站数。每节展开后呈 Excel 表格，列与 BOM 导出一致。',
        quantityValue: '数量 {{value}}',
        gatewayNotSelected: '尚未选网关',
        softwareServerLicense: '软件 + 服务器 + License',
        sectionNotSelected: '尚未选 {{section}}',
        detailSummary:
          '{{name}} · 扇区 {{sector}} · {{bands}} · ×{{sites}} 站。每个卡片展开后呈 Excel 风格表格。',
        baseStationSectorNumber: '基站 · 扇区 {{number}}',
        baseStationRowsHint: '按频段生成基站行：{{bands}}。每个基站行下方带对应配件包区',
        antennaSectorNumber: '天线 · 扇区 {{number}}',
        sectors: '扇区',
        addTemplate: '新增站型',
        copy: '复制',
        delete: '删除',
        confirmDeleteTemplate: '确认删除站型？',
        deleteTemplateDescription:
          '删除后将永久移除 {{name}} 的站点、扇区、基站、天线、License 及塔下配件配置，且无法撤销。',
        confirmDelete: '确认删除',
        cancel: '取消',
        noBand: '未选 band',
        sectorConfiguration: '扇区配置',
        sharedSectors: '{{count}} 扇区共用 · {{summary}}',
        band: '频段',
        selectBand: '选择频段',
        baseStationSector: '基站 · 扇区配置',
        baseStationAuto: '每个 Band 自动生成 1 台基站：{{bands}}',
        antennaSector: '天线 · 扇区配置',
        antennaShared: '天线按扇区共用，预留未来扩展频段',
        templateSummary: '{{sectors}} 扇区 · {{sites}} 站 · {{bands}}',
        sharedConfigHint: '当前站型 {{count}} 个扇区共用一份配置，基站下方自动展开对应配件包区。',
        siteSupport: '站点配套',
        siteSupportHint: '站点级配套配置，按站型维度展开到 BOM',
        baseStationScope: '基站 {{value}}',
      },
      bom: {
        title: 'BOM 汇总',
        columns: {
          name: '名称',
          quantity: '数量',
          unit: '单位',
          listPrice: '目录价',
          salesPrice: '销售价',
          directorPrice: '总监价',
          quotePrice: '报价价格',
          subtotal: '小计',
          source: '来源',
          remarks: '备注',
          packed: '入箱',
        },
        actions: {
          view: '视图',
          byMaterial: '按物料聚合',
          byTemplate: '按站型分列',
          refreshing: '刷新中...',
          copy: '复制',
          copyHint: '复制完整 BOM 明细到剪贴板，可直接粘贴到 Excel',
          resetQuote: '重置报价',
          submit: '提交至报价',
        },
        quotePlaceholder: '填写',
        clearQuotePrice: '清空报价价',
        submitTitle: '确认提交至报价单',
        confirmSubmit: '确认提交',
        cancel: '取消',
        submitDescription:
          '将展开后的 BOM 回填到报价单。提交后价格审批由 crest 报价单流程统一处理，配置器不在本端分级审批。',
        skuCount: 'SKU 种数',
        quoteTotal: '报价合计',
        empty: 'BOM 为空',
        emptyHint: 'BOM 为空，请先在配置页添加至少一项物料',
        quotePriceMissing: '请先补齐 BOM 汇总中的报价价格',
        submitFailed: '提交失败',
      },
      export: {
        title: '报价导出',
        export: '导出',
        exportPdf: '导出 PDF',
        exportCurrent: '导出当前 Sheet',
        noDraft: '暂无 BOQ 配置草稿，请先快速配置',
        loadFailed: '加载报价导出失败',
        exported: '已导出当前 Sheet',
        exportFailed: '导出失败',
        previewMissing: '未找到可导出的预览区域',
        pdfOpened: '已打开 PDF 保存窗口',
        pdfFailed: 'PDF 导出失败，请检查浏览器是否拦截弹窗',
        sheets: { customer: '客户报价单', production: '生产BOM', approval: '审批包' },
        meta: { quoteNumber: '报价/商机号', customer: '客户', project: '项目', currency: '币种' },
        customerTitle: '销售报价单 / Sales Quotation',
        productionTitle: '生产 BOM / Production Bill of Materials',
        approvalTitle: '审批包 / Approval Pack',
        columns: {
          site: '站点',
          segment: '段',
          category: '分类',
          name: '产品名称',
          description: '产品描述',
          quantity: '数量',
          unit: '单位',
          unitPrice: '单价',
          subtotal: '小计',
          remarks: '备注',
          partNumber: '产品编号',
          productModel: '产品型号',
          specification: '规格描述',
          source: '来源',
        },
        grandTotal: '报价总金额 / Grand Total',
        termsTitle: '商务条款 / Terms & Conditions',
        terms: {
          payment: '付款条件',
          trade: '贸易术语',
          deliveryMethod: '运输方式',
          leadTime: '交货周期',
          warranty: '质保',
          validUntil: '报价有效期',
          billTo: '账单地址',
          shipTo: '收货地址',
          bank: '银行信息',
          compliance: '出口合规',
          sellerSignature: '我方签署',
          customerSignature: '客户签署',
          notes: '商务条款正文',
        },
        report: {
          quote: '报价单',
          quoteNumber: '报价单号',
          customerName: '客户名称',
          projectName: '项目名称',
          countryCurrency: '国家 / 币种',
          siteTypeSite: '站型 / 站点',
          siteTypeCount: '{{templates}} 站型 / {{sites}} 站',
          validUntil: '有效期至',
          siteTypeTotal: '站型 / 总站数',
          skuCount: 'SKU 数',
          totalQuantity: '总件数',
          exportDate: '导出日期',
          productionHint: '△ 本表为生产/物流配单依据，不含价格。配件包按子件展开，含入箱件在内。',
          productionSource: '来源（哪些站型用到）',
          items: '件',
          productionPlanner:
            '生产计划员：按“品类”分批排产；同 partNumber 不同站型来源建议合并下采。',
          packedHint: '入箱件已含整机价，按基站随箱发货，不在客户报价单中单独列示。',
          internal: '内部用 · 含让幅分析',
          listTotal: '总目录价（List）',
          salesTotal: '原始销售价（Sales / WPS 价盘）',
          quoteTotal: '当前报价合计（Quote）',
          concessionVsSales: 'vs 销售价（让幅）',
          discountVsList: 'vs 目录价（总折扣）',
          concessionItems: '让幅项数',
          fullDetail: 'Sheet 1 / 全量明细（层级 · 配件全展开 · 含价格四档）',
          concessionDetail: 'Sheet 2 / 让幅明细（按让幅% 倒序 · {{count}} 项报价低于销售价）',
          approval: '审批意见 / Approval',
          salesDirector: '销售总监 / Sales Director',
          commercial: '商务 / Commercial',
          date: '日期',
          productionCategory: '品类',
          listPrice: '目录价',
          salesPrice: '销售价',
          quotePrice: '报价',
          concessionPct: '让幅%',
          concessionAmount: '让幅金额',
          total: '合计',
        },
      },
    },
    columnVisibility: {
      title: '显示列',
      searchPlaceholder: '搜索列...',
      all: '全选',
      default: '默认',
      clear: '清空',
      noColumnsFound: '未找到 "{{query}}"',
      required: '必显',
      resetTooltip: '重置到默认列',
      reset: '重置',
      savedLocally: '自动保存到本地',
    },
    salesList: {
      account: '客户',
      contact: '联系人',
      lead: '线索',
      opportunity: '商机',
      quote: '报价单',
      salesOrder: '订单',
      deliveryProject: '交付项目',
      sinosure: '中信保',
      status: '状态',
      primaryContact: '主要联系人',
      contactEmail: '联系人邮箱',
      parentAccount: '所属客户',
      mobilePhone: '手机号码',
      active: '启用',
      inactive: '停用',
      activateAccount: '启用',
      deactivateAccount: '停用',
      activateAccountConfirm: '确认启用该客户？',
      deactivateAccountConfirm: '确认停用该客户？',
      activateAccountHint: '启用后，该客户可以重新用于业务关联。',
      deactivateAccountHint: '停用后，该客户不可用于新建商机关联。',
      activated: '客户已启用',
      deactivated: '客户已停用',
      statusChangeFailed: '客户状态更新失败',
      inactiveAccountCannotCreateOpportunity: '客户已停用，不能创建商机',
      inactiveAccountCannotSelect: '客户已停用，不可选择',
      approvalStatus: '审核状态',
      allAuditStatuses: '全部审核状态',
      allOwners: '全部负责人',
      allRegions: '全部大区',
      otherOverseas: '其他海外',
      notSubmitted: '未提交',
      inReview: '审核中',
      approved: '已批准',
      rejected: '已拒绝',
      approver: '审批人',
      rejectedAt: '拒绝时间',
      comment: '审批意见',
      createOnBehalf: '代为创建',
      submit: '提交',
      submitted: '已提交',
      submitFailed: '提交失败',
      sapSyncQueued: '已入队 SAP 同步 (job={{job}})',
      sapSyncFailed: 'SAP 同步失败',
      leadOpen: '未识别',
      leadQualified: '已识别',
      leadDisqualified: '已取消',
      leadQualify: '识别',
      leadQualifyConverted: '已授予资格，并已转化为客户和联系人',
      leadQualifySuccess: '已转化 (acc={{accountId}}, opp={{opportunityId}})',
      leadQualifyFailed: '转化失败',
      leadTargetContactInformation: '目标联系人信息',
      leadTargetAccountInformation: '目标客户信息',
      leadTargetAccountSapInformation: '目标客户 SAP 必填信息',
      leadTargetAddressInformation: '目标客户/联系人地址',
      opportunityOpen: '进行中',
      opportunityWon: '赢单',
      opportunityLost: '输单',
      allOpportunityStatuses: '全部商机状态',
      hot: '热',
      warm: '温',
      cold: '冷',
      details: '详情',
      openAccountInNewTab: '在新标签页打开',
      openOpportunityInNewTab: '在新标签页打开',
    },
    roleList: {
      title: '角色权限',
      loadFailed: '加载角色失败',
      totalRoles: '共 {{count}} 个角色',
      searchPlaceholder: '搜索角色名 / 描述',
      newRole: '新建角色',
      marketScope: '角色归属',
      marketScopeDescription: '仅用于规范角色名称；角色的数据权限仍在数据范围中单独配置。',
      marketScopeRequired: '请选择公共、国内或海外',
      marketScopeDomestic: '国内',
      marketScopeOverseas: '海外',
      marketScopeCommon: '公共',
      generatedRoleName: '生成的角色名称',
      generatedRoleNameTooLong: '生成后的角色名称不能超过 100 个字符',
      manualSort: '手动排序',
      saveOrder: '保存顺序',
      sortColumn: '排序',
      sortHint: '使用上移、下移调整当前分区中的角色顺序；可切换国内、海外和公共分区后统一保存。',
      sortClearFilters: '请先清除搜索、类型和业务组织筛选后再排序',
      sortSaved: '角色顺序已保存',
      sortSaveFailed: '保存角色顺序失败',
      moveUp: '上移',
      moveDown: '下移',
      moveRoleUp: '上移角色 {{name}}',
      moveRoleDown: '下移角色 {{name}}',
      noRoles: '暂无角色',
      noMatches: '未找到 "{{query}}" 的匹配',
      noMatchesDescription: '试试其他关键词',
      emptyDescription: '加载完成后角色将显示在这里',
      roleName: '角色名',
      builtinTooltip: '内置角色 - 不可删除/重命名',
      builtin: '内置',
      buScopedTooltip:
        '同名角色在 {{count}} 个企业组织下都有实例，此处显示根模板，计数已聚合所有组织',
      type: '类型',
      system: '系统',
      admin: '管理',
      reviewer: '审核',
      business: '业务',
      all: '全部',
      allBusinessUnits: '全部业务组织',
      domestic: '国内 ({{count}})',
      overseas: '海外 ({{count}})',
      commonRegion: '公共 ({{count}})',
      scopeFilterLabel: '列表范围',
      scopeAll: '全部 ({{count}})',
      withinGroup: '本组 ({{count}})',
      crossGroup: '跨组 ({{count}})',
      organizationInstanceCount: '× {{count}} 组织',
      organizationScope: '业务组织范围',
      defaultOrganization: '默认数据范围',
      description: '描述',
      members: '成员',
      privileges: '权限',
      global: '全局',
      actions: '操作',
      details: '详情',
      deleteRole: '删除',
      deleteSuccess: '角色 "{{name}}" 已删除',
      deleteFailed: '删除角色失败',
      deleteConfirmTitle: '删除角色 "{{name}}"？',
      deleteConfirmDescription: '仅非内置且无成员的角色可删除，删除后不可恢复。',
    },
    platformPermissions: {
      title: '角色与权限',
      subtitle: 'CREST 基座权限：应用访问、系统管理、企业组织管理',
      boundaryTitle: '这里只管理 CREST 平台权限',
      boundaryDesc:
        'CRM 客户、商机、报价、审批等业务权限请在 CRM设置 -> 角色权限 中维护；本页只配置平台角色的应用入口和系统设置菜单。',
      platformRoles: '平台角色',
      totalRoles: '共 {{count}} 个平台角色',
      searchPlaceholder: '搜索平台角色',
      newRole: '新建角色',
      noRoles: '暂无平台角色',
      noMatches: '未找到 "{{query}}" 的匹配',
      noMatchesDescription: '试试其他关键词',
      emptyDescription: '加载完成后平台角色将显示在这里',
      roleName: '角色名',
      displayName: '显示名',
      type: '类型',
      roleType: '角色类型',
      system: '系统',
      admin: '管理',
      user: '用户',
      all: '全部',
      description: '描述',
      members: '成员',
      privileges: '权限',
      actions: '操作',
      details: '详情',
      editRole: '编辑',
      deleteRole: '删除',
      deleteSuccess: '角色“{{name}}”已删除',
      deleteFailed: '删除角色失败',
      deleteConfirmTitle: '删除角色“{{name}}”？',
      deleteConfirmDescription: '仅可删除无成员的非内置角色，删除后不可恢复。',
      builtin: '内置',
      builtinTooltip: '内置平台角色',
      general: '通用',
      selectRole: '请选择一个平台角色',
      appAccess: '应用访问',
      assignableAppsDescription:
        '仅显示已启用并具有当前正式 Release 的应用；规划项和集成项不参与角色授权。',
      menuPermissions: '菜单权限',
      platformMenus: '系统管理与企业组织管理',
      platformMenusDesc:
        '仅维护 CREST Platform 自有菜单；子应用菜单由所属应用自行管理。',
      platformDataPrivileges: '平台数据权限',
      platformDataBoundaryTitle: '这里仅维护平台级数据权限',
      platformDataBoundaryDesc:
        '仅展示系统用户、角色、企业组织、应用、字段安全等 CREST 平台对象；CRM 客户、商机、报价、审批等业务对象请到角色权限中维护。',
      changedCount: '{{count}} 个改动',
      save: '保存',
      saveRoleInfo: '保存角色信息',
      roleInfoSaved: '角色信息已保存',
      roleNameRequired: '请输入角色名',
      roleNameMax: '角色名不能超过 100 个字符',
      roleNamePlaceholder: '例如：普通员工',
      displayNamePlaceholder: '可选，用于补充展示名称',
      descriptionPlaceholder: '说明这个平台角色的用途',
      selectRoleType: '请选择角色类型',
      loadFailed: '加载角色与权限失败',
      detailLoadFailed: '加载角色详情失败',
      privilegesLoadFailed: '加载平台数据权限失败',
      appsSaved: '应用访问已保存',
      menusSaved: '平台菜单权限已保存',
      privilegesSaved: '平台数据权限已保存',
      saveFailed: '保存失败',
      savePrivilegeChanges: '保存权限 ({{count}} 改动)',
      noApps: '暂无可配置应用',
      noMenus: '暂无可配置菜单',
    },
    accessCenter: {
      title: '权限中心',
      subtitle: '统一维护岗位、跨系统角色目录与授权来源；详细权限仍由各业务系统定义和执行',
      platformRoles: '平台角色',
      positions: '岗位管理',
      roleCatalog: '角色目录',
      assignments: '用户授权与生效任务',
      requests: '权限申请',
      openAccess: '权限中心',
      configureUserRoles: '权限配置',
      grantGovernance: '授权治理',
      legacyMembersMoved: '角色成员授权已迁移到权限中心',
      legacyMembersMovedDescription:
        '当前 {{count}} 条成员关系仅供核对。新增、撤销、岗位继承和临时代理统一在权限中心完成。',
      legacyCrmAuthorizationTitle: 'CRM 用户授权已迁移',
      legacyCrmAuthorizationSubtitle: 'CRM 继续维护角色定义，成员授权由 CREST 统一治理',
      legacyCrmAuthorizationDescription:
        '请在权限中心通过岗位、直接例外或审批申请维护用户授权。CRM 不再提供独立用户授权页面。',
      newPosition: '新建岗位',
      positionSubtitle: '岗位是人在企业组织中的正式身份，可绑定多个业务系统角色',
      positionCode: '岗位编码',
      positionName: '岗位名称',
      enterpriseOrg: '企业组织',
      jobFamily: '职族',
      jobLevel: '职级',
      noPositions: '暂无岗位',
      editPosition: '修改名称',
      editPositionFor: '修改“{{name}}”',
      editPositionSubtitle: '仅修改岗位显示名称，不改变岗位编码、所属组织、任职或角色绑定',
      savePositionName: '保存岗位名称',
      positionNameRequired: '请输入岗位名称',
      positionUpdated: '岗位名称已更新',
      configureRoles: '配置角色',
      configureRolesFor: '配置“{{name}}”的角色',
      bindingSubtitle: '岗位绑定只引用角色目录，角色的详细权限仍在所属业务系统维护',
      bindingCreated: '岗位角色绑定已创建',
      positionMembers: '任职成员',
      selectUser: '请选择用户',
      assignPosition: '添加兼岗',
      assignmentCreated: '任职已创建',
      assignmentEnded: '任职已结束',
      positionType: '任职类型',
      primaryPosition: '主岗',
      concurrentPosition: '兼岗',
      endAssignment: '结束任职',
      selectRole: '请选择角色',
      scopePolicy: '数据范围策略',
      dataScope: '数据范围',
      salesScope: '业务组织',
      selectSalesScope: '选择一个或多个业务组织',
      includeChildSalesOrgs: '授权包含下级业务组织',
      includeChildScopes: '包含下级业务组织',
      scopeRequired: '请至少选择一个业务组织',
      scopeLoadFailed: '加载 CRM 业务组织失败',
      scopeCount: '{{count}} 个业务组织',
      scopeNodeCount: '{{count}} 项',
      businessOrgScope: '钉钉业务组织范围',
      salesRegionScope: '销售大区范围',
      selectBusinessOrgScope: '选择一个或多个钉钉业务组织',
      selectSalesRegionScope: '选择一个或多个销售大区',
      includeChildBusinessOrgs: '包含下级钉钉业务组织',
      scopeMode_all: '全部',
      scopeMode_selected: '指定范围',
      scopeMode_personal: '个人所属大区',
      scope_role_default: '角色默认范围',
      scope_position_org: '岗位所属组织',
      scope_position_org_descendants: '岗位所属组织及下级',
      scope_explicit: '指定组织与大区',
      scope_personal_region: '个人大区范围',
      addRoleBinding: '添加角色与范围',
      created: '岗位已创建',
      searchRoles: '搜索角色名称',
      allDomains: '全部业务域',
      domain: '业务域',
      roleName: '角色',
      roleType: '角色类型',
      riskLevel: '授权风险',
      approvalRequired: '需要审批',
      ordinaryRole: '普通角色',
      workflowEligible: '可用于审批',
      version: '版本',
      noRoles: '暂无跨域角色',
      syncCrmRoles: '同步 CRM 角色',
      roleSyncDone: 'CRM 角色目录对账完成',
      directGrant: '直接/临时授权',
      directGrantSubtitle: '仅可直接授予普通业务角色；系统和管理员角色必须走审批',
      newAccessRequest: '新建权限申请',
      accessRequestSubtitle: '高权限、Global 数据权限、临时代理和紧急授权必须审批后生效',
      requestType: '申请类型',
      requestReason: '申请理由',
      delegatedFrom: '原权限持有人',
      source_direct: '高权限授权',
      source_delegation: '临时代理',
      source_emergency: '紧急授权',
      expiryRequired: '临时代理和紧急授权必须设置到期时间',
      approvalPolicy: '高风险授权实行申请人与审批人分离',
      approvalPolicyDescription:
        '审批通过后才向所属业务系统投递；业务系统不可用时保留申请并显示失败状态，不会放宽权限。',
      requestSubmitted: '权限申请已提交审批',
      requestSubmitFailed: '申请已保存或提交失败，请刷新查看状态并按提示重试',
      requestRetryQueued: '已重新发起审批流程',
      noAccessRequests: '暂无高权限或代理授权申请',
      viewWorkflow: '查看审批',
      user: '用户',
      source: '授权来源',
      validFrom: '生效时间',
      validTo: '到期时间',
      indefinite: '长期有效',
      allStates: '全部状态',
      noAssignments: '暂无授权事实',
      grantCreated: '授权已创建，状态以业务系统回执为准',
      retry: '重试',
      retryQueued: '已重新加入投递队列',
      revoke: '撤销',
      revoked: '撤销请求已提交',
      revokeConfirm: '确认撤销这条授权？相同角色若仍有其他有效来源，将继续保留。',
      orchestrationNotEnforced: '授权编排尚未强制生效',
      orchestrationNotEnforcedDescription: '当前模式为 {{mode}}，已禁止新增和撤销，避免任务状态与实际权限不一致。',
      projectionHealth: '投影健康',
      projectionHealthy: '各权限域授权投影一致',
      projectionMismatch: 'CRM 授权投影存在差异',
      projectionCounts: '无来源成员 {{missing}} 条，缺失成员 {{extra}} 条，失败 {{failed}} 条',
      reconcile: '执行对账修复',
      reconcileDone: '对账任务已完成',
      actions: '操作',
      loadFailed: '权限中心加载失败；请确认功能开关和数据库迁移已启用',
      state_pending: '待生效',
      state_approval_pending: '审批中',
      state_approval_failed: '审批发起失败',
      state_approval_rejected: '审批拒绝',
      state_approval_cancelled: '审批已取消',
      state_applying: '生效中',
      state_active: '已生效',
      state_failed: '失败',
      state_retrying: '重试中',
      state_revoke_pending: '撤销中',
      state_revoked: '已撤销',
      state_expired: '已过期',
    },
    crmUserAuthorization: {
      title: 'CRM用户列表',
      subtitle:
        '配置已进入 CRM 的用户角色和大区，并查看用户身份；人员主数据与岗位仍由 CREST 统一维护',
      readOnlyTitle: '本页仅用于查看 CRM 用户信息',
      readOnlyDescription:
        '用户主数据、岗位和任职仍由 CREST 统一维护；本页用于查看详情并管理 CRM 角色、大区和启停状态。',
      totalUsers: '共 {{count}} 个 CRM 用户',
      noUsers: '暂无 CRM 用户',
      membershipRevoked: '成员关系已撤销',
      searchPlaceholder: '搜索用户姓名 / 邮箱 / 账号',
      user: '用户',
      enterpriseOrg: 'CRM业务组织',
      crmRoles: 'CRM角色',
      crmIdentity: '用户身份',
      crmModeScope_domestic: '国内用户',
      crmModeScope_overseas: '海外用户',
      crmModeScope_both: '国内+国外',
      defaultCrmMode_domestic: '默认国内',
      defaultCrmMode_overseas: '默认海外',
      crmRegions: 'CRM大区',
      status: '状态',
      statusFilter: '按启用状态筛选',
      allStatuses: '全部状态',
      roleFilter: '按 CRM 角色筛选',
      allRoles: '全部 CRM 角色',
      identityFilter: '按用户身份筛选',
      allIdentities: '全部用户身份',
      active: '启用',
      inactive: '停用',
      noCrmRoles: '暂无 CRM 角色',
      noRegions: '暂无大区任命',
      actions: '操作',
      details: '详情',
      configure: '配置',
      handover: '交接',
      handoverTitle: '交接 {{name}} 的 CRM 业务资料',
      handoverSubtitle: '选择接收全部业务资料的新负责人',
      handoverWarning: '交接后，原用户将不再是这些资料的负责人。',
      handoverDescription:
        '系统会完整保留客户、联系人、商机及其关联报价和中信保资料，并统一变更负责人；不会创建重复记录。此操作不可撤销。',
      handoverTarget: '交接人',
      handoverTargetPlaceholder: '搜索并选择交接人',
      handoverTargetRequired: '请选择交接人',
      confirmHandover: '确认交接',
      handoverSuccess:
        '交接完成：{{accounts}} 个客户、{{contacts}} 个联系人、{{opportunities}} 个商机',
      handoverFailed: '交接失败，所有资料均未变更，请重试',
      authorize: '授权',
      enable: '启用',
      disable: '停用',
      drawerTitle: '{{name}} 的 CRM 授权',
      assignedCrmRoles: '已分配 CRM 角色',
      availableCrmRoles: '可分配 CRM 角色',
      assignedRegions: '已任命 CRM 大区',
      assignRegion: '任命 CRM 大区',
      selectRegion: '选择 CRM 大区',
      regionRoleOwner: '负责人',
      regionRoleMember: '成员',
      regionRoleApprover: '审批人',
      regionRoleViewer: '观察员',
      assign: '分配',
      roleNameDomesticRegionalVp: '国内区域VP',
      roleNameDomesticPresales: '国内售前',
      roleNameDomesticSales: '国内销售',
      roleNameDomesticSalesDirector: '国内销售总监',
      roleNameDomesticSalesHead: '国内销售总管',
      roleNameDomesticSalesSupervisor: '国内销售监察',
      roleNameOverseasKaPocApprover: '海外-KA-POC审批',
      roleNameOverseasRegionalVp: '海外区域VP',
      roleNameOverseasPresales: '海外售前',
      roleNameOverseasOpportunityOwner: '海外商机负责人',
      roleNameOverseasAccountOwner: '海外客户负责人',
      roleNameOverseasSales: '海外销售',
      roleNameOverseasSalesDirector: '海外销售总监',
      roleNameFinance: '财务',
      assignSuccess: 'CRM 角色已分配',
      revokeSuccess: 'CRM 角色已移除',
      saveIdentity: '保存身份',
      identitySaveSuccess: 'CRM 身份已保存',
      regionAssignSuccess: 'CRM 大区任命已保存',
      regionRevokeSuccess: 'CRM 大区任命已撤销',
      enableSuccess: 'CRM 用户已启用',
      disableSuccess: 'CRM 用户已停用',
      disableConfirmTitle: '确认停用用户',
      disableConfirmContent:
        '停用后 {{name}} 将不能登录 CRM，也不能再作为新的负责人被选择；其历史客户、商机等资产仍保留并对有权限人员可见。',
      detailTitle: '{{name}} 的用户详情',
      detailRefreshFailed: '详情刷新失败，当前展示列表中的最新数据',
      basicInformation: '基本信息',
      userName: '用户名',
      email: '邮箱',
      account: '登录账号',
      defaultCrmMode: '默认 CRM 模式',
      createdOn: '创建时间',
      modifiedOn: '更新时间',
      businessOrgHierarchy: '业务组织层级与描述',
      businessOrgLevel: '{{level}}级组织',
      noBusinessOrg: '暂无业务组织',
      noDescription: '暂无描述',
      loadFailed: '加载 CRM 用户授权失败',
      partialLoadFailed: '用户列表已加载，但角色或大区配置暂时不可用',
      saveFailed: '保存失败',
    },
    crmRegionAuthorization: {
      title: 'CRM大区授权',
      subtitle: '按 CRM 业务组织批量生成用户的大区任命，并统一查看、撤销当前任命',
      assignByDepartment: '按CRM业务组织授权大区',
      assignmentList: '当前大区任命',
      selectRegion: '选择 CRM 大区',
      selectRegionAndDepartment: '请选择 CRM 大区和 CRM 业务组织',
      includeChildren: '包含子业务组织',
      assign: '生成任命',
      people: '人',
      filterRegion: '筛选大区',
      searchPlaceholder: '搜索用户 / 邮箱 / CRM业务组织 / 大区',
      region: '大区',
      user: '用户',
      department: '用户所在企业部门',
      role: '身份',
      source: '来源',
      actions: '操作',
      revoke: '撤销',
      source_manual: '单人任命',
      source_department_import: '部门批量生成',
      source_business_org_import: 'CRM业务组织批量生成',
      regionRoleOwner: '负责人',
      regionRoleMember: '成员',
      regionRoleApprover: '审批人',
      regionRoleViewer: '观察员',
      bulkAssignSuccess: '已生成 {{count}} 个用户的大区任命',
      revokeSuccess: 'CRM 大区任命已撤销',
      loadFailed: '加载 CRM 大区授权失败',
      saveFailed: '保存失败',
    },
    crmBusinessOrg: {
      title: '业务组织',
      subtitle: '由管理员选择进入 CRM 的企业组织，名称、层级和成员归属与企业组织保持同步',
      orgTree: '业务组织树',
      addOrganization: '新建业务组织',
      selectEnterpriseOrg: '新建业务组织',
      selectEnterpriseOrgDescription:
        '从当前启用的企业组织中选择；系统会自动保存所选组织的全部上级目录',
      enterpriseOrgLoadFailed: '加载企业组织失败',
      alreadyAdded: '已添加',
      people: '人',
      selectionRule: '所选组织及其全部启用上级目录会自动保存到 CRM，确保业务组织树层级完整。',
      includeChildOrganizations: '同时添加全部下级组织',
      addSelectedOrg: '新建并保存',
      addSelectedSuccess: '已保存 {{count}} 个业务组织（含所需上级目录）',
      addSelectedFailed: '新建业务组织失败',
      clearTree: '清空组织树',
      clearConfirm: '清空当前业务组织树？',
      clearConfirmDescription:
        '所有当前业务组织将从 CRM 停用；企业组织、钉钉组织和历史引用不会被删除。',
      clearSuccess: '当前业务组织树已清空',
      clearFailed: '清空业务组织树失败',
      newRoot: '新建根组织',
      newChild: '新建下级组织',
      newRootOrg: '新建根组织',
      newChildOrg: '新建下级组织',
      newOrg: '新建业务组织',
      editOrg: '编辑业务组织',
      modalSubtitle: '定义 CRM 销售经营层级；成员关系仅在 CRM 生效，不改变 CREST 用户、岗位和任职',
      orgName: '组织名称',
      orgCode: '组织编码',
      scopeCode: '组织编码',
      parentOrg: '上级业务组织',
      rootScope: '根组织',
      rootOrg: '根组织',
      notLinked: '未关联',
      projectedMemberCount: 'CRM成员数',
      governanceMoved: '人员主数据仍由 CREST 统一维护',
      governanceMovedDescription:
        '本页只维护 CRM 业务组织及成员关系，不创建、删除或停用 CREST 用户。',
      organizationBoundary: 'CRM 业务组织与 CREST 人员主数据相互隔离',
      organizationBoundaryDescription:
        '本页新增、移除成员或删除组织，只改变 CRM 业务组织及成员关系；不会删除、停用或调整 CREST 中的用户、行政组织、岗位和任职。',
      organizationSyncTitle: 'CRM 业务组织由管理员选择',
      organizationSyncDescription:
        '管理员从企业组织中新建 CRM 业务组织，系统自动补齐上级目录；组织名称、上下级和成员归属持续跟随企业组织。',
      syncSource: '同步来源',
      description: '描述',
      linkedCrestOrg: '关联 CREST 组织',
      linkedCrestOrgPlaceholder: '选择关联的 CREST 子组织',
      linkedCrestOrgIncludeChildren: '同步时包含子组织人员',
      linkedCrestOrgInfo: '关联 CREST 组织：{{name}}',
      linkedCrestOrgIncludeChildrenShort: '包含子组织',
      linkedCrestOrgCurrentOnly: '仅当前组织',
      syncLinkedOrg: '同步关联组织人员',
      linkedOrgSynced:
        '关联组织已同步：范围 {{active}} 人，更新 {{synced}} 人，移除 {{removed}} 人',
      save: '保存',
      saveSuccess: '业务组织已保存',
      deleteSuccess: 'CRM 业务组织已删除，历史记录仍保留',
      deleteFailed: '删除 CRM 业务组织失败',
      saveFailed: '保存失败',
      loadFailed: '加载 CRM 业务组织失败',
      empty: '尚未添加业务组织',
      selectOrg: '请选择业务组织',
      noDescription: '暂无描述',
      member: '成员',
      enterpriseOrg: '所属企业组织',
      source: '来源',
      manual: '手工添加',
      departmentImport: '部门导入',
      crestOrgSync: '关联组织同步',
      localProjection: '本地投影',
      actions: '操作',
      remove: '移除',
      edit: '编辑',
      delete: '删除',
      deleteConfirm: '删除该业务组织？',
      deleteConfirmDescription:
        '删除后该部门将不再参与 CRM 权限和业务范围计算；企业组织、钉钉部门及历史记录不受影响。',
      deleteBlockedChildren: '该部门仍有生效下级，请先处理下级部门',
      deleteBlockedMembers: '该部门仍有 {{count}} 名成员，请先迁移成员归属',
      members: '组织成员',
      memberBoundary: '成员操作仅影响 CRM',
      memberBoundaryDescription:
        '添加、移除或清空成员只改变 CRM 业务组织关系，不会删除、停用或调整 CREST 人员数据。',
      syncedMemberTitle: '成员随企业组织自动同步',
      syncedMemberDescription: '如需调整成员归属，请在企业组织或钉钉通讯录中修改后重新同步。',
      selectUser: '选择要加入的用户',
      addUser: '添加用户',
      selectDepartment: '选择企业部门批量添加成员',
      addByDepartment: '按部门添加',
      clearDepartment: '清空部门人员',
      clearCurrentMembers: '清空',
      includeChildren: '包含子部门人员',
      memberAdded: '成员已添加',
      memberRemoved: '成员已移除',
      membersCleared: '当前组织成员已清空',
      memberOperationFailed: '成员操作失败',
      noMembers: '当前组织暂无成员',
      deptAdded: '已从部门加入 {{count}} 人',
      deptCleared: '已清空 {{count}} 个部门成员',
      currentMembersCleared: '已清空当前部门 {{count}} 名成员',
      clearDeptConfirm: '确认清空所选部门范围内的成员？',
      clearCurrentMembersConfirm: '清空当前 CRM 业务组织的全部成员？',
      clearCurrentMembersDescription:
        '只撤销当前组织的 CRM 成员关系，不影响下级组织，也不会影响 CREST 用户、岗位和任职。',
      removeConfirm: '移除该 CRM 组织成员？',
      removeConfirmDescription: '只移除 CRM 业务组织成员关系，不会删除或停用 CREST 用户。',
    },
    userAvatar: {
      profile: '个人中心',
      settings: '个人设置',
      userType: '用户属性',
      domestic: '国内用户',
      overseas: '海外用户',
      profileTitle: '个人中心',
      settingsTitle: '个人设置',
      name: '姓名',
      account: '账号',
      businessUnit: '所属企业组织',
      roles: '角色',
      platformRoles: 'Platform 角色',
      crmRoles: 'CRM 角色',
      agentRoles: 'Agent 角色',
      currentUserType: '当前属性',
      uiLanguage: '界面语言',
      defaultCurrency: '默认货币',
      switchHint: '国内/海外属性可在头像菜单下方切换；切换后会同步更新界面语言。',
      changePassword: '修改登录密码',
      currentPassword: '当前密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      enterCurrentPassword: '请输入当前密码',
      enterNewPassword: '请输入新密码',
      passwordMinLength: '新密码至少 8 位',
      confirmPasswordPrompt: '请再次输入新密码',
      passwordMismatch: '两次输入的新密码不一致',
      savePassword: '保存密码',
      passwordChanged: '密码已修改',
      passwordChangeFailed: '密码修改失败',
    },
    header: {
      notificationCenter: '通知中心',
      sipCallCenter: 'SIP 通话中心',
      sipSettings: 'SIP 参数配置',
      logout: '退出登录',
      agentAssistant: 'Agent 助手',
      agentStudio: '打开 Agent Studio',
      stopResponse: '停止回答',
      dragToResize: '拖动调整大小',
      dragToResizeWidth: '拖动调整宽度',
      dragToResizeHeight: '拖动调整高度',
    },
    inbox: {
      drawerTitle: '审批详情',
      cancel: '取消',
      reject: '驳回',
      approve: '批准',
      taskInfo: '任务信息',
      taskName: '任务名',
      targetEntity: '目标实体',
      ownerName: '提交人',
      createdOn: '创建时间',
      approvalComment: '审批意见',
      openFullDetails: '打开完整详情页',
      businessSummary: '业务概要',
      noBusinessFields: '无业务字段',
      noEntityDetails: '无目标实体详情',
    },
    reporting: {
      appName: '报告中心',
      myReports: '我的报告',
      myReportsSubtitle: '管理日报、周报和月报',
      newReport: '新建报告',
      refreshCrestData: '刷新 Crest 数据',
      createDraftFailed: '创建草稿失败，请稍后重试',
      loadFailed: '报告数据加载失败，请刷新重试',
      saveFailed: '保存失败，请稍后重试',
      submitFailed: '提交失败，请稍后重试',
      revisionConflictTitle: '草稿已有新版本',
      revisionConflictDescription:
        '其他操作已经更新了这份草稿。请刷新后继续编辑，避免覆盖最新内容。',
      reloadDraft: '刷新草稿',
      syncFailed: 'Crest 数据刷新失败，仍可手工填写报告',
      sourceSyncSkipped: 'Crest 数据源未启用，仍可手工填写报告',
      sourceSyncSucceeded: '已同步 {{count}} 条 Crest 事实',
      sourceSyncPartial: '已同步 {{count}} 条 Crest 事实，部分来源暂不可用',
      agentSkipped: '报告 Agent 未启用或缺少证据，仍可手工填写报告',
      agentSucceeded: '已生成 {{count}} 条 AI 摘要',
      agentFailed: 'AI 摘要未生成，仍可手工填写报告',
      systemFactsComposed: '系统事实已生成',
      submitReport: '提交周报',
      submitReportByType: '提交{{type}}',
      submitNoWriteback: '提交后会生成候选事项，但不会自动写入 CRM。接受候选只表示报告内确认。',
      evidenceCoveragePreview: '证据覆盖：{{covered}}/{{total}} 个段落，{{sources}} 条来源',
      preview: '预览',
      save: '保存草稿',
      compose: '生成系统事实',
      refineWithAgent: '生成 AI 摘要',
      carryOver: '带入未处理事项',
      sourceSync: '同步 Crest 数据',
      sourcePanel: 'Crest 数据源',
      systemFact: 'Crest 事实',
      aiSummary: 'AI 生成',
      aiOriginal: 'AI 原文',
      manualText: '人工补充',
      acceptedNotSynced: '已接受（未同步 CRM）',
      rejected: '已拒绝',
      deferred: '稍后处理',
      writebackDisabled: '同步到 CRM（未启用）',
      writebackNotRequested: '未请求写回',
      writebackUnavailable: '写回不可用',
      writebackPrepared: '已准备（不可执行）',
      contractReserved: 'Writeback Contract 已预留',
      providerNotInstalled: 'CRM Provider 未安装',
      readonlyConnector: 'CRM 只读 Connector 提供，不会修改 CRM',
      candidateNoWriteback: '接受候选不会自动写入 CRM',
      crmProvider: 'CRM',
      crmSourceSummary: '活动 / 商机 / 客户',
      sourceConnector: 'CRM 只读数据源',
      preGeneration: '预生成',
      manualReporting: '手工报告',
      intelligenceRuntime: '智能能力',
      agentRuntime: 'Agent',
      backgroundJobs: '后台任务',
      deliveryRuntime: '分发',
      opsStatus: '分发与后台任务',
      deliveries: '分发记录',
      jobs: '任务记录',
      requestDelivery: '请求分发',
      requestPregenerate: '请求预生成',
      emptyOps: '暂无状态记录',
      opsLoadFailed: '分发和任务状态加载失败，请刷新重试',
      opsRequestFailed: '请求未提交成功，请稍后重试',
      attemptCount: '尝试 {{count}} 次',
      ops_blocked: '已阻断',
      ops_queued: '已排队',
      ops_running: '运行中',
      ops_succeeded: '已成功',
      ops_sent: '已发送',
      ops_failed: '失败',
      ops_skipped: '已跳过',
      candidateExtraction: '候选提取',
      llmStatus: 'LLM',
      llmNotConfiguredShort: '未配置',
      enabled: '已启用',
      disabled: '未启用',
      contractVersion: '合约版本',
      execute: '执行',
      reportType: '报告类型',
      period: '周期',
      weeklyPeriodTitle: '{{year}} 第 {{week}} 周（{{start}} ~ {{end}}）',
      submittedAt: '提交时间',
      daily: '日报',
      weekly: '周报',
      monthly: '月报',
      revision: '版本 {{revision}}',
      crestFactsSynced: '已同步 Crest 事实，数据截至 {{time}}',
      reportsRecent: '近期报告',
      manualModeAvailable: 'Connector 关闭时仍可手工写报告',
      draft: '草稿',
      submitted: '已提交',
      notSubmitted: '未提交',
      obligation_none: '未生成义务',
      obligation_open: '待提交',
      obligation_submitted: '已提交',
      obligation_late: '已逾期',
      obligation_waived: '已豁免',
      submittedLate: '迟交已提交',
      dueAt: '截止 {{time}}',
      continueEditing: '继续编辑',
      view: '查看',
      exportHtml: '导出 HTML',
      exportPdf: '导出 PDF',
      exportWord: '导出 Word（未启用）',
      exportWordUnavailable: '当前运行时没有 Word 生成组件，请使用 HTML 或 PDF 导出',
      reportEditor: '编辑周报',
      reportEditorByType: '编辑{{type}}',
      settings: '报告设置',
      settingsSubtitle: '配置模板、提交规则、数据源和智能能力',
      reportTemplates: '报告模板',
      submissionRules: '提交规则',
      dataSource: '数据源',
      attachmentLinks: '附件链接',
      addAttachmentLink: '添加附件链接',
      attachmentUrl: '粘贴 https:// 附件链接',
      attachmentName: '附件名称（可选）',
      attachmentDescription: '说明（可选）',
      emptyAttachments: '暂无附件链接',
      attachmentAddFailed: '附件链接保存失败，请检查链接后重试',
      attachmentDeleteFailed: '附件链接删除失败，请稍后重试',
      sourceIncluded: '已包含',
      sourceExcluded: '已排除',
      include: '包含',
      exclude: '排除',
      actions: '操作',
      emptyDraft: '还没有报告草稿',
      emptySources: '还没有同步到 Crest 事实',
      evidence: '证据快照',
      evidenceDetails: '证据详情',
      viewEvidence: '查看证据',
      sourceType: '来源类型',
      sourceId: '来源 ID',
      subject: '对象',
      evidenceAccessVisible: '当前可见',
      evidenceAccessNotVisible: '当前不可见',
      evidenceAccessSourceDisabled: '数据源未启用',
      evidenceRedacted: '当前无权查看该证据',
      emptyEvidence: '暂无冻结证据快照',
      readonlySnapshot: '提交时冻结的只读快照',
      emptyCandidates: '暂无候选事项',
      factCandidates: '事实候选',
      emptyFactCandidates: '暂无事实候选',
      factCandidateLoadFailed: '事实候选加载失败，请稍后重试',
      factCandidateReviewFailed: '事实候选审核失败，请稍后重试',
      emptyFactText: '无事实内容',
      versionTimeline: '版本历史',
      emptyVersions: '暂无版本历史',
      versionLoadFailed: '版本历史加载失败，请稍后重试',
      versionNo: '版本 {{version}}',
      currentVersion: '当前版本',
      detected: '待审核',
      accepted: '已接受',
      superseded: '已替代',
      supersede: '标记替代',
      coverage: '提交覆盖率',
      intelligence: '经营洞察',
      briefings: '周期简报',
      scopeSelf: '我的',
      scopeTeam: '团队',
      scopeSelfDescription: '当前展示我的报告范围',
      scopeTeamDescription: '当前展示我可查看的团队报告范围',
      employee: '员工',
      totalPeriods: '周期数',
      submittedPeriods: '已提交周期',
      missingPeriods: '未提交周期',
      latePeriods: '逾期周期',
      completionRate: '完成率',
      latestSubmittedAt: '最近提交',
      columnSettings: '列设置',
      reviewStatus: '确认状态',
      writebackStatus: '写回状态',
      count: '数量',
      llmNotConfigured: 'LLM/Agent 未启用，当前展示确定性汇总',
      generatedDeterministically: '由报告内容确定性生成',
      editBriefing: '编辑简报',
      publishBriefing: '发布简报',
      archiveBriefing: '归档简报',
      briefingUpdateFailed: '简报更新失败，请稍后重试',
      blockCount: '内容块',
      systemFactCount: '系统事实',
      manualTextCount: '人工补充',
      syncedFactsShort: '已同步 {{count}} 条事实',
      crestNotSynced: 'Crest 未同步',
      manualPendingAll: '手工待补充全部',
      noBriefings: '暂无可汇总的已提交报告',
      currentPeriod: '当前周期',
      timezone: '时区',
      dataFreshness: '数据截至',
      connectorManualFallback: '当前 Connector 存在不可用来源，仍可使用手工模式填写和提交报告',
      dueTime: '截止时间',
      lastSubmitted: '最后提交',
      lastSaved: '最后保存',
      allChangesSaved: '已保存',
      revisionShort: '第 {{revision}} 版',
      dataUntil: 'Crest 数据截至 {{time}}',
      basedOnEvidence: '基于 {{count}} 条事实',
      sourceFrom: '来源：{{type}}',
      viewSource: '查看来源',
      adopt: '采纳',
      ignore: '忽略',
      manuallyEdited: '人工已修改',
      lastSyncShort: '上次同步：{{time}}',
      partialSourceWarning: '部分数据同步失败，1 个连接不可用',
      sourceTabAll: '全部 ({{count}})',
      title: '标题',
      viewMoreWithCount: '查看更多 ({{count}})',
      connectorUnavailable: '连接不可用，ERP 连接权限变更不可用，部分成本数据未同步。',
      completedCheckItems: '已完成 {{completed}}/{{total}} 项检查',
      missingCustomerFeedback: '缺少客户满意度反馈',
      manualPending: '未填写辅助事项',
      attachmentMissing: '未上传相关附件',
      aiSuggestionShort: '建议补充客户预算评估进展',
      crmEvidenceDetails: 'CRM 证据详情',
      occurredAt: '发生时间',
      safeSummary: '安全摘要',
      currentAccessStatus: '当前授权状态',
      noOriginalRecordAccess: '当前无权查看原记录',
      accessChangedCopy: '你所在的角色或组织范围变更，无法查看此条原始记录。',
      metadata: '元数据',
      reportSection: '纳入报告章节',
      securityNotice: '安全声明',
      evidenceSecurityCopy: '报告中仅展示安全摘要，不展示系统敏感字段。',
      openCrmRecord: '打开 CRM 原记录',
      noOriginalRecordAccessAction: '当前无权查看原记录，不可打开。',
      returnToCheck: '返回检查',
      includedCrestFacts: '纳入 Crest 事实',
      submitFreezeNotice: '提交后将创建不可变版本，并生成候选事项与候选行动。',
      submitNoCrmWrite: '本次提交不会自动写入 CRM。',
      submitVisibleInReports: '已提交的候选会在本版本中显示，来源为“未同步 CRM”。',
      submitCandidateNotice: '后续如需启用写入能力，将在系统设置中另行配置并公告。',
      manualSupplementPlaceholder: '补充本章节其他事项...',
      attachments: '附件',
      uploadAttachmentHint: '点击或拖拽文件到此处上传',
      uploadAttachmentTypes: '支持 docx、xlsx、pptx、pdf、png、jpg',
      sourceConnectorStatus: 'Connector 状态',
      connectorNormal: '正常',
      sourceMode: '来源模式',
      sourceModeAuto: '自动',
      sourceModeMixed: '混合',
      sourceModeManual: '手工',
      sourceModeUnknown: '未记录',
      version: '版本',
      revisionLabel: '草稿版本',
      evidenceCount: '证据 {{count}} 条',
      totalSources: '全部 {{count}}',
      includedSources: '已包含 {{count}}',
      suggestedSources: '建议 {{count}}',
      excludedSources: '已排除 {{count}}',
      reportCompletion: '报告完成度',
      aiSuggestion: 'AI 建议',
      aiSuggestionDescription: '基于当前证据补全缺口，应用前仍需人工确认',
      sourceTypeUnknown: '未知来源',
      sourceTypeGeneric: '外部来源：{{type}}',
      sourceType_activity: '活动',
      sourceType_opportunity: '商机',
      sourceType_account: '客户',
      sourceType_contact: '联系人',
      sourceType_contract: '合同',
      sourceType_order: '订单',
      block_generic: '自定义分区：{{section}}',
      block_summary: '本周期摘要',
      block_progress: '重点进展',
      block_plan: '下周期计划',
      block_manual: '人工补充',
      block_risk: '风险与阻塞',
      block_risks: '风险与阻塞',
      block_next_steps: '下一步行动',
      block_achievements: '关键成果',
      block_highlights: '亮点事项',
      block_customer: '客户情况',
      block_customer_progress: '客户与商机进展',
      reportInfo: '报告信息',
      openSourceRecord: '打开源记录（只读，未启用）',
      teamCoverageDetail: '员工提交明细',
      totalPeriodsWithCount: '共 {{count}} 个周期',
      latePeriodsWithCount: '逾期 {{count}} 个周期',
      generatedInsights: '生成洞察',
      reviewQueue: '待确认队列',
      riskQueue: '风险与阻塞队列',
      topicAggregation: '主题聚合',
      allInsights: '全部洞察',
      scope: '组织范围',
      dataGenerationMode: '生成方式',
      briefingList: '简报列表',
      briefingContent: '简报内容',
      briefingInfo: '简报信息',
      dataSourceOverview: '数据与来源概览',
      reviewFlow: '审阅流程',
      createBriefing: '创建简报',
      teamReview: '团队审阅中',
      evidenceTotal: '证据总数',
      operationLog: '操作记录',
      connectorHealth: 'Connector 健康',
      pilotScope: '试点范围',
      futureSourceLocked: '后续可接入，当前不参与报告生成',
      erpSource: 'ERP',
      supportSource: '支持系统',
      taskStatus: '任务状态',
      agentRuntimeDescription: '负责摘要生成、建议补全和深度分析',
      backgroundJobsDescription: '负责预生成、刷新和异步计算',
      deliveryRuntimeDescription: '负责定时分发和提醒',
    },
    workflow: {
      todo: '我的待办',
      done: '我的已办',
      copy: '抄送我的',
      manager: '任务管理',
      taskName: '任务',
      businessKey: '业务编号',
      source: '来源',
      assignee: '审批人',
      createdAt: '创建时间',
      search: '搜索流程、业务编号或审批人',
      unavailable: '工作流服务暂不可用',
      partialData: '审批数据未完整加载',
      reportUnavailable: '流程报表暂不可用，请检查工作流服务后重试',
      reportTitle: '流程报表',
      reportRetry: '重试加载',
      reportPartialFailure: '部分报表加载失败',
      reportSummaryFailure: '流程实例统计加载失败',
      reportMigrationFailure: '旧审批一致性核对加载失败',
      reportTotal: '实例总数',
      reportRunning: '运行中',
      reportCompleted: '已完成',
      reportAverageHours: '平均耗时（小时）',
      reportByProcess: '按流程统计',
      reportProcessKey: '流程标识',
      reportInstanceCount: '实例数量',
      reportInstanceDetails: '流程实例明细',
      reportMigrationConsistency: '旧审批灰度一致性',
      reportCheckedTasks: '核对任务',
      reportMatched: '一致',
      reportMismatched: '不一致',
      reportLegacyTask: '旧任务',
      reportBusinessType: '业务类型',
      reportLegacyStatus: '旧状态',
      reportLegacyApprover: '旧审批人',
      reportFlowableApprover: 'Flowable 审批人',
      models: '流程模型',
      createModel: '新建流程',
      modelName: '流程名称',
      modelKey: '流程标识',
      designerType: '设计器',
      version: '版本',
      status: '状态',
      publish: '发布',
      startScope: '谁可以发起',
      allUsers: '所有用户',
      selectedUsers: '指定用户',
      selectedDepartments: '指定部门',
      organizationNameLoading: '正在读取组织名称…',
      organizationUnavailable: '组织不可用或无查看权限',
      organizationConditionValue: '条件组织',
      organizationConditionPlaceholder: '搜索并选择业务组织',
      organizationNotFound: '没有匹配的组织',
      organizationDirectoryLoadFailed: '组织目录加载失败，请重新搜索',
      startUsers: '可发起用户',
      startDepartments: '可发起部门',
      processManagers: '流程管理员',
      processManagersHint: '可查看和管理该模型产生的流程实例',
      description: '流程说明',
      permissionSettings: '流程操作权限',
      allowCancelRunningProcess: '允许发起人撤销审批中的申请',
      allowWithdrawTask: '允许审批人撤回已经处理的任务',
      processNumberRule: '流程编号规则',
      processNumberDisabled: '未启用',
      numberPrefix: '编号前缀',
      datePattern: '日期格式',
      noDate: '不含日期',
      numberSuffix: '编号后缀',
      sequenceLength: '流水号长度',
      numberExample: '编号示例',
      displaySettings: '标题与摘要',
      autoApproval: '重复审批人自动处理',
      autoApprovalNone: '不自动通过',
      autoApprovalOnce: '只审批一次，后续节点自动通过',
      autoApprovalConsecutive: '仅连续节点自动通过',
      customTitle: '自定义实例标题',
      titleTemplate: '标题模板',
      titleTemplateHint: '例如：请假申请 - {{applicantName}}',
      summaryFields: '实例摘要字段',
      safeTriggers: '流程与任务触发器',
      safeTriggerHint: '仅允许选择监听器目录中已经通过安全审查的触发器。',
      processBeforeListenerKey: '流程启动前',
      processAfterListenerKey: '流程结束后',
      taskBeforeListenerKey: '任务创建时',
      taskAfterListenerKey: '任务完成后',
      printTemplate: '审批单打印模板',
      notification: '通知渠道',
      stationMessage: '站内信',
      email: '邮件',
      sms: '短信',
      dingtalk: '钉钉',
      feishu: '飞书',
      wecom: '企业微信',
    },
    contractPayment: {
      title: '付款计划',
      subtitle: '支持多节点及节点内按月分期',
      paymentThrough: '付款通道',
      validPercent: '比例合计 100%',
      node: '节点 {{index}}',
      moveUp: '上移付款节点 {{index}}',
      moveDown: '下移付款节点 {{index}}',
      removeNode: '删除付款节点 {{index}}',
      addNode: '新增付款节点',
      nodeType: '节点类型',
      percent: '付款比例',
      timing: '时间关系',
      milestone: '付款里程碑',
      offset: '偏移时间',
      offsetUnit: '偏移单位',
      dueDays: '付款期限',
      settlementMode: '结算方式',
      description: '对客说明',
      single: '单次付款',
      monthly: '按月分期',
      prepayment: '预付款',
      milestonePayment: '里程碑付款',
      fixedDate: '固定日期付款',
      import: '导入付款计划',
      downloadTemplate: '下载模板',
      previewTitle: '付款计划导入预览',
      closePreview: '关闭',
      apply: '应用付款计划',
      fileErrors: '文件存在错误，修正后重新导入',
      rowError: '第 {{row}} 行 · {{column}}：{{message}}',
      downloadFailed: '付款计划模板下载失败，请稍后重试',
      parseFailed: '付款计划解析失败，请检查文件格式',
      periodNo: '期数',
      dueDate: '预计付款日期',
      principal: '应付本金',
      interest: '应付利息',
      totalDue: '当期应付总额',
      balance: '剩余本金',
      fillSchedule: '填写分期计划',
      editSchedule: '编辑分期计划',
      scheduleTitle: '分期付款计划',
      addPeriod: '新增一期',
      removePeriod: '删除第 {{index}} 期',
      cancelSchedule: '取消',
      applyToContract: '应用到合同',
      actions: '操作',
      scheduleHint: '可增加三期、五期或更多期；系统自动计算当期应付总额和剩余本金。',
      targetPrincipal: '本节点应付本金',
    },
    legacy: legacyResources.zh,
    hardcoded: hardcodedResources.zh,
  },
  en: {
    feedback: {
      "title": "Report an issue",
      "submit": "Submit",
      "cancel": "Cancel",
      "page": "Current page",
      "subject": "Issue title",
      "subjectRequired": "Enter an issue title",
      "subjectMax": "Use at most 120 characters",
      "subjectPlaceholder": "Summarize the issue",
      "description": "Description",
      "descriptionPlaceholder": "What happened and what did you expect? Paste screenshots here.",
      "descriptionRequired": "Enter a description (up to 4,000 characters) or add images",
      "addImages": "Add images",
      "imageHint": "Press Ctrl+V / ⌘V in the box to paste screenshots. PNG, JPEG or WebP; up to 3 images, 1MB in total.",
      "tooMany": "Add up to 3 images",
      "tooLarge": "Images must total no more than 1MB",
      "imageType": "Only PNG, JPEG and WebP images are supported",
      "readFailed": "Could not read image. Try again.",
      "removeImage": "Remove image {{index}}",
      "remove": "Remove",
      "submitted": "Feedback submitted",
      "submitFailed": "Submission failed. Try again.",
      "detailFailed": "Could not load feedback details. Try again."
    },
    account: {
      settings: { title: 'Personal settings' },
      dingtalk: {
        title: 'DingTalk connection',
        loadFailed: 'Unable to load the DingTalk connection status.',
        connectFailed: 'Unable to connect DingTalk. Please try again.',
        connectionError: 'Connection error',
        authorizationFailedTitle: 'Full DingTalk authorization was not completed',
        authorizationFailed: 'Full DingTalk authorization was not completed. Reauthorize to retry.',
        connected: 'DingTalk connected',
        revoked: 'CREST has been disconnected from DingTalk.',
        reauthorize: 'Reauthorization required',
        notConnected: 'Not connected',
        disabled: 'Managed DingTalk connections are not enabled by your administrator.',
        purposeTitle: 'How CREST uses DingTalk permissions',
        purpose:
          'Allows the assistant to read and work with your calendars, tasks, messages, documents, and other personal DingTalk data. CREST manages tokens and the CLI; every write action still requires separate confirmation.',
        organization: 'Authorized organization',
        permissions: 'Authorized capabilities',
        items: 'items',
        authorizedAt: 'Last authorized',
        manifest: 'Permission manifest version',
        confirmFullAuthorization: 'Confirm full authorization',
        reauthorizeAction: 'Reauthorize',
        connectAction: 'Connect and authorize DingTalk capabilities',
        revokeConfirm: 'Disconnect CREST from DingTalk?',
        revokeAction: 'Disconnect',
        cardTitle: 'Connect DingTalk to continue',
        cardPurpose: 'CREST needs your DingTalk authorization to complete this request.',
        managedHint:
          'CREST securely manages tokens and the CLI; every write action still requires separate confirmation.',
        connect: 'Connect DingTalk',
        later: 'Later',
        read: 'Read',
        write: 'Write',
        provider: 'DingTalk',
      },
    },
    knowledgeBaseManagement: {
      title: 'Knowledge Base Management',
      subtitle:
        'Manage personal and enterprise knowledge with catalog, preview, and on-demand content loading.',
      personal: 'Personal Knowledge',
      enterprise: 'Enterprise Knowledge',
      public: 'Public Knowledge',
      department: 'Department Knowledge',
      newKnowledgeBase: 'New Knowledge Base',
      name: 'Name',
      description: 'Description',
      departments: 'Accessible Departments',
      selectDepartments: 'Select at least one department',
      create: 'Create Knowledge Base',
      cancel: 'Cancel',
      createSuccess: 'Knowledge base created',
      createFailed: 'Could not create the knowledge base. Check the configuration and retry.',
      loadFailed: 'Could not load knowledge bases. Try again later.',
      deleteTitle: 'Delete knowledge base “{{name}}”?',
      deleteDescription:
        'All documents and section indexes in this knowledge base will be permanently deleted.',
      delete: 'Delete Knowledge Base',
      deleteSuccess: 'Knowledge base deleted',
      empty: 'No knowledge bases yet. Create one to start organizing information.',
      selectHint: 'Select a knowledge base to manage its documents.',
      documents: 'documents',
      sections: 'sections',
      source: 'Source',
      conversationSource: 'Conversation',
      directUploadSource: 'Direct upload',
      progressiveTag: 'OpenViking · Progressive loading',
      progressiveHint:
        'CREST enforces access and progressive loading while OpenViking provides semantic and vector retrieval. Agents discover catalogs and summaries, then read bounded sections on demand.',
      personalDescription: 'Visible and usable only by its creator.',
      publicDescription: 'Visible and usable by everyone in the enterprise.',
      departmentDescription: 'Visible and usable only by members of selected CREST organizations.',
      myKnowledgeBases: 'My knowledge bases',
      candidates: 'To organize',
      documentHistory: 'Document history',
      publishRequests: 'Publish requests',
      publishReview: 'Publish review',
      requestPublish: 'Request publish',
      requestEnterprisePublish: 'Publish to enterprise knowledge',
      publishRequestHint:
        'A knowledge administrator reviews the request. Enterprise OpenViking is updated only after approval.',
      publishAfterApproval:
        'Submitting a request does not modify enterprise knowledge, and you may withdraw it before review.',
      enterpriseTarget: 'Enterprise target',
      selectEnterpriseTarget: 'Select an accessible enterprise knowledge base',
      publishReason: 'Publish rationale',
      publishReasonPlaceholder: 'Describe the purpose, scope, and intended audience',
      submitForReview: 'Submit for review',
      publishTargetsLoadFailed: 'Failed to load enterprise knowledge bases. Try again later.',
      publishRequestCreated: 'Publish request submitted',
      publishRequestFailed: 'Failed to submit the publish request. Try again later.',
      publishRequestsLoadFailed: 'Failed to load publish requests. Try again later.',
      noPublishRequests: 'No knowledge publish requests.',
      publishStatus: 'Review status',
      submittedAt: 'Submitted',
      requester: 'Requester',
      withdraw: 'Withdraw',
      cancelPublishTitle: 'Withdraw this publish request?',
      confirmCancelPublish: 'Withdraw',
      publishRequestCancelled: 'Publish request withdrawn',
      approve: 'Approve',
      retryPublish: 'Retry publish',
      reject: 'Reject',
      qualityCheck: 'Quality check',
      exactDuplicate: 'Exact duplicate exists',
      highRisk: '{{count}} high-risk issue(s)',
      qualityWarnings: '{{count}} warning(s)',
      qualityPassed: 'Passed',
      approvePublishTitle: 'Approve enterprise knowledge publication',
      rejectPublishTitle: 'Reject enterprise knowledge publication',
      approveAndPublish: 'Approve and publish',
      confirmReject: 'Reject request',
      reviewNotePlaceholder: 'Add review notes or describe required changes',
      publishApproved: 'Document published to enterprise knowledge',
      publishRejected: 'Publish request rejected',
      reviewFailed: 'Review action failed. Try again later.',
      publishStatuses: {
        pending: 'Pending review',
        publishing: 'Publishing',
        approved: 'Published',
        rejected: 'Rejected',
        cancelled: 'Withdrawn',
        failed: 'Publish failed',
      },
      file: 'File',
      uploadedAt: 'Uploaded',
      knowledgeStatus: 'Knowledge status',
      actions: 'Actions',
      organize: 'Save to knowledge base',
      notOrganized: 'Conversation only',
      unsupportedForKnowledge: 'Unsupported',
      noCandidates: 'No documents to organize. Attachments can remain conversation-only.',
      noConversationFiles: 'No available conversation document history.',
      conversationFilesLoadFailed: 'Failed to load conversation documents. Try again later.',
      knowledgeBase: 'Knowledge base',
      scope: { owner: 'Personal', system: 'Enterprise', shared: 'Department' },
      status: {
        pending: 'Pending',
        parsing: 'Parsing',
        chunking: 'Organizing',
        embedding: 'Indexing',
        done: 'Published',
        failed: 'Failed',
      },
    },
    openVikingStudio: {
      title: 'Document Library',
      subtitle:
        'Manage document resources, connections, and knowledge backend settings in OpenViking Studio.',
      checking: 'Checking connection…',
      connected: 'OpenViking connected',
      disconnected: 'OpenViking unavailable',
      reload: 'Reload',
      openStandalone: 'Open Studio',
      unavailableTitle: 'OpenViking connection unavailable',
      unavailableDescription:
        'Check the OpenViking service, Crest backend flag, and Studio URL, then reload this page.',
      loading: 'Loading OpenViking Studio…',
      frame: 'OpenViking Studio connection and settings',
      directoryTitle: 'Crest user directory sync',
      directoryAccount: 'OpenViking Account',
      crestActiveUsers: 'Active Crest users',
      synchronizedUsers: 'Synchronized',
      pendingUsers: 'Pending',
      directoryStatus: 'Directory status',
      directorySynchronized: 'Synchronized',
      directoryPending: 'Sync required',
      directoryUnavailable:
        'Unable to read the OpenViking directory. Check administrator access and backend configuration.',
      syncUsers: 'Sync Crest users',
      syncSuccess: 'Synchronized {{count}} Crest users',
      syncFailed: 'Directory sync failed. Check the OpenViking Root Key and service logs.',
    },
    openVikingConsole: {
      common: {
        refresh: 'Refresh',
        loadFailed: 'Failed to load OpenViking data',
        requestFailed: 'Request failed',
        query: 'Query',
        reset: 'Reset',
        date: 'Date',
        delete: 'Delete',
      },
      home: {
        title: 'Home',
        description: 'Review OpenViking context, token, retrieval, and commit trends.',
        contextData: 'Context data',
        items: 'items',
        todayTokens: 'Tokens today',
        todayRetrievals: 'Retrievals today',
        tokenTrend: '14-day token trend',
        contextCommits: 'Context commits',
        total: 'Total',
        resources: 'Resources',
        messages: 'Messages',
        commits: 'Commits',
        contextBreakdown: '{{files}} files · {{skills}} skills · {{memories}} memories',
        tokenBreakdown:
          'VLM input {{vlm_input}} · output {{vlm_output}} · Embedding {{embedding_input}}',
        retrievalBreakdown: 'find {{find}} · search {{search}}',
      },
      retrieval: {
        title: 'Retrieval',
        description: 'Run OpenViking find or search and inspect plans and hierarchical results.',
        mode: 'Mode',
        scope: 'Target URI',
        limit: 'Limit',
        query: 'Query',
        queryRequired: 'Enter a query',
        queryPlaceholder: 'Enter a natural-language query',
        run: 'Run retrieval',
        queryPlan: 'Query plan',
        resultCount: '{{count}} results',
      },
      playground: {
        title: 'Playground',
        description: 'Browse context files, preview resources, and chat with OpenViking Agent.',
        explorer: 'Context explorer',
        preview: 'Preview',
        agent: 'Agent',
        addResource: 'Add resource',
        dir: 'Dir',
        file: 'File',
        directorySelected: 'Directory selected',
        previewFailed: 'Failed to read content',
        selectResource: 'Select a file or directory',
        chatEmpty: 'Start an Agent conversation',
        send: 'Send',
        chatPlaceholder: 'Ask OpenViking Agent',
        source: 'Resource source',
        upload: 'Upload file',
        remote: 'Remote URL',
        uploadHint: 'Click or drag a file here',
        fileRequired: 'Select a file to upload',
        remoteUrl: 'Remote resource URL',
        targetUri: 'Target URI',
        resourceAdded: 'Resource submitted for processing',
        resourceFailed: 'Failed to submit resource',
      },
      logs: {
        title: 'Request Logs',
        description: 'Inspect audited OpenViking API requests, status, and latency.',
        total: 'Total calls',
        successRate: 'Success rate',
        apiType: 'API type',
        status: 'Status',
        time: 'Time',
        method: 'Method',
        path: 'Path',
        duration: 'Duration',
      },
      sessions: {
        title: 'Sessions',
        description: 'Manage sessions, messages, context commits, and memory extraction.',
        new: 'New session',
        empty: 'No sessions',
        deleteConfirm: 'Delete this session?',
        select: 'Select a session',
        commit: 'Commit context',
        extract: 'Extract memory',
        committed: 'Context commit started',
        extracted: 'Memory extraction started',
        noMessages: 'No messages',
        send: 'Send',
        placeholder: 'Enter a session message',
        replyReceived: 'Agent reply received',
        messageAdded: 'Message added',
      },
      identity: {
        title: 'Connection & Identity',
        description: 'Review the service, Crest trusted identity, and directory sync.',
        connection: 'Connection',
        connected: 'OpenViking connected',
        disconnected: 'OpenViking unavailable',
        secretHint:
          'The Root Key is injected by the Crest backend and is never stored in the browser.',
        current: 'Current identity',
        directory: 'User directory',
        crestActive: 'Active Crest users',
        synchronized: 'Synchronized',
        pending: 'Pending',
        sync: 'Sync Crest users',
        syncSuccess: 'Synchronized {{count}} Crest users',
        syncFailed: 'Directory sync failed',
        systemStatus: 'OpenViking system status',
        users: 'Directory users',
      },
      oauth: {
        title: 'OAuth Verify',
        description: 'Approve OpenViking OAuth requests from another device or client.',
        hint: 'Enter the one-time code shown by the requester. Approval uses the current Crest trusted identity.',
        code: 'Verification code',
        codeRequired: 'Enter the verification code',
        approve: 'Approve access',
        success: 'Approved access for {{client}}',
        successUnknown: 'Access request approved',
      },
    },
    portalNavigation: {
      toolApplications: 'AI Toolbox',
      openAssistant: 'Open AI chat window',
      assistantUnavailable: 'Unable to load the chat window. Please try again.',
      assistantUpgradeRequired: 'Update Agent to enable the chat window.',
    },
    opportunityDetail: {
      closedReadOnly: 'This opportunity has been closed and can no longer be edited.',
      displayPreferences: 'Personalize display',
      displayPreferencesHint: 'Choose which process areas open by default on opportunity details.',
      showApprovalProcess: 'Show approval process by default',
      showOpportunityProcess: 'Show opportunity process by default',
      processTitle: 'Opportunity Process',
      processState: {
        active: 'Active',
        completed: 'Completed',
        aborted: 'Aborted',
      },
      preferencesSaved: 'Display preferences saved',
    },
    notificationMessages: {
      oaClosePending: 'The message is read, but the OA notification could not be closed yet.',
      batchOaClosePending:
        '{{read}} in-app messages marked as read; {{pending}} OA notifications could not be closed yet.',
    },
    serviceLogs: {
      title: 'Service Logs',
      subtitle:
        'Review external system calls to workflows or agents, including status and approval opinions.',
      sourceSystem: 'External System',
      eventName: 'Trigger Event',
      taskType: 'Task Type',
      oaId: 'OA Process ID',
      oaProcessStatus: 'OA Process Status',
      processName: 'Process Name',
      initiator: 'Initiator',
      agent: 'Agent',
      approvalOpinion: 'Agent Approval Opinion',
      status: 'Status',
      startedAt: 'Started At',
      duration: 'Duration',
      searchPlaceholder: 'Search event, OA ID, process, initiator, or agent',
      sourcePlaceholder: 'Filter external system',
      statusPlaceholder: 'Filter status',
      refresh: 'Refresh Logs',
      retry: 'Reload',
      loadFailed: 'Unable to load service logs',
      loadFailedDescription: 'Service logs could not be loaded. Check the service and try again.',
      empty: 'No external system calls',
      total: '{{total}} records',
      runId: 'Run ID',
      workflowRunId: 'Workflow Run ID',
      error: 'Failure',
      overview: {
        title: 'Runtime Overview',
        systems: 'Connected Systems',
        taskTypes: 'Task Types',
        totalInvocations: 'Total Invocations',
        last24Hours: 'Last 24 Hours',
        questionAnswering: 'Q&A',
        workflowProcessing: 'Workflow Runs',
        riskAlerts: 'Risk Alerts',
        agentTasks: 'Agent Tasks',
        completed: 'Completed',
        inProgress: 'In Progress',
        failed: 'Failed/Canceled',
        completionRate: 'Completion Rate',
        averageDuration: 'Average Duration',
        systemDistribution: 'Systems',
        taskTypeDistribution: 'Task Types',
      },
      statuses: {
        submitted: 'Submitted',
        working: 'Processing',
        input_required: 'Awaiting Confirmation',
        completed: 'Completed',
        failed: 'Failed',
        canceled: 'Canceled',
      },
      oaProcessStatuses: {
        '1': 'Approved',
        '2': 'Rejected',
        '3': 'Pending Approval',
        '4': 'Withdrawn',
        unknown: 'Unknown ({{status}})',
      },
    },
    contractExport: {
      title: 'Contract Export',
      subtitle: 'Generate the sales document import workbook from OA contract approvals.',
      refresh: 'Refresh',
      searchPlaceholder: 'Search contract or template name',
      contract: 'Contract',
      templateId: 'Template ID',
      templateName: 'Template Name',
      updatedAt: 'Process Updated At',
      action: 'Action',
      download: 'Download',
      selectCurrentPage: 'Select Current Page',
      selectSearchResults: 'Select All Search Results ({{total}})',
      clearSelection: 'Clear Selection',
      batchDownload: 'Batch Download ({{total}})',
      batchFilename: 'Contract Batch Export',
      total: '{{total}} records',
      loadFailed: 'Unable to load contract approval data',
      downloadFailed: 'Unable to generate the contract workbook',
      batchDownloadFailed: 'All selected contracts failed to download. Please try again.',
      batchDownloadPartial: 'Batch download completed with {{failed}} failed files.',
    },
    enterpriseBrainSettings: {
      title: 'Platform Settings',
      subtitle: 'Manage the runtime, assistants, orchestration, and extensions for Agent Platform.',
      groups: {
        runtime: {
          title: 'Runtime',
          description: 'Configure model services and agent runtimes used by Agent Platform.',
        },
        assistants: {
          title: 'Assistants and Orchestration',
          description: 'Manage enterprise assistants, workflows, tools, and execution boundaries.',
        },
        extensions: {
          title: 'Extensions',
          description: 'Manage reusable tools, MCP servers, skills, and plugins.',
        },
      },
      links: {
        models: 'Model Management',
        cli: 'Agent Management',
        agents: 'Assistant Management',
        orchestration: 'Agent Orchestration',
        tools: 'Tool Management',
        mcp: 'MCP Management',
        skills: 'Skill Management',
        knowledge: 'Knowledge Base Management',
        plugins: 'Plugin Management',
        presentations: 'PPT Templates',
      },
    },
    presentationTemplates: {
      title: 'PPT Template Center',
      subtitle:
        'Manage brand templates, fixed layouts, business data bindings, and assistant defaults.',
      upload: 'Upload template',
      empty: 'No PPT templates yet. Upload an enterprise template to begin.',
      loadFailed: 'Failed to load PPT templates',
      operationFailed: 'Operation failed',
      name: 'Template',
      mode: 'Mode',
      brandMode: 'Brand template',
      fixedMode: 'Fixed structure',
      version: 'Version',
      structure: 'Structure',
      structureSummary: '{{slides}} sample slides / {{layouts}} layouts',
      pendingAnalysis: 'Pending analysis',
      businessData: 'Business data',
      unbound: 'Not bound',
      status: 'Status',
      published: 'Published',
      archived: 'Archived',
      draft: 'Draft',
      actions: 'Actions',
      publish: 'Publish',
      dataBinding: 'Data binding',
      bindAssistant: 'Bind assistant',
      more: 'More',
      archive: 'Archive',
      setOrgDefault: 'Set as organization default',
      orgDefaultSaved: 'Organization default template updated',
      orgDefault: 'Organization default',
      created: 'Template created. Review the analysis before publishing.',
      profileSaved: 'Business data binding saved',
      assistantBound: 'Assistant default template bound',
      versionUploaded: 'New version uploaded. Publish it when ready.',
      publishTitle: 'Publish “{{name}}” v{{version}}',
      publishWarning: 'Structure warnings: {{warnings}}',
      publishHint: 'After publishing, this template can be selected in Workbench.',
      publishWithWarnings: 'Accept warnings and publish',
      publishTemplate: 'Publish template',
      publishedSuccess: 'Template published',
      archiveTitle: 'Archive “{{name}}”',
      archiveHint:
        'Archived templates cannot be used for new decks. Historical version references remain.',
      archiveTemplate: 'Archive template',
      archivedSuccess: 'Template archived',
      cancel: 'Cancel',
      currentVersion: 'Current version',
      canvas: 'Canvas',
      templateStructure: 'Template structure',
      templateStructureSummary:
        '{{masters}} masters / {{layouts}} layouts / {{slides}} sample slides',
      placeholders: 'Placeholders',
      unresolved: 'Not detected',
      warnings: 'Structure warnings',
      none: 'None',
      uploadVersion: 'Upload new version',
      downloadSource: 'Download source',
      downloadSourceFailed: 'Failed to download source template',
      createTitle: 'Upload PPT template',
      createAction: 'Analyze and create',
      templateGuidance:
        'Fixed templates should use PowerPoint masters, layouts, and named placeholders. CREST analyzes the structure before publishing.',
      templateName: 'Template name',
      templateNameRequired: 'Enter a template name',
      description: 'Usage notes',
      templateMode: 'Template mode',
      brandModeHint: 'Brand template: preserve visual style while AI selects slide types',
      fixedModeHint: 'Fixed structure: preserve slide order and placeholder roles',
      scope: 'Availability',
      shared: 'Enterprise shared',
      owner: 'Only me',
      businessProfile: 'Business data scenario (optional)',
      pptxFile: 'PPTX file',
      choosePptx: 'Choose PPTX file',
      choosePptxRequired: 'Choose a PPTX template file',
      profileTitle: 'Configure business data',
      saveBindings: 'Save data bindings',
      profilePlaceholder: 'Select a standard business data scenario',
      callsBeforeGeneration: 'Called before generation: {{bindings}}',
      bindingTitle: 'Bind assistant default template',
      saveBinding: 'Save binding',
      bindingHint:
        '“{{name}}” becomes the default for this assistant. An explicit Workbench choice overrides it.',
      selectAssistant: 'Select assistant',
      generationHistory: 'Generation history and quality trace',
      historyLoadFailed: 'Failed to load presentation history',
      historyEmpty: 'No presentation generation history yet',
      generatedOn: 'Generated',
      usedTemplate: 'Template version',
      nativeMode: 'Smart layout (no fixed template)',
      qualityTier: 'Quality tier',
      qualityTiers: { native: 'Native quality', template: 'Template', fallback: 'Basic fallback' },
      generationStatuses: {
        planning: 'Planning',
        generating: 'Generating',
        completed: 'Completed',
        failed: 'Failed',
      },
      refresh: 'Refresh',
      download: 'Download',
      downloadFailed: 'Failed to download presentation',
    },
    assistantDefinitionForm: {
      reasoning: {
        label: 'Reasoning effort (optional)',
        tooltip:
          'Only levels supported by the selected official model are shown. Leave empty to use the model default.',
        default: 'Model default',
        panoramaActive: 'Report runtime active',
        maxHelp:
          'Best for cross-table research, business attribution, and management reports; takes longer and uses more tokens.',
        levels: {
          minimal: 'minimal (fastest)',
          low: 'low',
          medium: 'medium (standard)',
          high: 'high',
          xhigh: 'xhigh (very high)',
          max: 'max (deepest analysis)',
        },
      },
      mcp: {
        label: 'MCP',
        tooltip:
          'Select MCP servers for this assistant. Global approval and status stay in MCP Management.',
        placeholder: 'Select MCP servers for this assistant',
        status: {
          enabled: 'Enabled',
          disabled: 'Disabled',
          pending: 'Pending',
          blocked: 'Blocked',
        },
      },
      plugins: {
        label: 'Plugins',
        tooltip: 'Select installed and enabled Codex plugins for this assistant only.',
        placeholder: 'Select plugins for this assistant',
        codexOnly: 'Assistant-level plugins require the Codex runtime',
      },
    },
    brainParameterSettings: {
      title: 'Parameter Configuration',
      subtitle: 'Manage global non-sensitive parameters used by Agent Platform.',
      tabs: {
        flowParameters: 'Flow Parameters',
        interfaceRoutes: 'Interface Routes',
      },
      flow: {
        cardTitle: 'OA Flow Templates',
        sourceNote:
          'OA template IDs and names are synchronized from EKP.KM_REVIEW_TEMPLATE. Flow owners, approval nodes, and approvers are maintained in CREST and retained during sync. Workflow associations come from Agent Orchestration.',
        count: '{{count}} flows',
        filteredCount: '{{count}} records shown',
        sequence: 'No.',
        flowId: 'Template ID',
        crestTemplateName: 'CREST Template Name',
        oaTemplateName: 'OA Template Name',
        owner: 'Flow Owner',
        ownerEditLabel: 'Set the owner of flow {{name}}',
        selectOwner: 'Select a flow owner',
        unassigned: 'No owner configured',
        approvalNodes: 'Approval Nodes',
        nodeCount: '{{count}} nodes',
        nodeSequence: 'Order',
        nodeName: 'Node Name',
        nodeNameEditLabel: 'Edit approval node {{name}}',
        nodeApprovers: 'Node Approvers',
        nodeApproverEditLabel: 'Set approvers for node {{name}}',
        selectApprovers: 'Select node approvers',
        noApprovers: 'No approvers configured',
        noNodes: 'No approval nodes configured',
        addNode: 'Add Approval Node',
        newNodeName: 'New Approval Node',
        deleteNode: 'Delete approval node {{name}}',
        detailTitle: 'Flow Details',
        associatedWorkflow: 'Associated Workflow',
        associatedApi: 'Associated API',
        webhookApi: 'Webhook API',
        notAssociated: 'No workflow associated',
        active: 'Active',
        inactive: 'Inactive',
        noActiveWorkflow: 'No active workflow',
        noWebhookApi: 'The active workflow has no published webhook',
        associationLoadFailed:
          'Workflow association data is temporarily unavailable. OA template parameters remain editable.',
        crestNameEditLabel: 'Edit the CREST template name for flow {{id}}',
        actions: 'Actions',
        searchPlaceholder: 'Search template ID, OA name, or CREST name',
        addPlaceholder: 'Enter a 32-character template ID',
        addNamePlaceholder: 'Enter an OA template name',
        add: 'Add',
        deleteLabel: 'Delete flow ID {{id}}',
        save: 'Save Configuration',
        saveSuccess: 'Flow parameters saved',
        saveFailed: 'Unable to save flow parameters',
        invalidId: 'A template ID must be a 32-character hexadecimal string',
        invalidName: 'OA and CREST template names are required',
        duplicateId: 'This template ID is already configured',
        loadFailed: 'Unable to load flow parameters',
        loadFailedDescription:
          'Flow parameters could not be loaded. Check the service and database migration.',
        retry: 'Reload',
      },
      flowWorkspace: {
        title: 'Flows',
        subtitle:
          'Review OA flow templates you own or participate in, including approval nodes and approvers.',
        owned: 'Owned by Me ({{count}})',
        participated: 'Participated by Me ({{count}})',
        search: 'Search flow name, owner, or template ID',
        empty: 'No matching flows',
        loadFailed: 'Unable to load flows',
      },
      interfaceRoute: {
        pageTitle: 'Interface Routes',
        pageSubtitle:
          'Manage Agent Platform public endpoints, request validation, and active workflow routing.',
        cardTitle: 'Published Interface Routes',
        descriptionText:
          'External systems can POST JSON to a published endpoint without login or an API Key; routing is resolved automatically.',
        create: 'New Interface Route',
        createTitle: 'New Interface Route',
        editTitle: 'Edit Interface Route',
        formSubtitle:
          'Configure routing, request, and response parameters, or generate definitions from JSON.',
        key: 'Route Key',
        keyPlaceholder: 'e.g. oa-approval-route',
        keyRequired: 'Enter a route key',
        keyPattern: 'Start with a lowercase letter; use 2-40 lowercase letters, digits, or hyphens',
        postAddress: 'POST Endpoint',
        postAddressHint:
          'Edit the route key in the middle of the endpoint. External systems call this address after publishing.',
        postAddressPublishedHint:
          'Changing the route key immediately invalidates the current POST endpoint. Update all callers.',
        name: 'Interface Name',
        nameRequired: 'Enter an interface name',
        description: 'Description',
        requestSchema: 'Request JSON Schema',
        requestSchemaHint: 'Defines the JSON request body accepted from external systems.',
        responseSchema: 'Response JSON Schema',
        requestParameters: 'Request Parameters',
        responseParameters: 'Response Parameters',
        schemaRequired: 'Enter a request JSON Schema',
        invalidSchema: 'The request JSON Schema must be a valid JSON object',
        invalidResponseSchema: 'Response parameters must contain a valid JSON object',
        routingField: 'Routing Field',
        routingFieldHint:
          'Each request reads this field and queries parameter settings for the workflow and Webhook URL.',
        routingFieldRequired: 'Enter the request field path used for routing',
        routingRules: 'Parameter Routing Rules',
        fieldPathPlaceholder: 'Request path, e.g. data.type',
        operator: 'Operator',
        matchValue: 'Match value',
        target: 'Target Workflow Webhook',
        targetRequired: 'Select a target workflow webhook',
        removeRule: 'Remove rule {{index}}',
        addRule: 'Add Routing Rule',
        save: 'Save',
        cancel: 'Cancel',
        status: 'Status',
        published: 'Published',
        unpublished: 'Unpublished',
        publicUrl: 'POST Endpoint',
        publishToCreateUrl: 'Publish to create a POST endpoint',
        requestRules: 'Parameter Mapping',
        viewRules: 'View ({{count}})',
        calls: 'Calls',
        actions: 'Actions',
        edit: 'Edit',
        test: 'Test',
        testTitle: 'Test Interface Route: {{name}}',
        testSubtitle: 'Enter a JSON request body and inspect the target Agent workflow output.',
        testSideEffectWarning:
          'This test triggers the target workflow and its output API. Use test data only.',
        testRequestBody: 'Request JSON',
        runTest: 'Run Test',
        testResponse: 'Agent Output API Response ({{duration}} ms)',
        testInvalidJson: 'Enter a valid JSON object before running the test',
        testSuccess: 'Route test completed',
        testFailed: 'Route test failed',
        publish: 'Publish',
        unpublish: 'Unpublish',
        unpublishConfirm: 'The public URL will stop accepting calls. Continue?',
        rulesTitle: 'Parameter Mapping Details',
        templateId: 'Template ID',
        workflowTaskId: 'Workflow Task ID',
        workflowName: 'Workflow Name',
        webhookUrl: 'Webhook URL',
        defaultRule: 'Default rule',
        loadFailed: 'Unable to load interface routes',
        retry: 'Reload',
        saveSuccess: 'Interface route saved',
        saveFailed: 'Unable to save interface route',
        publishSuccess: 'Interface route published',
        unpublishSuccess: 'Interface route unpublished',
        actionFailed: 'Interface route action failed',
        operators: {
          equals: 'Equals',
          in: 'In list',
          contains: 'Contains',
          exists: 'Exists',
          default: 'Default',
        },
      },
    },
    workflowBusinessForm: {
      title: 'Business Form Registry',
      refresh: 'Refresh',
      register: 'Register Business Form',
      edit: 'Edit',
      save: 'Save Registration',
      loadFailedTitle: 'Business form registry is unavailable',
      loadFailedDescription: 'The business form contract could not be loaded. Try again later.',
      retry: 'Retry',
      empty: 'No business forms are registered',
      saveSuccess: 'Business form registration saved',
      saveFailed: 'Failed to save business form registration',
      invalidJson: '{{field}} must be a valid JSON object',
      businessType: 'Business Type',
      businessTypeHint: 'Use domain.entity format, for example crm.account',
      name: 'Name',
      domain: 'Domain',
      createRoute: 'Business Entry',
      viewRoute: 'Detail Route',
      businessKeyRule: 'Business Key Rule',
      conditionFields: 'Workflow Field Allowlist',
      conditionFieldsHint: 'Comma-separated fields allowed in workflow conditions and snapshots',
      status: 'Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      startMode: 'Start Mode',
      workflowCenter: 'Allow starts from Workflow Center',
      businessSystemOnly: 'Start from business system only',
      businessSystemOnlyShort: 'Business system',
      formContractVersion: 'Contract Version',
      allowedActions: 'Allowed Business Actions',
      inputSchema: 'Input JSON Schema',
      snapshotSchema: 'Business Snapshot JSON Schema',
      advancedContract: 'Advanced Form Contract',
      operation: 'Action',
      systemOnlyTitle: 'Submit this approval from the business system',
      systemOnlyDescription:
        'This workflow uses a CRM business form. Complete business validation in CRM, then use Submit for Approval on the account or opportunity.',
      goToBusinessSystem: 'Open {{name}}',
      startApproval: 'Start Approval',
    },
    crmApproval: {
      title: 'Workflow approval',
      processing: 'Approval handled by',
      workflowCenter: 'Workflow Center',
      currentNode: 'Current step',
      pendingAssignees: 'Current approvers',
      updatedAt: 'Last updated',
      timeline: 'Approval activity',
      openWorkflow: 'Open workflow instance',
      refresh: 'Refresh approval activity',
      loadFailed: 'Workflow approval status is temporarily unavailable. CRM data is unaffected.',
      noActivities: 'Submitted. Waiting for the workflow engine to return activity.',
      assigneeUnavailable: 'User unavailable or not visible',
      status: {
        START_REQUESTED: 'Waiting to start',
        RUNNING: 'In review',
        CANCELLATION_REQUESTED: 'Cancelling',
        APPROVED: 'Approved',
        REJECTED: 'Rejected',
        CANCELLED: 'Cancelled',
        START_FAILED: 'Start failed',
      },
      events: {
        'workflow.instance.started': 'Workflow started',
        'workflow.task.created': 'Approval task created',
        'workflow.task.completed': 'Approval task completed',
        'workflow.instance.completed': 'Workflow completed',
        'workflow.instance.cancelled': 'Workflow cancelled',
      },
      actions: {
        pending: 'Pending review',
        approve: 'Approve',
        approved: 'Approve',
        reject: 'Reject',
        rejected: 'Reject',
        cancelled: 'Cancel',
      },
    },
    crmApprovalPeople: {
      title: 'Approver List',
      subtitle: '{{total}} approvers with their workflows, organization scope, and notifications',
      approverName: 'Approver Name',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      approvalFlows: 'Approval Workflows',
      approvableOrganizations: 'Approvable Organizations',
      globalScope: 'All Organizations',
      notificationTypes: 'Notification Types',
      notification: {
        oa: 'OA notification',
        email: 'Email notification',
        system: 'CRM system notification',
        station: 'CRM system notification',
        dingtalk: 'DingTalk bot notification',
      },
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      searchPlaceholder: 'Search approvers, workflows, or organizations',
      approvalFlowFilter: 'Approval workflow filter',
      allApprovalFlows: 'All approval workflows',
      organizationFilter: 'Organization scope filter',
      allOrganizationScopes: 'All organization scopes',
      specificOrganizations: 'Specific organizations',
      statusFilter: 'Status filter',
      allStatuses: 'All statuses',
      refresh: 'Refresh',
      total: '{{count}} approvers',
      loadFailed: 'Could not load the approver list. Refresh and try again.',
      loadFailedWithReason: 'Could not load the approver list: {{reason}}',
    },
    crmLiteApproval: {
      designerTitle: 'CRM Lite Approval',
      designerSubtitle:
        'Configure CRM-local approval chains without changing the standalone Flowable workflow center.',
      inboxTitle: 'CRM Lite Approval Inbox',
      inboxSubtitle: 'Process tasks created by the CRM-local lightweight runtime.',
      name: 'Flow name',
      code: 'Flow code',
      description: 'Description',
      businessType: 'Business type',
      associatedBusiness: 'Associated business',
      associatedBusinessRequired: 'Select an associated business action.',
      associatedBusinessPlaceholder: 'Select a submission action',
      associatedBusinessHint:
        'Business submissions match the currently published approval flow by this action.',
      associatedBusinessUnset: 'Not configured',
      businessActions: {
        ACCOUNT_OVERSEAS_SUBMIT: 'Overseas account submission',
        OPPORTUNITY_OVERSEAS_SUBMIT: 'Overseas opportunity submission',
        POC_OVERSEAS_SUBMIT: 'Overseas POC submission',
        ACCOUNT_DOMESTIC_SUBMIT: 'Domestic account submission',
        OPPORTUNITY_DOMESTIC_SUBMIT: 'Domestic opportunity submission',
        POC_DOMESTIC_SUBMIT: 'Domestic POC submission',
      },
      engineType: 'Approval engine',
      engineRequired: 'Select an approval engine.',
      internalEngine: 'CRM internal approval engine',
      internalEngineShort: 'CRM internal',
      internalEngineHint: 'Design visually and run in the lightweight CRM runtime',
      externalEngine: 'External Flowable approval engine',
      externalEngineShort: 'External Flowable',
      externalEngineHint: 'Reference a Flowable process deployed in Workflow Center',
      externalEngineNotice:
        'CRM stores only the external process reference. Publishing and execution use workflow-api without changing the standalone Flowable project.',
      externalProcess: 'Flowable process definition',
      externalProcessRequired: 'Select a Flowable process definition.',
      externalProcessHint:
        'CRM stores the process key and starts the latest deployed matching Flowable definition.',
      externalProcessPlaceholder: 'Search by process name or key',
      externalCatalogFailed:
        'The Flowable catalog is unavailable. Enter a known process key; publishing validates it again.',
      notificationConfig: 'Notification settings',
      notificationRequired: 'Select at least one notification channel.',
      notificationHint:
        'Notifications are sent when an approval task reaches an approver. DingTalk bot setup must be completed at platform level first.',
      notificationChannel: {
        oa: 'OA notification',
        email: 'Email notification',
        system: 'CRM system notification',
        dingtalk: 'DingTalk bot notification',
      },
      version: 'Version',
      statusLabel: 'Status',
      updatedAt: 'Updated',
      actions: 'Actions',
      edit: 'Edit',
      publish: 'Publish',
      disable: 'Disable',
      refresh: 'Refresh',
      create: 'Create flow',
      createTitle: 'Create lite approval flow',
      editTitle: 'Edit lite approval flow',
      saveDraft: 'Save draft',
      approvalNode: 'Approval step',
      nodeName: 'Step name',
      approvalMode: 'Multi-approver mode',
      anyMode: 'Any approver',
      allMode: 'All approvers',
      assigneeIds: 'Approver user IDs',
      assigneeIdsHint: 'The first release uses CRM systemuserid values. Press Enter after each ID.',
      assigneeIdsPlaceholder: 'Enter user UUID',
      selectApprover: 'Select approver',
      selectedApprovers: 'Select approvers',
      selectApproverPlaceholder: 'Search by name or email',
      addApprover: 'Add approver',
      removeApprover: 'Remove approver',
      approverRequired: 'Select an approver.',
      approverMinimum: 'Select at least one approver.',
      duplicateApprover: 'The same approver cannot be selected twice.',
      approverEmail: 'Email: {{email}}',
      emailMissing: 'No email configured',
      approverCatalogFailed: 'Could not load the approver directory. Refresh and try again.',
      addApprovalNode: 'Add approval step',
      addConditionNode: 'Add condition branch',
      addConditionAfterStart: 'Add condition branch after Start',
      addParallelAfterStart: 'Add parallel approval after Start',
      addBranchAfterStart: 'Add approval branch from Start',
      startNode: 'Start step',
      startNodeHint:
        'Approvals enter the flow here. You can first branch by initiator or business data.',
      startMultipleTargetsHint:
        'The Start step can connect directly to multiple approval or condition steps.',
      canvasConnectionHint:
        'The first condition is inserted after Start; later conditions become horizontal sibling branches.',
      parallelApprovalHint:
        'An approval step is selected; adding another step creates a parallel branch.',
      starterDepartment: "Initiator's department",
      departmentLevel: 'Organization level',
      departmentLevelPlaceholder: "Select the initiator department's organization level",
      departmentValuePlaceholder: 'Select an organization at this level',
      departmentLevels: {
        ROOT: 'Root organization',
        LEVEL_1: 'Level 1 organization',
        LEVEL_2: 'Level 2 organization',
        LEVEL_3: 'Level 3 organization',
        LEVEL_4: 'Level 4 organization',
      },
      starterUser: 'Initiator identity',
      starterRegion: 'Initiator sales region',
      businessField: 'Business field',
      opportunityForecastAmount: 'Opportunity forecast amount',
      forecastAmountPlaceholder: 'Enter forecast amount',
      conditionSource: 'Condition source',
      conditionBranches: 'Condition branches',
      conditionCompare: 'Comparison',
      conditionValue: 'Condition value',
      conditionValuePlaceholder: '100 or a,b',
      conditionCatalogFailed: 'Could not load condition options. Refresh and try again.',
      addCondition: 'Add condition',
      removeCondition: 'Remove condition',
      matchedTarget: 'Go to when matched',
      unmatchedTarget: 'Go to when unmatched',
      conditionOperator: {
        EQ: 'Equals',
        NE: 'Does not equal',
        GT: 'Greater than',
        GTE: 'Greater than or equal',
        LT: 'Less than',
        LTE: 'Less than or equal',
        IN: 'In list',
        CONTAINS: 'Contains',
        NOT_CONTAINS: 'Does not contain',
      },
      removeNode: 'Remove step',
      moveUp: 'Move step up',
      moveDown: 'Move step down',
      endNodeHint: 'The flow completes automatically after all approval steps.',
      loadFailed: 'Could not load flow definitions. Refresh and try again.',
      saved: 'Flow draft saved.',
      saveFailed: 'Could not save the flow. Check the fields and try again.',
      publishConfirm: 'New approvals will use this version. Publish now?',
      published: 'Flow version published.',
      disableConfirm: 'Disabled flows cannot start new approvals. Disable now?',
      subject: 'Subject',
      currentNode: 'Current step',
      receivedAt: 'Received',
      approve: 'Approve',
      reject: 'Reject',
      approveTitle: 'Approve task',
      rejectTitle: 'Reject task',
      commentPlaceholder: 'Approval comment (optional)',
      approved: 'Task approved.',
      rejected: 'Task rejected.',
      inboxLoadFailed: 'Could not load lite approval tasks. Refresh and try again.',
      status: { DRAFT: 'Draft', PUBLISHED: 'Published', DISABLED: 'Disabled' },
    },
    workbench: {
      assistantStudio: 'Settings',
      assistantStudioHint:
        'Manage assistants, supervise tasks, and configure personal skills and knowledge bases in one place.',
      assistantSkills: 'Skills',
      assistantKnowledge: 'Knowledge Base',
      myAssistants: 'Assistants',
      taskCenter: 'Tasks',
      taskCenterHint: 'View active, intervention-required, and recently completed assistant tasks.',
      crmWriteAccountTitle: 'Review required fields before creating the account',
      crmWriteOpportunityTitle: 'Review required fields before creating the opportunity',
      crmWriteAiPrefill: 'AI prefilled',
      crmWriteHint:
        'Options and lookups come from current CRM metadata and your access scope. CRM API validation still applies after confirmation.',
      pptxPagination: 'Slide navigation',
      previousSlide: 'Previous',
      nextSlide: 'Next',
      slidePage: 'Slide {{current}} of {{total}}',
      pptxPreview: 'PowerPoint preview',
      addContent: 'Add files, folders, or a task type',
      addFiles: 'Add files',
      addFolder: 'Add folder',
      secureDocumentsClosed: 'Enable enterprise document encryption',
      secureDocumentsOpen: 'Enterprise document encryption enabled',
      secureDocumentsChecking: 'Checking enterprise network…',
      secureDocumentsEnabled:
        'Connected to the enterprise network. Uploads will be decrypted and generated downloads encrypted.',
      secureDocumentsUnavailable: 'This feature is only available on the enterprise network',
      secureDownload: 'Encrypted download',
      taskType: 'Task type',
      taskTypeQuestion: 'Question answering',
      taskTypeWorkflow: 'Workflow processing',
      taskTypeRisk: 'Risk alert',
      taskTypeAgent: 'Agent task',
      copyMessage: 'Copy message',
      editMessage: 'Edit message',
      editingMessage: 'Editing a sent message; your changes will be sent as a new message',
      cancelEditMessage: 'Cancel message editing',
      presentationTemplate: 'PPT template',
      presentationTemplateAria: 'Select a PowerPoint generation template',
      saveAttachmentToKnowledgeBase: 'Save to knowledge base',
      saveAttachmentHint:
        'Reuse the original conversation file as durable knowledge after quality, duplicate, and sensitive-data checks.',
      saveToKnowledgeBase: 'Save to knowledge base',
      linkExistingKnowledge: 'Link existing document',
      savedToKnowledgeBase: 'Saved to knowledge base',
      targetKnowledgeBase: 'Target knowledge base',
      noPromotionTarget: 'No manageable knowledge base. Create a personal knowledge base first.',
      createPersonalKnowledgeBase: 'Create personal knowledge base',
      knowledgeBasesLoadFailed: 'Failed to load knowledge bases. Try again later.',
      attachmentSavedToKnowledgeBase: 'The document was saved and indexed.',
      attachmentAlreadyInKnowledgeBase: 'The same content exists and was linked.',
      attachmentSaveFailed: 'Failed to save the document. Check its status and retry.',
      preflightRunning: 'Checking document…',
      preflightFailed: 'Document check failed. Verify its format and your access.',
      preflightPassed: 'Quality checks passed. The document can be saved.',
      retryRun: 'Run again',
      modelConnectionInterrupted:
        'The model connection was interrupted before any operation was confirmed. Select “Run again” to retry.',
      duplicateKnowledge: 'The target already contains the same content: {{name}}',
      possibleKnowledgeVersion: 'A similarly named document may be an earlier version',
      acknowledgeSensitiveKnowledge:
        'I verified the access scope and accept saving potentially sensitive information.',
      knowledgeWarning: {
        short_content: 'The extracted text is short and may provide little searchable knowledge.',
        credential: '{{count}} possible credential, password, or token occurrence(s) detected.',
        personal_id: '{{count}} possible national ID occurrence(s) detected.',
        email: '{{count}} email address(es) detected.',
        phone: '{{count}} mobile number(s) detected.',
      },
    },
    orchestrationNode: {
      tool: 'Tool',
      selectTool: 'Select a tool',
      highRisk: 'High risk',
      destructiveTool: 'High-risk tool: approval is required before execution',
      toolArguments: 'Tool arguments',
      toolArgumentsHint:
        'Supports {{message}}, {{output}}, and trigger variables. Use Advanced JSON for typed or complex placeholders.',
      schemaMode: 'Form',
      jsonMode: 'Advanced JSON',
      toolArgumentsJson: 'Arguments JSON',
      noToolArguments: 'This tool has no configurable arguments.',
      invalidJsonObject: 'Tool arguments must be a valid JSON object',
      invalidJsonValue: 'Enter a valid JSON value',
      requiredArgument: 'This argument is required',
      boundAgent: 'Bound agent',
      boundAgentHint:
        'Runs this node with the selected agent, including its model group, skills, and tools.',
      selectAgent: 'Select an agent',
      agentDisabled: 'Disabled',
      agentUnavailable: 'Unavailable',
      acceptFileInput: 'Accept file input',
      multimodalInput: 'Multimodal file input',
      multimodalInputHint:
        'Images are passed directly to vision-capable models. Documents and other files are provided to runtimes that support original attachments. Actual support depends on the selected model and runtime.',
      fileInputVariable: 'File variable name',
      fileInputVariableHint: 'Bind a Webhook or upstream file list. The default variable is files.',
      fileInputVariableRequired: 'Enter a file variable name',
      llmModel: 'Model',
      llmModelRequired: 'Select a model',
      llmModelPlaceholder: 'Select a model group',
      llmDefaultModel: 'Default model group',
      llmContext: 'Context',
      llmContextHint:
        'Read context from a workflow variable using a dot path. Leave empty to use upstream output.',
      llmContextPlaceholder: 'Set a variable path, such as content or payload.form',
      llmMessagePlaceholder:
        'Enter a prompt. Use {{message}}, {{output}}, or {{variable.path}} to insert workflow data.',
      llmMessageRequired: 'Enter message content',
      llmAddMessage: 'Add message',
      llmDeleteMessage: 'Delete message {{index}}',
      llmVision: 'Vision',
      llmVisionHint:
        'Adds workflow attachment metadata to model context. Actual vision support depends on the model.',
      llmSeparateReasoning: 'Separate reasoning tags',
      llmSeparateReasoningHint:
        'When the model returns reasoning, store it separately in llm_reasoning.',
      llmOutputVariables: 'Output variables',
      llmStructuredOutput: 'Structured output',
      llmResponseSchema: 'Response JSON Schema',
      llmResponseSchemaInvalid: 'The response format must be a valid JSON Schema object',
      llmTextOutputHint: 'Outputs text by default and records the resolved model and token usage.',
      llmFailureRetry: 'Retry on failure',
      llmMaxAttempts: 'Maximum attempts',
      llmRetryDisabledHint: 'Model errors immediately enter exception handling.',
      llmExceptionStrategy: 'Exception handling',
      llmExceptionNone: 'None (stop workflow)',
      llmExceptionContinue: 'Continue with upstream output',
      llmExceptionFallback: 'Continue with fallback text',
      llmFallbackText: 'Fallback text',
      llmFallbackTextRequired: 'Enter fallback text for model failures',
      llmModelParameters: 'Model parameters',
      llmTemperature: 'Temperature',
      llmTemperatureHint: 'Higher values are more varied; lower values are more deterministic.',
      llmNextStepHint: 'Connect the node’s right handle to its next step on the canvas.',
      webhookAcceptFiles: 'Accept uploaded files',
      webhookMultipartTitle: 'multipart/form-data file input',
      webhookMultipartHint:
        'Send files in the configured field. Complex JSON can be sent in payload. Files are stored securely and only references enter the workflow.',
      webhookOaFormHint:
        'Put the OA form body in text or content. Multiple remote file URLs can be sent in file_urls.',
      webhookResponseBody: 'Response JSON template',
      webhookRequestBodySchema: 'Request body JSON Schema',
      webhookRequestBodySchemaHint:
        'Defines and validates the caller payload. Standard outputs are content and file; file is always a URL array.',
      webhookRequestBodySchemaInvalid:
        'The request body definition must be a valid JSON Schema object',
      webhookResponseBodyHint:
        'Supports {{request_id}}, {{workflow_id}}, {{oa_id}}, {{file_count}}, and {{payload}}.',
      webhookResponseBodyInvalid: 'The response template must be a valid JSON object',
      webhookEndpointSection: 'Webhook Endpoint',
      webhookUrl: 'Webhook URL',
      webhookPublishedUrlHint:
        'External systems can send POST requests directly to this endpoint after the workflow is saved and published.',
      webhookUrlSecretHint:
        'The invocation secret is included in the URL; no additional request header is required.',
      webhookContentType: 'Content Type',
      webhookHeaderParameters: 'Header Parameters',
      webhookRequired: 'Required',
      webhookRequestParameters: 'Request Body Parameters',
      webhookResponseParameters: 'Response Parameters',
      webhookPasteJson: 'Generate from JSON',
      webhookPasteJsonHint:
        'Paste a complete JSON object to format it and infer field paths, types, required fields, and nested structures.',
      webhookJsonSample: 'JSON sample',
      webhookJsonSamplePlaceholder:
        'Paste a JSON object. Code fences and string-escaped JSON are supported.',
      webhookGenerateParameters: 'Parse and Generate',
      webhookCancelGenerate: 'Cancel',
      webhookJsonGenerated: 'Parameter definitions generated from JSON',
      webhookJsonInvalid: 'The pasted content must be a valid JSON object',
      webhookNoParameters: 'Paste JSON to generate parameters',
      webhookParameterName: 'Name',
      webhookParameterType: 'Type',
      webhookParameterRequired: 'Required',
      webhookParameterExample: 'Example',
      webhookResponseExample: 'Response Body Example',
      webhookToggleRequired: 'Toggle whether {{name}} is required',
      webhookAdvancedDefinition: 'Advanced JSON Definition',
      webhookRequestExample: 'Request Body Example',
      webhookJsonSchema: 'JSON Schema',
      webhookJsonSchemaInvalid: 'The parameter definition must be a valid JSON Schema object',
      webhookInputMapping: 'Input Mapping',
      webhookInputPath: 'Input Field Path',
      webhookInputPathHint:
        'Reads text from the JSON request body using a dot path. Leave blank to use the whole body.',
      webhookTextTemplate: 'Input Mapping Template',
      webhookTextTemplateHint: 'Supports {{input}} and {{payload}}.',
      webhookTextTemplateRequired: 'Enter an input mapping template',
      webhookResponseSection: 'Response',
      webhookResponseStatus: 'Status Code',
      webhookOutputVariables: 'Output Variables',
      webhookSecuritySection: 'Request Security',
      webhookSecretWarning:
        'The secret is generated automatically and included in the endpoint. Share it only with trusted callers.',
      webhookSecret: 'Webhook Secret',
      webhookSecretHint: 'The secret is hidden by default. Use the eye button to reveal it.',
      webhookSecretRequired: 'No Webhook secret was generated. Add the node again.',
      webhookSecretPlaceholder: 'Generated automatically by the system',
      outputApiRequestTab: 'Business Request',
      outputApiTokenTab: 'Token Request',
      outputApiTokenHint:
        'Calls the authentication endpoint first, then adds the returned token to the business request. Client Secret values are referenced from environment variables and never stored in the workflow.',
      outputApiTokenEnabled: 'Enable token request',
      outputApiEndpoint: 'Target endpoint',
      outputApiEndpointRequired: 'Enter the target endpoint',
      outputApiBaseUrlEnv: 'Base URL environment variable',
      outputApiBaseUrlEnvHint: 'Required for relative endpoints, for example OA_API_BASE_URL.',
      outputApiMethod: 'Request method',
      outputApiTimeoutSeconds: 'Request timeout (seconds)',
      outputApiBodyTemplate: 'JSON body template',
      outputApiBodyTemplateHint:
        'Supports {{outputJson}}, {{messageJson}}, {{runIdJson}}, and JSON-safe workflow variable placeholders.',
      outputApiBodyTemplateRequired: 'Enter a JSON body template',
      outputApiHeaders: 'Headers (JSON)',
      outputApiHeadersInvalid: 'Headers must be a valid JSON object',
      outputApiRequestContract: 'Request Parameters',
      outputApiResponseContract: 'Response Parameters',
      outputApiLegacyAuthEnv: 'Static auth environment variable',
      outputApiLegacyAuthEnvHint:
        'For endpoints that do not require token exchange. Only the environment variable name is stored.',
      outputApiTargetHeader: 'Target authentication header',
      outputApiTokenEndpoint: 'Token endpoint',
      outputApiTokenEndpointRequired: 'Enter the token endpoint',
      outputApiTokenBodyTemplate: 'Token JSON body template',
      outputApiTokenBodyTemplateHint:
        'Use {{clientSecretJson}} to safely insert the environment secret. Never enter a plaintext Client Secret.',
      outputApiClientSecretRef: 'Client Secret reference',
      outputApiClientSecretRefHint:
        'Only env:VARIABLE_NAME is supported, and the variable must be in ORCHESTRATION_SECRET_ENV_ALLOWLIST.',
      outputApiClientSecretRefRequired: 'Enter a Client Secret environment reference',
      outputApiClientSecretRefInvalid: 'Use the format env:VARIABLE_NAME',
      outputApiTokenValuePath: 'Token field path',
      outputApiTokenTypePath: 'Token type field path',
      outputApiTokenRequestContract: 'Token Request Parameters',
      outputApiTokenResponseContract: 'Token Response Parameters',
      webhookFileField: 'Upload file field',
      webhookFileFieldRequired: 'Enter the upload file field',
      webhookFileVariable: 'Output file variable',
      webhookFileVariableHint:
        'Downstream agent nodes receive the file list through this variable.',
      webhookFileVariableRequired: 'Enter the output file variable',
      maximumFiles: 'Maximum files',
      allowedFileTypes: 'Allowed file types',
      allowedFileTypesRequired: 'Select at least one file type',
      fileTypeImage: 'Images',
      fileTypeDocument: 'Documents',
      fileTypeAudio: 'Audio',
      fileTypeVideo: 'Video',
      fileTypeOther: 'Other',
      resourceDownloadTitle: 'Governed remote resource download',
      resourceDownloadHint:
        'Reads one URL or a URL list from Webhook data. Only server-side egress allowlisted hosts are accepted, and downstream nodes receive file references only.',
      resourceUrlPath: 'Resource URL field path',
      resourceUrlPathHint:
        'Dot paths are supported, such as file_url, data.files, or payload.data.file_url.',
      resourceUrlPathRequired: 'Enter a resource URL field path',
      resourceOutputVariable: 'Output file variable',
      resourceMaximumFileMb: 'Per-file limit (MB)',
      resourceMaximumTotalMb: 'Total file limit (MB)',
      resourceTimeoutSeconds: 'Download timeout (seconds)',
      resourceRedirectLimit: 'Maximum redirects',
      resourceFailureMode: 'On download failure',
      resourceFailureFail: 'Stop the workflow',
      resourceFailureSkip: 'Skip failed files',
      resourceAuthorizationSecretRef: 'Authorization Secret reference',
      resourceAuthorizationSecretRefHint:
        'Optional. Use env:VARIABLE; the environment variable must also be included in the orchestration Secret allowlist.',
    },
    orchestrationCanvas: {
      nodeMenuMore: 'More node actions: {{name}}',
      nodeMenuRun: 'Run this step',
      nodeMenuReplace: 'Replace node',
      nodeMenuCopy: 'Copy',
      nodeMenuDuplicate: 'Duplicate',
      nodeMenuDelete: 'Delete',
      nodeMenuHelp: 'View help',
      nodeMenuAbout: 'About',
      nodeMenuNoDescription: 'No additional description is available for this node.',
      nodeMenuCopySuccess: 'Node configuration copied to the clipboard',
      nodeMenuCopyFailed: 'Clipboard access failed. Check the browser permission.',
      nodeMenuDuplicateSuccess: 'Node duplicate created',
      nodeMenuDeleteConfirmTitle: 'Delete node “{{name}}”?',
      nodeMenuDeleteConfirmDescription:
        'The node and its connected edges will be removed when the draft is saved.',
      nodeMenuHelpTitle: 'Help for “{{name}}”',
      nodeCopySuffix: ' (Copy)',
      nodeReplaceTitle: 'Replace “{{name}}”',
      nodeReplaceSubtitle:
        'The canvas position and connected edges are preserved. The replacement starts with default configuration.',
      nodeReplaceTriggers: 'Triggers',
      nodeReplaceProcessors: 'Processing nodes',
      nodeReplaceCurrent: 'Current',
      nodeReplaceConfirm: 'Replace node',
      nodeReplaceNoDescription: 'No node description is available.',
      nodeReplaceSuccess: 'Node replaced. Configure it before saving the draft.',
      nodeReplaceOptions: 'Replacement node options',
      canvasToolbar: 'Canvas toolbar',
      openNodeLibrary: 'Add node',
      closeNodeLibrary: 'Close node library',
      nodeLibraryTitle: 'Available nodes',
      nodeLibrarySearch: 'Search nodes',
      nodeLibrarySearchPlaceholder: 'Search nodes, agents, and tools…',
      nodeLibraryEmpty: 'No matching nodes',
      nodeLibraryNoDescription: 'No node description is available.',
      nodeLibraryGroups: {
        start: 'Start nodes',
        logic: 'Logic and transformation',
        tools: 'Tools',
      },
      nodeKindLabels: {
        router: 'Router',
        llm: 'LLM',
        agent: 'Agent',
        tool: 'Tool',
        resource_download: 'Resource download',
        reviewer: 'Reviewer',
        approval: 'Approval',
        subflow: 'Subflow',
        user_input: 'User input',
        schedule_trigger: 'Schedule trigger',
        webhook_trigger: 'Webhook trigger',
        input_api: 'Webhook trigger (legacy)',
        database_query: 'Database query',
        output_api: 'Output API',
        terminal: 'Terminal',
      },
      classicValidationPassed: 'Validation passed',
      classicValidationFailed: 'Validation failed. Please try again.',
      classicEditorHint:
        'The canvas is editable by default. Configure nodes, connect handles, and press Delete on a selection. Save the draft before publishing; dashed edges are conditional branches.',
      classicEditableDraft: 'Editable draft',
      classicUnsaved: 'Unsaved',
      classicAutoLayout: 'Auto layout',
      classicValidationResults: 'Validation results',
      classicValidate: 'Validate',
      classicIssueCount: ' ({{errors}} errors / {{warnings}} warnings)',
      classicSaveDraft: 'Save draft',
      classicPublishDraftConfirm: 'Publish this draft and rebuild the runtime graph?',
      classicPublish: 'Publish',
      classicRevertDraftConfirm: 'Discard draft changes and restore the published graph?',
      classicRevertDraft: 'Discard draft',
      classicValidationPassedNoIssues: 'Validation passed with no issues',
      classicError: 'Error',
      classicWarning: 'Warning',
      draftSaved: 'Draft saved',
      saveFailed: 'Failed to save draft. Check the node configuration.',
      publishBlocked: 'Publish validation failed: {{details}}',
      published: 'Published. The runtime orchestration graph is updated.',
      publishFailed: 'Publish failed. Please try again.',
      reverted: 'Reverted to the published graph',
      revertFailed: 'Failed to revert the draft. Please try again.',
      v2Title: 'Typed Canvas V2',
      debug: 'Debug',
      graphDebugger: 'Graph Debugger',
      liveDebug: 'Live Debug',
      runHistory: 'Run History',
      selectHistoricalRun: 'Select a historical run to replay',
      historyLoadFailed: 'Failed to load run history',
      playTimeline: 'Play timeline',
      pausePlayback: 'Pause playback',
      forkFromNode: 'Select fork node',
      forkRun: 'Fork Run',
      forkStarted: 'Safe fork run started',
      reusedOutput: 'Reused source output',
      compareRuns: 'Compare Runs',
      selectTwoRuns: 'Select two runs to compare',
      leftRun: 'Run A',
      rightRun: 'Run B',
      outputChanged: 'Output changed',
      yes: 'Yes',
      no: 'No',
      modelCostEstimation: 'Model cost estimation',
      inputCostPerMillion: 'Input price / 1M tokens',
      outputCostPerMillion: 'Output price / 1M tokens',
      costCurrency: 'Currency',
      modelCostHint:
        'Leave prices empty to disable estimation. Configured prices are attributed per node from actual token usage.',
      closeDebugger: 'Close graph debugger',
      debugPanelResize: 'Resize debug sidebar',
      debugDryRun: 'Safe Draft Snapshot Debugging',
      debugDryRunHint:
        'This run is bound to the current canvas snapshot. Tools, HTTP, Output API, and approvals only produce previews and never perform real side effects.',
      debugInputs: 'Workflow Input JSON',
      debugBreakpoints: 'Breakpoint Nodes',
      debugBreakpointsHint: 'Select one or more nodes to pause before execution',
      startDebug: 'Start Debugging',
      pauseDebug: 'Pause',
      continueDebug: 'Continue',
      stepDebug: 'Step',
      pausedBeforeNode: 'Paused before node {{nodeId}}',
      refreshTrace: 'Refresh Trace',
      debugFailed: 'Debug run failed',
      debugNode: 'Debug This Node',
      nodeDebugTitle: 'V2 Node Debug',
      runNodeDebug: 'Run This Node',
      nodeDebugIsolated: 'Isolated Dry Run',
      nodeDebugIsolatedHint:
        'Only the selected node runs with the explicit JSON values below. Tools, HTTP, Output API, external platforms, and code nodes return previews without real side effects. Keep sensitive values in Secret Bindings.',
      nodeDebugUnsupportedControl:
        'Control, branching, and container nodes must be debugged in the full workflow',
      nodeDebugInputs: 'Node Input JSON',
      nodeDebugInputsInvalid: 'Node inputs must be a valid JSON object',
      noTrace: 'Start a debug run to inspect node traces',
      traceDetails: 'Node Run Details',
      traceInput: 'Input',
      traceOutput: 'Output',
      traceType: {
        'node.started': 'Running',
        'node.output': 'Completed',
        'node.failed': 'Failed',
        'node.waiting_input': 'Waiting for input',
      },
      runStatus: {
        running: 'Running',
        paused: 'Paused',
        completed: 'Completed',
        failed: 'Failed',
        canceled: 'Canceled',
        terminated: 'Terminated',
        timed_out: 'Timed out',
        unknown: 'Unknown',
      },
      v2LoadFailed: 'Failed to load the V2 canvas',
      retry: 'Reload',
      searchNode: 'Search and focus a node',
      globalSearch: 'Search nodes, variables, issues, or comments',
      globalSearchGroups: {
        nodes: 'Nodes',
        variables: 'Variables',
        issues: 'Validation issues',
        comments: 'Collaboration comments',
      },
      globalSearchCommentsFailed: 'Comments failed to load; other search results remain available',
      globalSearchNoCanvasTarget: 'This result has no canvas node to focus',
      globalSearchVariableLocated: 'Variable located: {{name}} ({{type}})',
      nodeDebugScope: 'Debug scope',
      nodeDebugScopeSingle: 'Current node only',
      nodeDebugScopeDownstream: 'Current node and downstream',
      nodeDebugDownstream: 'Downstream dry-run',
      nodeDebugDownstreamHint:
        'Runs all reachable downstream nodes; side effects are forced to dry-run and external node dependencies are rejected.',
      nodeDebugWorkflowInputs: 'Workflow inputs (JSON)',
      variableInspector: 'Variables',
      variableInspectorTitle: 'Variable inspector and data lineage',
      variableInspectorSearch: 'Search variables, producers, consumers, or field paths',
      variableInspectorSummary:
        '{{variables}} variables, {{mismatches}} type conflicts, {{unknown}} paths to verify',
      variableInspectorHint:
        'Expand a variable to inspect its producer, consumers, deep paths, and explicit conversion suggestions.',
      variableInspectorEmpty: 'No matching variables',
      variableInspectorProducer: 'Producer',
      variableInspectorExternal: 'Workflow or environment',
      variableInspectorUnused: 'This variable currently has no consumers',
      variableInspectorPath: 'Field path',
      variableInspectorMismatchCount: '{{count}} conflicts',
      variableInspectorUnknownCount: '{{count}} to verify',
      focusProducer: 'Focus producer',
      variableGroups: {
        workflow_input: 'Workflow input',
        workflow: 'Workflow variable',
        conversation: 'Conversation variable',
        system: 'System variable',
        node: 'Node output',
        loop: 'Loop local variable',
      },
      variableInspectorStatus: {
        compatible: 'Compatible',
        unknown: 'Path type unknown',
        mismatch: 'Type mismatch',
      },
      variableConversionSuggestion: {
        template_transform: 'Insert a Template Transform node to explicitly produce a string.',
        code_sandbox:
          'Insert a Code Sandbox node to validate and explicitly convert to the target type.',
      },
      permissionImpact: 'Permission and data impact',
      permissionImpactNone: 'No external data access or writes detected',
      permissionAccess: {
        read: 'Read',
        write: 'Write',
        destructive: 'Destructive',
      },
      refreshPreview: 'Refresh Migration Preview',
      previewOnly: 'V2 Migration Preview',
      previewOnlyHint:
        'This view is deterministically migrated from the current V1 draft to inspect typed ports, data bindings, and publishing errors. It does not write a revision or enable V2.',
      previewUnavailableHint: 'This canvas is read-only. Reason: {{reason}}',
      v2FeatureDisabled: 'The V2 feature is not enabled for the current user',
      v2StorageMissing: 'Database capabilities are not initialized: {{names}}',
      v2CapabilityUnknown: 'The V2 capability status is unavailable. Check the API service.',
      storageCapability: {
        revisions: 'immutable revisions',
        releases: 'release records',
        environments: 'environment parameters',
        comments: 'collaboration comments',
        modelPricing: 'model pricing',
        stepAttempts: 'step retry attempts',
      },
      revisionMode: 'V2 Revision Draft',
      revisionModeHint:
        'Port connections create explicit variable bindings. Saving runs the same typed validation as the publishing API and creates a new immutable revision.',
      validationSummary: '{{errors}} errors / {{warnings}} warnings',
      validationIssues: 'V2 validation issues',
      validationPassed: 'The V2 draft passed validation',
      validationFailed: 'The V2 draft still has errors. Use the issue list to locate and fix them.',
      validationRequestFailed: 'V2 validation request failed: {{error}}',
      editDraft: 'Edit V2 Draft',
      unsaved: 'Unsaved',
      autoSaving: 'Auto-saving',
      autoSaved: 'Auto-saved',
      autoSaveFailed: 'Auto-save failed. Resolve the conflict or validation error.',
      publishRevision: 'Publish Revision',
      publishRevisionConfirm: 'Publish the current V2 revision and update the runtime version?',
      v2Published: 'Revision {{revision}} published',
      v2PublishFailed: 'V2 publish failed: {{error}}',
      publishGraphChanged:
        'The canvas changed while publishing. The snapshot was saved but not published; review and retry.',
      revisionStatus: {
        draft: 'Draft',
        published: 'Published',
        archived: 'Archived',
      },
      revisionHistory: 'Revision History',
      refreshRevisions: 'Refresh Revisions',
      revisionLoadFailed: 'Failed to load revision history',
      noRevisions: 'No V2 revisions yet',
      importRevision: 'Import DSL',
      revisionImported: 'Imported as revision {{revision}}',
      exportRevision: 'Export',
      restoreRevision: 'Restore',
      restoreRevisionConfirm: 'Create a new draft from revision {{revision}}?',
      revisionRestored: 'Created a new draft from revision {{revision}}',
      compareRevisions: 'Compare Revisions',
      selectTwoRevisions: 'Select two revisions',
      diffScope: 'Scope',
      diffEntity: 'Entity',
      diffOperation: 'Change',
      diffPath: 'Field path',
      undo: 'Undo',
      redo: 'Redo',
      addNode: 'Add Node',
      searchNodeType: 'Search node types',
      nodeCategory: 'Node category',
      allNodeTypes: 'All nodes',
      favoriteNodeTypes: 'Favorites',
      recentNodeTypes: 'Recently used',
      noNodeTypes: 'No matching node type',
      addFavorite: 'Add node type to favorites',
      removeFavorite: 'Remove node type from favorites',
      nodeTypes: {
        classifier: {
          name: 'LLM Classifier',
          description: 'Select one explicit branch from configured candidate classes.',
        },
        file_input: {
          name: 'File Input',
          description: 'Validate and output file references accessible to the current user.',
        },
        document_extractor: {
          name: 'Document Extractor',
          description:
            'Read a file under the current user identity and extract bounded plain text.',
        },
        list_operator: {
          name: 'List Operator',
          description: 'Join, flatten, or deduplicate an array.',
        },
        code_sandbox: {
          name: 'Code Sandbox',
          description:
            'After human approval, run Python or Bash in an isolated Docker container with networking disabled by default.',
        },
        crm_entity_query: {
          name: 'CRM Entity Query',
          description:
            'Query CRM as the initiating user while preserving RBAC, field security, and organization scope.',
        },
        crm_action: {
          name: 'CRM Action',
          description:
            'Preview or execute a CRM action protected by human confirmation, idempotency, and audit.',
        },
        erp_action: {
          name: 'ERP Action',
          description:
            'Preview or execute an ERP finance action protected by human confirmation, idempotency, and audit.',
        },
        flowable_approval: {
          name: 'Flowable Approval',
          description:
            'Durably wait for Flowable and apply business-calendar SLA delegation, escalation, and timeout routing.',
        },
        saga_compensation: {
          name: 'Saga Compensation',
          description:
            'Run approved CRM/ERP actions in sequence and compensate completed steps in reverse order after a failure.',
        },
        dify: {
          name: 'Dify',
          description: 'Call a Dify Workflow or Chatflow and return normalized structured output.',
        },
        coze: {
          name: 'Coze Studio',
          description: 'Call a published Coze Bot and aggregate its streaming answer.',
        },
        n8n: {
          name: 'n8n',
          description: 'Call an n8n production webhook and return normalized structured output.',
        },
        multi_agent_supervisor: {
          name: 'Multi-Agent Supervisor',
          description:
            'Delegate to CREST experts in parallel while preserving per-expert evidence.',
        },
        voting: {
          name: 'Voting',
          description:
            'Aggregate expert candidates deterministically by votes and confidence with full evidence.',
        },
      },
      copyNameSuffix: ' Copy',
      copyNodes: 'Copy selected nodes',
      pasteNodes: 'Paste nodes',
      autoLayout: 'Auto Layout',
      alignSelection: 'Align',
      distributeSelection: 'Distribute',
      alignment: {
        left: 'Align Left',
        center: 'Center Horizontally',
        right: 'Align Right',
        top: 'Align Top',
        middle: 'Center Vertically',
        bottom: 'Align Bottom',
      },
      distribution: {
        horizontal: 'Distribute Horizontally',
        vertical: 'Distribute Vertically',
      },
      deleteElement: 'Delete',
      addAnnotation: 'Add Note',
      newAnnotationText: 'New note',
      annotationAccessibleName: 'Canvas note',
      annotationDetails: 'Note Settings',
      annotationText: 'Note content',
      annotationTextRequired: 'Enter note content',
      annotationColor: 'Note color',
      annotationWidth: 'Note width',
      applyAnnotation: 'Apply Note',
      editAnnotation: 'Edit note',
      moveAnnotation: 'Move note',
      deleteAnnotation: 'Delete note',
      deleteAnnotationConfirm: 'Delete this note?',
      annotationColors: {
        yellow: 'Yellow',
        blue: 'Blue',
        green: 'Green',
        pink: 'Pink',
        gray: 'Gray',
      },
      collaborationComments: 'Collaboration Comments',
      collaborationOnline: 'Live collaboration',
      collaborationUnavailable:
        'Collaboration is unavailable. Revision conflict checks still run on save.',
      collaborationParticipant: '{{name}} · {{nodeId}}',
      activeNodeLocks: '{{count}} nodes being edited',
      nodeLockFailed: 'Failed to acquire the node edit lock',
      canvas: 'Canvas',
      releaseGovernance: 'Environment & Release Governance',
      governanceLoadFailed: 'Failed to load governance settings: {{error}}',
      firstRevisionNotSaved: 'The first V2 Revision has not been saved',
      firstRevisionDraft: 'Initial V2 Draft',
      firstRevisionDraftHint:
        'This content comes from the classic-canvas migration preview. Fix validation issues and save it to create the first immutable V2 Revision.',
      saveFirstRevisionBeforeGovernance:
        'Environment parameters can be configured now. Dependency checks, collaboration comments, and promotion become available after the first V2 Revision is saved.',
      environment: {
        development: 'Development',
        test: 'Test',
        production: 'Production',
      },
      secretReferenceOnly: 'Only Secret references are stored here',
      secretReferenceOnlyHint:
        'Use {"alias":"env:VARIABLE"}. Credential values remain in the deployment environment or secret platform and never enter the database or DSL.',
      environmentParameters: 'Non-sensitive environment parameters JSON',
      environmentParameter: 'Environment Parameter',
      secretBindings: 'Secret Binding JSON',
      environmentConfigVersion: 'Environment config version',
      configuredSecrets: 'Configured Secrets',
      saveEnvironment: 'Save Environment',
      environmentSaved: 'Environment configuration saved as v{{version}}',
      checkDependencies: 'Check Dependencies',
      dependenciesHealthy: 'All required dependencies are available',
      dependenciesUnhealthy: 'Required dependencies are unavailable; promotion is blocked',
      noDependencies: 'This revision has no external dependencies',
      rolloutPct: 'Production rollout percentage',
      promoteRevision: 'Promote Revision {{revision}}',
      saveRevisionBeforePromotion: 'Save a V2 Revision first',
      promotionSucceeded: 'Revision promoted',
      releaseHistory: 'Environment Release History',
      noReleases: 'No releases in this environment',
      rollbackHere: 'Rollback Here',
      rollbackSucceeded: 'A new rollback release was created',
      aiWorkflowDesigner: 'AI Workflow Designer',
      aiProposalDoesNotAutoApply:
        'AI creates a candidate and never changes the canvas automatically',
      aiProposalReviewHint:
        'The candidate is based on Revision {{revision}}. Review semantic changes, risks, and tests before applying it.',
      aiDesignInstruction: 'AI workflow design instruction',
      aiDesignInstructionPlaceholder:
        'Example: query CRM opportunities, classify risk with structured output, and route high risk to Flowable approval.',
      generateAiProposal: 'Generate Candidate and Tests',
      aiDesignFailed: 'Failed to generate AI workflow candidate: {{error}}',
      aiApplyFailed: 'Failed to apply AI candidate: {{error}}',
      aiProposalApplied: 'AI candidate saved as Revision {{revision}}',
      baseRevision: 'Base Revision',
      proposalExpiresAt: 'Proposal Expiration',
      candidateHash: 'Candidate Content Hash',
      semanticChanges: 'Semantic Changes',
      noSemanticChanges: 'The candidate has no semantic changes',
      wholeEntity: 'Whole entity',
      proposalRisks: 'Permission, Side-effect, and Cost Risks',
      generatedTests: 'AI-generated Tests',
      proposalWarnings: 'Compiler Warnings',
      applyAiProposalConfirm: 'Apply this AI candidate?',
      applyAiProposalConfirmHint:
        'The server rechecks the signature, content hash, and base Revision before creating a new immutable draft.',
      applyAsNewRevision: 'Apply as New Revision',
      commentOnNode: 'Comment on this node',
      refreshComments: 'Refresh comments',
      commentsLoadFailed: 'Failed to load collaboration comments',
      commentTargetNode: 'Target node: {{nodeId}}',
      replyingTo: 'Replying to {{author}}',
      cancelReply: 'Cancel reply',
      commentBody: 'Comment',
      commentPlaceholder: 'Enter a comment. Comments cannot be edited after creation.',
      commentsReadOnly: 'Comments are read-only for this revision',
      sendComment: 'Post Comment',
      sendReply: 'Send Reply',
      noComments: 'No collaboration comments for this revision',
      commentResolved: 'Resolved',
      commentOpen: 'Open',
      locateCommentNode: 'Locate Node',
      replyComment: 'Reply',
      resolveComment: 'Resolve',
      reopenComment: 'Reopen',
      createGroup: 'Group Selected Nodes',
      newGroupTitle: 'New group',
      groupAccessibleName: 'Canvas group: {{title}}',
      groupDetails: 'Group Settings',
      groupTitle: 'Group name',
      groupTitleRequired: 'Enter a group name',
      groupColor: 'Group color',
      groupWidth: 'Group width',
      groupHeight: 'Group height',
      applyGroup: 'Apply Group',
      editGroup: 'Edit group',
      deleteGroup: 'Delete group',
      deleteGroupConfirm: 'Delete this visual group? Its nodes will not be deleted.',
      groupColors: {
        blue: 'Blue',
        green: 'Green',
        purple: 'Purple',
        orange: 'Orange',
        gray: 'Gray',
      },
      conditionBuilder: 'Condition Builder',
      conditionLeft: 'Left variable',
      conditionOperator: 'Comparison operator',
      conditionValueType: 'Value type',
      conditionRight: 'Right value',
      conditionConnector: 'Condition connector',
      conditionAnd: 'AND',
      conditionOr: 'OR',
      applyCondition: 'Apply Condition',
      appendCondition: 'Append Condition',
      clearCondition: 'Clear Condition',
      conditionExpression: 'Restricted condition expression',
      conditionInvalid: 'Invalid condition expression',
      conditionValid: 'Condition expression syntax is valid',
      conditionRequired: 'Configure at least one condition',
      conditionValueTypes: {
        string: 'Text',
        number: 'Number',
        boolean: 'Boolean',
        null: 'Null',
        reference: 'Variable',
      },
      controlEdgeDetails: 'Control Edge Configuration',
      bindingEdgeDetails: 'Data Binding Details',
      applyEdgeConfig: 'Apply Edge Configuration',
      edgeSource: 'Source',
      edgeTarget: 'Target',
      edgeType: 'Edge type',
      controlEdge: 'Control flow',
      bindingEdge: 'Data binding',
      bindingEdgeManagedHint:
        "Data bindings are managed from the target node's input configuration.",
      insertNodeOnEdge: 'Insert Node on Edge',
      insertNodeHint:
        'The edge will be split in two. A conditional branch identifier remains on the source-to-new-node segment.',
      edgeLabel: 'Display label',
      edgeBranch: 'Branch identifier',
      edgeBranchRequired: 'Select a branch identifier',
      edgeBranchHint: 'The runtime uses this identifier to activate the matching control edge.',
      branchTrue: 'Condition matched (true)',
      branchFalse: 'Condition not matched (false)',
      unconditionalEdge: 'Unconditional',
      validateDraft: 'Validate Draft',
      saveRevision: 'Save Revision',
      saveRevisionConfirm: 'Validate and save a new immutable V2 revision?',
      exitEdit: 'Exit Editing',
      discardLocalChanges: 'Unsaved local V2 changes will be discarded. Continue?',
      fixErrorsBeforeSave: 'Fix publishing-level errors before publishing',
      revisionSaved: 'V2 revision r{{revision}} was saved',
      saveRevisionFailed: 'Failed to save the V2 revision: {{error}}',
      empty: 'The V2 specification has no displayable nodes',
      canvasAccessibleName: 'Agent Orchestration V2 Canvas',
      experimental: 'Experimental',
      destructive: 'High risk',
      definitionMissing: 'Node definition is missing, so port types cannot be verified',
      nodeAccessibleName: 'Workflow node: {{name}}',
      controlInput: 'Control input',
      controlOutput: 'Control output',
      inputPortAccessible: 'Input port {{name}}, type {{type}}',
      outputPortAccessible: 'Output port {{name}}, type {{type}}',
      requiredPort: 'Required port',
      editNode: 'Edit Node',
      nodeDetails: 'Node Details',
      applyNodeConfig: 'Apply Configuration',
      nodeName: 'Node Name',
      nodeNameRequired: 'Enter a node name',
      schemaForm: 'Schema Form',
      advancedJson: 'Advanced JSON',
      noConfigFields: 'This node has no configurable fields.',
      configJson: 'Configuration JSON',
      configRequired: 'This configuration is required',
      configJsonInvalid: 'Enter a valid JSON value',
      configObjectRequired: 'Node configuration must be a valid JSON object',
      inputBindings: 'Input Bindings',
      noInputPorts: 'This node has no input ports.',
      required: 'Required',
      secretAllowed: 'Secret allowed',
      requiredInputMissing: 'This required input is not bound',
      bindingKindFor: 'Binding method for {{name}}',
      variableFor: 'Variable source for {{name}}',
      selectVariable: 'Select a compatible variable',
      noCompatibleVariables: 'No type-compatible variable source is available',
      expressionFor: 'Expression for {{name}}',
      expectedType: 'Expected expression type',
      secretReferenceFor: 'Secret reference for {{name}}',
      literalFor: 'Literal value for {{name}}',
      workflowInput: 'Workflow input',
      nodeOutput: 'Node {{node}} output',
      bindingKind: {
        unset: 'Not bound',
        variable: 'Variable',
        literal: 'Literal',
        expression: 'Expression',
        secret: 'Secret reference',
      },
      connectionError: {
        endpoint_missing: 'The connection is missing a source or target',
        self_loop: 'A node cannot connect to itself',
        handle_invalid: 'Control and data ports cannot be connected to each other',
        port_missing: 'The selected port is not declared by the node definition',
        type_mismatch: 'The output type is incompatible with the target input type',
        input_occupied: 'The target input already has a binding. Remove it first.',
        control_duplicate: 'A control connection already exists between these nodes',
        edge_insert_control_only: 'Nodes can only be inserted on control-flow edges',
        edge_insert_endpoint_missing:
          'The edge source or target no longer exists. Refresh the canvas.',
        edge_insert_scope_mismatch: 'A node cannot be inserted across a loop or iteration boundary',
        edge_insert_node_unsupported:
          'Entry, terminal, and loop-control nodes cannot be inserted in the middle of an edge',
        group_selection_required: 'Select at least one node before creating a group',
      },
    },
    orchestrationDebug: {
      title: 'Conversation Debugger',
      open: 'Conversation Debugger',
      createWorkflow: 'New Workflow',
      close: 'Close conversation debugger',
      clear: 'Clear debug history',
      selectWorkflow: 'Select a workflow to debug',
      internal: 'Internal canvas',
      publishedHint:
        'Debugging uses the current published version and does not change the workflow.',
      inputFormat: 'Input format',
      outputFormat: 'Output format',
      inputUser: 'User input',
      inputSchedule: 'Schedule trigger',
      inputWebhook: 'Webhook trigger',
      outputText: 'Text',
      outputApi: 'API (JSON)',
      empty: 'Enter a message to test the current workflow',
      placeholder: 'Enter a test message; Enter to send, Shift + Enter for a new line',
      structuredInputPlaceholder:
        'Enter a JSON object; press Enter to send or Shift + Enter for a new line',
      structuredInputInvalid: 'Enter a valid JSON object before starting the debug run',
      send: 'Send Test Message',
      running: 'Workflow is running…',
      emptyResponse: 'The workflow completed without text output.',
      missingRunId: 'The server did not return a run ID',
      runEnded: 'Run ended ({{status}}) without text output.',
      statusFailed: 'Failed to read run status: {{error}}',
      executeFailed: 'Workflow execution failed: {{error}}',
      node: 'Node',
      traceTitle: 'Node execution trace',
      currentNode: 'Current node',
      lastNode: 'Last reached node',
      totalElapsed: 'Total elapsed',
      nodeInput: 'Input',
      nodeOutput: 'Output',
      nodeError: 'Error',
      emptyValue: 'None',
      downloadedFiles: 'Downloaded files ({{count}})',
      noDownloadedFiles: 'No files were downloaded successfully',
      stepStatusRunning: 'Running',
      stepStatusCompleted: 'Completed',
      stepStatusFailed: 'Failed',
      stepStatusWaiting: 'Waiting',
      approve: 'Approve and Continue',
      reject: 'Reject and Stop',
      approved: 'Approved. The workflow will continue.',
      rejected: 'Rejected. The workflow will stop.',
      approvalFailed: 'Failed to submit approval: {{error}}',
      pendingApproval: 'Waiting for approval',
      approvalTarget: 'About to execute: {{tool}}',
    },
    detailNavigation: {
      orchestration: 'Orchestration',
      api: 'API Access',
      logs: 'Logs',
      monitor: 'Monitoring',
      assistantType: 'Agent',
      workflowType: 'Workflow',
      refresh: 'Refresh',
      logsTitle: 'Run Logs',
      logsLoadFailed: 'Failed to load run logs',
      noLogs: 'No run records',
      runInput: 'Input',
      runOutput: 'Output',
      runError: 'Error',
      runStatus: 'Status',
      duration: 'Duration',
      startedAt: 'Started at',
      runStatus_submitted: 'Submitted',
      runStatus_working: 'Running',
      runStatus_input_required: 'Awaiting Confirmation',
      runStatus_completed: 'Completed',
      runStatus_failed: 'Failed',
      runStatus_canceled: 'Canceled',
      apiLoadFailed: 'Failed to load API configuration',
      apiOperationFailed: 'API operation failed',
      apiTitle: 'API Access',
      apiExampleMessage: 'Please process this message',
      apiPublished: 'API published',
      publishApi: 'Publish API',
      apiRotated: 'API key rotated',
      rotateKey: 'Rotate Key',
      revokeApiConfirm: 'Revoke this API? Existing integrations will stop working immediately.',
      apiRevoked: 'API revoked',
      revokeApi: 'Revoke API',
      enableBeforePublish: 'Enable this agent before publishing its API.',
      copyKeyNow: 'Copy the API key now',
      keyShownOnce: 'For security, the complete key is shown only after this operation.',
      apiNotPublished: 'API not published',
      apiNotPublishedHint:
        'Publish to let external systems call this agent with a dedicated API key.',
      endpoint: 'Endpoint',
      apiKey: 'API Key',
      authentication: 'Authentication',
      requestCount: 'Requests',
      lastUsedAt: 'Last used',
      neverUsed: 'Never used',
      requestExample: 'Request Example',
      workflowApiTitle: 'Workflow Entry APIs',
      platform: 'External Platform',
      configured: 'Configured',
      notConfigured: 'Not configured',
      noWebhook: 'This workflow has no Webhook entry',
      noWebhookHint: 'Add and publish a Webhook trigger to see its endpoint and schemas here.',
      outputApis: 'Downstream APIs',
      method: 'Method',
      contentTypes: 'Content Types',
      urlSecretAuthentication: 'URL secret (no additional header required)',
      noAuthentication: 'No signature secret configured',
      requestSchema: 'Request Body Schema',
      responseSchema: 'Response Schema',
      responseExample: 'Response Example',
      monitorLoadFailed: 'Failed to load monitoring data',
      monitorLoading: 'Summarizing runs from the last 30 days',
      monitorSummary: 'Last {{days}} days: {{total}} runs, {{rate}} success rate',
      monitorDescription:
        'Review safety blocks, failures, P95 latency, human confirmations, and citation coverage.',
      successRate: 'Success Rate',
      p95Latency: 'P95 Latency',
      awaitingConfirmation: 'Awaiting Confirmation',
      adoptionRate: 'User Adoption',
      eventsTitle: 'Events and Safety Signals',
      event: 'Event',
      times: 'Count',
      event_tool_call: 'Tool Call',
      event_error: 'Error',
      event_input_required: 'Awaiting Confirmation',
      event_citation: 'Citation',
      event_artifact: 'Artifact',
      monitorFooter:
        'Tokens: {{tokens}}; negative feedback: {{negative}}; failed runs: {{failed}}.',
    },
    orchestrationDetail: {
      title: 'Workflow Details',
      notFound: 'Workflow not found',
      back: 'Back to Workflows',
      refresh: 'Refresh',
      debug: 'Conversation Debugger',
      active: 'Active',
      inactive: 'Inactive',
      loadFailed: 'Failed to load workflow',
      retry: 'Reload',
      externalTitle: 'External Agent Workflow',
      platform: 'Platform',
      system: 'System',
      endpoint: 'Endpoint',
      apiKey: 'API Key',
      configured: 'Securely configured',
      notConfigured: 'Not configured',
      version: 'Version',
      canvasVersion: 'Canvas version',
      classicCanvas: 'Classic Canvas',
      v2Preview: 'V2 Typed Preview',
      v2Canvas: 'V2 Typed Canvas',
    },
    workflowEdit: {
      title: 'Edit Workflow Configuration',
      subtitle:
        'Update the workflow name, assignment, and external connection. The number and orchestration type cannot be changed.',
      save: 'Save Configuration',
      updated: 'Workflow configuration updated',
      updateFailed: 'Failed to update workflow configuration: {{error}}',
      key: 'Workflow Number',
      name: 'Workflow Name',
      nameRequired: 'Enter a workflow name',
      system: 'System',
      systemRequired: 'Select a system',
      activeAssignmentHint:
        'This workflow is active, so its system and OA template cannot be changed.',
      oaTemplate: 'Associated OA Template',
      oaTemplateRequired: 'Select an OA template',
      oaTemplatePlaceholder: 'Search by OA template name',
      templatesLoading: 'Loading…',
      templatesEmpty: 'No OA templates are configured',
      templatesLoadFailed: 'Failed to load OA templates: {{error}}',
      type: 'Orchestration Type',
      internal: 'CREST Internal Canvas',
      external: 'External Agent Platform',
      externalPlatform: 'External Platform',
      externalPlatformRequired: 'Select an external Agent platform',
      externalEndpoint: 'Platform Endpoint',
      externalEndpointRequired: 'Enter the platform endpoint',
      externalEndpointInvalid: 'Enter a complete HTTP/HTTPS URL',
      cozeEndpointHint: 'The Coze Studio endpoint must include the bot_id parameter.',
      externalApiKey: 'New API Key',
      externalApiKeyHint: 'Leave blank to keep the currently encrypted API key.',
      description: 'Description',
    },
    workflowCreate: {
      number: 'Number',
      numberHint: 'Assigned automatically after creation and cannot be changed.',
      numberPlaceholder: 'Automatically generated 8-digit number',
    },
    workflowManager: {
      sequence: 'No.',
      searchLabel: 'Search workflows',
      searchPlaceholder: 'Search by name, ID, description, or linked template',
      systemFilterLabel: 'Filter by system',
      allSystems: 'All systems',
      total: '{{total}} workflows',
      deactivate: 'Deactivate',
      deactivateConfirm:
        'Deactivate workflow “{{name}}”? Its system may temporarily have no active workflow.',
      deactivated: 'Workflow deactivated',
      deactivateFailed: 'Failed to deactivate workflow: {{error}}',
    },
    workflow: {
      todo: 'My pending tasks',
      done: 'Completed tasks',
      copy: 'Copied to me',
      manager: 'Task management',
      taskName: 'Task',
      businessKey: 'Business key',
      source: 'Source',
      assignee: 'Approver',
      createdAt: 'Created at',
      search: 'Search process, business key, or approver',
      unavailable: 'Workflow service is temporarily unavailable',
      partialData: 'Approval data is incomplete',
      reportUnavailable: 'Workflow reports are unavailable. Check the workflow service and retry.',
      reportTitle: 'Workflow reports',
      reportRetry: 'Retry',
      reportPartialFailure: 'Some report data failed to load',
      reportSummaryFailure: 'Process instance statistics failed to load',
      reportMigrationFailure: 'Legacy approval reconciliation failed to load',
      reportTotal: 'Total instances',
      reportRunning: 'Running',
      reportCompleted: 'Completed',
      reportAverageHours: 'Average duration (hours)',
      reportByProcess: 'By process',
      reportProcessKey: 'Process key',
      reportInstanceCount: 'Instances',
      reportInstanceDetails: 'Process instance details',
      reportMigrationConsistency: 'Legacy approval reconciliation',
      reportCheckedTasks: 'Checked tasks',
      reportMatched: 'Matched',
      reportMismatched: 'Mismatched',
      reportLegacyTask: 'Legacy task',
      reportBusinessType: 'Business type',
      reportLegacyStatus: 'Legacy status',
      reportLegacyApprover: 'Legacy approver',
      reportFlowableApprover: 'Flowable approver',
      models: 'Process models',
      createModel: 'Create process',
      modelName: 'Process name',
      modelKey: 'Process key',
      designerType: 'Designer',
      version: 'Version',
      status: 'Status',
      publish: 'Publish',
      startScope: 'Who can start',
      allUsers: 'All users',
      selectedUsers: 'Selected users',
      selectedDepartments: 'Selected departments',
      organizationNameLoading: 'Loading organization name…',
      organizationUnavailable: 'Organization unavailable or not visible',
      organizationConditionValue: 'Condition organization',
      organizationConditionPlaceholder: 'Search and select a business organization',
      organizationNotFound: 'No matching organization',
      organizationDirectoryLoadFailed: 'Failed to load the organization directory. Search again.',
      startUsers: 'Allowed users',
      startDepartments: 'Allowed departments',
      processManagers: 'Process managers',
      processManagersHint: 'Can view and manage instances created from this model',
      description: 'Process description',
      permissionSettings: 'Process permissions',
      allowCancelRunningProcess: 'Allow applicants to cancel running requests',
      allowWithdrawTask: 'Allow approvers to withdraw completed tasks',
      processNumberRule: 'Process number rule',
      processNumberDisabled: 'Disabled',
      numberPrefix: 'Prefix',
      datePattern: 'Date pattern',
      noDate: 'No date',
      numberSuffix: 'Suffix',
      sequenceLength: 'Sequence length',
      numberExample: 'Number example',
      displaySettings: 'Title and summary',
      autoApproval: 'Repeated approver handling',
      autoApprovalNone: 'Do not auto-approve',
      autoApprovalOnce: 'Approve once and auto-approve later duplicates',
      autoApprovalConsecutive: 'Auto-approve consecutive duplicates only',
      customTitle: 'Custom instance title',
      titleTemplate: 'Title template',
      titleTemplateHint: 'Example: Leave request - {{applicantName}}',
      summaryFields: 'Instance summary fields',
      safeTriggers: 'Process and task triggers',
      safeTriggerHint: 'Only security-reviewed triggers from the listener catalog can be selected.',
      processBeforeListenerKey: 'Before process start',
      processAfterListenerKey: 'After process completion',
      taskBeforeListenerKey: 'On task creation',
      taskAfterListenerKey: 'After task completion',
      printTemplate: 'Approval print template',
      notification: 'Notification channels',
      stationMessage: 'In-app',
      email: 'Email',
      sms: 'SMS',
      dingtalk: 'DingTalk',
      feishu: 'Feishu',
      wecom: 'WeCom',
    },
    userAvatar: {
      profile: 'Profile',
      settings: 'Settings',
      userType: 'User Type',
      domestic: 'Domestic',
      overseas: 'Overseas',
      profileTitle: 'Profile',
      settingsTitle: 'Settings',
      name: 'Name',
      account: 'Account',
      businessUnit: 'Enterprise Organization',
      roles: 'Roles',
      platformRoles: 'Platform Roles',
      crmRoles: 'CRM Roles',
      agentRoles: 'Agent Roles',
      currentUserType: 'User Type',
      uiLanguage: 'UI Language',
      defaultCurrency: 'Default Currency',
      switchHint: 'Switch user type from the avatar menu; the UI language will sync automatically.',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      enterCurrentPassword: 'Enter current password',
      enterNewPassword: 'Enter new password',
      passwordMinLength: 'At least 8 characters',
      confirmPasswordPrompt: 'Confirm new password',
      passwordMismatch: 'Passwords do not match',
      savePassword: 'Save Password',
      passwordChanged: 'Password changed',
      passwordChangeFailed: 'Failed to change password',
    },
    header: {
      notificationCenter: 'Notification Center',
      sipCallCenter: 'SIP Call Center',
      sipSettings: 'SIP Settings',
      logout: 'Logout',
      agentAssistant: 'Agent Assistant',
      agentStudio: 'Open Agent Studio',
      stopResponse: 'Stop Response',
      dragToResize: 'Drag to resize',
      dragToResizeWidth: 'Drag to resize width',
      dragToResizeHeight: 'Drag to resize height',
    },
    inbox: {
      drawerTitle: 'Approval Details',
      cancel: 'Cancel',
      reject: 'Reject',
      approve: 'Approve',
      taskInfo: 'Task Info',
      taskName: 'Task Name',
      targetEntity: 'Target Entity',
      ownerName: 'Owner Name',
      createdOn: 'Created On',
      approvalComment: 'Approval Comment',
      openFullDetails: 'Open Full Details',
      businessSummary: 'Business Summary',
      noBusinessFields: 'No business fields',
      noEntityDetails: 'No entity details',
    },
    common: {
      refresh: 'Refresh',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      create: 'New',
      search: 'Search',
      submit: 'Submit',
      submitForReview: 'Submit for Review',
      cancelSubmission: 'Cancel Submission',
      approve: 'Approve',
      accept: 'Accept',
      reject: 'Reject',
      back: 'Back',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      enable: 'Enable',
      disable: 'Disable',
      readOnly: 'Read Only',
      required: 'Required',
      loading: 'Loading...',
      noData: 'No data',
      total: 'Total',
      items: '',
      summary: 'Summary',
      details: 'Details',
      system: 'System',
      address: 'Address',
      lookupOpener: 'Please select',
      add: 'Add',
      remove: 'Remove',
      assign: 'Assign',
      activate: 'Activate',
      deactivate: 'Deactivate',
      qualify: 'Qualify',
      disqualify: 'Disqualify',
      close: 'Close',
      reopen: 'Reopen',
      export: 'Export',
      import: 'Import',
      print: 'Print',
      send: 'Send',
      reply: 'Reply',
      view: 'View',
      copy: 'Copy',
      download: 'Download',
      upload: 'Upload',
      filter: 'Filter',
      reset: 'Reset',
      apply: 'Apply',
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish',
      ok: 'OK',
      active: 'Active',
      inactive: 'Inactive',
      draft: 'Draft',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      completed: 'Completed',
      name: 'Name',
      description: 'Description',
      status: 'Status',
      owner: 'Owner',
      createdOn: 'Created On',
      modifiedOn: 'Modified On',
      createdBy: 'Created By',
      modifiedBy: 'Modified By',
      operationSuccess: 'Done',
      operationFailed: 'Operation failed',
      saveSuccess: 'Saved',
      saveFailed: 'Save failed',
      deleteSuccess: 'Deleted',
      deleteFailed: 'Delete failed',
      deleteConfirm: 'Confirm delete?',
      unsavedChanges: 'You have unsaved changes',
      pleaseSelect: 'Please select',
      pleaseInput: 'Please enter',
    },
    nav: {
      worklist: 'Work List',
      dashboard: 'Sales Dashboard',
      inbox: 'Approval Inbox',
      weeklyReport: 'Weekly Report',
      account: 'Account',
      contact: 'Contact',
      lead: 'Lead',
      opportunity: 'Opportunity',
      quote: 'Quote',
      sinosure: 'Sinosure',
      delivery: 'Delivery Project',
      salesHub: 'Sales Hub',
      financeCenter: 'Finance Center',
      operationsConsole: 'Operations Center',
      adminSettings: 'Admin Settings',
      settings: 'Parameter Configuration',
      appCenter: 'Application Center',
      users: 'User Management',
      roles: 'Role Permissions',
      fsp: 'Field Security Profiles',
      buTree: 'Organization',
      auditLog: 'Audit Log',
      integrationLog: 'Integration Log',
      notifyHistory: 'Email Configuration',
      businessUnit: 'Enterprise Organization',
      frequencyBand: 'Frequency Band',
      countryPhoneCode: 'Country Phone Code',
      currency: 'Currency',
      mailConfig: 'Recipient Configuration',
      approverSetup: 'Approval Settings',
      pricing: 'Pricing',
      quoteBasePrice: 'Quote Base Price',
      domesticPricing: 'Domestic Pricing',
      overseasPricing: 'Overseas Pricing',
      basePriceMaintenance: 'Base Price Maintenance',
    },
    financeCollections: {
      title: 'Customer Collections',
      domesticTitle: 'Domestic Customer Collections',
      overseasTitle: 'Overseas Customer Collections',
      tabOverview: 'Overview',
      tabDomestic: 'Domestic Collections',
      tabOverseas: 'Overseas Collections',
      tabAgent: 'Collections Agent',
      tabSettings: 'Sender Settings',
      senderConfigPageTitle: 'Collections Sender Settings',
      senderConfigPageSubtitle:
        'Manage and verify default, domestic, and overseas collection senders.',
      ledgerTitle: 'Collections Ledger',
      ledgerSubtitle:
        'Manage domestic, overseas, and mixed collection batches in one workspace: review, send, failures, and payments.',
      subtitle: 'Import the notice list and collection template to generate Word letters in bulk',
      domesticSubtitle:
        'Import the domestic customer notice list and collection template to generate Word letters in bulk',
      overseasSubtitle:
        'Import the overseas customer notice list and collection template to generate Word letters in bulk',
      agentSubtitle:
        'The AI agent reads inputs, gives collection guidance, drafts messages, and sends collection emails; this page only keeps the execution ledger.',
      agentRule:
        'Start collection work from the AI assistant in the upper right. Users no longer need fixed templates or manually normalized files; this page shows batches, cases, drafts, sends, and payment status.',
      agentPageTitle: 'Collections AI Assistant',
      agentPageSubtitle:
        'Upload a notice list and Word demand-letter template. The agent reads the original files, preserves the template style, and generates reviewable demand letters.',
      agentPromptPlaceholder:
        'Upload the customer list and Word demand-letter template, then choose Generate Letters, Create Collection Batch, Send Collection Emails, or describe the collection goal.',
      agentRun: 'Run Agent',
      agentAnswer: 'Agent Result',
      agentTrace: 'Execution Trace',
      agentConversation: 'Conversation',
      agentConversationEmpty: 'No collections conversation yet',
      agentComposerTitle: 'Continue Collaboration',
      agentQuickInstructions: 'Shortcuts',
      agentQuickInstructionDefault: 'Choose Task',
      agentWorking: 'Agent is working',
      agentFinalPending: 'Final result is being prepared',
      agentContinueWith: 'Continue with',
      agentThinkingSummary: 'Thinking Summary',
      agentDuration: '{{seconds}}s elapsed',
      agentStop: 'Stop',
      agentStopped: 'Stopped.',
      agentNewConversation: 'New Conversation',
      agentNewConversationConfirm:
        'The current page record will be cleared and a new context ID will be created.',
      agentConnecting: 'Connecting to Agent',
      agentCompleted: 'Completed',
      agentRunFailedShort: 'Failed',
      agentNoOutput: 'No output',
      agentDefaultCompleted: 'Processing completed.',
      agentEmptyResult:
        'The agent returned no result, so no action was confirmed. Please retry or start a new conversation.',
      agentSyncPending: 'Syncing background result',
      agentStreamInterrupted:
        'The agent may still be running in the background. Results will appear here automatically when ready.',
      agentUiIntentToast: 'Agent page action completed',
      agentUiIntentReady: 'Related page is ready. Open it from the result card.',
      agentRelatedPages: 'Related Pages',
      agentOpenCollectionLedger: 'Open this batch ledger in a new tab',
      agentOpenCollectionLedgerWithCount: 'Open this batch ledger in a new tab ({{count}} rows)',
      agentOpenUpdatedRecord: 'Open updated record in a new tab',
      agentOpenRelatedRecords: 'Open related records in a new tab',
      agentOpenLinkedPage: 'Open page in a new tab',
      agentConfirmActionLabel: 'Confirm {{name}}',
      agentConfirmActionPrompt:
        'Confirm {{name}}. Use the last preview scope; restate the impact before creating, sending, or changing status.',
      cancel: 'Cancel',
      agentFailed: 'Collections agent failed',
      attachInputFile: 'Attach List/Template File',
      agentFileParsed: 'File content was added to the agent prompt',
      agentFileParseFailed: 'Failed to parse the file. Paste the content instead.',
      agentAttachedFile: 'Content from file: {{name}}',
      agentFileUploaded: 'Original file uploaded. The agent will read the attachment directly.',
      agentFileUploadFailed: 'File upload failed. Please try again.',
      agentFileLimit: 'Attach up to 100 files per turn',
      agentOriginalFiles: 'Original Files',
      agentOriginalFileMode: 'Format preserved',
      agentDefaultFilePrompt:
        'Generate this batch of demand letters from the uploaded notice list and Word template, preserve the template formatting, and return downloadable files.',
      agentGeneratedFiles: 'Generated Files',
      agentFileBlocked: 'Unavailable',
      agentArtifactDownloadFailed: 'Failed to download the generated file. Please try again.',
      agentShortcutGenerateLetters: 'Generate Letters',
      agentShortcutCreateBatch: 'Create Batch',
      agentShortcutSendEmails: 'Send Emails',
      agentExample1:
        'Generate Letters: Use the uploaded customer list and Word demand-letter template to generate this batch of letters, preserve formatting, and return downloadable Word files plus a zip. Do not create a batch or send emails.',
      agentExample2:
        'Create Collection Batch: Reuse the letters already generated in this conversation; only generate them if missing. Then create or reuse the same-list collection batch and cases. Before creating, show customer count, amount, missing fields, and impact for confirmation.',
      agentExample3:
        'Send Collection Emails: Reuse the letters and collection batch already available in this conversation; only fill the missing step if needed. Send with the configured collections sender, attach the matching Word demand letter to each email, skip already sent cases by default, and confirm recipients, subject, attachments, and email count before sending.',
      senderConfigTitle: 'Collections Sender',
      senderConfigAction: 'Configure',
      senderConfigAdminAction: 'Admin Settings',
      senderConfigModalTitle: 'Collections Sender Settings',
      senderConfigSave: 'Save',
      senderConfigVerify: 'Save & Verify',
      senderConfigReady: 'Ready',
      senderConfigDisabled: 'Disabled',
      senderConfigNeedsVerify: 'Needs Verification',
      senderConfigNotSet: 'Sender email not configured',
      senderConfigDefault: 'Default',
      senderConfigDomestic: 'Domestic',
      senderConfigOverseas: 'Overseas',
      senderConfigContactAdmin:
        'Emails use the domestic or overseas sender automatically by collection scope. Contact an admin if a sender is not ready.',
      senderConfigAdminHint:
        'Microsoft 365 only needs sender information. Domestic/overseas senders fall back to default when not configured.',
      senderConfigProvider: 'Delivery Method',
      senderConfigProviderM365: 'Microsoft 365',
      senderConfigProviderM365Short: 'M365',
      senderConfigProviderSmtp: 'SMTP',
      senderConfigProviderSmtpShort: 'SMTP',
      senderConfigM365Hint:
        'Use the company Microsoft 365 authorization to send as this mailbox and save to Sent Items.',
      senderConfigSmtpHint:
        'Legacy SMTP mode requires SMTP account and app password for this sender.',
      senderConfigAdvanced: 'SMTP Compatibility',
      senderConfigEnabled: 'Enable collections sender',
      senderConfigFromName: 'Sender Name',
      senderConfigFromEmail: 'Sender Email',
      senderConfigReplyTo: 'Reply-To',
      senderConfigFromNamePlaceholder: 'Baicells Collections',
      senderConfigFromEmailPlaceholder: 'collections@baicells.com',
      senderConfigReplyToPlaceholder: 'ar@baicells.com',
      senderConfigSmtpHost: 'SMTP Host',
      senderConfigSmtpHostPlaceholder: 'smtp.example.com',
      senderConfigSmtpPort: 'Port',
      senderConfigSecure: 'SSL',
      senderConfigSmtpUser: 'SMTP User',
      senderConfigSmtpPassword: 'SMTP Password/App Password',
      senderConfigPasswordKeep: 'Leave blank to keep the saved password',
      senderConfigPasswordPlaceholder: 'Enter the SMTP password or app password',
      senderConfigEmailInvalid: 'Invalid email address',
      senderConfigLoadFailed: 'Failed to load sender settings',
      senderConfigSaved: 'Sender settings saved',
      senderConfigSaveFailed: 'Failed to save sender settings',
      senderConfigVerifySuccess: 'Sender settings verified',
      senderConfigVerifyFailed: 'Failed to verify sender settings',
      traceThinking: 'Thinking',
      traceToolCall: 'Tool call',
      traceToolResult: 'Tool result',
      traceError: 'Error',
      traceAgentStudioStarted: 'Connected to Agent Studio',
      traceRuntimeStarted: 'Agent Runtime started',
      traceToolCallWithName: 'Handling: {{name}}',
      traceToolResultWithName: 'Completed: {{name}}',
      traceActionPreviewWithName: 'Needs confirmation: {{name}}',
      traceUiIntentWithKind: 'Page action {{kind}}',
      traceArtifact: 'Generated file',
      stageStarted: 'Agent started and is reading context',
      stageThinking: 'Analyzing the collection task',
      stageToolCall: 'Handling: {{name}}',
      stageActionPreview: 'Preparing a confirmation action',
      stageToolResult: 'Completed: {{name}}',
      stageUiIntent: 'Updating the page',
      stageArtifact: 'Generated files are ready',
      stageDelta: 'Preparing the final result',
      backToLedger: 'Back to Ledger',
      refresh: 'Refresh',
      openAgent: 'Open AI Assistant',
      loadFailed: 'Failed to load collection records. Please try again later.',
      attemptLoadFailed: 'Failed to load send attempts. Please try again later.',
      markedPaid: 'Marked as paid',
      caseCount: 'Cases',
      overdueTotal: 'Overdue by Currency',
      draftCases: 'Needs Draft',
      blockedCases: 'Needs Review',
      readyCases: 'Ready to Send',
      testSentCases: 'Test Sent',
      failedCases: 'Failed',
      sentCases: 'Sent',
      ledgerSearchPlaceholder: 'Search customer, email, contract, invoice, or batch',
      scopeAll: 'All Scopes',
      allBatches: 'All Batches',
      scopeTitle: 'Scope',
      batchName: 'Batch',
      language: 'Language',
      fromEmail: 'Sender',
      recentBatches: 'Recent Batches',
      noBatch: 'No batches yet',
      caseUnit: 'cases',
      caseLedger: 'Collection Ledger',
      caseDetailView: 'Case Detail',
      customerSummaryView: 'By Customer',
      customerSummary: 'Customer Summary',
      batchCount: 'Batches',
      contractInvoiceCount: 'Contracts/Invoices',
      maxOverdueDays: 'Max Overdue Days',
      priority: 'Priority',
      statusTitle: 'Status',
      invoiceNo: 'Invoice No.',
      nextFollowup: 'Next Follow-up',
      validationIssues: 'Information to confirm',
      draftPreview: 'Email Draft',
      noDraft: 'No email draft yet',
      draftPendingHint:
        'Continue with “Generate Demand Letters” or “Send Collection Emails” in the AI assistant before reviewing the draft.',
      sendAttempts: 'Send Attempts',
      noAttempts: 'No send attempts yet',
      toEmail: 'Recipient',
      deliveryMode: 'Delivery Type',
      sentAt: 'Sent At',
      errorMessage: 'Error',
      markPaid: 'Mark Paid',
      status: {
        ready: 'Ready to Send',
        needs_review: 'Needs Review',
        test_sent: 'Test Sent',
        sent: 'Sent',
        failed: 'Failed',
        paid: 'Paid',
        closed: 'Closed',
        draft: 'Needs Draft',
        queued: 'Queued',
        partial_sent: 'Partially Sent',
        validating: 'Validating',
      },
      priorityMap: {
        low: 'Low',
        normal: 'Normal',
        high: 'High',
        critical: 'Critical',
      },
      attemptStatus: {
        sent: 'Sent',
        test_sent: 'Test Sent',
        failed: 'Failed',
        queued: 'Queued',
        skipped: 'Skipped',
      },
      statusView: {
        all: 'All',
        draft: 'Needs Draft',
        needs_review: 'Needs Review',
        ready: 'Ready to Send',
        test_sent: 'Test Sent',
        failed: 'Failed',
        sent: 'Sent',
      },
      deliveryModeMap: {
        customer: 'Customer',
        test: 'Test',
      },
      scope: {
        domestic: 'Domestic',
        overseas: 'Overseas',
        mixed: 'Mixed',
      },
      languageMap: {
        zh: 'Chinese',
        en: 'English',
        auto: 'Auto',
      },
      ruleTitle: 'Batch generation rules',
      ruleDescription:
        'Reads the “发函清单” sheet and replaces company name, customer name, customer email, contract number, overdue amount, due date, overdue days, uppercase amount, and cutoff date in the Word template.',
      uploadExcel: 'Upload Notice List',
      uploadExcelHint: 'Supports .xlsx / .xls; the workbook must include the “发函清单” sheet',
      uploadTemplate: 'Upload Collection Template',
      uploadTemplateHint: 'Supports .docx; keep replacement field text in the template',
      createCollection: 'New Collection',
      createTitle: 'New Collection',
      createSubtitle: 'Manually add one collection row to the current notice list',
      createConfirm: 'Save',
      createCancel: 'Cancel',
      created: 'Collection row added',
      requiredField: 'This field is required',
      invalidEmail: 'Enter a valid email address',
      downloadListTemplate: 'Download List Template',
      templateDownloadFailed: 'Failed to download the list template. Please try again later.',
      generate: 'Generate in Bulk',
      downloadFileName: 'collection-letters-{{date}}.zip',
      domesticDownloadFileName: 'domestic-collection-letters-{{date}}.zip',
      overseasDownloadFileName: 'overseas-collection-letters-{{date}}.zip',
      generateGuard: 'Upload the notice list, template, and confirm valid rows first',
      generated: '{{count}} collection letters generated',
      generateFailed: 'Failed to generate letters. Please check that the template is a valid docx.',
      imported: '{{count}} rows imported',
      importFailed: 'Failed to read the notice list. Please check the file format.',
      missingHeaders: 'Required columns are missing from the notice list',
      missingHeaderTitle: 'Missing required columns',
      sheetNames: 'Sheets',
      validRows: 'Valid customers',
      cutoffDate: 'Cutoff Date',
      companyName: 'Company Name',
      customerName: 'Customer Name',
      customerEmail: 'Customer Email',
      contractNo: 'Contract No.',
      overdueAmount: 'Overdue Amount',
      dueDate: 'Due Date',
      overdueDays: 'Overdue Days',
    },
    entityList: {
      actions: 'Actions',
      total: 'Total {{formattedCount}}',
      selected: '{{count}} selected',
      loading: 'Loading...',
      quickFind: 'Quick Find',
      createdOn: 'Created On',
      modifiedOn: 'Modified On',
      startDate: 'Start Date',
      endDate: 'End Date',
      new: 'New',
      moreActions: 'More actions',
      bulkDelete: 'Bulk Delete',
      bulkDeleteConfirmTitle: 'Delete {{count}} records?',
      bulkDeleteConfirmContent: 'This action cannot be undone.',
      bulkDeleteSuccess: 'Bulk delete completed: {{success}} succeeded, {{failed}} failed',
      clearSelection: 'Clear selection',
      noData: 'No data',
      noMatches: 'No matches for "{{query}}"',
      noMatchesDescription: 'Try another keyword, or clear search to view all',
      emptyDescription: 'Rows will appear here when the API returns data',
      loadFailed: 'Failed to load data',
      loadFailedDescription: 'Check your read permission or try again later',
      retry: 'Reload',
    },
    contractList: {
      title: 'Sales Contracts',
      create: 'New Sales Contract',
      details: 'Details',
      columns: {
        code: 'Contract Number',
        type: 'Contract Type',
        customer: 'Final Customer',
        country: 'Country/Region',
        status: 'Status',
        modifiedOn: 'Modified On',
      },
      filters: {
        allTypes: 'All Contract Types',
        allStatuses: 'All Statuses',
      },
      types: {
        overseas: 'Overseas Standard Contract',
        'domestic-channel': 'Domestic Channel Contract',
        'domestic-operator': 'Domestic Operator Contract',
        unclassified: 'Unclassified',
      },
      statuses: {
        draftPending: 'Draft/Pending Submission',
        draftApproval: 'Draft/In Approval',
        approved: 'Approved',
        syncFailed: 'Sync Failed',
      },
    },
    contractDetail: {
      loadFailed: 'Failed to load contract',
      loadFailedDescription:
        'The contract data could not be read or parsed. Refresh and try again, or contact an administrator if the problem continues.',
      backToList: 'Back to contracts',
      messages: {
        historyLoadFailed: 'Failed to load change history. Try again later.',
        documentSaved: 'Contract content saved.',
        documentSaveFailed: 'Failed to save contract content. Try again later.',
        quoteMissing: 'No quote is linked to this contract.',
        quotePdfReady: 'Quote PDF generated.',
        quotePdfFailed: 'Failed to generate the quote PDF. Try again later.',
        quoteRefreshSucceeded: 'The latest data from the linked quote has been applied.',
        quoteRefreshFailed: 'Failed to update the quote. Try again later.',
        contractPdfReady: 'Contract PDF generated.',
        contractPdfFailed: 'Failed to generate the contract PDF. Try again later.',
      },
      header: {
        back: 'Back',
        overseasTitle: 'Sales Contract {{code}}',
        domesticTitle: 'Sales Contract {{code}}',
        editing: 'Editing',
        readOnly: 'Read only',
        riskCount: '{{count}} risks',
        template: 'Template {{name}}',
        snapshotReady: 'Rule snapshot generated',
        customer: 'Customer',
        contractDate: 'Contract Date',
        contractAmount: 'Contract Amount',
        owner: 'Owner',
        history: 'Change History',
        relations: {
          title: 'Related contract records',
          customer: 'Customer',
          opportunity: 'Opportunity',
          quote: 'Quote',
          labelSeparator: ':',
          notLinked: 'Not linked',
          viewDetails: 'View details',
        },
        actions: {
          refresh: 'Refresh',
          refreshQuote: 'Update Quote',
          createCommercialInvoice: 'Create Commercial Invoice',
          edit: 'Edit',
          cancel: 'Cancel',
          save: 'Save',
          'generate-pdf': 'Generate PDF',
          share: 'Share',
        },
        quotePdf: 'Quote PDF',
        quotePdfGenerating: 'Quote PDF (Generating…)',
        quotePdfUnavailable: 'Quote PDF (No quote linked)',
        contractPdf: 'Contract PDF',
        contractPdfGenerating: 'Contract PDF (Generating…)',
        status: {
          draft: 'Draft',
          pending: 'In approval',
          approved: 'Approved',
          syncFailed: 'Sync failed',
          sapNotSynced: 'SAP Not Synced',
          sapSyncing: 'SAP Syncing',
          sapSyncFailed: 'SAP Sync Failed',
          sapSynced: 'SAP Synced',
          sapUnknown: 'SAP Status Unknown',
        },
      },
      tabs: {
        workspace: 'Contract',
        rules: 'Rules',
        clauses: 'Terms & Differences',
        audit: 'Audit Trail',
        attachments: 'Attachments',
      },
      workspace: {
        guidance:
          'Select a term on the right to open its editor on the left. You can complete fields, select parameters, edit text, insert clauses, or remove removable clauses.',
        editorTitle: 'Contract Editor',
        editorSummary:
          'The contract contains {{count}} structured content blocks from the standard template. Chapters are reordered automatically after clauses are added or removed.',
        structured: 'Structured Contract',
        previewTitle: 'Formal Contract Preview',
        previewDescription:
          'Displayed in A4 contract format. Select a term in the preview to return to its editor.',
        a4Layout: 'A4 Layout',
        defaultWarning:
          'This contract contains non-standard lead time, payment terms, or customer edits. Approval is required before generating the formal contract.',
      },
      attachments: {
        title: 'Contract Attachments',
        description:
          'Customer templates, rule snapshots, approval evidence, and formal contracts are archived by source.',
        upload: 'Upload Attachment',
        columns: {
          fileName: 'File Name',
          type: 'Type',
          source: 'Source',
          owner: 'Uploaded/Generated By',
          time: 'Time',
          actions: 'Actions',
        },
        sources: {
          customerTemplate: 'Customer Upload',
          generatedContract: 'System Generated',
          ruleSnapshot: 'Rule Engine',
          approvalEvidence: 'Approval Workflow',
        },
        types: {
          customerTemplate: 'Customer Template',
          generatedContract: 'Formal Contract',
          ruleSnapshot: 'Rule Snapshot',
          approvalEvidence: 'Approval Attachment',
        },
        owners: {
          customerTemplate: 'Customer / Emily Chen',
          generatedContract: 'Contract Generation Service',
          ruleSnapshot: 'System Rule Engine',
          approvalEvidence: 'Sales Operations',
        },
        afterApproval: 'Generated after approval',
        viewDifference: 'View Differences',
        preview: 'Preview',
        download: 'Download',
      },
      history: {
        drawerTitle: 'Change History',
        title: 'Contract Change History',
        description:
          'Compares the current contract with the standard template and records added, removed, and modified terms.',
        all: 'All',
        clauseChanges: 'Term Changes',
        loading: 'Loading',
        records: '{{count}} records',
        currentEdit: 'Current Edit',
        liveRecord: 'Live Record',
        empty: 'No change records',
        original: 'Original',
        current: 'Current',
      },
      clauses: {
        title: 'Contract Term Differences',
        empty: 'No contract term differences',
        columns: {
          clause: 'Term',
          standard: 'Standard Template',
          current: 'Current Contract',
        },
      },
      editor: {
        addAtChapterEnd: 'Add at Chapter End',
        locatePreview: 'Locate in Preview',
        approvalCalculation: 'Approval Calculation',
        insertClauseAfter: 'Insert Clause After',
        delete: 'Delete',
        required: 'Required',
        tableSummary:
          'Keeps the original contract table structure with {{count}} rows. Product, amount, and signing data are populated by the system or clause fields.',
        selectLabel: 'Option Field',
        selectDescription:
          'Select from the values allowed by the standard template; the contract preview updates immediately.',
        variableLabel: 'System Populated',
        variableDescription:
          'Read from the customer, opportunity, quote, or system calculation. Manual changes are not recommended.',
        tableLabel: 'Word Table',
        tableDescription:
          'Uses the standard contract table layout; data is populated from quote, product, or signing information.',
        textLabel: 'Contract Text',
        lockedTextDescription: 'Fixed text displayed as the template baseline.',
        editableTextDescription: 'Editable text for terms agreed with the customer.',
        added: 'Added',
        modified: 'Modified',
        validation: {
          separator: '; ',
          supplierContactRequired: 'Supplier Contact is required',
          supplierEmailRequired: 'Supplier Email is required',
          supplierEmailInvalid: 'Supplier Email format is invalid',
          supplierValid: 'Supplier contact information is valid.',
          paymentPercentage: 'Payment percentages total {{value}} and must be adjusted to 100%',
          paymentChannel: '{{channel}} requires commercial approval',
          paymentCreditDays: 'Credit Period Days is required for an after-payment milestone',
          paymentNotPrepaid: 'Payment that is not 100% prepaid requires commercial approval',
          paymentValid: 'The payment plan is valid and totals 100%.',
        },
        fields: {
          'supplier-signing-entity': {
            helper:
              'Select the contract signing entity. Supplier Name and Address are populated automatically.',
          },
          'supplier-name': {
            helper: 'Automatically populated from the selected signing entity.',
          },
          'supplier-address': {
            helper: 'Automatically populated from the selected signing entity.',
          },
          'supplier-contact': {
            helper: 'Required contact for signing the contract.',
          },
          'supplier-tel': {
            helper: 'Optional. Include the international dialing code when provided.',
          },
          'supplier-email': {
            helper: 'Required. The email format is validated before submission.',
          },
          'supplier-validation-summary': {
            helper:
              'Validates the supplier contact, phone, and email and synchronizes them to the contract party table.',
          },
          'overseas-product-table': {
            helper:
              'Products, quantities, unit prices, subtotals, and the total amount are synchronized from the quote.',
          },
          'delivery-days': {
            helper:
              'Lead Time replaces Delivery Date. A lead time below the allowed maximum triggers delivery approval.',
          },
          'shipment-incoterm': {
            helper: 'Defines delivery responsibilities and the transfer of risk.',
          },
          'shipment-named-place': {
            helper: 'The location where the supplier fulfills delivery and transfers risk.',
          },
          'warranty-months': {
            helper: 'Select from 12 to 60 months in six-month increments.',
          },
          'warranty-start-from': {
            helper: 'Defines the event that starts the warranty period.',
          },
          'payment-through': {
            helper:
              'Payment methods other than T/T or terms other than 100% prepayment require commercial approval.',
          },
          'payment-down-payment-existed': {
            helper: 'Select Yes to enter the down-payment percentage.',
          },
          'payment-down-payment-percent': {
            helper: 'Enter 1–100. The system validates the total payment percentage.',
          },
          'payment-remaining-percent': {
            helper: 'The remaining amount and down payment must total 100%.',
          },
          'payment-timing': {
            helper: 'Credit Period Days is required when Timing is after.',
          },
          'payment-milestone': { helper: 'The event that triggers payment.' },
          'payment-credit-days': {
            helper: 'Required when Timing is after; enter 0 when it is before.',
          },
          'payment-validation-summary': {
            helper:
              'Summarizes approval triggers based on payment method, percentage, milestone, and credit period.',
          },
          'quote-revenue': {
            label: 'Net Quote Revenue',
            helper:
              'Includes quoted products, software, technical services, and training charged to the customer.',
          },
          'quote-product-cost': {
            label: 'Product and Fulfillment Cost',
            helper:
              'Read from the quote or BOQ cost snapshot. No estimated profit is shown when cost is unavailable.',
          },
          'market-fee-mode': {
            label: 'Market Fee Method',
            helper:
              'Used for internal approval only; it is excluded from the contract text, amount, and PDF.',
          },
          'market-fee-value': {
            label: 'Market Fee Value',
            helper:
              'Enter an amount for Fixed Amount or a percentage from 0 to 100 for Percentage.',
          },
          'market-fee-note': {
            label: 'Fee Description',
            helper:
              'Describe the fee purpose or calculation basis for commercial and financial approval.',
          },
        },
      },
      rules: {
        title: 'Rule List',
        riskRules: 'Risk Rules',
        description:
          'Shows the rules and risk levels applicable to this contract. Review text differences and customer edits under “Terms & Differences”.',
        total: 'Rules',
        highRisk: 'High-risk Rules',
        mediumRisk: 'Medium-risk Rules',
        blocking: 'Blocking Rules',
        count: '{{count}}',
        high: 'High',
        medium: 'Medium',
        calculationSource: 'Calculation Sources',
        readOnlySnapshot: 'Read-only Snapshot',
        quoteRevenue: 'Net Quote Revenue',
        marketFeeMode: 'Market Fee Method',
        marketFeeAmount: 'Market Fee Amount',
        feeRecipient: 'Fee Recipient',
        productCost: 'Quoted Product Cost',
        profitAfterFee: 'Profit after Market Fee',
        profitMargin: 'Profit Margin after Fee',
        awaitingCost: 'Awaiting quote cost synchronization',
        percentage: '{{value}}%',
        fixed: 'Fixed Amount {{value}}',
        none: 'None',
        recipientSales: 'Sales',
        findings: {
          'lead-time': 'Lead time is shorter than the allowed maximum',
          payment: 'Payment terms are not 100% prepaid',
          currency: 'Currency is not USD',
          custom: 'Custom supplementary terms exist',
          legal: 'Customer modified fixed standard terms',
          'market-fee': 'Market fee exists',
        },
      },
      audit: {
        title: 'Audit Trail',
        description:
          'Records contract creation, rule snapshots, field changes, approval submissions, and file generation.',
        records: '{{count}} records',
        loadFailed: 'Failed to load the audit trail. Try again later.',
        columns: {
          time: 'Time',
          type: 'Type',
          actor: 'User',
          action: 'Action',
          impact: 'Impact',
        },
        categories: {
          create: 'Create',
          rule: 'Rule',
          edit: 'Edit',
          approval: 'Approval',
          file: 'File',
          integration: 'Integration',
        },
        ruleSnapshot: 'Rule Snapshot',
        generatedAt: 'Last generated at {{time}}',
        noRuleSnapshot: 'No rule snapshot has been generated for this contract.',
        generated: 'Generated',
        notGenerated: 'Not Generated',
        templateVersion: 'Template Version',
        templateVersionDescription:
          'Shows the contract baseline template version locked in the audit record.',
        notRecorded: 'Not Recorded',
        contractVersion: 'Contract Version V{{version}}',
        lockedAt: 'Locked at {{time}}',
        approvalPassed: 'Approved',
        pdfGenerated: 'PDF Generated',
        system: 'System',
        actions: {
          createContract: 'Create Contract',
          generateFormalVersion: 'Generate and Lock Formal Version',
          saveContractChanges: 'Save Contract Text Changes',
          modifyParameters: 'Modify Contract Parameters',
        },
        fields: {
          snapshotVersion: 'Contract Snapshot Version',
          paymentPlan: 'Payment Plan',
          iws_signingentity: 'Signing Entity',
          success: 'Success',
        },
      },
      approval: {
        processTitle: 'Contract Process',
        active: 'Active',
        completed: 'Completed',
        processHint: 'Stages advance in order. The current stage shows the approval to complete.',
        actions: {
          submitQuote: 'Submit Quote Approval',
          submitContract: 'Submit Contract Approval',
          withdrawQuote: 'Withdraw Quote Approval',
          withdrawContract: 'Withdraw Contract Approval',
          resubmittingQuote: 'Resubmitting Quote Approval…',
          reload: 'Reload',
        },
        editLocked:
          'The quote is in approval or already approved. Withdraw the current approval before editing.',
        statusLoadFailed: 'Failed to load quote approval status. Please try again.',
        contractEditLocked:
          'The contract is in OA approval or already approved. The current version cannot be edited.',
        contractStatusLoadFailed:
          'Failed to load the OA contract approval status. Editing is temporarily locked.',
        contractStatus: {
          not_submitted: 'Contract Pending Submission',
          preparing: 'Preparing Contract Approval',
          submitting: 'Submitting Contract Approval',
          in_progress: 'Contract Approval In Progress',
          create_failed: 'Contract Approval Creation Failed',
          create_uncertain: 'Contract Approval Creation Unconfirmed',
          withdrawing: 'Withdrawing Contract Approval',
          withdraw_uncertain: 'Contract Withdrawal Unconfirmed',
          resubmitting: 'Resubmitting Contract Approval',
          resubmit_uncertain: 'Contract Resubmission Unconfirmed',
          approved: 'Contract Approval Approved',
          rejected: 'Contract Approval Rejected',
          withdrawn: 'Contract Approval Withdrawn',
          voided: 'Contract Approval Voided',
        },
        contractOverview: {
          title: 'OA Contract Approval Progress',
          subtitle:
            'OA manages approval routing; CREST synchronizes the overall status and process ID.',
          notSubmittedTitle: 'Contract approval has not been submitted',
          notSubmittedDescription:
            'After quote approval, submit the contract approval from the page header.',
          meta: 'OA contract approval information',
          round: 'Round {{round}}',
          processId: 'OA Process ID {{id}}',
          submittedAt: 'Submitted {{time}}',
          completedAt: 'Completed {{time}}',
          activeDescription:
            'Approval continues in OA. CREST updates the status automatically after OA returns the result.',
          approvedDescription:
            'This contract approval round has been approved. The approved version remains locked.',
          rejectedDescription:
            'This contract approval round was rejected and has ended. Revise it and create a new approval round.',
          withdrawnDescription:
            'This contract approval round was withdrawn and has ended. Revise it and create a new approval round.',
          voidedDescription:
            'This contract approval round is void and no longer active. A new approval round can be created.',
          createFailedDescription:
            'This contract approval round was not created in OA. Check the issue and submit it again.',
          resultApproved: 'Approval result: Approved',
          resultRejected: 'Approval result: Rejected',
          resultWithdrawn: 'Approval result: Withdrawn',
          resultVoided: 'Approval result: Voided',
          resultCreateFailed: 'Approval result: Creation failed',
          resultInProgress: 'Current stage: Contract approval in progress',
          resultUncertain: 'Current status: Pending confirmation',
          nextApproved: 'Next: Proceed to signing and archiving.',
          nextRejected: 'Next: Revise the contract and submit a new contract approval.',
          nextResubmit: 'Next: Review the contract and submit a new contract approval.',
          nextRetry: 'Next: Check the parameters and submit the contract approval again.',
          nextWait: 'Next: Wait for OA to complete approval and return the result.',
          nextVerify: 'Next: Verify the workflow status in OA first.',
        },
        contractWarning: {
          inProgress:
            'The contract is in OA approval and the current version is locked. To make changes, end the current process in OA first, wait for the status update, then edit and submit a new approval.',
          approved: 'The contract is approved. The approved version remains locked.',
        },
        domesticSubmit: {
          title: 'Submit domestic contract to OA approval?',
          description:
            'System fields are read from the contract, quote, customer, and opportunity. Check the OA template parameters before confirming submission.',
          confirm: 'Submit to OA',
          checkParameters: 'Check Parameters',
          confirmAfterCheck: 'Confirm Submission to OA',
          parametersMissing: 'Approval parameters are incomplete',
          parametersReady: 'Approval parameters are complete',
          readyDescription:
            'The next confirmation locks the contract version, generates the PDF, and creates the domestic OA approval workflow.',
          validationMissing:
            'Domestic contract approval parameters are incomplete. Complete them and try again.',
          success: 'Domestic contract submitted to OA approval',
          failed: 'Failed to submit domestic contract to OA. Try again later.',
        },
        resubmitUncertain:
          'The OA resubmission result is not confirmed. Check OA before submitting again.',
        modal: {
          title: 'Submit Quote Approval',
          description:
            'Check the parameters required by CREST and the OA quote template first. A second confirmation is required before creating the OA workflow.',
          isStamped: 'Stamp required',
          includesModifiedProduct: 'Includes modified products',
          isTechnicalDevelopmentProject: 'Technical development project',
          productManagerOaId: 'Product Manager OA ID',
          productManagerRequired: 'A Product Manager OA ID is required for a technical project',
          deliveryProjectManagerOaId: 'Delivery Project Manager',
          deliveryProjectManagerPlaceholder: 'Select a delivery project manager',
          salesProjectWbs: 'Sales Project WBS',
          projectWbsCode: 'Project WBS Code',
          oaIdPlaceholder: 'Enter OA personnel ID',
          unresolvedMaterials: 'Confirm material status',
          unresolvedMaterialsDescription:
            'CREST cannot determine the following material statuses. Confirm each item before checking again.',
          materialEffectiveRequired: 'Select whether this material is effective',
          yes: 'Yes',
          no: 'No',
          cancel: 'Cancel',
          checkParameters: 'Check Parameters',
          confirmSubmit: 'Confirm Submission to OA',
          parametersMissing: 'Approval parameters are incomplete',
          parametersReady: 'Approval parameters are complete',
          readyDescription:
            'The next confirmation creates an immutable PDF snapshot and an OA quote approval workflow.',
          validateFailed: 'Parameter validation failed. Please try again.',
          submitFailed: 'Quote approval submission failed. Resolve the issue and retry.',
          submitSuccess: 'Quote approval submitted to OA',
        },
        contractModal: {
          title: 'Submit Overseas Contract Approval',
          description:
            'System fields are read from the contract, quote, customer, and opportunity. Complete the OA template fields, validate them, and confirm submission.',
          customerType: 'Customer Type',
          salesArea: 'Sales Area',
          salesType: 'Sales Type',
          contractType: 'Contract Type',
          salesPerson: 'Salesperson',
          salesPersonRequired: 'Select a salesperson',
          productManagerOaId: 'Product Manager OA ID',
          deliveryManagerOaId: 'Delivery Manager OA ID',
          oaIdPlaceholder: 'Enter OA personnel ID',
          optionalOaIdPlaceholder: 'Optional OA personnel ID',
          productManager: 'Product Manager',
          deliveryManager: 'Delivery Manager',
          referrerPerson: 'Referrer',
          personPlaceholder: 'Search by name or email',
          optionalPersonPlaceholder: 'Optional; search by name or email',
          framework: 'Framework Contract',
          referrer: 'Referrer Participates',
          includes5g: 'Includes 5G Products',
          referrerOaId: 'Referrer OA ID',
          referrerRequired: 'Select a referrer',
          specialRequirements: 'Special Requirements',
          hld: 'HLD Attachment (Optional)',
          testCase: 'Test Case Attachment (Optional)',
          uploadOptional: 'Upload Attachment',
          uploadFailed: 'Attachment upload failed. Try again.',
          yes: 'Yes',
          no: 'No',
          cancel: 'Cancel',
          checkParameters: 'Check Parameters',
          confirmSubmit: 'Confirm Submission to OA',
          parametersMissing: 'Approval parameters are incomplete',
          parametersReady: 'Approval parameters are complete',
          readyDescription:
            'The next confirmation locks the contract version, generates the PDF, and creates the OA workflow.',
          validateFailed: 'Contract approval validation failed. Try again.',
          submitFailed: 'Contract approval submission failed. Resolve the issue and retry.',
          submitSuccess: 'Overseas contract approval submitted to OA',
        },
        contractWithdraw: {
          title: 'Withdraw Overseas Contract Approval',
          description:
            'Only an active workflow can be withdrawn. The contract becomes editable after a successful withdrawal and must be resubmitted after changes.',
          reason: 'Withdrawal Reason',
          reasonPlaceholder: 'Explain why the contract approval must be withdrawn',
          reasonRequired: 'Enter a withdrawal reason',
          reasonTooLong: 'The withdrawal reason cannot exceed 500 characters',
          cancel: 'Cancel',
          confirm: 'Confirm Withdrawal',
          success: 'Overseas contract approval withdrawn from OA',
          failed: 'Failed to withdraw overseas contract approval. Try again.',
          uncertain:
            'The OA withdrawal result is not confirmed. Check OA before taking another action.',
        },
        withdraw: {
          title: 'Withdraw Quote Approval',
          description:
            'After withdrawal, the quote and contract can be edited again. The reason is sent to OA and retained for audit.',
          reason: 'Withdrawal Reason',
          reasonPlaceholder: 'Explain why the approval must be withdrawn',
          reasonRequired: 'Enter a withdrawal reason',
          reasonTooLong: 'The withdrawal reason cannot exceed 500 characters',
          cancel: 'Cancel',
          confirm: 'Confirm Withdrawal',
          success: 'Quote approval withdrawn from OA',
          failed: 'Failed to withdraw quote approval. Try again later.',
          uncertain:
            'The OA withdrawal result is not confirmed. Check OA before taking another action.',
        },
        stage: {
          drafting: 'Contract Drafting',
          quote: 'Quote Approval',
          contract: 'Contract Approval',
          archive: 'Signing & Archive',
          draftingComplete: 'Completed',
          quoteCurrent: 'Current stage',
          quoteApproved: 'Quote approved',
          contractBlocked: 'Available after quote approval',
          contractCurrent: 'Current stage',
          contractApproved: 'Contract approved',
          contractRejected: 'Rejected; revise and resubmit',
          contractWithdrawn: 'Withdrawn; revise and resubmit',
          contractVoided: 'Previous round voided; resubmit',
          archiveBlocked: 'Available after contract approval',
          archiveCurrent: 'Pending signature and archive',
        },
      },
      validation: {
        draftSavedIncomplete: 'Draft saved with {{count}} required fields incomplete',
        draftSavedComplete: 'Contract draft saved with all required fields complete',
        submitBlocked: 'Complete {{count}} required fields before submission',
        incomplete: 'Not completed',
        invalidEmail: 'Invalid email format',
        completeTag: 'Information complete',
        incompleteTag: '{{count}} items incomplete',
      },
    },
    quoteDetail: {
      customer: 'Customer',
      opportunity: 'Opportunity',
      notLinked: 'Not linked',
      viewRelation: 'View details',
      labelSeparator: ':',
      actions: {
        downloadQuotePdf: 'Download Quote PDF',
        exportBoqQuote: 'Export BOQ Quote',
        downloadExport: 'Download / Export',
        refresh: 'Refresh',
      },
      tabs: {
        quoteInfo: 'Quote Lines',
      },
      lines: {
        columns: {
          type: 'Type',
          partNumber: 'Part Number',
          productName: 'Product Name',
          productModel: 'Product Model',
          description: 'Product Description',
          quantity: 'Quantity',
          unitPrice: 'Unit Price',
          total: 'Total',
          notes: 'Notes',
        },
        count: '{{count}} items',
        totalLabel: 'Total:',
      },
      draft: {
        quickConfig: 'Quick Configuration',
        existing: 'Existing BOQ Draft',
        savedAt: 'Saved at',
        unknownTime: 'Unknown time',
        restoreHint: '. Quick Configuration will restore it automatically.',
        continue: 'Continue Configuration',
      },
      exportTerms: {
        title: 'Quotation Display Information',
        description:
          'Maintain only the information shown in the customer quotation export. Manage formal contract terms in the Contracts module.',
        updatedAt: 'Updated {{time}}',
        editSaveHint: 'Use Save at the top of the page after editing',
        messages: {
          loadFailed: 'Failed to load the quotation terms. Refresh and try again.',
          saved: 'Quotation terms saved',
          saveFailed: 'Failed to save the quotation terms. Try again later.',
        },
        sections: {
          basic: 'Basic Terms',
          address: 'Address Information',
          delivery: 'Delivery & Warranty',
          compliance: 'Compliance & Signatures',
          notes: 'Notes',
        },
        fields: {
          paymentTerms: 'Payment Terms',
          freightTerms: 'Trade / Freight Terms',
          shippingMethod: 'Shipping Method',
          expiresOn: 'Quote Valid Until',
          billToContact: 'Bill-to Contact',
          shipToContact: 'Ship-to Contact',
          billToAddress: 'Bill-to Address',
          shipToAddress: 'Ship-to Address',
          billToCity: 'Bill-to City',
          shipToCity: 'Ship-to City',
          billToCountry: 'Bill-to Country',
          shipToCountry: 'Ship-to Country',
          billToPostalCode: 'Bill-to Postal Code',
          deliveryLeadTime: 'Delivery Lead Time',
          warranty: 'Warranty',
          bankInfo: 'Bank Information',
          exportCompliance: 'Export Compliance',
          sellerSignature: 'Seller Signature',
          customerSignature: 'Customer Signature',
          additionalNotes: 'Internal / Customer Notes',
          guidance: 'Guidance',
        },
        guidanceExtra:
          'Used in the customer quotation export. Include pricing notes, tax scope, delivery assumptions, and other customer-visible terms.',
        guidanceExample:
          'Example:\n1. Freight, customs duties, and on-site installation are excluded.\n2. Lead time starts after contract signing and receipt of the advance payment.\n3. The signed contract or purchase order determines the final amount.',
        empty: {
          address: 'No address information',
          delivery: 'No delivery or warranty information',
          compliance: 'No compliance or signature information',
          notes: 'No notes',
        },
      },
      priceLookup: {
        title: 'Lookup Parameters',
        fields: { class: 'Class', subclass: 'Subclass' },
        placeholders: { class: 'Select Class', subclass: 'Select Subclass' },
        validation: { classRequired: 'Select a Class', subclassRequired: 'Select a Subclass' },
        actions: { lookup: 'Look Up Prices' },
        help: {
          lookupFlow:
            'Filter BOQ materials by Class and Subclass, then merge WPS information for the candidate part numbers.',
        },
        candidates: { summary: '{{count}} candidate part numbers found:' },
        results: {
          title: 'Candidate Materials ({{count}})',
          empty: 'Select a Class and Subclass to look up prices',
        },
        columns: {
          source: 'Source',
          partNumber: 'Part Number',
          productName: 'Product Name',
          productRemark: 'Product Remark',
          salesStatus: 'Sales Status',
          lifecycle: 'Lifecycle',
          description: 'External Description',
          model: 'Model',
          band: 'Band',
          listPrice: 'List Price',
          salesPrice: 'Sales Price',
          directorPrice: 'Director Price',
          priceStatus: 'Price Status',
          matchScore: 'Match Score',
        },
        messages: {
          catalogLoadFailed:
            'Failed to load base station categories. Refresh the page and try again.',
          missingQuote: 'Quote context is missing, so base station prices cannot be looked up.',
          noMatches: 'No matching base station price was found. Try another Class or Subclass.',
          matchesFound: '{{count}} matching base station prices found',
          lookupFailed: 'Price lookup failed: {{reason}}',
          unknownError: 'Unknown error',
        },
      },
    },
    boqConfigurator: {
      title: 'BOQ Configurator',
      tabs: { config: 'Configuration', bom: 'BOQ Summary' },
      fields: {
        quote: 'Quote',
        customer: 'Customer',
        project: 'Project',
        currentTotal: 'Current Quote Total',
      },
      status: {
        draft: 'Draft',
        saving: 'Saving',
        saved: 'Saved',
        savedAt: 'Saved {{time}}',
        pending: 'Pending save',
        error: 'Save failed',
      },
      statusHelp: {
        draft: 'Draft save status',
        saving: 'Saving draft automatically',
        saved: 'Draft saved',
        pending: 'Changes are waiting to be saved',
        error: 'Automatic draft save failed. Retry or check the network.',
      },
      actions: {
        close: 'Close',
        closeAria: 'Close BOQ configurator',
        retrySave: 'Retry Save',
        continueEditing: 'Continue Editing',
        createAnother: 'Create Another',
      },
      messages: {
        payloadTooLarge:
          'The configuration is too large. Refresh and retry, or contact an administrator.',
        catalogPartialFailure:
          'Some configuration catalogs failed to load. Retry later or reopen the configurator.',
        restoredDraft: 'Restored the previously saved BOQ draft: {{time}}',
        startFailed: 'Failed to start the configurator',
        draftSaved: 'Draft saved',
        draftSaveFailed: 'Draft save failed. Check the network and retry.',
        confirmClose: 'Close the configurator?',
        closeAfterSaveFailure:
          'Automatic draft save failed. We will retry before closing; if it still fails, this page will remain open.',
        closeWithChanges: 'There are unsaved changes. The draft will be saved before closing.',
        closeSaved: 'The draft is saved.',
        saveFailedKeptOpen: 'Draft save failed. This page remains open; retry later.',
        submittedLines: '{{count}} material lines were added to the quote',
        initializing: 'Initializing configurator...',
        submitSuccess: 'Submitted Successfully',
        submittedToQuote: 'Materials were written to the quote.',
      },
      directory: {
        title: 'Configuration Directory',
        aria: 'BOQ configuration directory',
        summary: '{{templates}} site types / {{sites}} sites',
        ranSummary: 'RAN · {{templates}} site types · {{sites}} sites',
        network: 'Network Facilities',
        networkEmpty: 'Network Facilities · Not added',
        networkEmptyTarget: 'Network Facilities empty state',
        gateway: 'Gateway',
        additionalMaterials: 'Additional Materials',
        additionalMaterialsCount: 'Additional Materials · {{count}} items',
        serviceExpenses: 'Service & Expenses',
        serviceExpensesCount: 'Service & Expenses · {{count}} items',
        locate: 'Go to {{target}}',
        expand: 'Expand {{target}}',
        collapse: 'Collapse {{target}}',
        noBand: 'No band selected',
        templateSummary: '{{name}} · {{sectors}} sectors · {{bands}} · {{sites}} sites',
        sectorConfig: 'Sector Configuration',
        sectorSummary: 'Sector Configuration · {{bands}}',
        baseStation: 'Base Station',
        antenna: 'Antenna',
        siteSupport: 'Site Equipment',
        issueSummary: '{{label}} has {{count}} items to resolve',
        issueDetails: '{{label}} has {{count}} items to resolve: {{messages}}',
      },
      additionalMaterials: {
        add: 'Add Additional Material',
        empty: 'No additional materials added',
        hint: 'Select from the complete catalog. Entered quantities go to the BOM without site multiplication.',
        selectTitle: 'Select Additional Materials',
        selectHint: 'Filter by material category, part number, Class, and Subclass.',
        total: '{{total}} items',
      },
      inquiry: {
        title: 'Outsourced Product Inquiry',
        newTitle: 'New Outsourced Product Inquiry',
        detailTitle: 'Inquiry Details',
        entry: 'Outsourced Product Inquiry',
        entryAria: 'Material inquiry, {{count}} records',
        empty: 'No inquiry records yet',
        itemCount: '{{count}} materials',
        resultAvailable: 'Result available',
        resultPending: 'Awaiting result',
        actions: {
          create: 'Create Inquiry',
          backToHistory: 'Back to Inquiry History',
          addItem: 'Add Material Line',
          removeItem: 'Remove material {{index}}',
          saveDraft: 'Save Inquiry Draft',
          submitApproval: 'Submit to OA',
          view: 'View',
          withdraw: 'Withdraw Inquiry',
          retry: 'Reload',
        },
        stats: { total: 'All', pending: 'In Approval', approved: 'Approved', draft: 'Drafts' },
        columns: {
          number: 'Inquiry No.',
          materials: 'Materials',
          applicant: 'Applicant',
          createdAt: 'Created At',
          status: 'Approval Status',
          result: 'Inquiry Result',
          actions: 'Actions',
        },
        status: {
          draft: 'Draft',
          pending: 'In Approval',
          approved: 'Approved',
          rejected: 'Rejected',
          withdrawn: 'Withdrawn',
        },
        form: {
          contextTitle: 'Business Context (Auto-filled)',
          requestTitle: 'Inquiry Requirements',
          itemsTitle: 'Inquiry Materials',
          itemTitle: 'Material {{index}}',
        },
        fields: {
          country: 'Country/Region',
          urgency: 'Urgency',
          requiredDate: 'Expected Reply Date',
          currency: 'Currency',
          reason: 'Inquiry Reason',
          materialName: 'Material Name',
          specification: 'Model / Specification',
          class: 'Class',
          subclass: 'Subclass',
          quantity: 'Quantity',
          unit: 'Unit',
          targetPrice: 'Target Unit Price ({{currency}})',
          technicalDescription: 'Technical Description',
          remarks: 'Inquiry Notes',
        },
        urgency: { normal: 'Normal', urgent: 'Urgent' },
        placeholders: { reason: 'Explain why a material outside PLM needs to be quoted' },
        validation: {
          materialName: 'Enter the material name',
          specification: 'Enter the model or specification',
          quantity: 'Enter the quantity',
        },
        messages: {
          draftSaved: 'Inquiry draft saved',
          submitted: 'Inquiry submitted to OA',
          loadFailed: 'Failed to load inquiry records. Try again.',
          saveFailed: 'Failed to save the inquiry. Check the content and try again.',
          withdrawn: 'Inquiry withdrawn',
          withdrawFailed: 'Failed to withdraw the inquiry. Refresh and try again.',
        },
      },
      picker: {
        choose: 'Choose',
        added: 'Added',
        zeroStockTitle: 'Inventory Notice',
        zeroStockMessage:
          'Material {{partNumber}} currently has zero inventory. Are you sure you want to select it?',
        zeroStockConfirm: 'Confirm',
        zeroStockCancel: 'Cancel',
        change: 'Change',
        changeSelection: '{{value}} Change',
        removeSelected: 'Remove selected material',
        unavailable: 'N/A',
        columns: 'Columns',
        keywordPlaceholder: 'Part Number / Model / Name',
        all: 'All',
        inStock: 'In stock',
        filter: 'Filter ▼',
        collapse: 'Collapse ▲',
        clear: 'Clear',
        noData: 'No data',
        select: 'Select {{target}}',
        noAntenna: 'No Antenna',
        noServer: 'No Server',
        clearCore: 'Clear CORE',
        clearOmc: 'Clear OMC',
        clearGateway: 'Clear Gateway',
        labels: {
          partNumber: 'Part Number',
          name: 'Name',
          model: 'Model',
          description: 'Description',
          externalDescription: 'External Description',
          inventory: 'Inventory',
          unit: 'Unit',
          price: 'Price',
          quantity: 'Quantity',
          operation: 'Operation',
          status: 'Status',
          category: 'Category',
          productRemark: 'Product Remark',
          salesStatus: 'Sales Status',
          listPrice: 'List Price',
          salesPrice: 'Sales Price',
          directorPrice: 'Director Price',
          class: 'Class',
          subclass: 'Subclass',
        },
      },
      material: {
        remarkColumn: 'Remarks',
        fullBands: 'Compatible bands: {{bands}}',
        listPrice: 'List',
        salesPrice: 'Sales',
        directorPrice: 'Director',
        remark: 'Material Remark',
        remarkAria: 'Material remark',
        remarkPlaceholder: 'Enter an internal material remark',
        cancelRemark: 'Cancel remark',
        saveRemark: 'Save remark',
        internalRemark: 'Material Remark (Internal Only)',
        editRemark: 'Edit material remark',
        fillRemark: 'Add remark',
        cancel: 'Cancel',
        save: 'Save',
      },
      config: {
        ranSummary: '{{templates}} site types · {{sites}} sites · {{bands}}',
        ranOptionalEmpty:
          'RAN is optional. Add a site type when base stations, antennas, or site equipment are needed.',
        expandBlock: 'Expand configuration section',
        collapseBlock: 'Collapse configuration section',
        expandNamedBlock: 'Expand {{title}}',
        collapseNamedBlock: 'Collapse {{title}}',
        expandTemplate: 'Expand site type {{name}}',
        collapseTemplate: 'Collapse site type {{name}}',
        deployment: 'Deployment',
        sites: 'Sites',
        siteTypeSiteCount: 'Site Types · {{templates}}/{{sites}} sites',
        keepOneTemplate: 'Keep at least one site type',
        selectLeftTemplate: 'Select a site type on the left',
        notSelected: 'Not selected',
        templateDeleted: 'Site type deleted',
        sectorNumber: 'Sector {{number}}',
        copySectorToAll: 'Copy this sector configuration to all sectors',
        selectLeftTarget: 'Select a site type or network facility on the left',
        quantitySubtotalHint: 'Quantity and subtotal are shown in the BOQ Summary tab above',
        networkNoSiteMultiplier:
          'Network facilities are not multiplied by site count. Add CORE, OMC, or gateway equipment in this area.',
        networkTableHint:
          'Network facilities are not multiplied by site count. Each section uses an Excel-style table aligned with the BOM export.',
        quantityValue: 'Quantity {{value}}',
        gatewayNotSelected: 'Gateway not selected',
        softwareServerLicense: 'Software + Server + License',
        sectionNotSelected: '{{section}} not selected',
        detailSummary:
          '{{name}} · Sector {{sector}} · {{bands}} · ×{{sites}} sites. Each card expands into an Excel-style table.',
        baseStationSectorNumber: 'Base Station · Sector {{number}}',
        baseStationRowsHint:
          'Generate base-station rows by band: {{bands}}. Each row includes its accessory package below.',
        antennaSectorNumber: 'Antenna · Sector {{number}}',
        sectors: 'Sectors',
        addTemplate: 'Add Site Type',
        copy: 'Copy',
        delete: 'Delete',
        confirmDeleteTemplate: 'Delete this site type?',
        deleteTemplateDescription:
          'Deleting {{name}} permanently removes its sites, sectors, base stations, antennas, licenses, and tower-base accessories. This cannot be undone.',
        confirmDelete: 'Confirm Delete',
        cancel: 'Cancel',
        noBand: 'No band selected',
        sectorConfiguration: 'Sector Configuration',
        sharedSectors: 'Shared by {{count}} sectors · {{summary}}',
        band: 'Band',
        selectBand: 'Select Band',
        baseStationSector: 'Base Station · Sector Configuration',
        baseStationAuto: 'One base station is generated for each band: {{bands}}',
        antennaSector: 'Antenna · Sector Configuration',
        antennaShared: 'Antennas are shared by sector, with room for future bands.',
        templateSummary: '{{sectors}} sectors · {{sites}} sites · {{bands}}',
        sharedConfigHint:
          'All {{count}} sectors in this site type share one configuration. Each base station expands its accessory package below.',
        siteSupport: 'Site Equipment',
        siteSupportHint: 'Site-level equipment expands into the BOM by site type.',
        baseStationScope: 'Base Station {{value}}',
      },
      bom: {
        title: 'BOQ Summary',
        columns: {
          name: 'Name',
          quantity: 'Quantity',
          unit: 'Unit',
          listPrice: 'List Price',
          salesPrice: 'Sales Price',
          directorPrice: 'Director Price',
          quotePrice: 'Quote Price',
          subtotal: 'Subtotal',
          source: 'Source',
          remarks: 'Remarks',
          packed: 'Packed',
        },
        actions: {
          view: 'View',
          byMaterial: 'Aggregate by Material',
          byTemplate: 'Columns by Site Type',
          refreshing: 'Refreshing...',
          copy: 'Copy',
          copyHint: 'Copy the complete BOM details for pasting into Excel',
          resetQuote: 'Reset Quote Prices',
          submit: 'Submit Quote',
        },
        quotePlaceholder: 'Enter',
        clearQuotePrice: 'Clear quote price',
        submitTitle: 'Submit to Quote',
        confirmSubmit: 'Confirm Submission',
        cancel: 'Cancel',
        submitDescription:
          'Write the expanded BOM back to the quote. Price approval continues through the crest quote workflow; the configurator does not add a separate approval layer.',
        skuCount: 'SKUs',
        quoteTotal: 'Quote Total',
        empty: 'The BOM is empty',
        emptyHint: 'The BOM is empty. Add at least one material in Configuration first.',
        quotePriceMissing: 'Complete all quote prices in the BOQ Summary first',
        submitFailed: 'Submission failed',
      },
      export: {
        title: 'Quote Export',
        export: 'Export',
        exportPdf: 'Export PDF',
        exportCurrent: 'Export Current Sheet',
        noDraft: 'No BOQ configuration draft. Run Quick Configuration first.',
        loadFailed: 'Failed to load quote export',
        exported: 'Current sheet exported',
        exportFailed: 'Export failed',
        previewMissing: 'The export preview area was not found',
        pdfOpened: 'PDF save window opened',
        pdfFailed: 'PDF export failed. Check whether the browser blocked the popup.',
        sheets: {
          customer: 'Customer Quotation',
          production: 'Production BOM',
          approval: 'Approval Package',
        },
        meta: {
          quoteNumber: 'Quote / Opportunity No.',
          customer: 'Customer',
          project: 'Project',
          currency: 'Currency',
        },
        customerTitle: 'Sales Quotation',
        productionTitle: 'Production BOM',
        approvalTitle: 'Approval Package',
        columns: {
          site: 'Site',
          segment: 'Segment',
          category: 'Category',
          name: 'Product Name',
          description: 'Product Description',
          quantity: 'Quantity',
          unit: 'Unit',
          unitPrice: 'Unit Price',
          subtotal: 'Subtotal',
          remarks: 'Remarks',
          partNumber: 'Product No.',
          productModel: 'Product Model',
          specification: 'Specification',
          source: 'Source',
        },
        grandTotal: 'Grand Total',
        termsTitle: 'Terms & Conditions',
        terms: {
          payment: 'Payment Terms',
          trade: 'Trade Terms',
          deliveryMethod: 'Delivery Method',
          leadTime: 'Delivery Lead Time',
          warranty: 'Warranty',
          validUntil: 'Quote Valid Until',
          billTo: 'Bill To',
          shipTo: 'Ship To',
          bank: 'Bank Information',
          compliance: 'Export Compliance',
          sellerSignature: 'Seller Signature',
          customerSignature: 'Customer Signature',
          notes: 'Terms & Conditions',
        },
        report: {
          quote: 'Quote',
          quoteNumber: 'Quote No.',
          customerName: 'Customer Name',
          projectName: 'Project Name',
          countryCurrency: 'Country / Currency',
          siteTypeSite: 'Site Types / Sites',
          siteTypeCount: '{{templates}} site types / {{sites}} sites',
          validUntil: 'Valid Until',
          siteTypeTotal: 'Site Types / Total Sites',
          skuCount: 'SKUs',
          totalQuantity: 'Total Quantity',
          exportDate: 'Export Date',
          productionHint:
            '△ This production and logistics picking list excludes prices. Accessory kits are expanded into components, including packed items.',
          productionSource: 'Source (Site Types)',
          items: 'pcs',
          productionPlanner:
            'Production planner: schedule by category; consolidate purchasing for the same part number used by different site types.',
          packedHint:
            'Packed items are included in the base-station price and ship with the unit; they are not listed separately on the customer quotation.',
          internal: 'Internal · Includes Concession Analysis',
          listTotal: 'Total List Price',
          salesTotal: 'Original Sales Price (WPS)',
          quoteTotal: 'Current Quote Total',
          concessionVsSales: 'vs Sales Price (Concession)',
          discountVsList: 'vs List Price (Total Discount)',
          concessionItems: 'Concession Items',
          fullDetail:
            'Sheet 1 / Full Details (Hierarchy · Expanded Accessories · Four Price Levels)',
          concessionDetail:
            'Sheet 2 / Concession Details (Descending · {{count}} items below sales price)',
          approval: 'Approval',
          salesDirector: 'Sales Director',
          commercial: 'Commercial',
          date: 'Date',
          productionCategory: 'Category',
          listPrice: 'List Price',
          salesPrice: 'Sales Price',
          quotePrice: 'Quote Price',
          concessionPct: 'Concession %',
          concessionAmount: 'Concession Amount',
          total: 'Total',
        },
      },
    },
    columnVisibility: {
      title: 'Columns',
      searchPlaceholder: 'Search columns...',
      all: 'All',
      default: 'Default',
      clear: 'Clear',
      noColumnsFound: 'No columns found for "{{query}}"',
      required: 'Required',
      resetTooltip: 'Reset to default columns',
      reset: 'Reset',
      savedLocally: 'Saved locally',
    },
    salesList: {
      account: 'Accounts',
      contact: 'Contacts',
      lead: 'Leads',
      opportunity: 'Opportunities',
      quote: 'Quotes',
      salesOrder: 'Orders',
      deliveryProject: 'Delivery Projects',
      sinosure: 'Sinosure',
      status: 'Status',
      primaryContact: 'Primary Contact',
      contactEmail: 'Contact Email',
      parentAccount: 'Account',
      mobilePhone: 'Mobile Phone',
      active: 'Active',
      inactive: 'Inactive',
      activateAccount: 'Activate',
      deactivateAccount: 'Deactivate',
      activateAccountConfirm: 'Activate this customer?',
      deactivateAccountConfirm: 'Deactivate this customer?',
      activateAccountHint: 'After activation, this customer can be used in business records again.',
      deactivateAccountHint:
        'After deactivation, this customer cannot be linked to new opportunities.',
      activated: 'Customer activated',
      deactivated: 'Customer deactivated',
      statusChangeFailed: 'Failed to update customer status',
      inactiveAccountCannotCreateOpportunity:
        'This customer is inactive and cannot be linked to a new opportunity',
      inactiveAccountCannotSelect: 'This customer is inactive and cannot be selected',
      approvalStatus: 'Approval Status',
      allAuditStatuses: 'All Audit Statuses',
      allOwners: 'All Owners',
      allRegions: 'All Regions',
      otherOverseas: 'Other Overseas',
      notSubmitted: 'Not Submitted',
      inReview: 'In Review',
      approved: 'Approved',
      rejected: 'Rejected',
      approver: 'Approver',
      rejectedAt: 'Rejected At',
      comment: 'Comment',
      createOnBehalf: 'Create on behalf',
      submit: 'Submit',
      submitted: 'Submitted',
      submitFailed: 'Submit failed',
      sapSyncQueued: 'SAP sync queued (job={{job}})',
      sapSyncFailed: 'SAP sync failed',
      leadOpen: 'Open',
      leadQualified: 'Qualified',
      leadDisqualified: 'Disqualified',
      leadQualify: 'Qualify',
      leadQualifyConverted: 'Lead qualified and converted to an account and contact',
      leadQualifySuccess: 'Qualified (acc={{accountId}}, opp={{opportunityId}})',
      leadQualifyFailed: 'Qualify failed',
      leadTargetContactInformation: 'Target Contact Information',
      leadTargetAccountInformation: 'Target Account Information',
      leadTargetAccountSapInformation: 'Target Account SAP Required Information',
      leadTargetAddressInformation: 'Target Account and Contact Address',
      opportunityOpen: 'Open',
      opportunityWon: 'Won',
      opportunityLost: 'Lost',
      allOpportunityStatuses: 'All Opportunity Statuses',
      hot: 'Hot',
      warm: 'Warm',
      cold: 'Cold',
      details: 'Details',
      openAccountInNewTab: 'Open in new tab',
      openOpportunityInNewTab: 'Open in new tab',
    },
    roleList: {
      title: 'Role Permissions',
      loadFailed: 'Failed to load roles',
      totalRoles: 'Total {{count}} roles',
      searchPlaceholder: 'Search role name / description',
      newRole: 'New Role',
      marketScope: 'Role Market',
      marketScopeDescription:
        'This only standardizes the role name. Configure data permissions separately in Data Scope.',
      marketScopeRequired: 'Select Domestic, Overseas, or Common',
      marketScopeDomestic: 'Domestic',
      marketScopeOverseas: 'Overseas',
      marketScopeCommon: 'Common',
      generatedRoleName: 'Generated Role Name',
      generatedRoleNameTooLong: 'The generated role name cannot exceed 100 characters',
      manualSort: 'Manual Sort',
      saveOrder: 'Save Order',
      sortColumn: 'Order',
      sortHint:
        'Move roles up or down within the current region. You can switch regions before saving all changes.',
      sortClearFilters: 'Clear search, type, and business organization filters before sorting',
      sortSaved: 'Role order saved',
      sortSaveFailed: 'Failed to save role order',
      moveUp: 'Move up',
      moveDown: 'Move down',
      moveRoleUp: 'Move role {{name}} up',
      moveRoleDown: 'Move role {{name}} down',
      noRoles: 'No roles',
      noMatches: 'No matches for "{{query}}"',
      noMatchesDescription: 'Try another keyword',
      emptyDescription: 'Roles will appear here after loading',
      roleName: 'Role Name',
      builtinTooltip: 'Built-in role - cannot be deleted or renamed',
      builtin: 'Builtin',
      buScopedTooltip:
        'This role has instances in {{count}} enterprise organizations. This row shows the root template and aggregates all organization counts.',
      type: 'Type',
      system: 'System',
      admin: 'Admin',
      reviewer: 'Reviewer',
      business: 'Business',
      all: 'All',
      allBusinessUnits: 'All Business Organizations',
      domestic: 'Domestic ({{count}})',
      overseas: 'Overseas ({{count}})',
      commonRegion: 'Common ({{count}})',
      scopeFilterLabel: 'List Scope',
      scopeAll: 'All ({{count}})',
      withinGroup: 'Current Group ({{count}})',
      crossGroup: 'Cross-Group ({{count}})',
      organizationInstanceCount: '× {{count}} organizations',
      organizationScope: 'Business Organization Scope',
      defaultOrganization: 'Default Scope',
      description: 'Description',
      members: 'Members',
      privileges: 'Privileges',
      global: 'Global',
      actions: 'Actions',
      details: 'Details',
      deleteRole: 'Delete',
      deleteSuccess: 'Role "{{name}}" deleted',
      deleteFailed: 'Failed to delete role',
      deleteConfirmTitle: 'Delete role "{{name}}"?',
      deleteConfirmDescription:
        'Only non-built-in roles without members can be deleted. This action cannot be undone.',
    },
    platformPermissions: {
      title: 'Roles & Permissions',
      subtitle:
        'CREST foundation permissions: app access, system administration, and enterprise organization administration.',
      boundaryTitle: 'Only CREST platform permissions are managed here',
      boundaryDesc:
        'CRM business permissions for accounts, opportunities, quotes, and approvals are managed under CRM Settings -> Role Permissions. This page only controls platform role app entry and Admin settings menus.',
      platformRoles: 'Platform Roles',
      totalRoles: 'Total {{count}} platform roles',
      searchPlaceholder: 'Search platform roles',
      newRole: 'New Role',
      noRoles: 'No platform roles',
      noMatches: 'No matches for "{{query}}"',
      noMatchesDescription: 'Try another keyword',
      emptyDescription: 'Platform roles will appear here after loading',
      roleName: 'Role Name',
      displayName: 'Display Name',
      type: 'Type',
      roleType: 'Role Type',
      system: 'System',
      admin: 'Admin',
      user: 'User',
      all: 'All',
      description: 'Description',
      members: 'Members',
      privileges: 'Privileges',
      actions: 'Actions',
      details: 'Details',
      editRole: 'Edit',
      deleteRole: 'Delete',
      deleteSuccess: 'Role “{{name}}” deleted',
      deleteFailed: 'Failed to delete role',
      deleteConfirmTitle: 'Delete role “{{name}}”?',
      deleteConfirmDescription:
        'Only non-built-in roles without members can be deleted. This action cannot be undone.',
      builtin: 'Builtin',
      builtinTooltip: 'Built-in platform role',
      general: 'General',
      selectRole: 'Select a platform role',
      appAccess: 'App Access',
      assignableAppsDescription:
        'Only enabled applications with a current production release are shown. Roadmap and integration entries are not assignable.',
      menuPermissions: 'Menu Permissions',
      platformMenus: 'System And Organization Administration',
      platformMenusDesc:
        'Only manages CREST Platform-owned menus; child-app menus are managed by their owning applications.',
      platformDataPrivileges: 'Platform Data Privileges',
      platformDataBoundaryTitle: 'Only platform-level data privileges are managed here',
      platformDataBoundaryDesc:
        'Only CREST platform objects such as users, roles, enterprise organization, apps, and field security are shown. CRM business objects such as accounts, opportunities, quotes, and approvals are managed under Role Permissions.',
      changedCount: '{{count}} changes',
      save: 'Save',
      saveRoleInfo: 'Save Role Info',
      roleInfoSaved: 'Role information saved',
      roleNameRequired: 'Enter a role name',
      roleNameMax: 'Role name cannot exceed 100 characters',
      roleNamePlaceholder: 'For example: Employee',
      displayNamePlaceholder: 'Optional display name',
      descriptionPlaceholder: 'Describe what this platform role is for',
      selectRoleType: 'Select a role type',
      loadFailed: 'Failed to load roles and permissions',
      detailLoadFailed: 'Failed to load role detail',
      privilegesLoadFailed: 'Failed to load platform data privileges',
      appsSaved: 'App access saved',
      menusSaved: 'Platform menu permissions saved',
      privilegesSaved: 'Platform data privileges saved',
      saveFailed: 'Save failed',
      savePrivilegeChanges: 'Save Permissions ({{count}} changes)',
      noApps: 'No configurable apps',
      noMenus: 'No configurable menus',
    },
    accessCenter: {
      title: 'Access Center',
      subtitle:
        'Manage positions, cross-system role catalog, and grant sources centrally while each business system defines and enforces its own permissions.',
      platformRoles: 'Platform Roles',
      positions: 'Positions',
      roleCatalog: 'Role Catalog',
      assignments: 'User Grants & Delivery',
      requests: 'Access Requests',
      openAccess: 'Access Center',
      configureUserRoles: 'Permission Configuration',
      grantGovernance: 'Grant Governance',
      legacyMembersMoved: 'Role membership moved to Access Center',
      legacyMembersMovedDescription:
        '{{count}} current memberships are shown for reference. Add, revoke, position inheritance, and delegation are managed in Access Center.',
      legacyCrmAuthorizationTitle: 'CRM User Authorization Moved',
      legacyCrmAuthorizationSubtitle:
        'CRM continues to define roles while CREST governs role membership centrally.',
      legacyCrmAuthorizationDescription:
        'Use Access Center to manage grants through positions, direct exceptions, or approval requests. CRM no longer provides a separate user authorization page.',
      newPosition: 'New Position',
      positionSubtitle:
        'A position is a person’s formal identity in the enterprise organization and may carry roles from multiple systems.',
      positionCode: 'Position Code',
      positionName: 'Position Name',
      enterpriseOrg: 'Enterprise Organization',
      jobFamily: 'Job Family',
      jobLevel: 'Job Level',
      noPositions: 'No positions',
      editPosition: 'Edit Name',
      editPositionFor: 'Edit “{{name}}”',
      editPositionSubtitle:
        'Change only the display name; position code, organization, assignments, and role bindings remain unchanged.',
      savePositionName: 'Save Position Name',
      positionNameRequired: 'Enter a position name',
      positionUpdated: 'Position name updated',
      configureRoles: 'Configure Roles',
      configureRolesFor: 'Configure roles for “{{name}}”',
      bindingSubtitle:
        'Position bindings reference the role catalog; detailed permissions remain managed by the owning system.',
      bindingCreated: 'Position role binding created',
      positionMembers: 'Position Members',
      selectUser: 'Select a user',
      assignPosition: 'Add Concurrent Position',
      assignmentCreated: 'Position assignment created',
      assignmentEnded: 'Position assignment ended',
      positionType: 'Assignment Type',
      primaryPosition: 'Primary',
      concurrentPosition: 'Concurrent',
      endAssignment: 'End Assignment',
      selectRole: 'Select a role',
      scopePolicy: 'Scope Policy',
      dataScope: 'Data Scope',
      salesScope: 'Business Organization',
      selectSalesScope: 'Select one or more business organizations',
      includeChildSalesOrgs: 'Include child business organizations',
      includeChildScopes: 'Include child business organizations',
      scopeRequired: 'Select at least one business organization',
      scopeLoadFailed: 'Failed to load CRM business organizations',
      scopeCount: '{{count}} business organizations',
      scopeNodeCount: '{{count}} item(s)',
      businessOrgScope: 'DingTalk Business Organization Scope',
      salesRegionScope: 'Sales Region Scope',
      selectBusinessOrgScope: 'Select one or more DingTalk business organizations',
      selectSalesRegionScope: 'Select one or more sales regions',
      includeChildBusinessOrgs: 'Include child DingTalk business organizations',
      scopeMode_all: 'All',
      scopeMode_selected: 'Selected',
      scopeMode_personal: 'Personal Regions',
      scope_role_default: 'Role Default Scope',
      scope_position_org: 'Position Organization',
      scope_position_org_descendants: 'Position Organization And Children',
      scope_explicit: 'Specific Organizations And Regions',
      scope_personal_region: 'Personal Region Scope',
      addRoleBinding: 'Add Role And Scope',
      created: 'Position created',
      searchRoles: 'Search role names',
      allDomains: 'All Domains',
      domain: 'Domain',
      roleName: 'Role',
      roleType: 'Role Type',
      riskLevel: 'Grant Risk',
      approvalRequired: 'Approval Required',
      ordinaryRole: 'Ordinary',
      workflowEligible: 'Workflow Eligible',
      version: 'Version',
      noRoles: 'No cross-domain roles',
      syncCrmRoles: 'Sync CRM Roles',
      roleSyncDone: 'CRM role catalog reconciliation completed',
      directGrant: 'Direct / Temporary Grant',
      directGrantSubtitle:
        'Only ordinary business roles may be granted directly. System and admin roles require approval.',
      newAccessRequest: 'New Access Request',
      accessRequestSubtitle:
        'High-privilege, Global data, temporary delegation, and emergency grants take effect only after approval.',
      requestType: 'Request Type',
      requestReason: 'Business Justification',
      delegatedFrom: 'Original Access Holder',
      source_direct: 'High-Privilege Grant',
      source_delegation: 'Temporary Delegation',
      source_emergency: 'Emergency Grant',
      expiryRequired: 'Temporary delegation and emergency grants require an expiry time',
      approvalPolicy: 'High-risk grants separate requester and approver duties',
      approvalPolicyDescription:
        'The grant is delivered to its owning system only after approval. If that system is unavailable, the request remains traceable and permissions are never broadened.',
      requestSubmitted: 'Access request submitted for approval',
      requestSubmitFailed:
        'The request may have been saved but not started. Refresh to review its status and retry.',
      requestRetryQueued: 'Approval workflow started again',
      noAccessRequests: 'No high-risk or delegated access requests',
      viewWorkflow: 'View Approval',
      user: 'User',
      source: 'Grant Source',
      validFrom: 'Effective From',
      validTo: 'Effective Until',
      indefinite: 'No expiry',
      allStates: 'All States',
      noAssignments: 'No access assignments',
      grantCreated: 'Grant created. Final status follows the business-system receipt.',
      retry: 'Retry',
      retryQueued: 'Queued for delivery again',
      revoke: 'Revoke',
      revoked: 'Revocation request submitted',
      revokeConfirm:
        'Revoke this grant? The role remains effective if another valid source still provides it.',
      orchestrationNotEnforced: 'Authorization orchestration is not enforced',
      orchestrationNotEnforcedDescription: 'The current mode is {{mode}}. Grant and revoke actions are disabled to prevent task state from diverging from effective access.',
      projectionHealth: 'Projection Health',
      projectionHealthy: 'Access projections are consistent across domains',
      projectionMismatch: 'CRM access projection has differences',
      projectionCounts:
        '{{missing}} members without a source, {{extra}} missing members, and {{failed}} failures',
      reconcile: 'Run Reconciliation',
      reconcileDone: 'Reconciliation completed',
      actions: 'Actions',
      loadFailed:
        'Failed to load the access center. Confirm that its feature flags and database migrations are enabled.',
      state_pending: 'Pending',
      state_approval_pending: 'Awaiting Approval',
      state_approval_failed: 'Approval Start Failed',
      state_approval_rejected: 'Rejected',
      state_approval_cancelled: 'Cancelled',
      state_applying: 'Applying',
      state_active: 'Active',
      state_failed: 'Failed',
      state_retrying: 'Retrying',
      state_revoke_pending: 'Revoking',
      state_revoked: 'Revoked',
      state_expired: 'Expired',
    },
    crmUserAuthorization: {
      title: 'CRM User List',
      subtitle:
        'Configure CRM roles and regions and review user identities; CREST remains the source of truth for people and positions.',
      readOnlyTitle: 'This page is for viewing CRM user information only',
      readOnlyDescription:
        'CREST remains the source of truth for people, positions, and assignments. Use this page to review details and manage CRM roles, regions, and enabled status.',
      totalUsers: '{{count}} CRM users',
      noUsers: 'No CRM users',
      membershipRevoked: 'Membership revoked',
      searchPlaceholder: 'Search name / email / account',
      user: 'User',
      enterpriseOrg: 'CRM Business Organization',
      crmRoles: 'CRM Roles',
      crmIdentity: 'CRM Identity',
      crmModeScope_domestic: 'Domestic User',
      crmModeScope_overseas: 'Overseas User',
      crmModeScope_both: 'Domestic + Overseas',
      defaultCrmMode_domestic: 'Default Domestic',
      defaultCrmMode_overseas: 'Default Overseas',
      crmRegions: 'CRM Regions',
      status: 'Status',
      statusFilter: 'Filter by enabled status',
      allStatuses: 'All Statuses',
      roleFilter: 'Filter by CRM role',
      allRoles: 'All CRM Roles',
      identityFilter: 'Filter by user identity',
      allIdentities: 'All User Identities',
      active: 'Active',
      inactive: 'Inactive',
      noCrmRoles: 'No CRM roles',
      noRegions: 'No region assignments',
      actions: 'Actions',
      details: 'Details',
      configure: 'Configure',
      handover: 'Handover',
      handoverTitle: 'Handover CRM records owned by {{name}}',
      handoverSubtitle: 'Select the new owner who will receive all business records',
      handoverWarning: 'The original user will no longer own these records after handover.',
      handoverDescription:
        'Accounts, contacts, opportunities, related quotes, and Sinosure records are preserved and reassigned without creating duplicates. This action cannot be undone.',
      handoverTarget: 'New owner',
      handoverTargetPlaceholder: 'Search and select the new owner',
      handoverTargetRequired: 'Select a new owner',
      confirmHandover: 'Confirm Handover',
      handoverSuccess:
        'Handover completed: {{accounts}} accounts, {{contacts}} contacts, {{opportunities}} opportunities',
      handoverFailed: 'Handover failed. No records were changed. Please try again.',
      authorize: 'Authorize',
      enable: 'Enable',
      disable: 'Disable',
      drawerTitle: 'CRM authorization for {{name}}',
      assignedCrmRoles: 'Assigned CRM Roles',
      availableCrmRoles: 'Available CRM Roles',
      assignedRegions: 'Assigned CRM Regions',
      assignRegion: 'Assign CRM Region',
      selectRegion: 'Select CRM region',
      regionRoleOwner: 'Owner',
      regionRoleMember: 'Member',
      regionRoleApprover: 'Approver',
      regionRoleViewer: 'Viewer',
      assign: 'Assign',
      roleNameDomesticRegionalVp: 'Domestic Regional VP',
      roleNameDomesticPresales: 'Domestic Pre-sales',
      roleNameDomesticSales: 'Domestic Sales',
      roleNameDomesticSalesDirector: 'Domestic Sales Director',
      roleNameDomesticSalesHead: 'Head of Domestic Sales',
      roleNameDomesticSalesSupervisor: 'Domestic Sales Supervisor',
      roleNameOverseasKaPocApprover: 'Overseas KA POC Approver',
      roleNameOverseasRegionalVp: 'Overseas Regional VP',
      roleNameOverseasPresales: 'Overseas Pre-sales',
      roleNameOverseasOpportunityOwner: 'Overseas Opportunity Owner',
      roleNameOverseasAccountOwner: 'Overseas Account Owner',
      roleNameOverseasSales: 'Overseas Sales',
      roleNameOverseasSalesDirector: 'Overseas Sales Director',
      roleNameFinance: 'Finance',
      assignSuccess: 'CRM role assigned',
      revokeSuccess: 'CRM role removed',
      saveIdentity: 'Save Identity',
      identitySaveSuccess: 'CRM identity saved',
      regionAssignSuccess: 'CRM region assignment saved',
      regionRevokeSuccess: 'CRM region assignment revoked',
      enableSuccess: 'CRM user enabled',
      disableSuccess: 'CRM user disabled',
      disableConfirmTitle: 'Disable user',
      disableConfirmContent:
        '{{name}} will no longer be able to sign in to CRM or be selected as a new owner. Existing accounts, opportunities, and other assets remain available to authorized users.',
      detailTitle: 'User details for {{name}}',
      detailRefreshFailed: 'Details could not be refreshed. Showing the latest list data.',
      basicInformation: 'Basic Information',
      userName: 'User Name',
      email: 'Email',
      account: 'Sign-in Account',
      defaultCrmMode: 'Default CRM Mode',
      createdOn: 'Created On',
      modifiedOn: 'Modified On',
      businessOrgHierarchy: 'Business Organization Hierarchy and Descriptions',
      businessOrgLevel: 'Level {{level}} Organization',
      noBusinessOrg: 'No business organization',
      noDescription: 'No description',
      loadFailed: 'Failed to load CRM user authorization',
      partialLoadFailed:
        'The user list loaded, but role or region configuration is temporarily unavailable.',
      saveFailed: 'Save failed',
    },
    crmRegionAuthorization: {
      title: 'CRM Region Authorization',
      subtitle:
        'Generate CRM region assignments by CRM business organization, then review and revoke active assignments.',
      assignByDepartment: 'Assign Region By CRM Business Org',
      assignmentList: 'Active Region Assignments',
      selectRegion: 'Select CRM region',
      selectRegionAndDepartment: 'Select a CRM region and a CRM business organization',
      includeChildren: 'Include child business orgs',
      assign: 'Generate Assignments',
      people: 'people',
      filterRegion: 'Filter region',
      searchPlaceholder: 'Search user / email / CRM business org / region',
      region: 'Region',
      user: 'User',
      department: 'Enterprise Department',
      role: 'Role',
      source: 'Source',
      actions: 'Actions',
      revoke: 'Revoke',
      source_manual: 'Single-user assignment',
      source_department_import: 'Department batch',
      source_business_org_import: 'CRM business org batch',
      regionRoleOwner: 'Owner',
      regionRoleMember: 'Member',
      regionRoleApprover: 'Approver',
      regionRoleViewer: 'Viewer',
      bulkAssignSuccess: 'Generated region assignments for {{count}} users',
      revokeSuccess: 'CRM region assignment revoked',
      loadFailed: 'Failed to load CRM region authorization',
      saveFailed: 'Save failed',
    },
    crmBusinessOrg: {
      title: 'Business Organization',
      subtitle:
        'Administrators choose which enterprise organizations enter CRM; names, hierarchy, and memberships stay synchronized.',
      orgTree: 'Business Organization Tree',
      addOrganization: 'New Business Organization',
      selectEnterpriseOrg: 'New Business Organization',
      selectEnterpriseOrgDescription:
        'Choose from active enterprise organizations. All parent directories are saved automatically.',
      enterpriseOrgLoadFailed: 'Failed to load enterprise organizations',
      alreadyAdded: 'Added',
      people: 'people',
      selectionRule:
        'The selected organizations and all active parent directories are saved automatically to preserve the full hierarchy.',
      includeChildOrganizations: 'Also add all child organizations',
      addSelectedOrg: 'Create and Save',
      addSelectedSuccess: 'Saved {{count}} business organizations, including required parents',
      addSelectedFailed: 'Failed to create business organizations',
      clearTree: 'Clear Organization Tree',
      clearConfirm: 'Clear the current business organization tree?',
      clearConfirmDescription:
        'All current CRM business organizations will be disabled. Enterprise organizations, DingTalk organizations, and historical references will remain.',
      clearSuccess: 'The business organization tree has been cleared',
      clearFailed: 'Failed to clear the business organization tree',
      newRoot: 'New Root Organization',
      newChild: 'New Child Organization',
      newRootOrg: 'New Root Organization',
      newChildOrg: 'New Child Organization',
      newOrg: 'New Business Organization',
      editOrg: 'Edit Business Organization',
      modalSubtitle:
        'Define the CRM sales hierarchy. Membership only applies in CRM and does not change CREST users, positions, or assignments.',
      orgName: 'Organization Name',
      orgCode: 'Organization Code',
      scopeCode: 'Organization Code',
      parentOrg: 'Parent Business Organization',
      rootScope: 'Root Organization',
      rootOrg: 'Root Organization',
      notLinked: 'Not linked',
      projectedMemberCount: 'CRM Members',
      governanceMoved: 'People master data remains governed by CREST',
      governanceMovedDescription:
        'This page only manages CRM business organizations and memberships. It never creates, deletes, or disables CREST users.',
      organizationBoundary: 'CRM business organizations are isolated from CREST people data',
      organizationBoundaryDescription:
        'Adding or removing members and deleting organizations here only changes CRM relationships. CREST users, administrative organizations, positions, and assignments are not changed.',
      organizationSyncTitle: 'CRM business organizations are administrator-selected',
      organizationSyncDescription:
        'Administrators create CRM business organizations from enterprise organizations, and required parent directories are added automatically. Names, hierarchy, and memberships remain synchronized.',
      syncSource: 'Sync Source',
      description: 'Description',
      linkedCrestOrg: 'Linked CREST Organization',
      linkedCrestOrgPlaceholder: 'Select a linked CREST child organization',
      linkedCrestOrgIncludeChildren: 'Include child organization members when syncing',
      linkedCrestOrgInfo: 'Linked CREST organization: {{name}}',
      linkedCrestOrgIncludeChildrenShort: 'Include children',
      linkedCrestOrgCurrentOnly: 'Current organization only',
      syncLinkedOrg: 'Sync Linked Organization Members',
      linkedOrgSynced:
        'Linked organization synced: {{active}} in scope, {{synced}} updated, {{removed}} removed',
      save: 'Save',
      saveSuccess: 'Business organization saved',
      deleteSuccess: 'CRM business organization deleted; history is retained',
      deleteFailed: 'Failed to delete CRM business organization',
      saveFailed: 'Save failed',
      loadFailed: 'Failed to load CRM business organizations',
      empty: 'No business organizations have been added',
      selectOrg: 'Select a business organization',
      noDescription: 'No description',
      member: 'Member',
      enterpriseOrg: 'Enterprise Organization',
      source: 'Source',
      manual: 'Manual',
      departmentImport: 'Department import',
      crestOrgSync: 'Linked organization sync',
      localProjection: 'Local projection',
      actions: 'Actions',
      remove: 'Remove',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Delete this business organization?',
      deleteConfirmDescription:
        'The department will no longer participate in CRM permissions or business scopes. Enterprise organization, DingTalk, and historical records are not affected.',
      deleteBlockedChildren: 'This department still has active children; handle them first',
      deleteBlockedMembers: 'This department still has {{count}} members; reassign them first',
      members: 'Organization Members',
      memberBoundary: 'Member operations only affect CRM',
      memberBoundaryDescription:
        'Adding, removing, or clearing members only changes CRM business-organization relationships. CREST people data is not changed.',
      syncedMemberTitle: 'Members synchronize from enterprise organizations',
      syncedMemberDescription:
        'To change membership, update the enterprise organization or DingTalk directory and synchronize again.',
      selectUser: 'Select user to add',
      addUser: 'Add User',
      selectDepartment: 'Select enterprise department to add members',
      addByDepartment: 'Add By Department',
      clearDepartment: 'Clear Department Members',
      clearCurrentMembers: 'Clear',
      includeChildren: 'Include child departments',
      memberAdded: 'Member added',
      memberRemoved: 'Member removed',
      membersCleared: 'Current organization members cleared',
      memberOperationFailed: 'Member operation failed',
      noMembers: 'No members in the current organization',
      deptAdded: 'Added {{count}} users from department',
      deptCleared: 'Cleared {{count}} department members',
      currentMembersCleared: 'Cleared {{count}} members in the current department',
      clearDeptConfirm: 'Clear members in the selected department scope?',
      clearCurrentMembersConfirm: 'Clear all members from the current CRM business organization?',
      clearCurrentMembersDescription:
        'Only the current CRM memberships are revoked. Child organizations and CREST users, positions, and assignments are not affected.',
      removeConfirm: 'Remove this CRM organization member?',
      removeConfirmDescription:
        'Only the CRM business-organization membership is removed. The CREST user is not deleted or disabled.',
    },
    reporting: {
      appName: 'Report Center',
      myReports: 'My Reports',
      myReportsSubtitle: 'Manage daily, weekly, and monthly reports',
      newReport: 'New Report',
      refreshCrestData: 'Refresh Crest Data',
      createDraftFailed: 'Failed to create draft. Try again later.',
      loadFailed: 'Failed to load reports. Refresh and try again.',
      saveFailed: 'Save failed. Try again later.',
      submitFailed: 'Submit failed. Try again later.',
      revisionConflictTitle: 'Draft has a newer version',
      revisionConflictDescription:
        'This draft was updated elsewhere. Reload it before continuing so the latest content is not overwritten.',
      reloadDraft: 'Reload Draft',
      syncFailed: 'Crest data refresh failed. Manual reporting is still available.',
      sourceSyncSkipped: 'Crest source is not enabled. Manual reporting is still available.',
      sourceSyncSucceeded: 'Synced {{count}} Crest facts',
      sourceSyncPartial: 'Synced {{count}} Crest facts. Some sources are temporarily unavailable.',
      agentSkipped:
        'Report Agent is disabled or has no evidence. Manual reporting is still available.',
      agentSucceeded: 'Generated {{count}} AI summaries',
      agentFailed: 'AI summaries were not generated. Manual reporting is still available.',
      systemFactsComposed: 'System facts generated',
      submitReport: 'Submit Weekly Report',
      submitReportByType: 'Submit {{type}}',
      submitNoWriteback:
        'Submitting creates candidates, but does not write to CRM. Accepting a candidate only confirms it inside the report.',
      evidenceCoveragePreview:
        'Evidence coverage: {{covered}}/{{total}} sections, {{sources}} sources',
      preview: 'Preview',
      save: 'Save Draft',
      compose: 'Compose System Facts',
      refineWithAgent: 'Generate AI Summary',
      carryOver: 'Carry Over Open Items',
      sourceSync: 'Sync Crest Data',
      sourcePanel: 'Crest Sources',
      systemFact: 'Crest Fact',
      aiSummary: 'AI Generated',
      aiOriginal: 'AI original',
      manualText: 'Manual Input',
      acceptedNotSynced: 'Accepted (not synced to CRM)',
      rejected: 'Rejected',
      deferred: 'Deferred',
      writebackDisabled: 'Sync to CRM (disabled)',
      writebackNotRequested: 'Not requested',
      writebackUnavailable: 'Writeback unavailable',
      writebackPrepared: 'Prepared (not executable)',
      contractReserved: 'Writeback Contract reserved',
      providerNotInstalled: 'CRM Provider not installed',
      readonlyConnector: 'Provided by CRM Read-only Connector and will not modify CRM',
      candidateNoWriteback: 'Accepting a candidate will not write to CRM automatically',
      crmProvider: 'CRM',
      crmSourceSummary: 'Activity / Opportunity / Account',
      sourceConnector: 'CRM Read-only Source',
      preGeneration: 'Pre-generation',
      manualReporting: 'Manual Reporting',
      intelligenceRuntime: 'Intelligence Runtime',
      agentRuntime: 'Agent',
      backgroundJobs: 'Background Jobs',
      deliveryRuntime: 'Delivery',
      opsStatus: 'Delivery and Background Jobs',
      deliveries: 'Delivery Records',
      jobs: 'Job Records',
      requestDelivery: 'Request Delivery',
      requestPregenerate: 'Request Pre-generation',
      emptyOps: 'No status records yet',
      opsLoadFailed: 'Failed to load delivery and job status. Refresh and try again.',
      opsRequestFailed: 'The request was not submitted. Try again later.',
      attemptCount: '{{count}} attempts',
      ops_blocked: 'Blocked',
      ops_queued: 'Queued',
      ops_running: 'Running',
      ops_succeeded: 'Succeeded',
      ops_sent: 'Sent',
      ops_failed: 'Failed',
      ops_skipped: 'Skipped',
      candidateExtraction: 'Candidate Extraction',
      llmStatus: 'LLM',
      llmNotConfiguredShort: 'Not configured',
      enabled: 'Enabled',
      disabled: 'Disabled',
      contractVersion: 'Contract Version',
      execute: 'Execute',
      reportType: 'Report Type',
      period: 'Period',
      weeklyPeriodTitle: '{{year}} Week {{week}} ({{start}} ~ {{end}})',
      submittedAt: 'Submitted At',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      revision: 'Revision {{revision}}',
      crestFactsSynced: 'Crest facts synced, data as of {{time}}',
      reportsRecent: 'Recent Reports',
      manualModeAvailable: 'Manual reporting remains available when Connector is off',
      draft: 'Draft',
      submitted: 'Submitted',
      notSubmitted: 'Not Submitted',
      obligation_none: 'No obligation',
      obligation_open: 'Due',
      obligation_submitted: 'Submitted',
      obligation_late: 'Late',
      obligation_waived: 'Waived',
      submittedLate: 'Submitted Late',
      dueAt: 'Due {{time}}',
      continueEditing: 'Continue Editing',
      view: 'View',
      exportHtml: 'Export HTML',
      exportPdf: 'Export PDF',
      exportWord: 'Export Word (disabled)',
      exportWordUnavailable:
        'Word generation is not available in this runtime. Use HTML or PDF export.',
      reportEditor: 'Edit Weekly Report',
      reportEditorByType: 'Edit {{type}}',
      settings: 'Report Settings',
      settingsSubtitle: 'Configure templates, rules, data sources, and intelligence',
      reportTemplates: 'Report Templates',
      submissionRules: 'Submission Rules',
      dataSource: 'Data Source',
      attachmentLinks: 'Attachment Links',
      addAttachmentLink: 'Add Attachment Link',
      attachmentUrl: 'Paste an https:// attachment link',
      attachmentName: 'Attachment name (optional)',
      attachmentDescription: 'Description (optional)',
      emptyAttachments: 'No attachment links yet',
      attachmentAddFailed: 'Failed to save the attachment link. Check the link and try again.',
      attachmentDeleteFailed: 'Failed to delete the attachment link. Try again later.',
      sourceIncluded: 'Included',
      sourceExcluded: 'Excluded',
      include: 'Include',
      exclude: 'Exclude',
      actions: 'Actions',
      emptyDraft: 'No report draft yet',
      emptySources: 'No Crest facts synced yet',
      evidence: 'Evidence Snapshots',
      evidenceDetails: 'Evidence Details',
      viewEvidence: 'View Evidence',
      sourceType: 'Source Type',
      sourceId: 'Source ID',
      subject: 'Subject',
      evidenceAccessVisible: 'Currently visible',
      evidenceAccessNotVisible: 'Currently not visible',
      evidenceAccessSourceDisabled: 'Source disabled',
      evidenceRedacted: 'You do not currently have permission to view this evidence.',
      emptyEvidence: 'No frozen evidence snapshots',
      readonlySnapshot: 'Read-only snapshot frozen at submission',
      emptyCandidates: 'No candidates yet',
      factCandidates: 'Fact Candidates',
      emptyFactCandidates: 'No fact candidates yet',
      factCandidateLoadFailed: 'Failed to load fact candidates. Try again later.',
      factCandidateReviewFailed: 'Failed to review the fact candidate. Try again later.',
      emptyFactText: 'No fact content',
      versionTimeline: 'Version History',
      emptyVersions: 'No version history yet',
      versionLoadFailed: 'Failed to load version history. Try again later.',
      versionNo: 'Version {{version}}',
      currentVersion: 'Current',
      detected: 'Pending Review',
      accepted: 'Accepted',
      superseded: 'Superseded',
      supersede: 'Mark Superseded',
      coverage: 'Coverage',
      intelligence: 'Intelligence',
      briefings: 'Briefings',
      scopeSelf: 'Mine',
      scopeTeam: 'Team',
      scopeSelfDescription: 'Showing my report scope',
      scopeTeamDescription: 'Showing the team report scope I can access',
      employee: 'Employee',
      totalPeriods: 'Periods',
      submittedPeriods: 'Submitted Periods',
      missingPeriods: 'Missing Periods',
      latePeriods: 'Late Periods',
      completionRate: 'Completion Rate',
      latestSubmittedAt: 'Latest Submission',
      columnSettings: 'Columns',
      reviewStatus: 'Review Status',
      writebackStatus: 'Writeback Status',
      count: 'Count',
      llmNotConfigured: 'LLM/Agent is not enabled; deterministic summaries are shown',
      generatedDeterministically: 'Generated from report content deterministically',
      editBriefing: 'Edit Briefing',
      publishBriefing: 'Publish Briefing',
      archiveBriefing: 'Archive Briefing',
      briefingUpdateFailed: 'Failed to update the briefing. Try again later.',
      blockCount: 'Blocks',
      systemFactCount: 'System Facts',
      manualTextCount: 'Manual Inputs',
      syncedFactsShort: 'Synced {{count}} facts',
      crestNotSynced: 'Crest not synced',
      manualPendingAll: 'Manual pending',
      noBriefings: 'No submitted reports to summarize yet',
      currentPeriod: 'Current Period',
      timezone: 'Time Zone',
      dataFreshness: 'Data Freshness',
      connectorManualFallback:
        'Some Connector sources are unavailable. Manual reporting and submission remain available.',
      dueTime: 'Due Time',
      lastSubmitted: 'Last Submitted',
      lastSaved: 'Last Saved',
      allChangesSaved: 'Saved',
      revisionShort: 'Revision {{revision}}',
      dataUntil: 'Crest data until {{time}}',
      basedOnEvidence: 'Based on {{count}} facts',
      sourceFrom: 'Source: {{type}}',
      viewSource: 'View Source',
      adopt: 'Adopt',
      ignore: 'Ignore',
      manuallyEdited: 'Manually edited',
      lastSyncShort: 'Last sync: {{time}}',
      partialSourceWarning: 'Some data failed to sync. 1 connector is unavailable.',
      sourceTabAll: 'All ({{count}})',
      title: 'Title',
      viewMoreWithCount: 'View more ({{count}})',
      connectorUnavailable:
        'Connector unavailable. ERP permission changed; some cost data is not synced.',
      completedCheckItems: '{{completed}}/{{total}} checks complete',
      missingCustomerFeedback: 'Missing customer feedback',
      manualPending: 'Manual items pending',
      attachmentMissing: 'Related attachment missing',
      aiSuggestionShort: 'Add customer budget assessment progress',
      crmEvidenceDetails: 'CRM Evidence Details',
      occurredAt: 'Occurred At',
      safeSummary: 'Safe Summary',
      currentAccessStatus: 'Current Access Status',
      noOriginalRecordAccess: 'No current access to original record',
      accessChangedCopy:
        'Your role or organization scope changed, so the original record cannot be opened.',
      metadata: 'Metadata',
      reportSection: 'Report Section',
      securityNotice: 'Security Notice',
      evidenceSecurityCopy: 'Reports only show safe summaries, not sensitive system fields.',
      openCrmRecord: 'Open CRM Record',
      noOriginalRecordAccessAction: 'No current access to the original record.',
      returnToCheck: 'Return to Check',
      includedCrestFacts: 'Included Crest Facts',
      submitFreezeNotice:
        'Submitting creates an immutable version and generates candidates and follow-up actions.',
      submitNoCrmWrite: 'This submission will not write to CRM automatically.',
      submitVisibleInReports:
        'Accepted candidates are visible in this version and marked as not synced to CRM.',
      submitCandidateNotice:
        'Future writeback must be enabled separately in system settings and announced.',
      manualSupplementPlaceholder: 'Add other items for this section...',
      attachments: 'Attachments',
      uploadAttachmentHint: 'Click or drag files here to upload',
      uploadAttachmentTypes: 'Supports docx, xlsx, pptx, pdf, png, jpg',
      sourceConnectorStatus: 'Connector Status',
      connectorNormal: 'Normal',
      sourceMode: 'Source Mode',
      sourceModeAuto: 'Auto',
      sourceModeMixed: 'Mixed',
      sourceModeManual: 'Manual',
      sourceModeUnknown: 'Not recorded',
      version: 'Version',
      revisionLabel: 'Draft Revision',
      evidenceCount: '{{count}} evidence',
      totalSources: 'All {{count}}',
      includedSources: 'Included {{count}}',
      suggestedSources: 'Suggested {{count}}',
      excludedSources: 'Excluded {{count}}',
      reportCompletion: 'Report Completion',
      aiSuggestion: 'AI Suggestion',
      aiSuggestionDescription:
        'Use current evidence to fill gaps. Human confirmation is still required.',
      sourceTypeUnknown: 'Unknown Source',
      sourceTypeGeneric: 'External Source: {{type}}',
      sourceType_activity: 'Activity',
      sourceType_opportunity: 'Opportunity',
      sourceType_account: 'Account',
      sourceType_contact: 'Contact',
      sourceType_contract: 'Contract',
      sourceType_order: 'Order',
      block_generic: 'Custom Section: {{section}}',
      block_summary: 'Cycle Summary',
      block_progress: 'Key Progress',
      block_plan: 'Next Cycle Plan',
      block_manual: 'Manual Notes',
      block_risk: 'Risks and Blockers',
      block_risks: 'Risks and Blockers',
      block_next_steps: 'Next Actions',
      block_achievements: 'Key Outcomes',
      block_highlights: 'Highlights',
      block_customer: 'Customer Status',
      block_customer_progress: 'Customer and Opportunity Progress',
      reportInfo: 'Report Info',
      openSourceRecord: 'Open Source Record (read-only, disabled)',
      teamCoverageDetail: 'Employee Submission Detail',
      totalPeriodsWithCount: '{{count}} periods total',
      latePeriodsWithCount: '{{count}} late periods',
      generatedInsights: 'Generated Insights',
      reviewQueue: 'Review Queue',
      riskQueue: 'Risk and Blocker Queue',
      topicAggregation: 'Topic Aggregation',
      allInsights: 'All Insights',
      scope: 'Organization Scope',
      dataGenerationMode: 'Generation Mode',
      briefingList: 'Briefing List',
      briefingContent: 'Briefing Content',
      briefingInfo: 'Briefing Info',
      dataSourceOverview: 'Data and Source Overview',
      reviewFlow: 'Review Flow',
      createBriefing: 'Create Briefing',
      teamReview: 'Team Review',
      evidenceTotal: 'Evidence Total',
      operationLog: 'Activity Log',
      connectorHealth: 'Connector Health',
      pilotScope: 'Pilot Scope',
      futureSourceLocked: 'Available for future integration; not used for report generation yet',
      erpSource: 'ERP',
      supportSource: 'Support System',
      taskStatus: 'Task Status',
      agentRuntimeDescription: 'Generates summaries, suggestions, and deeper analysis',
      backgroundJobsDescription: 'Handles pre-generation, refresh, and async computation',
      deliveryRuntimeDescription: 'Handles scheduled delivery and reminders',
    },
    contractPayment: {
      title: 'Payment Plan',
      subtitle: 'Supports multiple milestones and monthly installments',
      paymentThrough: 'Payment Through',
      validPercent: 'Total 100%',
      node: 'Milestone {{index}}',
      moveUp: 'Move payment milestone {{index}} up',
      moveDown: 'Move payment milestone {{index}} down',
      removeNode: 'Remove payment milestone {{index}}',
      addNode: 'Add Payment Milestone',
      nodeType: 'Milestone Type',
      percent: 'Payment Percent',
      timing: 'Timing',
      milestone: 'Payment Milestone',
      offset: 'Time Offset',
      offsetUnit: 'Offset Unit',
      dueDays: 'Payment Due Days',
      settlementMode: 'Settlement Mode',
      description: 'Customer-facing Note',
      single: 'Single Payment',
      monthly: 'Monthly Installments',
      prepayment: 'Prepayment',
      milestonePayment: 'Milestone Payment',
      fixedDate: 'Fixed-date Payment',
      import: 'Import Payment Schedule',
      downloadTemplate: 'Download Template',
      previewTitle: 'Payment Schedule Import Preview',
      closePreview: 'Close',
      apply: 'Apply Payment Schedule',
      fileErrors: 'Fix the file errors and import it again',
      rowError: 'Row {{row}} · {{column}}: {{message}}',
      downloadFailed: 'Unable to download the payment schedule template. Try again later.',
      parseFailed: 'Unable to parse the payment schedule. Check the file format.',
      periodNo: 'No.',
      dueDate: 'Due Date',
      principal: 'Principal',
      interest: 'Interest',
      totalDue: 'Total Due',
      balance: 'Balance',
      fillSchedule: 'Enter Installment Schedule',
      editSchedule: 'Edit Installment Schedule',
      scheduleTitle: 'Installment Payment Schedule',
      addPeriod: 'Add Period',
      removePeriod: 'Remove period {{index}}',
      cancelSchedule: 'Cancel',
      applyToContract: 'Apply to Contract',
      actions: 'Actions',
      scheduleHint:
        'Add three, five, or more periods. Total due and remaining principal are calculated automatically.',
      targetPrincipal: 'Milestone Principal',
    },
    legacy: legacyResources.en,
    hardcoded: hardcodedResources.en,
  },
} as const;
